webpackJsonp([138],{

/***/ "+At6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+CgP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+GCs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+blG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        items: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        nohead: Boolean
    },
    data: function data() {
        return {};
    },
    mounted: function mounted() {},

    methods: {},
    created: function created() {}
});

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

module.exports = Vue;

/***/ }),

/***/ "0Drh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: (_vm.options.title ? 'padding: 20px;' : '')
  }, [(!!_vm.options.title) ? _c('div', {
    staticClass: "jcsb",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "24px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.options.title))]), _vm._v(" "), _vm._t("head")], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "jcsb"
  }, [_c('div', [_c('Query', {
    attrs: {
      "options": _vm.options.query
    },
    on: {
      "on-query": function($event) {
        _vm.query = $event;
        _vm.page.current = 1;
        _vm.loadData()
      },
      "on-load": function($event) {
        _vm.query = $event;
        _vm.page.current = 1;
        _vm.loadData()
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._t("headright")], 2)]), _vm._v(" "), (!_vm.options.title) ? _vm._t("head") : _vm._e(), _vm._v(" "), _vm._t("body"), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "10px"
    }
  }), _vm._v(" "), _c('Table', {
    ref: "sheet",
    attrs: {
      "border": "",
      "fixed-shadow": "auto",
      "columns": _vm.columns,
      "show-summary": _vm.options.summary ? true : false,
      "summary-method": _vm.options.summaryMethod,
      "loading": _vm.loading,
      "data": _vm.datas
    },
    on: {
      "on-select": _vm.itemSelected,
      "on-select-cancel": _vm.itemSelectedCancel,
      "on-select-all": _vm.allSelected,
      "on-select-all-cancel": _vm.allSelectedCancel,
      "on-sort-change": _vm.sortChanged
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "jcsb"
  }, [_c('div', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('div', [(_vm.query.selections) ? _c('Tag', {
    attrs: {
      "closable": ""
    },
    on: {
      "on-close": function($event) {
        _vm.query.selections = null;
        _vm.loadData();
      }
    }
  }, [_vm._v("\n                    只看已选的 "), _c('span', {
    staticStyle: {
      "color": "#20bf64"
    }
  }, [_vm._v(_vm._s(_vm.query.selections.length))]), _vm._v(" 项")]) : (_vm.selections.length) ? _c('div', {
    staticStyle: {
      "margin-bottom": "10px",
      "display": "flex",
      "align-items": "center"
    }
  }, [_vm._v("\n                    已选"), _c('span', {
    staticStyle: {
      "color": "#20bf64",
      "margin": "0 4px"
    }
  }, [_vm._v(_vm._s(_vm.selections.length))]), _vm._v("项\n                    "), _c('div', {
    staticClass: "hover",
    staticStyle: {
      "color": "#20bf64",
      "margin-left": "10px"
    },
    on: {
      "click": _vm.showSelections
    }
  }, [_vm._v("查看")]), _vm._v(" "), _c('div', {
    staticClass: "hover",
    staticStyle: {
      "color": "#20bf64",
      "margin-left": "10px"
    },
    on: {
      "click": _vm.clearSelections
    }
  }, [_vm._v("取消选择")]), _vm._v(" "), _c('div', {
    staticClass: "hover",
    staticStyle: {
      "color": "#20bf64",
      "margin-left": "10px"
    },
    on: {
      "click": _vm.selectAllPage
    }
  }, [_vm._v("全选")])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [(_vm.options.exportable && _vm.selections.length < _vm.total) ? _c('div', {
    staticClass: "hover",
    staticStyle: {
      "color": "#20bf64",
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        return _vm.toExport('all')
      }
    }
  }, [_vm._v("导出全部" + _vm._s(_vm.total) + "条数据")]) : _vm._e(), _vm._v(" "), (_vm.options.exportable && _vm.selections.length) ? _c('div', {
    staticClass: "hover",
    staticStyle: {
      "color": "#20bf64",
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        return _vm.toExport('selection')
      }
    }
  }, [_vm._v("导出选中的" + _vm._s(_vm.selections.length) + "条数据")]) : _vm._e(), _vm._v(" "), _vm._t("foot")], 2), _vm._v(" "), (_vm.selections.length) ? _vm._t("batchops") : _vm._e()], 2), _vm._v(" "), _c('div', [(_vm.total > _vm.page.size || _vm.page.size > 10) ? _c('Page', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "placement": "top",
      "page-size-opts": [10, 20, 50, 100, 200],
      "total": _vm.total,
      "current": _vm.page.current,
      "page-size": _vm.page.size,
      "show-sizer": "",
      "show-total": ""
    },
    on: {
      "on-change": _vm.pageChanged,
      "on-page-size-change": _vm.pageSizeChanged
    }
  }) : _vm._e()], 1)])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0G7C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        unimode: {
            type: Boolean,
            default: false
        },
        moveable: {
            type: Boolean,
            default: true
        },
        datatype: {
            type: String
        },
        current: {
            type: [Object, Array],
            default: null
        },
        multi: {
            type: Boolean,
            default: false
        },
        all: {
            type: Boolean,
            default: false
        },
        max: {
            type: Number,
            default: null
        },
        editable: {
            type: Boolean,
            default: true
        },
        clearable: {
            type: Boolean,
            default: true
        },
        label: {
            type: String
        },
        loadurl: {
            type: String
        },
        disableItem: {
            type: Function //在选择时，部分Item将被动态禁用
        },
        useMendianSelector: {
            type: Boolean,
            default: false
        },
        fields: Object,
        query: Object,
        columns: Array,
        nopage: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        current: function current(value) {
            if (value) {
                this.result = this.copy(value);
                if (this.guanxiajigou) {
                    var session = this.$store.session;
                    this.result_not_in_guanxia = this.result.filter(function (o) {
                        return !session.zhanghao.guanxiajigous.some(function (j) {
                            return j._id == o._id;
                        });
                    });
                    this.result = this.result.filter(function (o) {
                        return session.zhanghao.guanxiajigous.some(function (j) {
                            return j._id == o._id;
                        });
                    });
                }
            } else {
                if (this.multi) {
                    this.result = [];
                } else {
                    this.result = null;
                }
            }
        }
    },
    data: function data() {
        var _this = this;

        return {
            guanxiajigou: false,
            result_not_in_guanxia: [],
            showAll: false,
            loading: false,
            result: this.multi ? [] : null,
            resultSelector: {
                display: false,
                index: null,
                _replace: false,
                options: null,
                show: function show(index) {
                    _this.resultSelector.options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
                        datatype: _this.datatype,
                        multi: _this.multi,
                        max: _this.max,
                        all: _this.all,
                        current: _this.unimode ? _this.result : [],
                        loadurl: _this.loadurl,
                        disableItem: _this.disableItem,
                        placeholder: '搜索'
                    }, _this.getDataSetting());
                    if (index !== undefined) {
                        _this.resultSelector.index = index;
                        _this.resultSelector._replace = true;
                    } else {
                        _this.resultSelector.index = null;
                    }
                    _this.resultSelector.display = true;
                },
                confirm: function confirm(value) {
                    if (_this.multi && !_this.unimode) {
                        if (_this.max && _this.result.length >= _this.max) return;
                        if (_this.resultSelector.index !== null) {
                            _this.result.splice(_this.resultSelector.index, 1);
                            value = value.reverse();
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;

                            try {
                                for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(value), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                    var item = _step.value;

                                    _this.result.splice(_this.resultSelector.index, 0, item);
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return) {
                                        _iterator.return();
                                    }
                                } finally {
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        } else {
                            _this.result = _this.result.concat(value);
                        }
                    } else {
                        _this.result = value;
                    }
                    _this.loading = false;
                    _this.resultSelector.display = false;
                    _this.confirm();
                }
            }
        };
    },
    mounted: function mounted() {
        // setTimeout(() => { this.init() }, 100)
        this.init();
    },

    methods: {
        moveUp: function moveUp(index) {
            if (index == 0) {
                return;
            }
            var temp = this.result[index - 1];
            this.result[index - 1] = this.result[index];
            this.result[index] = temp;
            this.confirm();
        },
        moveDown: function moveDown(index) {
            if (index == this.result.length - 1) {
                return;
            }
            var temp = this.result[index + 1];
            this.result[index + 1] = this.result[index];
            this.result[index] = temp;
            this.confirm();
        },
        init: function init() {
            if (this.query && this.query.guanxiajigou == true) {
                this.guanxiajigou = true;
            }
            if (this.current) {
                var result = this.copy(this.current);
                if (this.guanxiajigou) {
                    var session = this.$store.session;
                    this.result_not_in_guanxia = result.filter(function (o) {
                        return !session.zhanghao.guanxiajigous.some(function (j) {
                            return j._id == o._id;
                        });
                    });
                    this.result = result.filter(function (o) {
                        return session.zhanghao.guanxiajigous.some(function (j) {
                            return j._id == o._id;
                        });
                    });
                } else {
                    this.result = result;
                }
            }
        },
        confirm: function confirm() {
            var result = this.copy(this.result);
            if (this.result_not_in_guanxia && this.result_not_in_guanxia.length > 0) {
                result = result.concat(this.result_not_in_guanxia);
            }
            this.$emit('confirm', result);
        },
        toClear: function toClear(index) {
            if (this.multi) {
                this.result.splice(index, 1);
            } else {
                this.result = null;
            }
            this.confirm();
        },
        getDataSetting: function getDataSetting() {
            var _this2 = this;

            var datatype = this.datatype,
                name = this.name,
                fields = this.fields,
                query = this.query,
                columns = this.columns;

            if (datatype == 'jigou' || datatype == 'wupin') {
                if (!columns) {
                    columns = [{
                        title: '名称',
                        minWidth: 200,
                        render: function render(h, params) {
                            return h('div', params.row.name);
                        }
                    }, {
                        title: '编码',
                        minWidth: 100,
                        render: function render(h, params) {
                            return h('div', params.row.code);
                        }
                    }];
                }
            } else if (datatype == 'cangku') {
                if (!columns) {
                    columns = [{
                        title: '名称',
                        minWidth: 200,
                        render: function render(h, params) {
                            return h('div', params.row.name);
                        }
                    }, {
                        title: '编码',
                        minWidth: 100,
                        render: function render(h, params) {
                            return h('div', params.row.code);
                        }
                    }, {
                        title: '所属机构',
                        minWidth: 100,
                        render: function render(h, params) {
                            return h('div', params.row.jigou.name);
                        }
                    }];
                }
            } else if (datatype == 'coupon') {
                if (!columns) {
                    columns = [{
                        title: '名称',
                        minWidth: 200,
                        render: function render(h, params) {
                            return h('div', params.row.name);
                        }
                    }, {
                        title: '分组',
                        minWidth: 100,
                        render: function render(h, params) {
                            return h('div', params.row.group);
                        }
                    }, {
                        title: '类型',
                        minWidth: 80,
                        render: function render(h, params) {
                            return h('div', params.row.type);
                        }
                    }, {
                        title: '价值',
                        key: 'jiazhi',
                        minWidth: 80
                    }, {
                        title: '最后更新时间',
                        minWidth: 180,
                        render: function render(h, params) {
                            return h('div', _this2.moment(params.row.createTime).format('YYYY-MM-DD HH:mm:ss'));
                        }
                    }];
                }
            } else if (datatype == 'jiagongpin') {
                if (!columns) {
                    columns = [{
                        title: '名称',
                        minWidth: 200,
                        render: function render(h, params) {
                            // let divs = []
                            return h('div', { class: 'df' }, params.row.wupin.name);
                        }
                    }, {
                        title: '供货机构',
                        minWidth: 200,
                        render: function render(h, params) {
                            // let divs = []
                            return h('div', { class: 'df' }, params.row.jigou.name);
                        }
                    }, {
                        title: '加工间',
                        minWidth: 200,
                        render: function render(h, params) {
                            // let divs = []
                            return h('div', { class: 'df' }, params.row.jiagongjian.name);
                        }
                    }, {
                        title: '创建时间',
                        minWidth: 180,
                        render: function render(h, params) {
                            return h('div', _this2.moment(params.row.createTime).format('YYYY-MM-DD HH:mm:ss'));
                        }
                    }];
                }
            } else {
                if (!columns) {
                    columns = [{
                        title: '名称',
                        minWidth: 200,
                        render: function render(h, params) {
                            return h('div', params.row.name);
                        }
                    }];
                }
            }
            return {
                name: name,
                fields: fields,
                query: query,
                columns: columns
            };
        }
    }
});

/***/ }),

/***/ "0iaW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = moment;

/***/ }),

/***/ "134y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tagsNav_vue__ = __webpack_require__("hW7o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0333fdb0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_tagsNav_vue__ = __webpack_require__("LZ00");
function injectStyle (ssrContext) {
  __webpack_require__("R+fs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tagsNav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0333fdb0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_tagsNav_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1G29":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_Query_vue__ = __webpack_require__("Poms");





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Query: __WEBPACK_IMPORTED_MODULE_5__components_common_Query_vue__["a" /* default */]
    },
    props: {
        title: String,
        options: {
            type: Object,
            default: {}
        }
        // columns: {
        //     type: Array,
        //     default: []
        // },
        // fields: {
        //     type: Object,
        // },
        // querys: {
        //     type: Array,
        // }
    },
    data: function data() {
        return {
            session: this.$store.session,
            selections: [],
            loading: false,
            total: 0,
            page: {
                size: 10,
                current: 1
            },
            query: { init: true },
            datas: [],
            columns: []
        };
    },

    // watch: {
    //     options(value) {
    //         this.options = value
    //         this.init()
    //     }
    // },
    mounted: function mounted() {
        this.init();
    },

    methods: {
        sortChanged: function sortChanged(_ref) {
            var column = _ref.column,
                key = _ref.key,
                order = _ref.order;

            if (column && key && (order == 'asc' || order == 'desc')) {
                var sort = {};
                sort[key] = order == 'asc' ? 1 : -1;
                this.query.sort = sort;
            } else {
                this.query.sort = null;
            }
            this.loadData();
        },
        showSelections: function showSelections() {
            this.query.selections = this.selections.map(function (item) {
                return { _id: item._id };
            });
            this.page.current = 1;
            this.loadData();
        },
        clearSelections: function clearSelections() {
            this.selections = [];
            var datas = [];
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.datas), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    item._checked = false;
                    datas.push(item);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            this.datas = datas;
        },
        allSelected: function allSelected(items) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(items), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var item = _step2.value;

                    if (!this.selections.findOne({ _id: item._id })) {
                        this.selections.push(item);
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        },
        allSelectedCancel: function allSelectedCancel() {
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.datas), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var item = _step3.value;

                    this.selections.remove({ _id: item._id });
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }
        },
        itemSelected: function itemSelected(_, item) {
            this.selections.push(item);
        },
        itemSelectedCancel: function itemSelectedCancel(_, item) {
            this.selections.remove({ _id: item._id });
        },
        showConditions: function showConditions() {
            this.conditionModal = true;
        },
        init: function init() {
            var columns = this.options.columns;
            if (this.options.exportable === undefined) {
                this.options.exportable = false;
            }
            if (this.options.checkable) {
                if (!columns.findOne({ type: 'selection' })) {
                    columns.splice(0, 0, { type: 'selection', align: 'center', width: 60, fixed: 'left' });
                }
            }
            this.columns = columns.filter(function (item) {
                if (item.vif && !item.vif()) return false;
                return true;
            });
        },
        selectAllPage: function selectAllPage() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
                var res, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, item;

                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                res = void 0;

                                if (!_this.options.load) {
                                    _context.next = 7;
                                    break;
                                }

                                _context.next = 4;
                                return _this.options.load({
                                    query: _this.query,
                                    fields: _this.options.fields,
                                    nopage: true
                                });

                            case 4:
                                res = _context.sent;
                                _context.next = 10;
                                break;

                            case 7:
                                _context.next = 9;
                                return _this.$api.post(_this.options.api, {
                                    query: _this.query,
                                    fields: _this.options.fields,
                                    nopage: true
                                });

                            case 9:
                                res = _context.sent;

                            case 10:

                                // this.selections = res.data[`${this.options.data.name}s`]
                                // for (let item of this.datas) {
                                //     item._checked = false
                                //     if (this.selections.findOne({ _id: item._id })) {
                                //         item._checked = true
                                //     }
                                // }
                                _iteratorNormalCompletion4 = true;
                                _didIteratorError4 = false;
                                _iteratorError4 = undefined;
                                _context.prev = 13;
                                for (_iterator4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(res.data[_this.options.data.name + 's']); !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                                    item = _step4.value;

                                    if (!_this.selections.findOne({ _id: item._id })) {
                                        _this.selections.push(item);
                                    }
                                }
                                _context.next = 21;
                                break;

                            case 17:
                                _context.prev = 17;
                                _context.t0 = _context['catch'](13);
                                _didIteratorError4 = true;
                                _iteratorError4 = _context.t0;

                            case 21:
                                _context.prev = 21;
                                _context.prev = 22;

                                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                    _iterator4.return();
                                }

                            case 24:
                                _context.prev = 24;

                                if (!_didIteratorError4) {
                                    _context.next = 27;
                                    break;
                                }

                                throw _iteratorError4;

                            case 27:
                                return _context.finish(24);

                            case 28:
                                return _context.finish(21);

                            case 29:
                                _this.loadData();

                            case 30:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[13, 17, 21, 29], [22,, 24, 28]]);
            }))();
        },
        loadData: function loadData() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var res, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, data;

                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this2.loading = true;
                                res = void 0;

                                if (!_this2.options.load) {
                                    _context2.next = 8;
                                    break;
                                }

                                _context2.next = 5;
                                return _this2.options.load({
                                    query: _this2.query,
                                    page: _this2.page,
                                    fields: _this2.options.fields,
                                    nopage: _this2.options.nopage
                                });

                            case 5:
                                res = _context2.sent;
                                _context2.next = 11;
                                break;

                            case 8:
                                _context2.next = 10;
                                return _this2.$api.post(_this2.options.api, {
                                    query: _this2.query,
                                    page: _this2.page,
                                    fields: _this2.options.fields,
                                    nopage: _this2.options.nopage
                                });

                            case 10:
                                res = _context2.sent;

                            case 11:
                                _this2.loading = false;
                                _this2.datas = res.data[_this2.options.data.name + 's'];
                                _iteratorNormalCompletion5 = true;
                                _didIteratorError5 = false;
                                _iteratorError5 = undefined;
                                _context2.prev = 16;
                                for (_iterator5 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(_this2.datas); !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                                    data = _step5.value;

                                    if (data.createTime) {
                                        data.createTimeStr = _this2.moment(data.createTime).format('MM月DD日 HH:mm');
                                    }
                                    if (data.lastUpdateTime) {
                                        data.lastUpdateTimeStr = _this2.moment(data.lastUpdateTime).format('MM月DD日 HH:mm');
                                    }
                                    if (_this2.selections.findOne({ _id: data._id })) {
                                        data._checked = true;
                                    }
                                }
                                _context2.next = 24;
                                break;

                            case 20:
                                _context2.prev = 20;
                                _context2.t0 = _context2['catch'](16);
                                _didIteratorError5 = true;
                                _iteratorError5 = _context2.t0;

                            case 24:
                                _context2.prev = 24;
                                _context2.prev = 25;

                                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                                    _iterator5.return();
                                }

                            case 27:
                                _context2.prev = 27;

                                if (!_didIteratorError5) {
                                    _context2.next = 30;
                                    break;
                                }

                                throw _iteratorError5;

                            case 30:
                                return _context2.finish(27);

                            case 31:
                                return _context2.finish(24);

                            case 32:
                                _this2.total = res.data.total;
                                if (_this2.query.init) {
                                    _this2.query.init = false;
                                }
                                _this2.$emit('loadData', _this2.datas);

                            case 35:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2, [[16, 20, 24, 32], [25,, 27, 31]]);
            }))();
        },
        pageSizeChanged: function pageSizeChanged(value) {
            this.page.size = value;
            // sessionStorage.pagesize = value
            if (this.page.current == 1) this.loadData();
        },
        pageChanged: function pageChanged(value) {
            this.page.current = value;
            this.loadData();
        },
        toExport: function toExport(scope) {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var that, columns_export, columns, i, column, datas_export, r, _res, _loop, _iteratorNormalCompletion6, _didIteratorError6, _iteratorError6, _iterator6, _step6, item, recordConfig, type, pageQuery;

                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                that = _this3;
                                columns_export = [];
                                columns = void 0;

                                if (_this3.options.exportOptions && _this3.options.exportOptions.loadColumns) {
                                    columns = _this3.options.exportOptions.loadColumns();
                                } else {
                                    columns = _this3.options.columns;
                                }
                                i = 0;

                            case 5:
                                if (!(i < columns.length)) {
                                    _context3.next = 17;
                                    break;
                                }

                                column = columns[i];

                                if (!(column.vif && !column.vif())) {
                                    _context3.next = 9;
                                    break;
                                }

                                return _context3.abrupt('continue', 14);

                            case 9:
                                if (!column.exportskip) {
                                    _context3.next = 11;
                                    break;
                                }

                                return _context3.abrupt('continue', 14);

                            case 11:
                                if (column.title) {
                                    _context3.next = 13;
                                    break;
                                }

                                return _context3.abrupt('continue', 14);

                            case 13:
                                if (column.key) {
                                    columns_export.push({ title: column.title, key: column.key });
                                } else {
                                    columns_export.push({ title: column.title, key: 'column_' + i });
                                }

                            case 14:
                                i++;
                                _context3.next = 5;
                                break;

                            case 17:
                                datas_export = void 0;

                                if (!(_this3.options.exportOptions && _this3.options.exportOptions.load)) {
                                    _context3.next = 25;
                                    break;
                                }

                                _context3.next = 21;
                                return _this3.options.exportOptions.load({ query: _this3.query, scope: scope, selections: _this3.selections });

                            case 21:
                                r = _context3.sent;

                                datas_export = r.datas;
                                _context3.next = 40;
                                break;

                            case 25:
                                if (!(scope == 'all')) {
                                    _context3.next = 39;
                                    break;
                                }

                                _res = void 0;

                                if (!_this3.options.load) {
                                    _context3.next = 33;
                                    break;
                                }

                                _context3.next = 30;
                                return _this3.options.load({
                                    query: _this3.query,
                                    fields: _this3.options.fields
                                });

                            case 30:
                                _res = _context3.sent;
                                _context3.next = 36;
                                break;

                            case 33:
                                _context3.next = 35;
                                return _this3.$api.post(_this3.options.api, {
                                    query: _this3.query,
                                    fields: _this3.options.fields
                                });

                            case 35:
                                _res = _context3.sent;

                            case 36:
                                datas_export = _res.data[_this3.options.data.name + 's'];
                                _context3.next = 40;
                                break;

                            case 39:
                                if (scope == 'page') {
                                    datas_export = _this3.copy(_this3.datas);
                                } else if (scope == 'selection') {
                                    datas_export = _this3.copy(_this3.selections);
                                }

                            case 40:
                                _loop = function _loop(item) {
                                    var _loop2 = function _loop2(_i) {
                                        var column = columns[_i];
                                        if (column.vif && !column.vif()) return 'continue';
                                        if (column.exportskip) return 'continue';
                                        if (!column.title) return 'continue';
                                        var columns_export_item = columns_export.findOne({ title: column.title });
                                        if (!columns_export_item) return 'continue';
                                        if (column.exporter) {
                                            item[columns_export_item.key] = column.exporter(item);
                                        } else if (column.render) {
                                            column.render(function () {
                                                var _ref2;

                                                item[columns_export_item.key] = (_ref2 = arguments.length - 1, arguments.length <= _ref2 ? undefined : arguments[_ref2]);
                                            }, { row: item });
                                        } else {
                                            item[columns_export_item.key] = item[columns_export_item.key];
                                        }
                                    };

                                    for (var _i = 0; _i < columns.length; _i++) {
                                        var _ret2 = _loop2(_i);

                                        if (_ret2 === 'continue') continue;
                                    }
                                    var _iteratorNormalCompletion7 = true;
                                    var _didIteratorError7 = false;
                                    var _iteratorError7 = undefined;

                                    try {
                                        for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(item)), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                                            var key = _step7.value;

                                            if (typeof item[key] == 'string') {
                                                item[key] = '"' + item[key] + '"';
                                            }
                                        }
                                    } catch (err) {
                                        _didIteratorError7 = true;
                                        _iteratorError7 = err;
                                    } finally {
                                        try {
                                            if (!_iteratorNormalCompletion7 && _iterator7.return) {
                                                _iterator7.return();
                                            }
                                        } finally {
                                            if (_didIteratorError7) {
                                                throw _iteratorError7;
                                            }
                                        }
                                    }
                                };

                                _iteratorNormalCompletion6 = true;
                                _didIteratorError6 = false;
                                _iteratorError6 = undefined;
                                _context3.prev = 44;

                                for (_iterator6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(datas_export); !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                                    item = _step6.value;

                                    _loop(item);
                                }
                                // 记录风险操作 - 如果配置了exportOptions.recordRiskOperation，则记录导出操作
                                _context3.next = 52;
                                break;

                            case 48:
                                _context3.prev = 48;
                                _context3.t0 = _context3['catch'](44);
                                _didIteratorError6 = true;
                                _iteratorError6 = _context3.t0;

                            case 52:
                                _context3.prev = 52;
                                _context3.prev = 53;

                                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                                    _iterator6.return();
                                }

                            case 55:
                                _context3.prev = 55;

                                if (!_didIteratorError6) {
                                    _context3.next = 58;
                                    break;
                                }

                                throw _iteratorError6;

                            case 58:
                                return _context3.finish(55);

                            case 59:
                                return _context3.finish(52);

                            case 60:
                                if (_this3.options.exportOptions && _this3.options.exportOptions.recordRiskOperation) {
                                    recordConfig = _this3.options.exportOptions.recordRiskOperation;
                                    type = recordConfig.type || (_this3.options.title || '数据') + '导出';
                                    pageQuery = recordConfig.pageQuery || (_this3.query && _this3.query.riqi ? { riqi: _this3.query.riqi, riqitype: _this3.query.riqitype } : {});

                                    _this3.$api.post('/admin/xtsj/fxcz/record', {
                                        queryInfo: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({ type: type, query: _this3.query }),
                                        dataCount: datas_export.length,
                                        pageQuery: pageQuery
                                    }).catch(function () {});
                                }
                                setTimeout(function () {
                                    var append = 0;
                                    if (datas_export.length > 1) {
                                        append = _this3.moment().format('YYYYMMDDHHmmss');
                                    }
                                    that.$refs.sheet.exportCsv({
                                        filename: (_this3.options.title || '') + '\u6570\u636E\u5BFC\u51FA_' + append,
                                        columns: columns_export,
                                        data: datas_export
                                    });
                                }, 200);

                            case 62:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3, [[44, 48, 52, 60], [53,, 55, 59]]);
            }))();
        }
    }
});

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = Vuex;

/***/ }),

/***/ "2XLQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jsbarcode__ = __webpack_require__("TwlK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jsbarcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jsbarcode__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        // 表格数据
        list: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        // 页头页脚
        print: {
            type: Object,
            default: function _default() {}
        },
        // 布局数据
        layout: {
            type: Object,
            default: function _default() {
                return {};
            }
        },
        // 模拟填充数据
        mock: {
            type: Boolean,
            default: true
        },
        // 页数
        pages: {
            type: Number,
            default: 1
        },
        // 当前页数
        page: {
            type: Number,
            default: 1
        },
        // 标识(区分同一页面不同Printer)
        identify: {
            type: String,
            default: ''
        }
    },
    data: function data() {
        return {
            // 独占一行字段
            alones: ['shouhuodizhi', 'beizhu', 'peisongfahuodan.wuliugongsi'],
            height: {
                base: '5.5mm',
                thin: '4mm'
            },
            // 纸张大小
            paperSize: {
                A4纸: {
                    width: '210mm',
                    height: '296.5mm',
                    minHeight: '296.5mm',
                    padding: '5mm 10mm'
                },
                '一等分(针式)': {
                    width: '9.5in',
                    height: '11in',
                    minHeight: '11in',
                    padding: '6mm 23mm 6mm 18mm'
                },
                '二等分(针式)': {
                    width: '9.5in',
                    height: '5.5in',
                    minHeight: '5.5in',
                    padding: '6mm 25mm 6mm 15mm'
                },
                '三等分(针式)': {
                    width: '241mm',
                    height: '93mm',
                    minHeight: '93mm',
                    padding: '6mm 25mm 6mm 15mm'
                }
            },
            printData: [],
            printColumns: [],
            isChangeWidth: false,
            shopName: ''
        };
    },

    computed: {
        showBarcode: function showBarcode() {
            return this.layout.dayintiaoma === 'true' || this.layout.dayintiaoma === true;
        },
        thin: function thin() {
            return (this.layout || {}).dayinzhizhangleixing === '三等分(针式)';
        },
        printerCls: function printerCls() {
            return 'printer' + (this.identify || '');
        },

        // 纸张类型
        paperType: function paperType() {
            var style = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
                color: '#000',
                overflow: 'hidden',
                border: this.mock ? '2px solid #d3d3d3' : 'none',
                zoom: this.mock ? (this.layout ? this.layout.dayinzhizhangleixing : 'A4纸') === 'A4纸' ? '0.8' : '0.7' : 1
            }, this.paperSize[this.layout ? this.layout.dayinzhizhangleixing : 'A4纸'], {
                boxSizing: 'border-box',
                'page-break-after': 'always'
            });
            return style;
        },
        headItems: function headItems() {
            return ((this.layout || {}).head || {}).items || [];
        },
        footItems: function footItems() {
            return ((this.layout || {}).foot || {}).items || [];
        },
        showChainName: function showChainName() {
            return String(this.layout.jituanming) === 'true';
        },
        chainName: function chainName() {
            return (this.shopName || ((this.layout || {}).jituan || {}).name) + ' -';
        }
    },
    watch: {
        'layout.meiyebiaogehangshu': function layoutMeiyebiaogehangshu() {
            this.drawList(this.list || []);
        },
        'layout.body.items': function layoutBodyItems() {
            console.debug('fea/change');
        },
        'list': function list() {
            this.drawList(this.list || []);
        },
        'layout.hebinghang': function layoutHebinghang() {
            this.drawList(this.list || []);
        },
        'layout.fenleixiaoji': function layoutFenleixiaoji() {
            this.drawList(this.list || []);
        }
    },
    methods: {
        cellStyle: function cellStyle() {
            return {
                height: (this.layout.hanggao || '6mm') + ' !important',
                lineHeight: (this.layout.hanggao || '6mm') + ' !important'
            };
        },

        // 页头页尾格式化
        tempFmt: function tempFmt(item, path) {
            var label = '';
            var value = '';
            if (this.mock) {
                value = '：数据';
            } else if (path) {
                var pathArray = Array.isArray(path) ? path : path.match(/([^[.\]])+/g);
                var prop = pathArray.reduce(function (prevObj, key) {
                    return prevObj && prevObj[key];
                }, this.print);
                if (prop === undefined || prop === null) prop = '';
                if (/^-?\d+\.\d+$/.test(prop)) {
                    value = '：' + Number(Number(prop).toFixed(2));
                } else {
                    value = '：' + prop;
                }
            }

            if (item) {
                if (item.blank) {
                    if (typeof item.newLabel === 'string') {
                        label = item.newLabel;
                    } else {
                        label = '\xa0';
                    }
                } else if (item.key) {
                    if (typeof item.newLabel === 'string') {
                        label = item.newLabel + value;
                    } else {
                        label = item.label + value;
                    }
                } else {
                    label = item.label || '\xa0';
                }
            }
            return label;
        },

        /**
         * 获取表格表头数据
         */
        drawColumns: function drawColumns(list) {
            this.printColumns = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(list || [], function (v) {
                var r = { field: v.key, title: v.newLabel || v.label || '' };
                if (v.width) {
                    r.width = v.width;
                    r.minWidth = v.width;
                }
                return r;
            });
            this.$refs.table.reloadColumn(this.printColumns);
        },
        getTotal: function getTotal() {
            var total = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var danjuleixing = this.layout.danjuleixing;
            if (danjuleixing === '配送发货单') {
                total.fahuoshuliang = '数据';
                total.fahuoshuliangkucun = '数据';
                total.fahuojinehanshui = '数据';
            } else if (danjuleixing === '配送收货单') {
                total.shouhuoshuliang = '数据';
                total.shouhuojinehanshui = '数据';
            } else if (danjuleixing === '配送订单') {
                total.caigoushuliang = '数据';
                total.kucunshuliang = '数据';
                total.caigoujinehanshui = '数据';
            } else if (danjuleixing === '配送返货单') {
                total.tuihuoshuliang = '数据';
                total.tuihuojinehanshui = '数据';
            } else if (danjuleixing === '采购订单') {
                total.caigoushuliang = '数据';
                total.caigoujinehanshui = '数据';
            } else if (danjuleixing === '采购收货') {
                total.shouhuoshuliang = '数据';
                total.shouhuojinehanshui = '数据';
                total.yishouhuojinehanshui = '数据';
            } else if (danjuleixing === '收发货差异处理单') {
                total.chayishuliang = '数据';
                total.chayijinehanshui = '数据';
            }
            return total;
        },

        /**
         * 获取表格数据
         */
        drawList: function drawList(list) {
            var _this = this;

            if (this.printColumns.length === 0 && this.layout.body.items.length) {
                this.drawColumns(this.layout.body.items);
            }
            this.printData = [];
            var page = this.page,
                layout = this.layout,
                mock = this.mock;
            var meiyebiaogehangshu = layout.meiyebiaogehangshu,
                hangshu = layout.hangshu;
            // 预览页

            if (mock) {
                var mockItem = this.printColumns.reduce(function (a, c) {
                    a[c.field] = '数据';
                    return a;
                }, {});
                this.printData = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()({ length: meiyebiaogehangshu || 24 }, function (_, idx) {
                    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, mockItem, {
                        xuhao: idx + 1
                    });
                });
                // 处理mock合并行
                var isShowTotal = String(this.layout.hebinghang || false) === 'true';
                var isShowCategoryTotal = String(this.layout.fenleixiaoji || '不展示') === '展示';
                if (isShowCategoryTotal) {
                    var idx = isShowTotal ? this.printData.length - 2 : this.printData.length - 1;
                    if (idx > 0) {
                        this.printData.splice(idx, 1, this.getTotal({ xuhao: '分类小计' }));
                    }
                }
                if (isShowTotal && this.printData.length - 1 > 0) {
                    this.printData.splice(this.printData.length - 1, 1, this.getTotal({ xuhao: '合计' }));
                }
                return;
            }
            // 业务页
            var totalNum = 0;
            list.forEach(function (v, idx) {
                var item = _this.printColumns.reduce(function (a, c) {
                    if (c.field === 'xuhao') {
                        // 处理序号
                        if (v[c.field]) {
                            a[c.field] = v[c.field];
                        } else {
                            a[c.field] = (page - 1) * (meiyebiaogehangshu || 10) + idx + 1 - totalNum;
                        }
                    } else {
                        var pathArray = Array.isArray(c.field) ? c.field : c.field.match(/([^[.\]])+/g);
                        var prop = pathArray.reduce(function (a1, c1) {
                            return a1 && a1[c1];
                        }, v);
                        if (prop === undefined || prop === null) prop = '';
                        // 处理金额
                        if (/^-?\d+\.\d+$/.test(prop)) {
                            var fix = 2;
                            fix = c.field.indexOf('jine') > -1 ? 2 : 6;
                            a[c.field] = Number(Number(prop).toFixed(fix));
                        } else {
                            a[c.field] = prop;
                        }
                    }
                    return a;
                }, {});
                if (v.isTotal && v.totalName) {
                    totalNum += 1;
                    item['isTotal'] = true;
                    item['xuhao'] = v.totalName;
                }
                _this.printData.push(item);
            });
            if (!mock && hangshu === 'true' && meiyebiaogehangshu > list.length) {
                var _printData;

                (_printData = this.printData).push.apply(_printData, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()({ length: meiyebiaogehangshu - list.length }, function () {
                    return {};
                })));
            }
        },

        /**
         * 获取最小列宽
         */
        getMinWidth: function getMinWidth(v) {
            var minWidth = document.querySelectorAll('.vxe-table .vxe-cell--title')[v._columnIndex].offsetWidth;
            return minWidth || 56;
        },

        /**
         * 获取所有列的宽度
         */
        getColumnWidth: function getColumnWidth() {
            if (this.isChangeWidth) {
                var zoom = Number(this.mock ? (this.layout ? this.layout.dayinzhizhangleixing : 'A4纸') === 'A4纸' ? '0.8' : '0.7' : 1);
                var list = document.querySelectorAll('.vxe-table .vxe-header--column');
                if (list && list.length > 0) {
                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(this.layout.body.items || [], function (o, i) {
                        var width = Math.floor(list[i].getBoundingClientRect().width / zoom);
                        if (width) {
                            o.width = width;
                        }
                        return o;
                    });
                }
            }
            return JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.layout.body.items));
        },
        resetWidth: function resetWidth() {
            this.drawColumns(((this.layout || {}).body || {}).items || []);
            this.isChangeWidth = false;
        },
        changeWidth: function changeWidth() {
            this.isChangeWidth = true;
            this.$forceUpdate();
        },
        changeColumns: function changeColumns() {
            this.drawColumns(((this.layout || {}).body || {}).items || []);
        },
        drawBarcode: function drawBarcode() {
            var value = '';
            if (this.mock) {
                value = 'test';
            } else {
                value = this.print.code || '';
            }
            var canvas = document.createElement("canvas");
            __WEBPACK_IMPORTED_MODULE_4_jsbarcode___default()(canvas, value, {
                format: "CODE128", //选择要使用的条形码类型
                margin: 0,
                height: 50, //高度
                displayValue: false //是否在条形码下方显示文字
            });
            return canvas.toDataURL('image/png');
        }
    },
    mounted: function mounted() {
        this.drawColumns(((this.layout || {}).body || {}).items || []);
        this.drawList(this.list || []);
        if (this.$store.session.jigou) {
            this.shopName = this.$store.session.jigou.name;
        }
    }
});

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = VueRouter;

/***/ }),

/***/ "3z2j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);



/**
 * @Author: ZhouQiang
 * @Date: 2023-03-22 10:05:10
 * @LastEditors: ZhouQiang
 * @LastEditTime: 2023-04-04 14:51:38
 * @description: description
**/
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      uploadConfig: null,
      uploadKey: '',
      imageUrl: '', //未截取前的图片
      cropperVisible: false, // 裁剪弹窗显示隐藏
      fileName: '', /**文件名称 */
      uploadIndex: 0,
      uploadFile: null, //图片截取后的文件
      loading: false
    };
  },

  methods: {
    /**上传图片错误 */
    handleFormatError: function handleFormatError() {
      this.$Message.error('请上传图片类型文件，支持jpg;jpeg;png;bmp格式');
    },

    /**上传图片进度 */
    imageProgress: function imageProgress(res, file) {
      if (!file) {
        return;
      }
      this.loading = true;
    },


    //base64转file
    dataURLtoFile: function dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(','),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },


    /**图片上传前钩子 */
    handleUploadIntercept: function handleUploadIntercept(file) {
      var _this = this;

      var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (file.type.indexOf('image') <= -1) {
        return;
      }
      this.uploadIndex = i;
      this.fileName = file.name;
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        _this.imageUrl = reader.result;
        _this.cropperVisible = true;
        if (_this.handleCroper) _this.handleCroper();
      };
      return false;
    },


    /**刷新上传配置
     * key: 上传字段，便于获取当前操作字段
    */
    refreshUploadToken: function refreshUploadToken() {
      var _this2 = this;

      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.uploadKey = key;
      this.loadUploadToken(function (token) {
        _this2.uploadConfig = {
          token: token
        };
      });
    },
    uploadRichTextImage: function uploadRichTextImage(html) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var list, base64Regex, token, newList, newHtmlString;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (html) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return', '');

              case 2:
                list = [];
                base64Regex = /src="data:image\/(png|jpg|jpeg|gif);base64,([^"]+)"/gi;

                html.replace(base64Regex, function (match) {
                  list.push(match.slice(5, -1));
                  return match;
                });
                _context.next = 7;
                return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
                  _this3.loadUploadToken(function (res) {
                    resolve(res);
                  });
                });

              case 7:
                token = _context.sent;
                _context.next = 10;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(list.map(function (v) {
                  return _this3.uploadBase64Image(v, token);
                }));

              case 10:
                newList = _context.sent;
                newHtmlString = html.replace(base64Regex, function (match) {
                  var index = list.indexOf(match.slice(5, -1));
                  return newList[index] ? 'src="' + newList[index] + '"' : match;
                });
                return _context.abrupt('return', newHtmlString);

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    uploadBase64Image: function uploadBase64Image(base64Url, token) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var file, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                file = _this4.dataURLtoFile(base64Url, Math.random().toString(32).slice(2) + '.png');
                _context2.next = 3;
                return _this4.$api.uploadFile(file, token);

              case 3:
                res = _context2.sent;

                if (!res.data.key) {
                  _context2.next = 8;
                  break;
                }

                return _context2.abrupt('return', '//igyl.weizhilian.com/' + res.data.key);

              case 8:
                return _context2.abrupt('return', '');

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    }
  }
});

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = ExcelJS;

/***/ }),

/***/ "48ci":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextList_vue__ = __webpack_require__("9eBS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63d97895_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_TextList_vue__ = __webpack_require__("a9CP");
function injectStyle (ssrContext) {
  __webpack_require__("EMOm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-63d97895"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63d97895_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_TextList_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4Cfx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_XiafaMendianView_vue__ = __webpack_require__("O30v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56458928_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_XiafaMendianView_vue__ = __webpack_require__("ypck");
function injectStyle (ssrContext) {
  __webpack_require__("JKNl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_XiafaMendianView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56458928_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_XiafaMendianView_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4Jp4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4rdx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        dateSearh: { //是否需要时间筛选
            type: Boolean,
            default: false
        },
        selectList: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        searhForm: {
            type: Object,
            default: function _default() {}
        },
        columnsSearch: { //搜索配置
            type: Array,
            default: function _default() {
                return [];
            }
        }
    },
    computed: {
        column: function column() {
            return this.columnsSearch;
        }
    },
    // watch: {
    //     columnsSearch: {
    //         handler(val) {
    //             this.column = this.copy(val)
    //         },
    //         immediate: true,
    //         deep: true,
    //     }
    // },
    data: function data() {
        return {
            inputing: {},
            editing: {},
            isDeleteButton: false
            // column: [],
        };
    },

    methods: {
        textBlur: function textBlur(item, index) {
            if (this.inputing[item.key] != item.value) {
                this.textChanged(item, index);
            }
        },
        textChanged: function textChanged(item, index) {
            item.value = this.inputing[item.key];
            this.columnsSearch[index].value = item.value;
            this.$set(this.editing, item.key, false);
            this.change(index, item.value);
        },
        textEdit: function textEdit(item) {
            var _this = this;

            this.$set(this.editing, item.key, true);
            setTimeout(function () {
                var input = _this.$refs['input:' + item.key][0];
                if (input) input.focus();
            }, 200);
        },
        textClear: function textClear(item, index) {
            var _this2 = this;

            item.value = '';
            this.inputing[item.key] = '';
            this.$set(this.editing, item.key, true);
            setTimeout(function () {
                var input = _this2.$refs['input:' + item.key][0];
                if (input) input.focus();
            }, 200);
            this.columnsSearch[index].value = item.value;
            this.change(index, item.value);
        },
        deleteButtonClick: function deleteButtonClick(index) {
            var _this3 = this;

            this.$nextTick(function () {
                _this3.column[index].value = [];
                _this3.isDeleteButton = false;
            });
        },
        selectChange: function selectChange(index, val) {
            var citem = this.column[index];
            var key = citem.key,
                field = citem.field;

            if (citem.multiple || citem.multi) {
                if (val && field) {
                    val = citem.options.filter(function (o) {
                        return val.some(function (s) {
                            return s == (o.value || o.name || o._id || o);
                        });
                    });
                    this.columnsSearch[index].value = val.map(function (o) {
                        return o[field];
                    });
                } else {
                    this.columnsSearch[index].value = val;
                }
            } else {
                if (val && field) {
                    val = citem.options.find(function (o) {
                        return val == (o.value || o.name || o._id || o);
                    });
                    val = val ? val[field] : null;
                }
            }
            this.$emit("change", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, key, val));
            if (citem.change) {
                citem.change({ key: key, field: field, val: val });
            }
        },
        searchChange: function searchChange(index, val, local) {
            var _column$index = this.column[index],
                key = _column$index.key,
                field = _column$index.field,
                options = _column$index.options;

            if (this.column[index].change) {
                this.column[index].change({ key: key, field: field, val: val });
            }
            var keywords = '';
            if (options.multiple || options.multi) {
                //此处为多选
                var list = [];
                if (val) {
                    if (key == 'chukuleixings' || key == 'tongjileixings' || key == 'leixings' || key == 'rukuleixings' || key == 'yuanyins') {
                        list = val.map(function (el) {
                            return el.name;
                        });
                    } else {
                        val.forEach(function (i) {
                            list.push({ _id: i._id, code: i.code });
                        });
                    }
                }
                this.$emit("change", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, key, list), local);
            } else {
                if (val && field) {
                    keywords = val[field];
                } else if (val && val.name) {
                    keywords = val.name;
                }
                this.$emit("change", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, key, keywords), local);
            }
        },
        change: function change(index) {
            var _column$index2 = this.column[index],
                key = _column$index2.key,
                value = _column$index2.value;

            this.$emit("change", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, key, value));
        },
        zhidingriqiChanged: function zhidingriqiChanged(index, val) {
            var key = this.column[index].key;

            this.$emit("change", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, key, val));
        }
    }
});

/***/ }),

/***/ "56hx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5LYF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SOCKET_PATH; });
var SOCKET_PATH = '//';

/***/ }),

/***/ "5aUe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5jv3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("AQqA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22a4b291_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("6B86");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22a4b291_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5wAk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "20px 0"
    }
  }, [_c('div', {
    staticClass: "jcsb",
    staticStyle: {
      "font-size": "20px",
      "padding": "0 20px"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.items
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "padding": "0 20px",
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "200px",
      "margin-right": "20px"
    },
    attrs: {
      "search": "",
      "size": "small",
      "placeholder": "搜索"
    },
    on: {
      "on-enter": _vm.keywordsChanged
    },
    model: {
      value: (_vm.query.keywords),
      callback: function($$v) {
        _vm.$set(_vm.query, "keywords", $$v)
      },
      expression: "query.keywords"
    }
  }), _vm._v(" "), _c('Page', {
    attrs: {
      "placement": "top",
      "page-size-opts": [10, 20, 50, 100, 200],
      "total": _vm.total,
      "current": _vm.page.current,
      "page-size": _vm.page.size,
      "show-sizer": "",
      "show-total": "",
      "size": "small"
    },
    on: {
      "on-change": _vm.pageChanged,
      "on-page-size-change": _vm.pageSizeChanged
    }
  })], 1)], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6B86":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.sum) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "calc(33vw - 100px)",
      "text-align": "center",
      "padding": "50px 0"
    }
  }, [_c('div', [_vm._v("收货金额合计（元）")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "20px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.session.permission.baobiaojiage ? _vm.AmountDecimal(_vm.sum['wupin.yishouhuojinehanshui'], 2) : '--'))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "calc(33vw - 100px)",
      "text-align": "center",
      "padding": "50px 0"
    }
  }, [_c('div', [_vm._v("退货金额合计（元）")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "20px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.session.permission.baobiaojiage ? _vm.AmountDecimal(_vm.sum['wupin.tuihuojinehanshui'], 2) : '--'))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "calc(33vw - 100px)",
      "text-align": "center",
      "padding": "50px 0"
    }
  }, [_c('div', [_vm._v("实收金额合计（元）")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "20px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.session.permission.baobiaojiage ? _vm.AmountDecimal(_vm.sum['wupin.yishouhuojinehanshui'] - _vm.sum['wupin.tuihuojinehanshui'], 2) : '--'))])])]) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7yAi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("f+Sb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf9c4526_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("e+zK");
function injectStyle (ssrContext) {
  __webpack_require__("VL7Z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bf9c4526"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf9c4526_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8OJP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "wrapper",
    staticClass: "custom-input-bor",
    class: ((_vm.isEdit ? 'active' : '') + " " + (_vm.error?'error':'')),
    style: (("width: " + _vm.width + "px; height: " + _vm.height + "px; border: " + _vm.border + ";"))
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    ref: "input",
    staticClass: "custom-input",
    attrs: {
      "disabled": _vm.disabled,
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.inputValue)
    },
    on: {
      "focus": _vm.onFocus,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.inputValue = $event.target.value
      }, _vm.onInput],
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onEnter($event)
      },
      "blur": _vm.onBlur
    }
  }), _vm._v(" "), (_vm.unit) ? _c('span', {
    staticClass: "unit"
  }, [_vm._v(_vm._s(_vm.unit))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "unit"
  }, [_vm._t("icon")], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8cYE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BaseFormTitle',
  props: {
    title: {
      type: String,
      default: ''
    }
  }
});

/***/ }),

/***/ "8muv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8rhJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShengchanmobanSelector_vue__ = __webpack_require__("DafF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4664d90a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ShengchanmobanSelector_vue__ = __webpack_require__("Z7KV");
function injectStyle (ssrContext) {
  __webpack_require__("8muv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4664d90a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShengchanmobanSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4664d90a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ShengchanmobanSelector_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9bjM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Form', {
    ref: "form",
    staticClass: "mt-20",
    attrs: {
      "model": _vm.form,
      "inline": _vm.inline,
      "rules": _vm.rules,
      "label-position": _vm.labelPosition,
      "label-width": _vm.labelWidth
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return (function () {})($event)
      }
    }
  }, [_vm._l((_vm.formItem), function(item) {
    return _c('FormItem', {
      key: item.prop,
      attrs: {
        "prop": item.prop,
        "required": item.required,
        "label": item.label + ':'
      }
    }, [(item.labelSlot) ? _c('label', {
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_vm._v("\n       " + _vm._s(item.label) + "：\n       "), _c('BaseTooltip', {
      attrs: {
        "placement": "top",
        "content": item.tip
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.type === 'select') ? [_c('Select', {
      staticClass: "form-item",
      on: {
        "on-change": function($event) {
          return _vm.change($event, item.prop)
        }
      },
      model: {
        value: (_vm.form[item.prop]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.prop, $$v)
        },
        expression: "form[item.prop]"
      }
    }, _vm._l((_vm.formExtraConfig[item.configKey]), function(config) {
      return _c('Option', {
        key: config.id,
        attrs: {
          "value": config.id
        }
      }, [_vm._v(_vm._s(config.label))])
    }), 1)] : (item.type === 'input') ? [_c('Input', {
      staticClass: "form-item",
      attrs: {
        "placeholder": item.placeholder,
        "icon": item.enterSearch ? 'ios-search' : '',
        "maxlength": item.maxLength
      },
      on: {
        "on-click": function($event) {
          return _vm.inputEnterSearch(_vm.form[item.prop], item.prop, item.enterSearch)
        },
        "on-enter": function($event) {
          return _vm.inputEnterSearch(_vm.form[item.prop], item.prop, item.enterSearch)
        },
        "on-blur": function($event) {
          return _vm.change($event, item.prop)
        }
      },
      model: {
        value: (_vm.form[item.prop]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.prop, $$v)
        },
        expression: "form[item.prop]"
      }
    }), _vm._v(" "), (item.desc) ? _c('span', [_vm._v(_vm._s(item.desc))]) : _vm._e()] : (item.type === 'textarea') ? [_c('Input', {
      staticClass: "form-item",
      attrs: {
        "placeholder": item.placeholder,
        "type": "textarea",
        "maxlength": item.maxLength,
        "show-word-limit": ""
      },
      on: {
        "on-blur": function($event) {
          return _vm.change($event, item.prop)
        }
      },
      model: {
        value: (_vm.form[item.prop]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.prop, $$v)
        },
        expression: "form[item.prop]"
      }
    }), _vm._v(" "), (item.desc) ? _c('span', [_vm._v(_vm._s(item.desc))]) : _vm._e()] : (item.type === 'radio') ? [_c('RadioGroup', {
      on: {
        "on-change": function($event) {
          return _vm.change($event, item.prop)
        }
      },
      model: {
        value: (_vm.form[item.prop]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.prop, $$v)
        },
        expression: "form[item.prop]"
      }
    }, _vm._l((_vm.formExtraConfig[item.configKey]), function(config) {
      return _c('Radio', {
        key: config.id,
        attrs: {
          "label": config.id,
          "disabled": config.disabled
        }
      }, [_vm._v("\n             " + _vm._s(config.label) + "\n           ")])
    }), 1)] : (item.type === 'checkbox') ? [_c('CheckboxGroup', {
      on: {
        "on-change": function($event) {
          return _vm.change($event, item.prop)
        }
      },
      model: {
        value: (_vm.form[item.prop]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.prop, $$v)
        },
        expression: "form[item.prop]"
      }
    }, _vm._l((_vm.formExtraConfig[item.configKey]), function(config) {
      return _c('Checkbox', {
        key: config.id,
        attrs: {
          "disabled": config.disabled,
          "label": config.id
        }
      }, [_vm._v(_vm._s(config.label))])
    }), 1)] : (item.type === 'upload') ? _c('div', [_c('Upload', {
      ref: "upload",
      refInFor: true,
      attrs: {
        "max-size": item.uploadSize,
        "format": ['jpg', 'jpeg', 'png', 'bmp'],
        "on-format-error": _vm.handleFormatError,
        "data": _vm.uploadConfig,
        "show-upload-list": false,
        "on-success": _vm.uploadSuccess,
        "on-exceeded-size": function (v) {
          _vm.checkImageSize(v, item.uploadSize)
        },
        "on-progress": _vm.imageProgress,
        "action": "//upload.qiniup.com/"
      }
    }, [(!_vm.form[item.prop]) ? _c('div', {
      staticClass: "upload-wrap flex flex-center align-center cur-p",
      on: {
        "click": function($event) {
          return _vm.refreshUploadToken(item.prop)
        }
      }
    }, [_c('Icon', {
      attrs: {
        "type": "ios-add",
        "size": "24"
      }
    })], 1) : _c('img', {
      staticClass: "upload-wrap upload-img",
      attrs: {
        "src": _vm.form[item.prop]
      },
      on: {
        "click": function($event) {
          return _vm.refreshUploadToken(item.prop)
        }
      }
    })]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.desc))]), _vm._v(" "), (_vm.form[item.prop] && item.isDelete) ? _c('div', {
      staticStyle: {
        "cursor": "pointer",
        "color": "#20bf64"
      },
      on: {
        "click": function($event) {
          return _vm.deleteImage(item.prop)
        }
      }
    }, [_vm._v("删除图片")]) : _vm._e()], 1) : (item.type === 'switch') ? [_c('i-switch', {
      on: {
        "on-change": function($event) {
          return _vm.change($event, item.prop)
        }
      },
      model: {
        value: (_vm.form[item.prop]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.prop, $$v)
        },
        expression: "form[item.prop]"
      }
    })] : _c('div', [_vm._v(_vm._s(_vm.form[item.prop]))]), _vm._v(" "), _vm._t(item.prop)], 2)
  }), _vm._v(" "), (_vm.showButton) ? _c('div', {
    staticClass: "footer-spl"
  }) : _vm._e(), _vm._v(" "), (_vm.showButton) ? _c('FormItem', {
    staticClass: "footer flex",
    class: _vm.btnAlign === 'right' ? ' flex-end' : ''
  }, [_c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(_vm._s(_vm.cancelText))]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSave
    }
  }, [_vm._v(_vm._s(_vm.confirmText))])], 1) : _vm._e()], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9eBS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        options: {
            type: Object,
            default: {}
        },
        current: {
            type: Array,
            default: []
        }
    },
    data: function data() {
        return {
            loading: false,
            form: { value: '' },
            editIndex: -1
        };
    },
    mounted: function mounted() {},

    methods: {
        addItem: function addItem() {
            if (!this.form.value) return;
            this.current.push(this.form.value);
            this.form.value = '';
        },
        removeItem: function removeItem(index) {
            this.current.splice(index, 1);
            this.editIndex = -1;
        },
        toEdit: function toEdit(index) {
            var _this = this;

            this.editIndex = index;
            setTimeout(function () {
                _this.$refs['input_' + index][0].focus({ cursor: 'all' });
            }, 100);
        },
        saveItem: function saveItem(item, index) {
            if (item === '') {
                this.removeItem(index);
            }
            this.editIndex = -1;
        }
    }
});

/***/ }),

/***/ "9jHG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "opacity": "0",
      "position": "fixed",
      "left": "9999px",
      "top": "0",
      "zIndex": "-9999"
    }
  }, _vm._l((_vm.finalPrints), function(print, index) {
    return _c('div', {
      key: index
    }, [(print[_vm.listKey].length > _vm.rows) ? _c('div', _vm._l((_vm.getPages(print[_vm.listKey])), function(p, idx) {
      return _c('div', {
        key: idx
      }, [_c('print-form', {
        staticClass: "print-form",
        attrs: {
          "identify": _vm.identify,
          "layout": _vm.layout,
          "print": print,
          "list": p,
          "pages": _vm.getPages(print[_vm.listKey]).length || 1,
          "page": idx + 1,
          "mock": false
        }
      })], 1)
    }), 0) : _c('div', [_c('print-form', {
      staticClass: "print-form",
      attrs: {
        "identify": _vm.identify,
        "layout": _vm.layout,
        "print": print,
        "list": print[_vm.listKey],
        "pages": 1,
        "page": 1,
        "mock": false
      }
    })], 1)])
  }), 0)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9neA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_validator__ = __webpack_require__("w3CS");
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        // 单位
        unit: {
            type: String,
            default: null
        },
        width: {
            type: Number,
            default: 65
        },
        height: {
            type: Number,
            default: 31
        },
        // 小数位数 6/2/2
        fix: {
            type: Number,
            default: 6
        },
        // 输入框类型 decimal(小数)/int(整数)/text(字符串)negInt(允许负数整数) negDecimal(允许负数小数)
        type: {
            type: String,
            default: 'decimal'
        },
        value: {
            type: [String, Number],
            default: ''
        },
        placeholder: {
            type: String,
            default: '请输入'
        },
        max: {
            type: Number,
            default: null
        },
        min: {
            type: Number,
            default: null
        },
        step: {
            type: Number,
            default: null
        },
        /**是否禁用 */
        disabled: {
            type: Boolean,
            default: false
        },
        /**是否支持enter抛出数据 */
        enter: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        },
        border: {
            type: String,
            default: '1px solid #e7e7e7'
        }
    },
    watch: {
        'value': function value(v) {
            if (this.fix && (this.type === 'decimal' || this.type === 'negDecimal')) {
                this.inputValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_validator__["a" /* inputValidFloat */])('' + v, this.fix, this.type === 'decimal');
            } else {
                this.inputValue = v;
            }
        }
    },
    mounted: function mounted() {
        if (this.fix && (this.type === 'decimal' || this.type === 'negDecimal')) {
            this.inputValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_validator__["a" /* inputValidFloat */])('' + this.value, this.fix, this.type === 'decimal');
        } else {
            this.inputValue = this.value;
        }
    },
    data: function data() {
        return {
            isEdit: false,
            inputValue: '',
            lastInputTime: 0,
            quickcount: 0,
            stash: null,
            stashTask: null,
            error: null
        };
    },

    methods: {
        onFocus: function onFocus() {
            this.isEdit = true;
            this.lastInputTime = 0;
            this.quickcount = 0;
            this.stash = this.inputValue;
        },

        // 处理输入
        onInput: function onInput(e) {
            var _this = this;

            if (this.stashTask) {
                clearTimeout(this.stashTask);
                this.stashTask = null;
            }
            var fromScan = false;
            var inputTime = new Date().getTime();
            if (inputTime - this.lastInputTime < 30) {
                this.quickcount++;
                if (this.quickcount > 5 && e.inputType == 'insertText') {
                    //连续5次快速输入，可能为扫码枪
                    fromScan = true;
                }
            }
            this.lastInputTime = inputTime;
            if (fromScan) {
                this.inputValue = this.stash;
            }
            this.stashTask = setTimeout(function () {
                _this.stash = _this.value;
            }, 300);

            if (this.type === 'text') {
                this.$emit('input', this.inputValue);
                return;
            }

            var before = this.stash;

            // 输入小数且限制小数位数
            if (this.fix >= 0 && (this.type === 'decimal' || this.type === 'negDecimal')) {
                this.inputValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_validator__["a" /* inputValidFloat */])(this.inputValue, this.fix, this.type === 'decimal');
            }
            // 只能输入正整数
            if (this.type === 'int') {
                this.inputValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_validator__["k" /* inputValidInt */])(this.inputValue);
            }
            if (this.type === 'negInt') {
                this.inputValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_validator__["m" /* inputValidNegInt */])(this.inputValue);
            }
            if (this.max !== undefined && this.max !== null && Number(this.inputValue) > this.max) {
                this.inputValue = this.max;
            }
            if (this.min !== undefined && this.min !== null && String(this.min).length <= String(this.inputValue).length && Number(this.inputValue) < this.min) {
                this.inputValue = this.min;
            }
            if (this.step && Number(this.inputValue) % this.step > 0) {
                this.inputValue = this.inputValue - Number(this.inputValue) % this.step;
            }

            var after = this.inputValue;

            // this.inputValue = Number(this.inputValue)
            this.triggerEvent(before, after);
        },


        /**enter */
        onEnter: function onEnter(e) {
            if (this.enter) {
                this.$emit('enter');
            }
            var currentInput = e.target; // 当前输入框
            var nextInput = getNextInput(currentInput); // 下一个输入框
            if (nextInput) {
                nextInput.focus();
                nextInput.select();
                // e.preventDefault();
            }
        },
        onBlur: function onBlur() {
            if (this.type !== 'text') {
                if (isNaN(Number(this.inputValue))) {
                    this.inputValue = 0;
                }
                this.inputValue = this.inputValue !== '' ? Number(this.inputValue) : '';
            }
            this.isEdit = false;

            if (this.required && (this.inputValue === '' || this.inputValue == 0 || this.inputValue === null)) {
                this.error = true;
            } else {
                this.error = false;
            }
        },


        // 数据抛出
        triggerEvent: function triggerEvent(before, after) {
            if (isNaN(Number(this.inputValue))) {
                return;
            }
            this.$emit('input', this.inputValue !== '' ? Number(this.inputValue) : 0);

            //如果当前值和输入前没变化，不触发
            if (before === '' || before === null || before === undefined) before = 0;
            if (after === '' || after === null || after === undefined) after = 0;
            if (before == after) {
                return;
            }
            if (this.inputValue === '' && this.value === 0) {
                //在输入框长按删除的情况
                return;
            }

            //如果末位是小数点，不触发
            if (after.toString().endsWith('.')) {
                return;
            }

            this.$emit('change', this.inputValue !== '' ? Number(this.inputValue) : 0);
        },


        /**自动获取焦点 */
        setFocus: function setFocus() {
            this.$refs.input.focus();
        }
    }
});

function getNextInput(currentInput) {
    // 获取下一个输入框（循环指定数量的输入框）
    var allInputs = document.getElementsByClassName('custom-input');
    var currentIndex = Array.prototype.indexOf.call(allInputs, currentInput);
    for (var i = 1; i <= allInputs.length; i++) {
        var nextIndex = (currentIndex + i) % allInputs.length;
        var nextInput = allInputs[nextIndex];
        if (nextInput !== currentInput && !nextInput.disabled && !nextInput.readOnly) {
            return nextInput;
        }
    }
}

/***/ }),

/***/ "ANfu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddressInput_vue__ = __webpack_require__("htLF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e21dae0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_AddressInput_vue__ = __webpack_require__("apBt");
function injectStyle (ssrContext) {
  __webpack_require__("kCMK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3e21dae0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddressInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e21dae0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_AddressInput_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AOEg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AQqA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_price__ = __webpack_require__("rlYW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        sum: Object
    },
    data: function data() {
        return {
            AmountDecimal: __WEBPACK_IMPORTED_MODULE_0__utils_price__["a" /* AmountDecimal */],
            session: this.$store.session
        };
    }
});

/***/ }),

/***/ "BKnb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createStyle */
/* unused harmony export createLinkStyle */
/* unused harmony export createIFrame */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Printd; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);




var URL_LONG = /^(((http[s]?)|file):)?(\/\/)+([0-9a-zA-Z-_.=?&].+)$/;
var URL_SHORT = /^((\.|\.\.)?\/)([0-9a-zA-Z-_.=?&]+\/)*([0-9a-zA-Z-_.=?&]+)$/;
var isValidURL = function isValidURL(str) {
  return URL_LONG.test(str) || URL_SHORT.test(str);
};
function createStyle(doc, cssText) {
  var style = doc.createElement("style");
  style.type = "text/css";
  style.appendChild(window.document.createTextNode(cssText));
  return style;
}
function createLinkStyle(doc, url) {
  var style = doc.createElement("link");
  style.type = "text/css";
  style.rel = "stylesheet";
  style.href = url;
  return style;
}
function createIFrame(parent) {
  var el = window.document.createElement("iframe");
  el.setAttribute("src", "about:blank");
  el.setAttribute("style", "visibility:hidden;width:0;height:0;position:absolute;z-index:-9999;bottom:0;");
  el.setAttribute("width", "0");
  el.setAttribute("height", "0");
  el.setAttribute("wmode", "opaque");
  parent.appendChild(el);
  return el;
}
var DEFAULT_OPTIONS = {
  parent: window.document.body,
  headElements: [],
  bodyElements: []
};
/** Printd class that prints HTML elements in a blank document */

var Printd = function () {
  function Printd(options) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Printd);

    this.isLoading = false;
    this.hasEvents = false;
    // IE 11+ "Object.assign" polyfill
    this.opts = [DEFAULT_OPTIONS, options || {}].reduce(function (a, b) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(b).forEach(function (k) {
        return a[k] = b[k];
      });
      return a;
    }, {});
    this.iframe = createIFrame(this.opts.parent);
  }
  /** Gets current Iframe reference */


  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Printd, [{
    key: "getIFrame",
    value: function getIFrame() {
      return this.iframe;
    }
  }, {
    key: "prints",
    value: function prints(els, styles, scripts, callback) {
      if (this.isLoading) return;
      var _iframe = this.iframe,
          contentDocument = _iframe.contentDocument,
          contentWindow = _iframe.contentWindow;

      if (!contentDocument || !contentWindow) return;
      this.iframe.src = "about:blank";
      // this.elCopy = el.cloneNode(true);
      this.elCopy = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(els)).reduce(function (acc, cur) {
        return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(acc), [cur.cloneNode(true)]);
      }, []);
      if (!this.elCopy) return;
      this.isLoading = true;
      this.callback = callback;
      var doc = contentWindow.document;
      doc.open();
      doc.write('<!DOCTYPE html><html><head><meta charset="utf-8"></head><body style="padding: 0; margin: 0;"></body></html>');
      this.addEvents();
      // 1. append custom elements
      var _opts = this.opts,
          headElements = _opts.headElements,
          bodyElements = _opts.bodyElements;
      // 1.1 append custom head elements

      if (Array.isArray(headElements)) {
        headElements.forEach(function (e) {
          return doc.head.appendChild(e);
        });
      }
      // 1.1 append custom body elements
      if (Array.isArray(bodyElements)) {
        bodyElements.forEach(function (e) {
          return doc.body.appendChild(e);
        });
      }
      // 2. append custom styles
      if (Array.isArray(styles)) {
        styles.forEach(function (value) {
          if (value) {
            doc.head.appendChild(isValidURL(value) ? createLinkStyle(doc, value) : createStyle(doc, value));
          }
        });
      }
      // 3. append element copy
      // doc.body.appendChild(this.elCopy);
      this.elCopy.map(function (e) {
        doc.body.appendChild(e);
      });
      // 4. append custom scripts
      if (Array.isArray(scripts)) {
        scripts.forEach(function (value) {
          if (value) {
            var script = doc.createElement("script");
            if (isValidURL(value)) {
              script.src = value;
            } else {
              script.innerText = value;
            }
            doc.body.appendChild(script);
          }
        });
      }
      doc.close();
    }

    /**
     * Print an HTMLElement
     *
     * @param el HTMLElement
     * @param styles Optional styles (css texts or urls) that will add to iframe document.head
     * @param scripts Optional scripts (script texts or urls) that will add to iframe document.body
     * @param callback Optional callback that will be triggered when content is ready to print
     */

  }, {
    key: "print",
    value: function print(el, styles, scripts, callback) {
      if (this.isLoading) return;
      var _iframe2 = this.iframe,
          contentDocument = _iframe2.contentDocument,
          contentWindow = _iframe2.contentWindow;

      if (!contentDocument || !contentWindow) return;
      this.iframe.src = "about:blank";
      this.elCopy = el.cloneNode(true);
      if (!this.elCopy) return;
      this.isLoading = true;
      this.callback = callback;
      var doc = contentWindow.document;
      doc.open();
      doc.write('<!DOCTYPE html><html><head><meta charset="utf-8"></head><body></body></html>');
      this.addEvents();
      // 1. append custom elements
      var _opts2 = this.opts,
          headElements = _opts2.headElements,
          bodyElements = _opts2.bodyElements;
      // 1.1 append custom head elements

      if (Array.isArray(headElements)) {
        headElements.forEach(function (e) {
          return doc.head.appendChild(e);
        });
      }
      // 1.1 append custom body elements
      if (Array.isArray(bodyElements)) {
        bodyElements.forEach(function (e) {
          return doc.body.appendChild(e);
        });
      }
      // 2. append custom styles
      if (Array.isArray(styles)) {
        styles.forEach(function (value) {
          if (value) {
            doc.head.appendChild(isValidURL(value) ? createLinkStyle(doc, value) : createStyle(doc, value));
          }
        });
      }
      // 3. append element copy
      doc.body.appendChild(this.elCopy);
      // 4. append custom scripts
      if (Array.isArray(scripts)) {
        scripts.forEach(function (value) {
          if (value) {
            var script = doc.createElement("script");
            if (isValidURL(value)) {
              script.src = value;
            } else {
              script.innerText = value;
            }
            doc.body.appendChild(script);
          }
        });
      }
      doc.close();
    }
    /**
     * Print an URL
     *
     * @param url URL to print
     * @param callback Optional callback that will be triggered when content is ready to print
     */

  }, {
    key: "printURL",
    value: function printURL(url, callback) {
      if (this.isLoading) return;
      this.addEvents();
      this.isLoading = true;
      this.callback = callback;
      this.iframe.src = url;
    }
  }, {
    key: "launchPrint",
    value: function launchPrint(contentWindow) {
      var result = contentWindow.document.execCommand("print", false, undefined);
      if (!result) {
        contentWindow.print();
      }
    }
  }, {
    key: "addEvents",
    value: function addEvents() {
      var _this = this;

      if (!this.hasEvents) {
        this.hasEvents = true;
        this.iframe.addEventListener("load", function () {
          return _this.onLoad();
        }, false);
      }
    }
  }, {
    key: "onLoad",
    value: function onLoad() {
      var _this2 = this;

      if (this.iframe) {
        this.isLoading = false;
        var _iframe3 = this.iframe,
            contentDocument = _iframe3.contentDocument,
            contentWindow = _iframe3.contentWindow;

        if (!contentDocument || !contentWindow) return;
        if (this.callback) {
          this.callback({
            iframe: this.iframe,
            element: this.elCopy,
            launchPrint: function launchPrint() {
              return _this2.launchPrint(contentWindow);
            }
          });
        } else {
          this.launchPrint(contentWindow);
        }
      }
    }
  }], [{
    key: "getInstance",
    value: function getInstance() {
      if (!Printd.instance) {
        Printd.instance = new Printd();
      }
      return Printd.instance;
    }
  }]);

  return Printd;
}();

/* unused harmony default export */ var _unused_webpack_default_export = (Printd);



/***/ }),

/***/ "Bjk0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        item: {
            type: Object,
            default: {}
        }
    },
    data: function data() {
        return {};
    }
});

/***/ }),

/***/ "Bvx/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.editable) ? _c('div', [(_vm.multi) ? _c('div', [_c('Upload', {
    ref: "uploader",
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "data": _vm.uploadConfig,
      "accept": _vm.accept,
      "max-size": _vm.maxsize,
      "show-upload-list": false,
      "before-upload": _vm.beforeUpload,
      "on-success": _vm.imageUploadSuccess,
      "on-progress": _vm.imageProgress,
      "multiple": "",
      "action": "//upload.qiniup.com/"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap"
    }
  }, [_vm._l((_vm.result), function(image, index) {
    return _c('div', {
      key: index
    }, [_c('Poptip', {
      attrs: {
        "trigger": "hover",
        "transfer": ""
      }
    }, [_c('div', {
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, [_c('a', {
      staticClass: "hoverbtn",
      staticStyle: {
        "margin-right": "16px",
        "color": "tomato"
      },
      on: {
        "click": function($event) {
          return _vm.toView(index)
        }
      }
    }, [_vm._v("查看")]), _vm._v(" "), _c('a', {
      staticClass: "hoverbtn",
      staticStyle: {
        "margin-right": "16px",
        "color": "tomato"
      },
      on: {
        "click": function($event) {
          return _vm.moveUp(index)
        }
      }
    }, [_vm._v("前移")]), _vm._v(" "), _c('a', {
      staticClass: "hoverbtn",
      staticStyle: {
        "margin-right": "16px",
        "color": "tomato"
      },
      on: {
        "click": function($event) {
          return _vm.moveDown(index)
        }
      }
    }, [_vm._v("后移")]), _vm._v(" "), _c('a', {
      staticClass: "hoverbtn",
      staticStyle: {
        "color": "tomato"
      },
      on: {
        "click": function($event) {
          return _vm.removeItem(index)
        }
      }
    }, [_vm._v("删除")])]), _vm._v(" "), (_vm.type == 'image') ? _c('img', {
      staticClass: "hover image",
      staticStyle: {
        "width": "32px",
        "height": "32px",
        "border-radius": "4px",
        "display": "block"
      },
      attrs: {
        "src": image.url + '?imageView2/1/w/100/h/100'
      },
      on: {
        "click": function($event) {
          return _vm.toUpload(index)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.type == 'video') ? _c('img', {
      staticClass: "hover image",
      staticStyle: {
        "width": "32px",
        "height": "32px",
        "border-radius": "4px",
        "display": "block"
      },
      attrs: {
        "src": image.url + '?vframe/jpg/offset/1'
      },
      on: {
        "click": function($event) {
          return _vm.toUpload(index)
        }
      }
    }) : _vm._e()])], 1)
  }), _vm._v(" "), (!_vm.max || _vm.result.length < _vm.max) ? _c('Button', {
    staticClass: "image",
    staticStyle: {
      "height": "32px",
      "width": "32px",
      "border-radius": "4px",
      "border": "1px dashed #ddd",
      "color": "#20bf64",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center",
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "dashed"
    },
    on: {
      "click": function($event) {
        return _vm.toUpload()
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-add",
      "size": "32"
    }
  })], 1) : _vm._e()], 2)])], 1) : _c('div', [_c('Upload', {
    ref: "uploader",
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "data": _vm.uploadConfig,
      "accept": _vm.accept,
      "max-size": _vm.maxsize,
      "show-upload-list": false,
      "on-success": _vm.imageUploadSuccess,
      "on-progress": _vm.imageProgress,
      "multiple": "",
      "action": "//upload.qiniup.com/"
    }
  }, [(_vm.result) ? _c('div', [_c('Poptip', {
    attrs: {
      "trigger": "hover",
      "transfer": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('a', {
    staticClass: "hoverbtn",
    staticStyle: {
      "color": "tomato"
    },
    on: {
      "click": _vm.removeItem
    }
  }, [_vm._v("删除")])]), _vm._v(" "), (_vm.type == 'image') ? _c('img', {
    staticClass: "hover",
    staticStyle: {
      "width": "32px",
      "height": "32px",
      "display": "block",
      "border-radius": "4px"
    },
    attrs: {
      "src": _vm.result.url + '?imageView2/1/w/100/h/100'
    },
    on: {
      "click": function($event) {
        return _vm.toUpload()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'video') ? _c('img', {
    staticClass: "hover",
    staticStyle: {
      "width": "32px",
      "height": "32px",
      "display": "block",
      "border-radius": "4px"
    },
    attrs: {
      "src": _vm.result.url + '?vframe/jpg/offset/1'
    },
    on: {
      "click": function($event) {
        return _vm.toUpload()
      }
    }
  }) : _vm._e()])], 1) : _c('Button', {
    staticStyle: {
      "height": "32px",
      "width": "32px",
      "border-radius": "4px",
      "border": "1px dashed #ddd",
      "color": "#20bf64",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    },
    attrs: {
      "type": "dashed"
    },
    on: {
      "click": function($event) {
        return _vm.toUpload()
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-add",
      "size": "32"
    }
  })], 1)], 1)], 1)]) : _c('div', [(_vm.multi) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap"
    }
  }, _vm._l((_vm.result), function(image, index) {
    return _c('img', {
      key: index,
      staticClass: "image",
      staticStyle: {
        "width": "32px",
        "height": "32px",
        "border-radius": "4px",
        "display": "block"
      },
      attrs: {
        "src": image.url + '?imageView2/1/w/100/h/100'
      },
      on: {
        "click": function($event) {
          return _vm.openImage(image.url)
        }
      }
    })
  }), 0) : _c('div', [(_vm.result.type == 'image') ? _c('img', {
    staticStyle: {
      "width": "32px",
      "height": "32px",
      "display": "block",
      "border-radius": "4px"
    },
    attrs: {
      "src": _vm.result ? (_vm.result.url + '?imageView2/1/w/100/h/100') : ''
    },
    on: {
      "click": function($event) {
        return _vm.openImage(_vm.result ? _vm.result.url : '')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.result.type == 'video') ? _c('img', {
    staticStyle: {
      "width": "32px",
      "height": "32px",
      "display": "block",
      "border-radius": "4px"
    },
    attrs: {
      "src": _vm.result ? (_vm.result.url + '?vframe/jpg/offset/1') : ''
    },
    on: {
      "click": function($event) {
        return _vm.openImage(_vm.result ? _vm.result.url : '')
      }
    }
  }) : _vm._e()])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DEdE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Uploader_vue__ = __webpack_require__("irjp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44de5bd0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Uploader_vue__ = __webpack_require__("Bvx/");
function injectStyle (ssrContext) {
  __webpack_require__("VEJa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-44de5bd0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Uploader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44de5bd0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Uploader_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DafF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        current: Array,
        jigou: Object
    },
    data: function data() {
        var _this = this;

        return {
            loading: false,
            query: {
                keywords: '',
                init: true
            },
            usedKeywords: '',
            page: {
                current: 1,
                size: 5
            },
            total: 0,
            shengchanmobans: [],
            columns1: [{
                title: '模板编号',
                key: 'code',
                minWidth: 180
            }, {
                title: '模板名称',
                minWidth: 100,
                render: function render(h, params) {
                    return h('div', params.row.name);
                }
            }, {
                title: '操作',
                width: 180,
                align: 'center',
                fixed: 'right',
                render: function render(h, params) {
                    var that = _this;
                    var item = params.row;
                    var ops = [];
                    var op1 = h('div', {
                        class: 'hover',
                        style: {
                            color: '#20bf64'
                        },
                        on: {
                            'click': function click(e) {
                                that.selection = item;
                                that.$emit('shengchanmobanSelected', that.selection);
                                e.stopPropagation();
                            }
                        }
                    }, '确定');
                    ops.push(op1);
                    return h('div', { class: 'center' }, ops);
                }
            }],
            yaohuojigous: []
        };
    },
    mounted: function mounted() {
        this.loadData();
    },

    methods: {
        clearKeywords: function clearKeywords() {
            this.query.keywords = '';
            this.usedKeywords = '';
            this.loadData();
        },
        keywordsChanged: function keywordsChanged() {
            this.usedKeywords = this.query.keywords;
            this.page.current = 1;
            this.loadData();
        },
        pageChanged: function pageChanged(value) {
            this.page.current = value;
            this.loadData();
        },
        loadData: function loadData() {
            var that = this;
            that.loading = true;
            that.$api.post('/web/main/shengchanmobanselector/load', {
                jigouId: this.jigou ? this.jigou._id : null,
                query: this.query,
                page: this.page,
                fields: {
                    _id: 1,
                    code: 1,
                    name: 1,
                    'jiagongpins.wupin._id': 1,
                    'jiagongpins.wupin.name': 1,
                    'jiagongpins.wupin.code': 1
                }
            }).then(function (res) {
                that.loading = false;
                if (that.query.init) {
                    that.query.init = false;
                    // that.shouhuojigous = res.data.shouhuojigous
                }
                that.total = res.data.total;
                that.usedKeywords = that.query.keywords;
                var shengchanmobans = res.data.shengchanmobans;
                // for (let shengchanmoban of shengchanmobans) {}
                that.shengchanmobans = shengchanmobans;
            }, function () {
                that.loading = false;
            });
        },
        search: function search() {
            this.loadData();
        },
        cancel: function cancel() {
            this.$emit('cancel');
        }
    }
});

/***/ }),

/***/ "Dcjb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__ = __webpack_require__("MICi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_web_xtsz_dymbsz_mblb_PrintForm_vue__ = __webpack_require__("y33K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__printer_js__ = __webpack_require__("BKnb");








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import html2canvas from 'html2canvas';
// import printjs from 'print-js';


/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        // 打印模板布局
        layout: {
            type: Object,
            default: function _default() {
                return {};
            }
        },
        // 打印多条数据
        prints: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        // 单条数据列表key(比如wupins)
        listKey: {
            type: String,
            default: ''
        },
        // 标识(区分同一页面不同Printer)
        // 比如同一页面不同tab页下的Printer
        identify: {
            type: String,
            default: ''
        },
        sortStr: {
            type: String,
            default: ''
        }
    },
    components: {
        PrintForm: __WEBPACK_IMPORTED_MODULE_8__components_web_xtsz_dymbsz_mblb_PrintForm_vue__["a" /* default */]
    },
    data: function data() {
        return {
            printer: null,
            cssText: '\n                .printer * {\n                    font-family: "Microsoft YaHei", Arial, sans-serif !important;\n                    -webkit-font-smoothing: antialiased !important;\n                    -webkit-text-size-adjust: 100%;\n                    text-size-adjust: 100%;\n                    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n                    font-variant: tabular-nums;\n                    color: #000 !important;\n                    -webkit-font-feature-settings: \'tnum\', "tnum";\n                    font-feature-settings: \'tnum\', "tnum";\n                }\n                .print-ellipsis {\n                    white-space: nowrap;\n                    overflow: hidden;\n                    text-overflow: ellipsis;\n                }\n                .print-addr {\n                    height: 2.5em !important;\n                    line-height: 1.25em !important;\n                    overflow: hidden;\n                    text-overflow: ellipsis;\n                    display: -webkit-box;\n                    -webkit-line-clamp: 2;\n                    line-clamp: 2;\n                    -webkit-box-orient: vertical;\n                    white-space: inherit;\n                }\n                .vxe-table .vxe-table--body-wrapper {\n                    overflow: hidden !important;\n                }\n                .vxe-table .vxe-header--column .vxe-resizable {\n                    opacity: 0 !important;\n                }\n                .vxe-table .vxe-header--column,\n                .vxe-table .vxe-body--column {\n                    color: #000 !important;\n                    padding: 0 !important;\n                    border: none;\n                    box-sizing: border-box;\n                    text-align: center !important;\n                    border-right: 1px solid #000 !important;\n                    border-top: 1px solid #000 !important;\n                }\n                .vxe-table .vxe-header--column {\n                    border-top: 1px solid #000 !important;\n                }\n                .vxe-table .vxe-header--column:last-child,\n                .vxe-table .vxe-body--column:last-child {\n                    border-right: 1px solid #000 !important;\n                }\n                .vxe-table .vxe-cell {\n                    padding: 0;\n                    overflow: hidden !important;\n                    text-align: center !important;\n                    white-space: nowrap !important;\n                    box-sizing: border-box;\n                }\n                .table-thin .vxe-table .vxe-header--column,\n                .table-thin .vxe-table .vxe-body--column,\n                .table-thin .vxe-table .vxe-cell {\n                    height: 4.5mm !important;\n                    line-height: 4.5mm !important;\n                }\n                .vxe-table .vxe-header--column:first-child,\n                .vxe-table .vxe-body--column:first-child{\n                    border-left: 1px solid #000 !important;\n                }\n                .vxe-table .vxe-body--row:first-child .vxe-body--column {\n                    border-top: 1px solid #000 !important;\n                }\n                .vxe-table .vxe-body--row:last-child .vxe-body--column {\n                    border-bottom: 1px solid #000 !important;\n                }\n                .table-empty .vxe-table .vxe-header--column {\n                    border-bottom: 1px solid #000 !important;\n                }\n                .table-12px * {\n                    font-size: 12px !important;\n                }\n                .table-13px * {\n                    font-size: 13px !important;\n                }\n                .table-14px * {\n                    font-size: 14px !important;\n                }\n                .table-15px * {\n                    font-size: 15px !important;\n                }\n                .table-16px * {\n                    font-size: 16px !important;\n                }\n            '
        };
    },

    computed: {
        rows: function rows() {
            return this.layout ? this.layout.meiyebiaogehangshu : 10;
        },
        finalPrints: function finalPrints() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_array_from___default()(this.prints, function (o) {
                return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, o, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()({}, _this.listKey, _this.getList(o[_this.listKey])));
            });
        }
    },
    mounted: function mounted() {
        this.printer = __WEBPACK_IMPORTED_MODULE_9__printer_js__["a" /* Printd */].getInstance();
    },

    methods: {
        isSortByCatetory: function isSortByCatetory(e) {
            return ['按物品类别名称字母升序+物品编码升序', '按物品类别名称字母升序+物品名称字母升序', '按物品类别顺序+物品单位顺序'].includes(e);
        },
        print: function print() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
                var nodes;
                return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                // 获取要打印的NodeList
                                // [...html] 将NodeList转化为Array(NodeList没有map方法)
                                nodes = document.querySelectorAll('.printer' + (_this2.identify || ''));

                                setTimeout(function () {
                                    var callback = function callback(_ref) {
                                        var launchPrint = _ref.launchPrint,
                                            iframe = _ref.iframe;
                                        var contentWindow = iframe.contentWindow;

                                        contentWindow.onafterprint = function () {
                                            _this2.$emit('on-close');
                                        };
                                        launchPrint();
                                    };
                                    _this2.printer.prints(nodes, ['https://img.weizhilian.com/fe_static/vxe-table_3.5.6_lib_style.css', _this2.cssText], null, callback);
                                }, 100);

                            case 2:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },

        // 排序规则
        sortWord: function sortWord(a, b) {
            var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'zh-Hans-CN';

            return a.localeCompare(b, locale, { sensitivity: 'accent' });
        },

        // 物品排序
        sortWupin: function sortWupin(list, type) {
            var _this3 = this;

            if (type === '按单据物品排序' || type === '按物品类别顺序+物品单位顺序' || !type) {
                // 接口排序
                return list;
            } else if (type === '按物品类别名称字母升序+物品编码升序') {
                // 分类 + code
                return list.sort(function (a, b) {
                    if (_this3.sortWord(a.leibieStr, b.leibieStr) === 0) {
                        return _this3.sortWord(a.code, b.code, 'en');
                    } else {
                        return _this3.sortWord(a.leibieStr, b.leibieStr);
                    }
                });
            } else if (type === '按物品类别名称字母升序+物品名称字母升序') {
                // 分类 + name
                return list.sort(function (a, b) {
                    if (_this3.sortWord(a.leibieStr, b.leibieStr) === 0) {
                        return _this3.sortWord(a.name, b.name);
                    } else {
                        return _this3.sortWord(a.leibieStr, b.leibieStr);
                    }
                });
            } else if (type === '按物品编码升序') {
                // code
                return list.sort(function (a, b) {
                    return _this3.sortWord(a.code, b.code, 'en');
                });
            } else if (type === '按物品名称首字母升序') {
                // name
                return list.sort(function (a, b) {
                    return _this3.sortWord(a.name, b.name);
                });
            } else {
                return list;
            }
        },

        // 数组根据属性分组
        groupByProperty: function groupByProperty(arr, property) {
            return arr.reduce(function (acc, obj) {
                var key = obj[property];
                if (!acc[key]) {
                    acc[key] = [];
                }
                acc[key].push(obj);
                return acc;
            }, {});
        },

        // 属性分组转数组
        groupToArray: function groupToArray(arr, property) {
            var groups = this.groupByProperty(arr, property);
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(groups);
        },

        // 数组根据数量分组
        groupByCount: function groupByCount(arr, count) {
            return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_array_from___default()({ length: Math.ceil(arr.length / count) }, function (_, index) {
                return arr.slice(index * count, index * count + count);
            });
        },

        // 获取打印列表
        getList: function getList(list) {
            var _this4 = this;

            var _layout = this.layout,
                _layout$wupinpaixu = _layout.wupinpaixu,
                wupinpaixu = _layout$wupinpaixu === undefined ? '' : _layout$wupinpaixu,
                _layout$fenleixiaoji = _layout.fenleixiaoji,
                fenleixiaoji = _layout$fenleixiaoji === undefined ? '不展示' : _layout$fenleixiaoji,
                _layout$hebinghang = _layout.hebinghang,
                hebinghang = _layout$hebinghang === undefined ? 'false' : _layout$hebinghang;

            var isCategoryTotal = String(fenleixiaoji) === '展示';
            var isPageTotal = String(hebinghang) === 'true';
            var finalList = this.sortWupin(list, wupinpaixu);
            // 物品排序
            if (wupinpaixu) {
                // 分类小计
                if (this.isSortByCatetory(wupinpaixu) && isCategoryTotal) {
                    // 按分类分组
                    finalList = this.groupToArray(finalList, 'leibieStr');
                    finalList = finalList.reduce(function (a, c) {
                        var category = _this4.getTotal(c, {
                            isTotal: true,
                            totalName: '分类小计',
                            leibieStr: ''
                        });
                        return [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(c), [category]);
                    }, []);
                }
            }
            // 分页小计
            if (isPageTotal) {
                finalList = this.groupByCount(finalList, this.layout.meiyebiaogehangshu - 1);
                finalList = finalList.reduce(function (a, c) {
                    var pager = _this4.getTotal(c, {
                        isTotal: true,
                        totalName: '合计',
                        leibieStr: ''
                    });
                    if (c.some(function (o) {
                        return !o.isTotal;
                    })) {
                        c.push(pager);
                    }
                    return [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(c));
                }, []);
            }
            // 处理序号
            var idx = 1;
            finalList.forEach(function (o) {
                if (!o.isTotal) {
                    o.xuhao = idx;
                    idx += 1;
                }
            });
            return finalList;
        },

        // 分页
        getPages: function getPages(list) {
            var _this5 = this;

            return list.reduce(function (arr, item, idx) {
                return idx % _this5.rows === 0 ? [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(arr), [[item]]) : [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(arr.slice(0, -1)), [[].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(arr.slice(-1)[0]), [item])]);
            }, []);
        },
        isNotNumber: function isNotNumber(amount) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default()(parseFloat(amount));
        },

        // 汇总计算
        getTotal: function getTotal(list, base) {
            var _this6 = this;

            var danjuleixing = this.layout.danjuleixing;
            if (danjuleixing === '配送发货单') {
                base.fahuoshuliang = 0;
                base.fahuoshuliangkucun = 0;
                base.fahuojinehanshui = 0;
            } else if (danjuleixing === '配送收货单') {
                base.shouhuoshuliang = 0;
                base.shouhuojinehanshui = 0;
            } else if (danjuleixing === '配送订单') {
                base.caigoushuliang = 0;
                base.kucunshuliang = 0;
                base.caigoujinehanshui = 0;
            } else if (danjuleixing === '配送返货单') {
                base.tuihuoshuliang = 0;
                base.tuihuojinehanshui = 0;
            } else if (danjuleixing === '采购订单') {
                base.caigoushuliang = 0;
                base.caigoujinehanshui = 0;
            } else if (danjuleixing === '采购收货') {
                base.shouhuoshuliang = 0;
                base.shouhuojinehanshui = 0;
                base.yishouhuojinehanshui = 0;
            } else if (danjuleixing === '收发货差异处理单') {
                base.chayishuliang = 0;
                base.chayijinehanshui = 0;
            }
            return list.reduce(function (a, c) {
                if (c.isTotal) {
                    return a;
                }
                if (danjuleixing === '配送发货单') {
                    a.fahuoshuliang += c.fahuoshuliang || 0;
                    a.fahuoshuliangkucun += c.fahuoshuliangkucun || 0;
                    if (_this6.isNotNumber(a.fahuojinehanshui) || _this6.isNotNumber(c.fahuojinehanshui)) {
                        a.fahuojinehanshui = a.fahuojinehanshui || c.fahuojinehanshui;
                    } else {
                        a.fahuojinehanshui = parseFloat((a.fahuojinehanshui + parseFloat((c.fahuojinehanshui || 0).toFixed(2))).toFixed(8));
                    }
                } else if (danjuleixing === '配送收货单') {
                    a.shouhuoshuliang += c.shouhuoshuliang || 0;
                    if (_this6.isNotNumber(a.shouhuojinehanshui) || _this6.isNotNumber(c.shouhuojinehanshui)) {
                        a.shouhuojinehanshui = a.shouhuojinehanshui || c.shouhuojinehanshui;
                    } else {
                        a.shouhuojinehanshui = parseFloat((a.shouhuojinehanshui + parseFloat((c.shouhuojinehanshui || 0).toFixed(2))).toFixed(8));
                    }
                } else if (danjuleixing === '配送订单') {
                    a.caigoushuliang += c.caigoushuliang || 0;
                    a.kucunshuliang += c.kucunshuliang || 0;
                    if (_this6.isNotNumber(a.caigoujinehanshui) || _this6.isNotNumber(c.caigoujinehanshui)) {
                        a.caigoujinehanshui = a.caigoujinehanshui || c.caigoujinehanshui;
                    } else {
                        a.caigoujinehanshui = parseFloat((a.caigoujinehanshui + parseFloat((c.caigoujinehanshui || 0).toFixed(2))).toFixed(8));
                    }
                } else if (danjuleixing === '配送返货单') {
                    a.tuihuoshuliang += c.tuihuoshuliang || 0;
                    if (_this6.isNotNumber(a.tuihuojinehanshui) || _this6.isNotNumber(c.tuihuojinehanshui)) {
                        a.tuihuojinehanshui = a.tuihuojinehanshui || c.tuihuojinehanshui;
                    } else {
                        a.tuihuojinehanshui = parseFloat((a.tuihuojinehanshui + parseFloat((c.tuihuojinehanshui || 0).toFixed(2))).toFixed(8));
                    }
                } else if (danjuleixing === '采购订单') {
                    a.caigoushuliang += c.caigoushuliang || 0;
                    if (_this6.isNotNumber(a.caigoujinehanshui) || _this6.isNotNumber(c.caigoujinehanshui)) {
                        a.caigoujinehanshui = a.caigoujinehanshui || c.caigoujinehanshui;
                    } else {
                        a.caigoujinehanshui = parseFloat((a.caigoujinehanshui + parseFloat((c.caigoujinehanshui || 0).toFixed(2))).toFixed(8));
                    }
                } else if (danjuleixing === '采购收货') {
                    a.shouhuoshuliang += c.shouhuoshuliang || 0;
                    if (_this6.isNotNumber(a.shouhuojinehanshui) || _this6.isNotNumber(c.shouhuojinehanshui)) {
                        a.shouhuojinehanshui = a.shouhuojinehanshui || c.shouhuojinehanshui;
                    } else {
                        a.shouhuojinehanshui = parseFloat((a.shouhuojinehanshui + parseFloat((c.shouhuojinehanshui || 0).toFixed(2))).toFixed(8));
                    }
                    if (_this6.isNotNumber(a.yishouhuojinehanshui) || _this6.isNotNumber(c.yishouhuojinehanshui)) {
                        a.yishouhuojinehanshui = a.yishouhuojinehanshui || c.yishouhuojinehanshui;
                    } else {
                        a.yishouhuojinehanshui = parseFloat((a.yishouhuojinehanshui + parseFloat((c.yishouhuojinehanshui || 0).toFixed(2))).toFixed(8));
                    }
                } else if (danjuleixing === '收发货差异处理单') {
                    a.chayishuliang += c.chayishuliang || 0;
                    if (_this6.isNotNumber(a.chayijinehanshui) || _this6.isNotNumber(c.chayijinehanshui)) {
                        a.chayijinehanshui = a.chayijinehanshui || c.chayijinehanshui;
                    } else {
                        a.chayijinehanshui = parseFloat((a.chayijinehanshui + parseFloat((c.chayijinehanshui || 0).toFixed(2))).toFixed(8));
                    }
                }
                return a;
            }, __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, base));
        }
    }
});

/***/ }),

/***/ "EMOm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EPV4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "base-layout wrap"
  }, [_c('p', {
    staticClass: "container-tit"
  }, [_vm._v("\n    " + _vm._s(_vm.pageTitle) + "\n  ")]), _vm._v(" "), _c('Divider'), _vm._v(" "), _vm._t("default")], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "F9TA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_constants_api_optimize__ = __webpack_require__("siF6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);





var OptimizeApi = function () {
    function OptimizeApi() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, OptimizeApi);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(OptimizeApi, [{
        key: 'getOrganiztion',

        /**获取机构（供货、要货、管辖机构等） */
        value: function getOrganiztion(params) {
            return __WEBPACK_IMPORTED_MODULE_3_vue___default.a.prototype.$api.post(__WEBPACK_IMPORTED_MODULE_2__helpers_constants_api_optimize__["a" /* default */].GET_ORGANIZATION, params);
        }

        /**供货机构（供应商）下拉框 - 加载数据 */

    }, {
        key: 'getSublevel',
        value: function getSublevel(params) {
            return __WEBPACK_IMPORTED_MODULE_3_vue___default.a.prototype.$api.post(__WEBPACK_IMPORTED_MODULE_2__helpers_constants_api_optimize__["a" /* default */].GET_SUBLEVEL, params);
        }
        /**仓库下拉框 - 加载数据 */

    }, {
        key: 'getwarehouse',
        value: function getwarehouse(params) {
            return __WEBPACK_IMPORTED_MODULE_3_vue___default.a.prototype.$api.post(__WEBPACK_IMPORTED_MODULE_2__helpers_constants_api_optimize__["a" /* default */].GET_WAREHOUSE, params);
        }
        /**类别下拉框或树节点分段加载 - 加载数据  */

    }, {
        key: 'getCategory',
        value: function getCategory(params) {
            return __WEBPACK_IMPORTED_MODULE_3_vue___default.a.prototype.$api.post(__WEBPACK_IMPORTED_MODULE_2__helpers_constants_api_optimize__["a" /* default */].GET_CATEGORY, params);
        }
        /**类别下拉框或树节点分段加载 - 加载数据  */

    }, {
        key: 'getBumen',
        value: function getBumen(params) {
            return __WEBPACK_IMPORTED_MODULE_3_vue___default.a.prototype.$api.post(__WEBPACK_IMPORTED_MODULE_2__helpers_constants_api_optimize__["a" /* default */].GET_BUMEN, params);
        }
        /**类别下拉框或树节点分段加载 - 加载数据  */

    }, {
        key: 'getBiaoqian',
        value: function getBiaoqian(params) {
            return __WEBPACK_IMPORTED_MODULE_3_vue___default.a.prototype.$api.post(__WEBPACK_IMPORTED_MODULE_2__helpers_constants_api_optimize__["a" /* default */].GET_BIAOQIAN, params);
        }
        /**类别下拉框或树节点分段加载 - 加载数据  */

    }, {
        key: 'getYuanyin',
        value: function getYuanyin(params) {
            return __WEBPACK_IMPORTED_MODULE_3_vue___default.a.prototype.$api.post(__WEBPACK_IMPORTED_MODULE_2__helpers_constants_api_optimize__["a" /* default */].GET_YUANYIN, params);
        }
        /**类别下拉框或树节点分段加载 - 加载数据  */

    }, {
        key: 'getWupin',
        value: function getWupin(params) {
            return __WEBPACK_IMPORTED_MODULE_3_vue___default.a.prototype.$api.post(__WEBPACK_IMPORTED_MODULE_2__helpers_constants_api_optimize__["a" /* default */].GET_WUPIN, params);
        }
        /**类别下拉框或树节点分段加载 - 加载数据  */

    }, {
        key: 'getCaipin',
        value: function getCaipin(params) {
            return __WEBPACK_IMPORTED_MODULE_3_vue___default.a.prototype.$api.post(__WEBPACK_IMPORTED_MODULE_2__helpers_constants_api_optimize__["a" /* default */].GET_CAIPIN, params);
        }
        /**类别下拉框或树节点分段加载 - 加载数据  */

    }, {
        key: 'getWaixiaokehu',
        value: function getWaixiaokehu(params) {
            return __WEBPACK_IMPORTED_MODULE_3_vue___default.a.prototype.$api.post(__WEBPACK_IMPORTED_MODULE_2__helpers_constants_api_optimize__["a" /* default */].GET_WAIXIAOKEHU, params);
        }
    }, {
        key: 'getItems',
        value: function getItems(params) {
            return __WEBPACK_IMPORTED_MODULE_3_vue___default.a.prototype.$api.post(__WEBPACK_IMPORTED_MODULE_2__helpers_constants_api_optimize__["a" /* default */].GET_ITEM, params);
        }
    }]);

    return OptimizeApi;
}();

/* harmony default export */ __webpack_exports__["a"] = (OptimizeApi);

/***/ }),

/***/ "FdG9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FjSk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.readonly || _vm.disabled) ? _c('div', [_vm._v(_vm._s(_vm.inputValue))]) : _c('div', {
    ref: "dropRef",
    staticClass: "ivu-select ivu-select-single ivu-select-default option-box"
  }, [(_vm.multiple) ? _c('div', {
    style: (("width: " + (_vm.width||'210px') + ";")),
    on: {
      "mouseover": function($event) {
        (_vm.values.length || _vm.constValues.length || _vm.content) ? _vm.isDeleteButton = true: _vm.isDeleteButton = false
      },
      "mouseleave": function($event) {
        _vm.isDeleteButton = false
      }
    }
  }, [_c('div', {
    ref: "multipleR",
    staticClass: "ivu-select-selection",
    staticStyle: {
      "height": "auto",
      "min-height": "32px !important",
      "padding": "0 0 0 5px"
    },
    on: {
      "click": _vm.selectUp
    }
  }, [(_vm.values.length == 1) ? _c('Tag', {
    attrs: {
      "closable": ""
    },
    on: {
      "on-close": function($event) {
        return _vm.handleClose()
      }
    }
  }, [_vm._v(_vm._s(_vm.values[0].name))]) : _vm._e(), _vm._v(" "), (_vm.values.length > 1) ? _c('Tag', [_vm._v("已选" + _vm._s(_vm.values.length) + "项")]) : _vm._e(), _vm._v(" "), (_vm.constValues.length == 1) ? _c('Tag', {
    attrs: {
      "closable": ""
    },
    on: {
      "on-close": function($event) {
        return _vm.handleClose()
      }
    }
  }, [_vm._v(_vm._s(_vm.constValues[0].name))]) : _vm._e(), _vm._v(" "), (_vm.constValues.length > 1) ? _c('Tag', [_vm._v("已选" + _vm._s(_vm.constValues.length) + "项")]) : _vm._e(), _vm._v(" "), (!_vm.options || _vm.options.length == 0) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    ref: "inputVal",
    staticClass: "ivu-select-input",
    staticStyle: {
      "padding": "0 0 0 4px"
    },
    style: (_vm.inputStyle),
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "onautocomplete": "off",
      "placeholder": _vm.values.length ? '' : _vm.placeholder
    },
    domProps: {
      "value": (_vm.inputValue)
    },
    on: {
      "keyup": _vm.selectKeyDown,
      "compositionstart": function($event) {
        _vm.flag = false
      },
      "compositionend": function($event) {
        _vm.flag = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputValue = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.options && _vm.options.length > 0) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.constinputValue),
      expression: "constinputValue"
    }],
    ref: "inputVal",
    staticClass: "ivu-select-input",
    staticStyle: {
      "padding": "0 0 0 4px"
    },
    style: (_vm.inputStyle),
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "onautocomplete": "off",
      "placeholder": _vm.constValues.length ? '' : _vm.placeholder
    },
    domProps: {
      "value": (_vm.constinputValue)
    },
    on: {
      "keyup": _vm.shopInput,
      "compositionstart": function($event) {
        _vm.flag = false
      },
      "compositionend": function($event) {
        _vm.flag = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.constinputValue = $event.target.value
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('span', {
    staticClass: "delete-selected",
    staticStyle: {
      "top": "10px"
    },
    on: {
      "click": _vm.selectUp
    }
  }, [_c('Icon', {
    staticStyle: {
      "margin-left": "4px"
    },
    attrs: {
      "type": _vm.contentShow ? 'ios-arrow-up' : 'ios-arrow-down',
      "size": "14",
      "color": "#808695"
    }
  })], 1), _vm._v(" "), (_vm.clear && _vm.isDeleteButton) ? _c('span', {
    staticClass: "delete-selected",
    on: {
      "click": function($event) {
        return _vm.deleteButtonClick()
      }
    }
  }, [_c('Icon', {
    staticStyle: {
      "margin-left": "4px"
    },
    attrs: {
      "type": "ios-close-circle",
      "size": "14",
      "color": "#5C6B77"
    }
  })], 1) : _vm._e()]) : _c('div', {
    staticClass: "ivu-select-selection ",
    style: (("width: " + (_vm.width||'200px') + ";")),
    on: {
      "mouseover": function($event) {
        (_vm.inputValue || _vm.content) ? _vm.isDeleteButton = true: _vm.isDeleteButton = false
      },
      "mouseleave": function($event) {
        _vm.isDeleteButton = false
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    staticClass: "ivu-select-input",
    attrs: {
      "id": "tentant-input",
      "type": "text",
      "autocomplete": "off",
      "onautocomplete": "off",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.inputValue)
    },
    on: {
      "click": _vm.selectUp,
      "keyup": _vm.selectKeyDown,
      "compositionstart": function($event) {
        _vm.flag = false
      },
      "compositionend": function($event) {
        _vm.flag = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "delete-selected",
    on: {
      "click": _vm.selectUp
    }
  }, [_c('Icon', {
    staticStyle: {
      "margin-left": "4px"
    },
    attrs: {
      "type": _vm.contentShow ? 'ios-arrow-up' : 'ios-arrow-down',
      "size": "14",
      "color": "#808695"
    }
  })], 1), _vm._v(" "), (_vm.clear && _vm.isDeleteButton) ? _c('span', {
    staticClass: "delete-selected",
    on: {
      "click": function($event) {
        return _vm.deleteButtonClick()
      }
    }
  }, [_c('Icon', {
    staticStyle: {
      "margin-left": "4px"
    },
    attrs: {
      "type": "ios-close-circle",
      "size": "14",
      "color": "#5C6B77"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', [(!_vm.options || _vm.options.length == 0) ? _c('div', [(_vm.contentShow) ? _c('div', {
    directives: [{
      name: "loadmore",
      rawName: "v-loadmore",
      value: ({
        loadMore: _vm.loadMoreGroup
      }),
      expression: "{loadMore:loadMoreGroup}"
    }],
    staticClass: "ivu-select-dropdown selected-content",
    style: ({
      top: (_vm.multiple ? _vm.paddTop + 'px' : '30px')
    }),
    attrs: {
      "id": "selected-content"
    }
  }, [_c('ul', {
    staticClass: "el-scrollbar__view ivu-select-dropdown-list ul-content"
  }, [_vm._l((_vm.contentOptions), function(i, index) {
    return _c('li', {
      key: index,
      staticClass: "ivu-select-item option-item",
      class: {
        selected: _vm.multiple ? _vm.values.some(function (row) { return (row._id || row.code) == (i._id || i.code); }) : index === _vm.current
      },
      on: {
        "click": function($event) {
          return _vm.contentClick(i, index)
        }
      }
    }, [_c('div', [_c('p', {
      staticClass: "nowrap",
      style: (("max-width: " + _vm.selectionWidth + "px;"))
    }, [_vm._v(_vm._s(i.name))]), _vm._v(" "), _c('p', {
      staticClass: "nowrap",
      staticStyle: {
        "color": "#ccc"
      }
    }, [_vm._v(_vm._s(i.code))])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.multiple && _vm.values.some(function (row) { return (row._id || row.code) == (i._id || i.code); })),
        expression: "multiple && values.some(row=>(row._id||row.code) == (i._id||i.code))"
      }]
    }, [_c('Icon', {
      attrs: {
        "type": "ios-checkmark",
        "size": "24",
        "color": "rgba(32, 191, 100, 0.9)"
      }
    })], 1)])
  }), _vm._v(" "), _c('li', {
    staticClass: " hint jcsb"
  }, [_c('span', [_vm._v("共 "), _c('span', {
    staticStyle: {
      "color": "#888"
    }
  }, [_vm._v(_vm._s(_vm.totalTenants))]), _vm._v(" 条结果")])])], 2), _vm._v(" "), (_vm.contentOptions.length === 0 && !_vm.loading) ? _c('p', {
    staticClass: "tip-class"
  }, [_vm._v("暂无数据")]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('p', {
    staticClass: "tip-class"
  }, [_vm._v("数据加载中...")]) : _vm._e()]) : _vm._e()]) : _c('div', [(_vm.contentShow) ? _c('div', {
    staticClass: "ivu-select-dropdown selected-content",
    style: ({
      top: (_vm.multiple ? _vm.paddTop + 'px' : '30px')
    }),
    attrs: {
      "id": "selected-content"
    }
  }, [_c('ul', {
    staticClass: "el-scrollbar__view ivu-select-dropdown-list ul-content"
  }, [_vm._l((_vm.fixationOptions), function(i, index) {
    return _c('li', {
      key: index,
      staticClass: "ivu-select-item option-item",
      class: {
        selected: _vm.multiple ? _vm.constValues.some(function (row) { return row.name == i.name; }) : index === _vm.current
      },
      on: {
        "click": function($event) {
          return _vm.constClick(i, index)
        }
      }
    }, [_c('div', [_c('p', {
      staticClass: "nowrap",
      staticStyle: {
        "max-width": "200px"
      }
    }, [_vm._v(_vm._s(i.name))])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.multiple && _vm.constValues.some(function (row) { return row.name == i.name; })),
        expression: "multiple && constValues.some(row=>row.name == i.name)"
      }]
    }, [_c('Icon', {
      attrs: {
        "type": "ios-checkmark",
        "size": "24",
        "color": "rgba(32, 191, 100, 0.9)"
      }
    })], 1)])
  }), _vm._v(" "), _c('li', {
    staticClass: " hint jcsb"
  }, [_c('span', [_vm._v("共 "), _c('span', {
    staticStyle: {
      "color": "#888"
    }
  }, [_vm._v(_vm._s(_vm.fixationOptions.length))]), _vm._v(" 条结果")])])], 2)]) : _vm._e()])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GU67":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-form"
  }, [(_vm.dateSearh) ? _c('div', {
    staticStyle: {
      "padding-bottom": "10px"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "on-change": _vm.change
    },
    model: {
      value: (_vm.searhForm.riqitype),
      callback: function($$v) {
        _vm.$set(_vm.searhForm, "riqitype", $$v)
      },
      expression: "searhForm.riqitype"
    }
  }, _vm._l((_vm.selectList), function(item) {
    return _c('Option', {
      key: item.name,
      attrs: {
        "value": item.name
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 1), _vm._v(" "), _c('DatePicker', {
    staticStyle: {
      "width": "432px",
      "margin-top": "10px"
    },
    attrs: {
      "value": _vm.searhForm.riqi,
      "format": "yyyy-MM-dd",
      "type": "daterange",
      "placement": "bottom-end",
      "placeholder": "选择日期范围",
      "clearable": false
    },
    on: {
      "on-change": _vm.change
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.column), function(citem, index) {
    return (!citem.hide && (!citem.vif || citem.vif())) ? _c('div', {
      key: index,
      staticClass: "box"
    }, [(citem.type === 'select') ? _c('Select', {
      style: (("width:" + (citem.width || 200) + "px")),
      attrs: {
        "multiple": citem.multi || citem.multiple,
        "value": citem.value,
        "clearable": "",
        "placeholder": citem.placeholder
      },
      on: {
        "on-change": function($event) {
          return _vm.selectChange(index, $event)
        }
      }
    }, _vm._l((citem.options), function(item) {
      return _c('Option', {
        key: item.name,
        attrs: {
          "value": item.value === undefined ? item.name : item.value
        }
      }, [(citem.code) ? _c('div', [_c('div', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
        staticClass: "nowrap",
        staticStyle: {
          "color": "#ccc",
          "font-size": "14px"
        }
      }, [_vm._v(_vm._s(item.code))])]) : _c('div', [_vm._v(_vm._s(item.name))])])
    }), 1) : (citem.type === 'selectSearch') ? _c('BaseSelect', {
      attrs: {
        "value": citem.value || null,
        "options": citem.options.options,
        "multiple": citem.multi || citem.multiple || citem.options.multiple || citem.options.multi,
        "type": citem.options.type,
        "parameter": citem.options.parameter,
        "placeholder": citem.options.placeholder
      },
      on: {
        "change": function($event) {
          return _vm.searchChange(index, $event)
        },
        "localSearchchange": function($event) {
          return _vm.searchChange(index, $event, 'local')
        }
      }
    }) : (citem.type === 'datePicker') ? _c('DatePicker', {
      staticStyle: {
        "width": "432px"
      },
      attrs: {
        "value": citem.value,
        "format": "yyyy-MM-dd",
        "type": "daterange",
        "placement": "bottom-end",
        "placeholder": citem.placeholder,
        "clearable": false
      },
      on: {
        "on-change": function($event) {
          return _vm.zhidingriqiChanged(index, $event)
        }
      }
    }) : _c('div', [(!citem.value || _vm.editing[citem.key]) ? _c('Input', {
      ref: 'input:' + citem.key,
      refInFor: true,
      style: (("width:" + (citem.width || 280) + "px")),
      attrs: {
        "icon": "ios-search",
        "placeholder": citem.placeholder || ''
      },
      on: {
        "on-enter": function($event) {
          return _vm.textChanged(citem, index)
        },
        "on-blur": function($event) {
          return _vm.textBlur(citem, index)
        }
      },
      model: {
        value: (_vm.inputing[citem.key]),
        callback: function($$v) {
          _vm.$set(_vm.inputing, citem.key, $$v)
        },
        expression: "inputing[citem.key]"
      }
    }) : _vm._e(), _vm._v(" "), ((!!citem.value) && !_vm.editing[citem.key]) ? _c('div', {
      staticClass: "jcsb nowrap",
      style: (("height: 32px;line-height: 32px;margin: 0;width: " + (citem.width || 280) + "px;background-color: #f5f5f5;color: #aaa;padding: 0 8px;border-radius: 4px;")),
      on: {
        "click": function($event) {
          return _vm.textEdit(citem, index)
        }
      }
    }, [_c('div', [_vm._v(_vm._s(citem.value))]), _vm._v(" "), _c('Icon', {
      attrs: {
        "type": "ios-close-circle"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.textClear(citem, index)
        }
      }
    })], 1) : _vm._e()], 1)], 1) : _vm._e()
  })], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GrSP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-left"
  }, _vm._l((_vm.itemList), function(formItem, index) {
    return _c('div', {
      key: index
    }, [(_vm.edit) ? _c('div', [(formItem.show) ? _c('FormItem', {
      attrs: {
        "label": formItem.label,
        "prop": formItem.prop
      }
    }, [(formItem.type === 'select') ? _c('Select', {
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "filterable": "",
        "disabled": formItem.disabled,
        "filterable": ""
      },
      on: {
        "on-change": function($event) {
          return _vm.change(index, $event)
        }
      },
      model: {
        value: (formItem.value),
        callback: function($$v) {
          _vm.$set(formItem, "value", $$v)
        },
        expression: "formItem.value"
      }
    }, _vm._l((formItem.selectList), function(item, index) {
      return _c('Option', {
        key: index,
        attrs: {
          "value": item.name,
          "label": item.name
        }
      }, [_c('span', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
        staticClass: "nowrap",
        staticStyle: {
          "float": "right",
          "color": "#ccc"
        }
      }, [_vm._v(_vm._s(item.code))])])
    }), 1) : (formItem.type == 'selector') ? _c('BaseSelect', {
      attrs: {
        "type": formItem.datatype,
        "value": formItem.value,
        "autoload": formItem.autoload,
        "parameter": formItem.parameter
      },
      on: {
        "change": function($event) {
          return _vm.selectorchange(index, $event)
        }
      }
    }) : (formItem.type === 'input') ? _c('Input', {
      attrs: {
        "disabled": formItem.disabled
      },
      on: {
        "on-change": function($event) {
          return _vm.change(index, $event)
        }
      },
      model: {
        value: (formItem.value),
        callback: function($$v) {
          _vm.$set(formItem, "value", $$v)
        },
        expression: "formItem.value"
      }
    }) : (formItem.type === 'textarea') ? _c('Input', {
      attrs: {
        "type": "textarea",
        "rows": 4,
        "placeholder": "请输入"
      },
      on: {
        "on-change": function($event) {
          return _vm.change(index, $event)
        }
      },
      model: {
        value: (formItem.value),
        callback: function($$v) {
          _vm.$set(formItem, "value", $$v)
        },
        expression: "formItem.value"
      }
    }) : (formItem.type === 'switch') ? _c('i-switch', {
      on: {
        "on-change": function($event) {
          return _vm.change(index, $event)
        }
      },
      model: {
        value: (formItem.value),
        callback: function($$v) {
          _vm.$set(formItem, "value", $$v)
        },
        expression: "formItem.value"
      }
    }, [_c('span', {
      attrs: {
        "slot": "open"
      },
      slot: "open"
    }, [_vm._v("是")]), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "close"
      },
      slot: "close"
    }, [_vm._v("否")])]) : (formItem.type === 'DatePicker') ? _c('DatePicker', {
      attrs: {
        "type": "date",
        "disabled": formItem.disabled,
        "value": formItem.value,
        "clearable": false,
        "options": formItem.pickerOptions,
        "placeholder": "请选择"
      },
      on: {
        "on-change": function($event) {
          return _vm.change(index, $event)
        }
      }
    }) : (formItem.type === 'text') ? _c('div', [_vm._v(_vm._s(formItem.value))]) : _vm._e()], 1) : _vm._e()], 1) : _c('div', [(formItem.show) ? _c('FormItem', {
      attrs: {
        "label": formItem.label,
        "prop": formItem.prop
      }
    }, [(formItem.type === 'switch') ? _c('i-switch', {
      attrs: {
        "disabled": ""
      },
      on: {
        "on-change": function($event) {
          return _vm.change(index, $event)
        }
      },
      model: {
        value: (formItem.value),
        callback: function($$v) {
          _vm.$set(formItem, "value", $$v)
        },
        expression: "formItem.value"
      }
    }, [_c('span', {
      attrs: {
        "slot": "open"
      },
      slot: "open"
    }, [_vm._v("是")]), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "close"
      },
      slot: "close"
    }, [_vm._v("否")])]) : (formItem.type == 'selector' && formItem.value && formItem.value.name) ? _c('span', [_vm._v(_vm._s(formItem.value.name))]) : _c('span', [_vm._v(_vm._s(formItem.value))])], 1) : _vm._e()], 1)])
  }), 0)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "H18h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HSXY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        dataurl: String,
        dataquery: Object,
        // 下发门店列表
        // items: {
        //     type: Array,
        //     default: () => []
        // },
        title: {
            type: String,
            default: '适用机构'
        }
    },
    data: function data() {
        return {
            loading: false,
            total: 0,
            page: {
                size: 10,
                current: 1
            },
            query: {
                keywords: ""
            },
            usedKeywords: '',
            items: [],
            selections: [],
            columns: [{ title: '编号', key: 'code' }, { title: '机构名称', key: 'name' }, { title: '经营方式', key: 'jingyingfangshi' }, { title: '上级机构', key: 'parentStr' }, { title: '品牌', key: 'pinpaiStr' }]
        };
    },
    mounted: function mounted() {},

    methods: {
        keywordsChanged: function keywordsChanged() {
            this.usedKeywords = this.query.keywords;
            this.page.current = 1;
            this.loadData();
        },
        sortChanged: function sortChanged() {
            this.page.current = 1;
            this.loadData();
        },
        loadData: function loadData() {
            var _this = this;

            this.loading = true;
            this.$api.post(this.dataurl, {
                query: this.query,
                // fields: this.option.fields,
                page: this.page
            }).then(function (res) {
                _this.loading = false;
                _this.items = res.data.items;
                _this.total = res.data.total;
                _this.getparentStr();
            }, function () {
                _this.loading = false;
            });
        },
        getparentStr: function getparentStr() {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.items), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var i = _step.value;

                    i.parentStr = i.parent ? i.parent.name : '';
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },
        pageSizeChanged: function pageSizeChanged(value) {
            this.page.size = value;
            // sessionStorage.pagesize = value
            if (this.page.current == 1) this.loadData();
        },
        pageChanged: function pageChanged(value) {
            this.page.current = value;
            this.loadData();
        }
    },
    created: function created() {
        // this.$set(this.page, 'size', Number(sessionStorage.pagesize || 10))
        if (this.dataquery) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.dataquery)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var key = _step2.value;

                    this.query[key] = this.dataquery[key];
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }
        this.loadData();
    }
});

/***/ }),

/***/ "ITRb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "padding": "20px",
      "box-sizing": "border-box",
      "position": "fixed",
      "background-color": "#fff",
      "z-index": "1000",
      "width": "440px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "font-weight": "bold",
      "padding": "10px 0"
    }
  }, [_vm._v("更新日志")]), _vm._v(" "), (!_vm.query.keywords) ? _c('Input', {
    ref: "input:keywords",
    attrs: {
      "icon": "ios-search",
      "placeholder": '搜索'
    },
    on: {
      "on-enter": _vm.keywordsChanged
    },
    model: {
      value: (_vm.keywords),
      callback: function($$v) {
        _vm.keywords = $$v
      },
      expression: "keywords"
    }
  }) : _vm._e(), _vm._v(" "), ((!!_vm.query.keywords)) ? _c('div', {
    staticClass: "jcsb nowrap",
    style: ("height: 32px;line-height: 32px;margin: 0;width: 100%;background-color: #f5f5f5;color: #aaa;padding: 0 8px;border-radius: 4px;"),
    on: {
      "click": _vm.keywordsEdit
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.query.keywords))]), _vm._v(" "), _c('Icon', {
    attrs: {
      "type": "ios-close-circle"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.keywordsClear($event)
      }
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "100px"
    }
  }), _vm._v(" "), _c('Scroll', {
    ref: "list",
    attrs: {
      "on-reach-top": _vm.refresh,
      "on-reach-bottom": _vm.loadMore,
      "distance-to-edge": 20,
      "height": _vm.listHeight
    }
  }, [_vm._l((_vm.gengxinrizhis), function(gengxinrizhi, index) {
    return _c('div', {
      staticClass: "gengxinrizhi",
      style: (("background-color: " + (index%2==0?'#fff':'#fafafa') + ";"))
    }, [_c('Badge', {
      attrs: {
        "dot": _vm.newversiontip(gengxinrizhi),
        "offset": [5, -6]
      }
    }, [_c('div', {
      staticStyle: {
        "font-size": "18px",
        "font-weight": "bold"
      }
    }, [_c('Icon', {
      attrs: {
        "type": "md-bookmark"
      }
    }), _vm._v("\n                    " + _vm._s(gengxinrizhi.version) + "\n                ")], 1)]), _vm._v(" "), _c('div', {
      staticStyle: {
        "font-size": "14px",
        "color": "#aaa",
        "margin-bottom": "10px"
      }
    }, [_vm._v("文档更新于 " + _vm._s(gengxinrizhi.lastUpdateTimeStr))]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(gengxinrizhi.content)
      }
    })], 1)
  }), _vm._v(" "), (_vm.nomore) ? _c('div', {
    staticClass: "nomore"
  }, [_vm._v("没有更多了")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "20px"
    }
  })], 2)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IYde":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_tagsNav__ = __webpack_require__("wC9Q");




__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vuex___default.a);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex___default.a.Store({
    state: {},
    mutations: {},
    actions: {},
    modules: {
        tagsNav: __WEBPACK_IMPORTED_MODULE_2__modules_tagsNav__["a" /* default */]
    }
}));

/***/ }),

/***/ "IdYH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        columns: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        items: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        option: {
            type: Object,
            default: function _default() {}
        },
        queryForm: {
            type: Object,
            default: function _default() {}
        },
        minHeight: {
            type: Number
        },
        maxHeight: {
            type: String
        },
        quickedit: false, //是否支持快捷加减按钮,
        checkable: false, //是否支持选中
        guanxiajigou: false, //当内容是机构且需要按照管辖范围过滤时，设置为true
        scollBarThick: {
            type: Boolean,
            default: true
        },
        autoHideScrollBar: {
            type: Boolean,
            default: true
        }
    },
    data: function data() {
        return {
            onepagemode: false,
            allitemChecked: false,
            batchitem: { _batchitem: true },
            loading: false,
            total: 0,
            page: {
                size: 10,
                current: 1
            },
            query: {
                keywords: "",
                leibieStr: ""
            },
            newItems: [],
            usedKeywords: '',
            // items: [],
            selections: [],
            session: this.$store.session
        };
    },

    watch: {
        'items': function items(v) {
            var _this = this;

            if (this.guanxiajigou && this.$store.session.zhanghao.guanxiajigous) {
                var _loop = function _loop(item) {
                    if (_this.$store.session.zhanghao.guanxiajigous.some(function (o) {
                        return o._id == item._id;
                    })) {
                        delete item._readonly;
                    } else {
                        item._readonly = true;
                    }
                };

                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(v), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var item = _step.value;

                        _loop(item);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
            this.newItems = v;
        },
        queryForm: {
            handler: function handler(v) {
                this.query.keywords = v.keywords;
                this.query.leibieStr = v.leibieStr;
                this.page.current = 1;
                this.loadData();
            },

            // 代表在wacth里声明了firstName这个方法之后立即先去执行handler方法
            // immediate: true,
            deep: true
        }
    },
    computed: {
        customTableClass: function customTableClass() {
            var cls = 'scroll-none';
            // 滚动条加厚
            if (this.scollBarThick) {
                cls += ' scroll-none-thick';
            }
            // 没有数据的时候隐藏滚动条
            if (this.autoHideScrollBar && this.newItems.length === 0) {
                cls += ' scroll-none-hide';
            }
            return cls;
        },
        customTableStyle: function customTableStyle() {
            var str = "overflow: scroll;overflow-y: hidden; display: grid; width: 100%; padding-bottom: 20px;min-height: " + (this.minHeight || 100) + "px;";
            if (this.maxHeight) {
                str += ";max-height: " + this.maxHeight + ";overflow-y: scroll;";
            }
            return str;
        }
    },
    mounted: function mounted() {
        this.newItems = this.items;
    },

    methods: {
        getInput: function getInput(value, item, c, index) {
            if (index == 'batch') {
                for (var i = 0; i < this.newItems.length; i++) {
                    var checkedItem = this.newItems[i];
                    if (checkedItem._checked) {
                        this.getInput(value, checkedItem, c, i);
                    }
                }
                this.$set(item, c.key, value);
                return;
            }
            var key = c.keyStr || c.key;
            this.$set(item, c.key, value);
            if (c.oninput) c.oninput(value, key, index);
            if (c.onchange) c.onchange(value, key, index);
        },
        dataChanged: function dataChanged(item, c, valueStr, index) {
            if (item._batchitem) {
                if (valueStr !== undefined) {
                    for (var i = 0; i < this.newItems.length; i++) {
                        var checkedItem = this.newItems[i];
                        if (checkedItem._checked) {
                            this.dataChanged(checkedItem, c, valueStr, i);
                        }
                    }
                }
                this.$set(item, c.keyStr || c.key + 'Str', valueStr);
                return;
            }
            var key = void 0;
            if (c.type == "selection") {
                key = c.keyStr || c.key + 'Str';
            } else {
                key = c.keyStr || c.key;
            }
            var data = {};
            data[c.selectionKey] = valueStr;
            item[c.key] = c.selections(item).findOne(data);
            if (c.onchange) c.onchange(valueStr, key, index, item);
        },
        showSelections: function showSelections() {
            this.query.selections = this.selections.map(function (item) {
                return { _id: item._id };
            });
            this.page.current = 1;
            this.loadData();
        },
        keywordsChanged: function keywordsChanged() {
            this.usedKeywords = this.query.keywords;
            this.page.current = 1;
            this.loadData();
        },
        leibieChanged: function leibieChanged() {
            // this.usedKeywords = this.query.leibieStr
            this.page.current = 1;
            this.loadData();
        },
        sortChanged: function sortChanged() {
            this.page.current = 1;
            this.loadData();
        },
        loadData: function loadData() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
                var res;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!_this2.option.dataurl) {
                                    _context.next = 10;
                                    break;
                                }

                                _this2.loading = true;
                                _context.next = 4;
                                return _this2.$api.post(_this2.option.dataurl, {
                                    query: _this2.query,
                                    fields: _this2.option.fields,
                                    page: _this2.page
                                });

                            case 4:
                                res = _context.sent;

                                _this2.loading = false;
                                _this2.newItems = res.data.items;
                                _this2.total = res.data.total;
                                _context.next = 11;
                                break;

                            case 10:
                                if (_this2.option.items) {
                                    _this2.newItems = _this2.option.items;
                                    _this2.total = _this2.option.items.length;
                                    _this2.page.size = _this2.total;
                                    _this2.onepagemode = true;
                                }

                            case 11:
                                if (_this2.option && _this2.option.onload) {
                                    _this2.option.onload(_this2.newItems);
                                }

                            case 12:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        pageSizeChanged: function pageSizeChanged(value) {
            this.page.size = value;
            // sessionStorage.pagesize = value
            if (this.page.current == 1) this.loadData();
        },
        pageChanged: function pageChanged(value) {
            this.page.current = value;
            this.loadData();
        },
        addItem: function addItem(item, index) {
            this.$emit('addItem', { item: item, index: index });
            this.checkStateChanged();
        },
        removeItem: function removeItem(item, index) {
            this.items.splice(index, 1);
            this.$emit('removeItem', { item: item, index: index });
            this.checkStateChanged();
        },
        checkChanged: function checkChanged() {
            this.checkStateChanged();
        },
        checkStateChanged: function checkStateChanged() {
            this.allitemChecked = this.newItems.every(function (item) {
                return item._checked;
            });
            if (this.newItems.length == 0) this.allitemChecked = false;
            this.batchitem = { _batchitem: true };
        },
        checkAllChanged: function checkAllChanged() {
            this.allitemChecked = !this.allitemChecked;
            if (this.allitemChecked) {
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.newItems), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var item = _step2.value;

                        item._checked = true;
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
            } else {
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.newItems), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var _item = _step3.value;

                        _item._checked = false;
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
            }
            this.checkStateChanged();
        }
    },
    created: function created() {
        // this.$set(this.page, 'size', Number(sessionStorage.pagesize || 10))
        this.editable = this.option.editable;
        if (this.option.dataurl) {
            if (this.option.datasize) {
                this.page.size = this.option.datasize;
            } else {
                this.page.size = 10;
            }
            if (this.option.dataquery) {
                var _iteratorNormalCompletion4 = true;
                var _didIteratorError4 = false;
                var _iteratorError4 = undefined;

                try {
                    for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.option.dataquery)), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                        var key = _step4.value;

                        this.query[key] = this.option.dataquery[key];
                    }
                } catch (err) {
                    _didIteratorError4 = true;
                    _iteratorError4 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
                            _iterator4.return();
                        }
                    } finally {
                        if (_didIteratorError4) {
                            throw _iteratorError4;
                        }
                    }
                }
            }
            this.loadData();
        } else if (this.option.items) {
            this.loadData();
        }
    }
});

/***/ }),

/***/ "J6E2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        current: Array,
        jigou: Object
    },
    data: function data() {
        var _this = this;

        return {
            loading: false,
            query: {
                keywords: '',
                init: true
            },
            usedKeywords: '',
            page: {
                current: 1,
                size: 5
            },
            total: 0,
            kucunmobans: [],
            columns1: [{
                title: '模板编号',
                key: 'code',
                minWidth: 180
            }, {
                title: '模板名称',
                minWidth: 100,
                render: function render(h, params) {
                    return h('div', params.row.name);
                }
            }, {
                title: '操作',
                width: 180,
                align: 'center',
                fixed: 'right',
                render: function render(h, params) {
                    var that = _this;
                    var item = params.row;
                    var ops = [];
                    var op1 = h('div', {
                        class: 'hover',
                        style: {
                            color: '#20bf64'
                        },
                        on: {
                            'click': function click(e) {
                                that.selection = item;
                                that.$emit('kucunmobanSelected', that.selection);
                                e.stopPropagation();
                            }
                        }
                    }, '确定');
                    ops.push(op1);
                    return h('div', { class: 'center' }, ops);
                }
            }],
            yaohuojigous: []
        };
    },
    mounted: function mounted() {
        this.loadData();
    },

    methods: {
        clearKeywords: function clearKeywords() {
            this.query.keywords = '';
            this.usedKeywords = '';
            this.loadData();
        },
        keywordsChanged: function keywordsChanged() {
            this.usedKeywords = this.query.keywords;
            this.page.current = 1;
            this.loadData();
        },
        pageChanged: function pageChanged(value) {
            this.page.current = value;
            this.loadData();
        },
        loadData: function loadData() {
            var that = this;
            that.loading = true;
            that.$api.post('/web/main/kucunmobanselector/load', {
                jigouId: this.jigou ? this.jigou._id : null,
                query: this.query,
                page: this.page,
                fields: {
                    _id: 1,
                    code: 1,
                    name: 1,
                    'wupins._id': 1,
                    'wupins.name': 1,
                    'wupins.code': 1
                }
            }).then(function (res) {
                that.loading = false;
                if (that.query.init) {
                    that.query.init = false;
                    // that.shouhuojigous = res.data.shouhuojigous
                }
                that.total = res.data.total;
                that.usedKeywords = that.query.keywords;
                var kucunmobans = res.data.kucunmobans;
                // for (let kucunmoban of kucunmobans) {}
                that.kucunmobans = kucunmobans;
            }, function () {
                that.loading = false;
            });
        },
        search: function search() {
            this.loadData();
        },
        cancel: function cancel() {
            this.$emit('cancel');
        }
    }
});

/***/ }),

/***/ "JKNl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jg8W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_constants_route_js__ = __webpack_require__("nLDP");
/**订货商城路由 */

var mallSettings = function mallSettings() {
  return __webpack_require__.e/* import() */(75).then(__webpack_require__.bind(null, "Eqg0"));
}; /**商城配置 */
var mallCategoryManage = function mallCategoryManage() {
  return __webpack_require__.e/* import() */(57).then(__webpack_require__.bind(null, "ERd2"));
}; /**商城分类管理 */
var mallGoodsManage = function mallGoodsManage() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, "RKhO"));
}; /**商品管理 */
var mallDress = function mallDress() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, "NiVA"));
}; /**商品装扮 */
var settingSet = function settingSet() {
  return __webpack_require__.e/* import() */(72).then(__webpack_require__.bind(null, "081Z"));
}; /**商城配置设置 */
var saveGood = function saveGood() {
  return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, "+/Eq"));
}; /**商品管理编辑 */
/* harmony default export */ __webpack_exports__["a"] = ([{
  path: __WEBPACK_IMPORTED_MODULE_0__helpers_constants_route_js__["a" /* ROUTE */].MALL_SETTINGS, /**商城配置 */
  component: mallSettings,
  name: '商城配置',
  meta: {
    title: '商城配置'
    // children: [
    //   {
    //     path: '/set', /**商城配置设置 */
    //     meta: {title: '配置商城'},
    //     component: settingSet
    //   }
    // ]
  } }, {
  path: __WEBPACK_IMPORTED_MODULE_0__helpers_constants_route_js__["a" /* ROUTE */].MALL_CATEGORY_MANAGE, /**商城分类管理 */
  name: '商品分类管理',
  component: mallCategoryManage,
  meta: { title: '商品分类管理' }
}, {
  path: __WEBPACK_IMPORTED_MODULE_0__helpers_constants_route_js__["a" /* ROUTE */].MALL_GOODS_MANAGE, /**商品管理 */
  component: mallGoodsManage,
  name: '商品管理',
  meta: { title: '商品管理' }
}, {
  path: __WEBPACK_IMPORTED_MODULE_0__helpers_constants_route_js__["a" /* ROUTE */].MALL_DRESS, /**商品装扮 */
  component: mallDress,
  name: '商城装修',
  meta: { title: '商城装修' }
}, {
  path: __WEBPACK_IMPORTED_MODULE_0__helpers_constants_route_js__["a" /* ROUTE */].SETTING_SET, /**商城配置设置 */
  name: '配置商城',
  meta: { title: '配置商城' },
  component: settingSet
}, {
  path: __WEBPACK_IMPORTED_MODULE_0__helpers_constants_route_js__["a" /* ROUTE */].SAVE_GOOD, /**商品管理编辑 */
  name: '创建商品',
  meta: { title: '创建商品' },
  component: saveGood
}]);

/***/ }),

/***/ "KF/o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        options: {
            type: Object,
            default: {}
        }
    },
    data: function data() {
        return {
            session: this.$store.session,
            query: {},
            inputing: {},
            loading: true
        };
    },
    mounted: function mounted() {
        this.init();
        this.loadQuery();
    },

    methods: {
        saveQuery: function saveQuery() {
            sessionStorage[this.$store.session.zhanghao._id + ':query:' + this.options.page] = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.query);
        },
        loadQuery: function loadQuery() {
            if (this.options.page) {
                var savedData = sessionStorage[this.$store.session.zhanghao._id + ':query:' + this.options.page];
                if (savedData) {
                    var data = JSON.parse(savedData);
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.options.items), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var item = _step.value;

                            if (item.nocache) continue;
                            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data).indexOf(item.key) != -1) {
                                var value = data[item.key];
                                this.query[item.key] = value;
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    this.$emit('on-load', this.query);
                } else {
                    this.$emit('on-load', this.query);
                }
            }
        },
        init: function init() {
            var query = { init: true
                // 不再在初始化时过滤vif项，改为在模板中动态显示
                // this.options.items = this.options.items.filter(o => !o.vif || o.vif())
            };var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.options.items), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var item = _step2.value;

                    if (item.default === undefined) {
                        if (item.multi) {
                            item.default = [];
                        } else {
                            item.default = null;
                        }
                    }
                    query[item.key] = item.default;
                    if (item.type == 'selection') {
                        if (item.multi) {
                            if (!item['max-tag-count']) item['max-tag-count'] = 0;
                            if (!item['max-tag-placeholder']) {
                                item['max-tag-placeholder'] = function (count) {
                                    return '\u5DF2\u9009' + count + '\u9879';
                                };
                            }
                        }
                        if (!item.render) {
                            item.render = function (data) {
                                if (data && data.name) {
                                    return data.name;
                                } else {
                                    return data;
                                }
                            };
                        }
                        if (item.clearable === undefined) item.clearable = true;
                    } else if (item.riqitypes && item.riqitype) {
                        query['riqitype'] = item.riqitype;
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            query.options = this.options;
            this.query = query;
            this.loading = false;
            this.inputing = {};
        },
        textChanged: function textChanged(item) {
            this.query[item.key] = this.inputing[item.key];
            this.$set(this.query, item.key, this.query[item.key]);
            if (!this.options.confirm) this.doQuery();
        },
        textEdit: function textEdit(item) {
            var _this = this;

            this.query[item.key] = '';
            // this.inputing[item.key] = ''
            setTimeout(function () {
                var input = _this.$refs['input:' + item.key][0];
                if (input) input.focus();
            }, 200);
            // if (!this.options.confirm) this.doQuery()
        },
        textClear: function textClear(item) {
            var _this2 = this;

            this.query[item.key] = '';
            this.inputing[item.key] = '';
            setTimeout(function () {
                var input = _this2.$refs['input:' + item.key][0];
                if (input) input.focus();
            }, 200);
            if (!this.options.confirm) this.doQuery();
        },
        numberrangeEdit: function numberrangeEdit(item) {
            var _this3 = this;

            this.query[item.key] = null;
            // this.inputing[item.key] = ''
            setTimeout(function () {
                var input = _this3.$refs['input:' + item.key + '_min'][0];
                if (input) input.focus();
            }, 200);
            // if (!this.options.confirm) this.doQuery()
        },
        numberrangeClear: function numberrangeClear(item) {
            var _this4 = this;

            this.query[item.key] = null;
            this.inputing[item.key] = '';
            setTimeout(function () {
                var input = _this4.$refs['input:' + item.key + '_min'][0];
                if (input) input.focus();
            }, 200);
            if (!this.options.confirm) this.doQuery();
        },
        daterangeChanged: function daterangeChanged(item, value) {
            this.query[item.key] = value;
            if (!this.options.confirm) this.doQuery();
        },
        riqitypeChanged: function riqitypeChanged(item, value) {
            this.query['riqitype'] = value;
            if (!this.options.confirm) this.doQuery();
        },
        selectorChanged: function selectorChanged(item, value) {
            if (item.loader) item.selections = item.loader();
            var selections = [];
            if (item.group) {
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(item.selections)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var key = _step3.value;

                        selections = selections.concat(item.selections[key]);
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
            } else {
                selections = item.selections;
            }
            if (item.multi) {
                var result = [];
                var _iteratorNormalCompletion4 = true;
                var _didIteratorError4 = false;
                var _iteratorError4 = undefined;

                try {
                    for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(value), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                        var i = _step4.value;
                        var _iteratorNormalCompletion5 = true;
                        var _didIteratorError5 = false;
                        var _iteratorError5 = undefined;

                        try {
                            for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(selections), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                                var selection = _step5.value;

                                if (item.render(selection) == i) {
                                    result.push(this.simple(selection, item._fields));
                                    break;
                                }
                            }
                        } catch (err) {
                            _didIteratorError5 = true;
                            _iteratorError5 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                                    _iterator5.return();
                                }
                            } finally {
                                if (_didIteratorError5) {
                                    throw _iteratorError5;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError4 = true;
                    _iteratorError4 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
                            _iterator4.return();
                        }
                    } finally {
                        if (_didIteratorError4) {
                            throw _iteratorError4;
                        }
                    }
                }

                this.query[item.key] = result;
            } else {
                if (value === undefined) {
                    this.query[item.key] = undefined;
                } else {
                    var _iteratorNormalCompletion6 = true;
                    var _didIteratorError6 = false;
                    var _iteratorError6 = undefined;

                    try {
                        for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(selections), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                            var _selection = _step6.value;

                            if (item.render(_selection) == value) {
                                this.query[item.key] = this.simple(_selection, item._fields);
                                break;
                            }
                        }
                    } catch (err) {
                        _didIteratorError6 = true;
                        _iteratorError6 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion6 && _iterator6.return) {
                                _iterator6.return();
                            }
                        } finally {
                            if (_didIteratorError6) {
                                throw _iteratorError6;
                            }
                        }
                    }
                }
            }
            if (item.change) {
                item.change({ value: this.query[item.key], query: this.query, item: item });
            }

            if (!this.options.confirm) this.doQuery();
        },
        doQuery: function doQuery() {
            this.$emit('on-query', this.query);
            this.saveQuery();
        },
        jigouChanged: function jigouChanged(item, value) {
            this.query[item.key] = value;
            if (!this.options.confirm) this.doQuery();
        },
        numberrangeChanged: function numberrangeChanged(item) {
            this.query[item.key] = [this.inputing[item.key + '_min'], this.inputing[item.key + '_max']];
            if (!this.options.confirm) this.doQuery();
        }
    }
});

/***/ }),

/***/ "LJOd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LZ00":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tags-nav"
  }, [_c('div', {
    staticClass: "close-con"
  }, [_c('Dropdown', {
    staticStyle: {
      "margin-top": "7px"
    },
    attrs: {
      "transfer": ""
    },
    on: {
      "on-click": _vm.handleTagsOption
    }
  }, [_c('Button', {
    attrs: {
      "size": "small",
      "type": "text"
    }
  }, [_c('Icon', {
    attrs: {
      "size": 18,
      "type": "ios-close-circle-outline"
    }
  })], 1), _vm._v(" "), _c('DropdownMenu', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('DropdownItem', {
    attrs: {
      "name": "close-all"
    }
  }, [_vm._v("关闭所有")]), _vm._v(" "), _c('DropdownItem', {
    attrs: {
      "name": "close-others"
    }
  }, [_vm._v("关闭其他")])], 1)], 1)], 1), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "contextmenu",
    style: ({
      left: _vm.contextMenuLeft + 'px',
      top: _vm.contextMenuTop + 'px'
    })
  }, _vm._l((_vm.menuList), function(item, key) {
    return _c('li', {
      key: key,
      on: {
        "click": function($event) {
          return _vm.handleTagsOption(key)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "btn-con left-btn"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.handleScroll(240)
      }
    }
  }, [_c('Icon', {
    attrs: {
      "size": 18,
      "type": "ios-arrow-back"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-con right-btn"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.handleScroll(-240)
      }
    }
  }, [_c('Icon', {
    attrs: {
      "size": 18,
      "type": "ios-arrow-forward"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    ref: "scrollOuter",
    staticClass: "scroll-outer",
    on: {
      "DOMMouseScroll": _vm.handlescroll,
      "mousewheel": _vm.handlescroll
    }
  }, [_c('div', {
    ref: "scrollBody",
    staticClass: "scroll-body",
    style: ({
      left: _vm.tagBodyLeft + 'px'
    })
  }, [_c('transition-group', {
    attrs: {
      "name": "taglist-moving-animation"
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('Tag', {
      key: ("tag-nav-" + index),
      ref: "tagsPageOpened",
      refInFor: true,
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "dot",
        "name": item.name,
        "data-route-item": item,
        "closable": _vm.list.length > 1,
        "color": _vm.isCurrentTag(item) ? '#20bf64' : 'default'
      },
      on: {
        "on-close": function($event) {
          return _vm.handleClose(item)
        }
      },
      nativeOn: {
        "click": function($event) {
          return _vm.handleClick(item)
        },
        "contextmenu": function($event) {
          $event.preventDefault();
          return _vm.contextMenu(item, $event)
        }
      }
    }, [_vm._v(_vm._s(_vm.showTitleInside(item)))])
  }), 1)], 1)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LfpU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__logics_services_common__ = __webpack_require__("SRib");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var commonService = new __WEBPACK_IMPORTED_MODULE_4__logics_services_common__["a" /* default */]();
/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        //参数
        parameter: {
            type: Object,
            default: function _default() {}
        },
        placeholder: {
            type: String,
            default: '请选择'
        },
        value: { //需要回显的数据
            type: [Object, Array]
        },
        type: {
            type: String,
            default: 'organization' //organization机构、supplier供应商、warehouse仓库、category类别
        },
        readonly: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        autoload: {
            type: Boolean,
            default: false
        },
        //是否多选
        multiple: {
            type: Boolean,
            default: false
        },
        //没有请求的options
        options: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        //是否展示清空
        clear: {
            type: Boolean,
            default: true
        },
        width: {
            type: String
        },
        transfer: {
            type: Boolean
        },
        fields: {
            type: Object
        },
        sort: Object
    },
    watch: {
        parameter: {
            deep: true,
            immediate: true, //深度监听设置为 true
            handler: function handler(val) {
                this.optionsObj = val;
                if (val && this.autoload) {
                    this.optionsObj = val;
                    this.inputValue = val.keywords;
                    this.page = 1;
                    this.currentValue = this.value;
                    this.selectScroll(this.value);
                }
            }
        },
        options: {
            deep: true,
            handler: function handler(val) {
                this.fixationOptions = val;
            }
        },
        value: {
            deep: true,
            handler: function handler(val) {
                if (!val) {
                    this.content = val;
                    this.inputValue = '';
                    this.currentValue = null;
                    return;
                }
                if (val.name !== undefined) {
                    this.content = val;
                    var label = this.content ? this.content.name : '';
                    // this.optionsObj.keywords = label
                    this.inputValue = label;
                } else {
                    // this.optionsObj.keywords = ''
                    this.inputValue = '';
                    this.content = null;
                }
                if (!this.multiple) {
                    this.page = 1;
                }
                this.currentValue = val;
                // this.selectScroll()
            }
        }
    },
    computed: {
        inputStyle: function inputStyle() {
            var _this = this;

            var style = {};
            if (this.multiple) {
                if (this.values && this.values.length == 0 || this.options && this.options.length && this.constValues && this.constValues.length == 0) {
                    style.width = this.width || '100%';
                } else {
                    style.width = this.width || (this.inputValue ? this.inputValue.length : 0) * 12 + 20 + 'px' || (this.constinputValue ? this.constinputValue.length : 0) * 12 + 20 + 'px';
                    this.$nextTick(function () {
                        _this.paddTop = _this.$refs.multipleR.offsetHeight;
                    });
                }
            }
            return style;
        },
        selectionWidth: function selectionWidth() {
            var maxlength = Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(this.options.map(function (item) {
                return (item.name ? item.name : item).length;
            })));
            return maxlength * 12 + 20;
        }
    },
    directives: {
        loadmore: {
            bind: function bind(el, binding) {
                el.addEventListener('scroll', function () {
                    var isBottom = this.scrollHeight - this.scrollTop <= this.clientHeight + 1;
                    //this.scrollHeight>281 搜索后不调用
                    if (isBottom && this.scrollHeight > 281) {
                        binding.value.loadMore();
                    }
                });
            }
        }
    },
    data: function data() {
        return {
            currentValue: null,
            optionsObj: {},
            flag: true,
            contentOptions: [], //options数据
            loading: false, //是否加载中
            isAllLoaded: false, //是否还有更多数据
            isDeleteButton: false, //是否显示删除
            content: null, //选中的机构对象
            inputValue: '', //输入框的值
            current: '', //下拉框悬浮，高亮
            totalTenants: 0, //总数量
            contentShow: false, //下拉框是否显示
            timeout: null,
            inited: false,
            count: 0,
            page: 1,
            session: this.$store.session,
            values: [],
            constValues: [],
            paddTop: 30,
            fixationOptions: [],
            constinputValue: '',
            multiChanged: false
        };
    },
    mounted: function mounted() {
        if (this.options.length) this.fixationOptions = this.options;
        this.optionsObj = this.parameter;
        document.addEventListener('click', this.outClick);
        if (this.multiple) {
            console.log('this.value', this.value);
            this.values = this.value || [];
        } else {
            if (!this.value) {
                this.content = this.value;
                this.inputValue = '';
                return;
            }
            if (this.value.name !== undefined) {
                this.content = this.value;
                this.currentValue = this.value;
                var label = this.content ? this.content.name : '';
                this.inputValue = label;
            } else {
                this.inputValue = '';
                this.content = null;
            }
        }
    },
    destroyed: function destroyed() {
        document.removeEventListener('click', this.outClick);
    },

    methods: {
        shopInput: function shopInput() {
            var _this2 = this;

            var copyZhanghao = this.copy(this.options);
            var list = copyZhanghao.filter(function (row) {
                return row.name.indexOf(_this2.constinputValue) > -1;
            });
            this.fixationOptions = list;
        },
        constClick: function constClick(row, index) {
            var _this3 = this;

            this.current = index;
            if (this.constValues.some(function (item) {
                return item.name == row.name;
            })) {
                var i = this.constValues.findIndex(function (item) {
                    return item.name == row.name;
                });
                this.constValues.splice(i, 1);
            } else {
                this.constValues.push(row);
            }
            this.$nextTick(function () {
                _this3.paddTop = _this3.$refs.multipleR.offsetHeight;
            });
            this.dataChanged(this.constValues);
        },
        loadMoreGroup: function loadMoreGroup() {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
                var list;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!(_this4.totalTenants == _this4.contentOptions.length)) {
                                    _context.next = 2;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 2:
                                _this4.page++;
                                _this4.optionsObj.page = _this4.page;
                                _this4.optionsObj.size = 10;
                                list = void 0;

                                if (!(_this4.type == "organization" || _this4.type == "jigou")) {
                                    _context.next = 12;
                                    break;
                                }

                                _context.next = 9;
                                return commonService.getOrganiztion(_this4.optionsObj);

                            case 9:
                                list = _context.sent;
                                _context.next = 69;
                                break;

                            case 12:
                                if (!(_this4.type == "supplier" || _this4.type == "gonghuojigou")) {
                                    _context.next = 18;
                                    break;
                                }

                                _context.next = 15;
                                return commonService.getSublevel(_this4.optionsObj);

                            case 15:
                                list = _context.sent;
                                _context.next = 69;
                                break;

                            case 18:
                                if (!(_this4.type == 'warehouse' || _this4.type == "cangku")) {
                                    _context.next = 24;
                                    break;
                                }

                                _context.next = 21;
                                return commonService.getwarehouse(_this4.optionsObj);

                            case 21:
                                list = _context.sent;
                                _context.next = 69;
                                break;

                            case 24:
                                if (!(_this4.type == 'category' || _this4.type == "leibie")) {
                                    _context.next = 30;
                                    break;
                                }

                                _context.next = 27;
                                return commonService.getCategory(_this4.optionsObj);

                            case 27:
                                list = _context.sent;
                                _context.next = 69;
                                break;

                            case 30:
                                if (!(_this4.type == 'bumen')) {
                                    _context.next = 36;
                                    break;
                                }

                                _context.next = 33;
                                return commonService.getBumen(_this4.optionsObj);

                            case 33:
                                list = _context.sent;
                                _context.next = 69;
                                break;

                            case 36:
                                if (!(_this4.type == 'biaoqian')) {
                                    _context.next = 42;
                                    break;
                                }

                                _context.next = 39;
                                return commonService.getBiaoqian(_this4.optionsObj);

                            case 39:
                                list = _context.sent;
                                _context.next = 69;
                                break;

                            case 42:
                                if (!(_this4.type == 'yuanyin')) {
                                    _context.next = 48;
                                    break;
                                }

                                _context.next = 45;
                                return commonService.getYuanyin(_this4.optionsObj);

                            case 45:
                                list = _context.sent;
                                _context.next = 69;
                                break;

                            case 48:
                                if (!(_this4.type == 'wupin')) {
                                    _context.next = 54;
                                    break;
                                }

                                _context.next = 51;
                                return commonService.getWupin(_this4.optionsObj);

                            case 51:
                                list = _context.sent;
                                _context.next = 69;
                                break;

                            case 54:
                                if (!(_this4.type == 'caipin')) {
                                    _context.next = 60;
                                    break;
                                }

                                _context.next = 57;
                                return commonService.getCaipin(_this4.optionsObj);

                            case 57:
                                list = _context.sent;
                                _context.next = 69;
                                break;

                            case 60:
                                if (!(_this4.type == 'waixiaokehu')) {
                                    _context.next = 66;
                                    break;
                                }

                                _context.next = 63;
                                return commonService.getWaixiaokehu(_this4.optionsObj);

                            case 63:
                                list = _context.sent;
                                _context.next = 69;
                                break;

                            case 66:
                                _context.next = 68;
                                return commonService.getItems(_this4.optionsObj, _this4.type);

                            case 68:
                                list = _context.sent;

                            case 69:
                                if (list.success) {
                                    // this.totalTenants = list.total
                                    _this4.loading = false;
                                    if (_this4.type == "organization" || _this4.type == "jigou") {
                                        _this4.contentOptions = _this4.contentOptions.concat(list.jigous);
                                    } else if (_this4.type == "supplier" || _this4.type == "gonghuojigou") {
                                        _this4.contentOptions = _this4.contentOptions.concat(list.gonghuojigous);
                                    } else if (_this4.type == 'warehouse' || _this4.type == "cangku") {
                                        _this4.contentOptions = _this4.contentOptions.concat(list.cangkus);
                                    } else if (_this4.type == 'category' || _this4.type == "leibie") {
                                        _this4.contentOptions = _this4.contentOptions.concat(list.leibies);
                                    } else if (_this4.type == 'bumen') {
                                        _this4.contentOptions = _this4.contentOptions.concat(list.bumens);
                                    } else if (_this4.type == 'biaoqian') {
                                        _this4.contentOptions = _this4.contentOptions.concat(list.biaoqians);
                                    } else if (_this4.type == 'yuanyin') {
                                        _this4.contentOptions = _this4.contentOptions.concat(list.yuanyins);
                                    } else if (_this4.type == 'wupin') {
                                        _this4.contentOptions = _this4.contentOptions.concat(list.wupins);
                                    } else if (_this4.type == 'caipin') {
                                        _this4.contentOptions = _this4.contentOptions.concat(list.caipins);
                                    } else if (_this4.type == 'waixiaokehu') {
                                        _this4.contentOptions = _this4.contentOptions.concat(list.waixiaokehus);
                                    } else {
                                        _this4.contentOptions = _this4.contentOptions.concat(list.items);
                                    }
                                    if (_this4.content) _this4.current = _this4.contentOptions.findIndex(function (o) {
                                        return o._id == _this4.content._id;
                                    });
                                }

                            case 70:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this4);
            }))();
        },
        dataChanged: function dataChanged(value) {
            if (this.multiple) {
                this.currentValue = value;
                this.multiChanged = false;
                this.$emit('change', value);
            } else {
                if (value === null || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.currentValue) != __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value)) {
                    this.currentValue = value;
                    this.$emit('change', value);
                }
            }
        },
        handleClose: function handleClose() {
            if (this.options.length == 0) {
                this.values.splice(0, 1);
                if (this.values.length == 0) {
                    this.paddTop = 30;
                    this.content = null;
                    this.inputValue = '';
                }
                this.dataChanged(this.values);
            } else {
                this.constValues.splice(0, 1);
                this.dataChanged(this.constValues);
            }
            if (this.constValues.length == 0) {
                this.paddTop = 30;
            }
        },
        outClick: function outClick(e) {
            var dropRef = this.$refs.dropRef;
            if (dropRef && !dropRef.contains(e.target) && this.contentShow) {
                if (this.multiple) {
                    if (this.options.length > 0) {
                        if (this.multiChanged) this.dataChanged(this.constValues);
                    } else {
                        if (this.multiChanged) this.dataChanged(this.values);
                    }
                } else if (!this.inputValue || !this.content || this.content && this.inputValue != this.content.name) {
                    this.content = null;
                    this.inputValue = '';
                    this.dataChanged(this.content);
                }
                this.contentShow = false;
            }
        },

        // 清除input值事件
        deleteButtonClick: function deleteButtonClick() {
            if (this.multiple) {
                this.values = [];
                this.constValues = [];
                this.paddTop = 30;
                this.constinputValue = '';
            }
            this.content = null;
            this.inputValue = '';
            this.current = '';
            this.page = 1;
            this.selectScroll();
            this.dataChanged(this.content);
        },
        selectUp: function selectUp() {
            this.count++;
            this.contentShow = !this.contentShow;
            if (this.$refs.inputVal) this.$refs.inputVal.focus();
            if (!this.autoload && this.count == 1) {
                this.selectScroll(this.content);
            }
        },

        // select框键盘弹起事件（键盘弹起时，触发搜索事件）
        selectKeyDown: function selectKeyDown() {
            // 向后台查询时，将原来select框的值置空
            if (this.flag) {
                this.contentOptions = [];
                // // 重新获取数据
                // this.selectScroll();
                // 搜索时弹出下拉列表
                this.page = 1;
                this.contentShow = true;
                if (this.timeout) {
                    clearTimeout(this.timeout);
                }
                this.timeout = setTimeout(this.selectScroll, 500);
            }
        },

        // 请求options数据 //需根据后端返回判断是否加载完毕
        selectScroll: function selectScroll() {
            var _this5 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var label, list, current, newvalue;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!(!_this5.optionsObj || _this5.readonly)) {
                                    _context2.next = 2;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 2:
                                //没有传入搜索参数时暂不加载（避免页面初始化时，多次加载）
                                _this5.loading = true;
                                label = _this5.inputValue;

                                if (_this5.optionsObj.keywords === undefined) {
                                    _this5.optionsObj.keywords = '';
                                } else {
                                    _this5.optionsObj.keywords = label;
                                }
                                _this5.optionsObj.size = 10;
                                _this5.optionsObj.page = _this5.page;
                                _this5.optionsObj.fields = _this5.fields;
                                _this5.optionsObj.sort = _this5.sort;
                                if (_this5.parameter.queryfn) {
                                    _this5.optionsObj.query = _this5.parameter.queryfn();
                                    console.log('this.optionsObj.query', _this5.optionsObj.query);
                                }
                                list = void 0;

                                if (!(_this5.type == "organization" || _this5.type == "jigou")) {
                                    _context2.next = 17;
                                    break;
                                }

                                _context2.next = 14;
                                return commonService.getOrganiztion(_this5.optionsObj);

                            case 14:
                                list = _context2.sent;
                                _context2.next = 74;
                                break;

                            case 17:
                                if (!(_this5.type == "supplier" || _this5.type == "gonghuojigou")) {
                                    _context2.next = 23;
                                    break;
                                }

                                _context2.next = 20;
                                return commonService.getSublevel(_this5.optionsObj);

                            case 20:
                                list = _context2.sent;
                                _context2.next = 74;
                                break;

                            case 23:
                                if (!(_this5.type == 'warehouse' || _this5.type == "cangku")) {
                                    _context2.next = 29;
                                    break;
                                }

                                _context2.next = 26;
                                return commonService.getwarehouse(_this5.optionsObj);

                            case 26:
                                list = _context2.sent;
                                _context2.next = 74;
                                break;

                            case 29:
                                if (!(_this5.type == 'category' || _this5.type == "leibie")) {
                                    _context2.next = 35;
                                    break;
                                }

                                _context2.next = 32;
                                return commonService.getCategory(_this5.optionsObj);

                            case 32:
                                list = _context2.sent;
                                _context2.next = 74;
                                break;

                            case 35:
                                if (!(_this5.type == 'bumen')) {
                                    _context2.next = 41;
                                    break;
                                }

                                _context2.next = 38;
                                return commonService.getBumen(_this5.optionsObj);

                            case 38:
                                list = _context2.sent;
                                _context2.next = 74;
                                break;

                            case 41:
                                if (!(_this5.type == 'biaoqian')) {
                                    _context2.next = 47;
                                    break;
                                }

                                _context2.next = 44;
                                return commonService.getBiaoqian(_this5.optionsObj);

                            case 44:
                                list = _context2.sent;
                                _context2.next = 74;
                                break;

                            case 47:
                                if (!(_this5.type == 'yuanyin')) {
                                    _context2.next = 53;
                                    break;
                                }

                                _context2.next = 50;
                                return commonService.getYuanyin(_this5.optionsObj);

                            case 50:
                                list = _context2.sent;
                                _context2.next = 74;
                                break;

                            case 53:
                                if (!(_this5.type == 'wupin')) {
                                    _context2.next = 59;
                                    break;
                                }

                                _context2.next = 56;
                                return commonService.getWupin(_this5.optionsObj);

                            case 56:
                                list = _context2.sent;
                                _context2.next = 74;
                                break;

                            case 59:
                                if (!(_this5.type == 'caipin')) {
                                    _context2.next = 65;
                                    break;
                                }

                                _context2.next = 62;
                                return commonService.getCaipin(_this5.optionsObj);

                            case 62:
                                list = _context2.sent;
                                _context2.next = 74;
                                break;

                            case 65:
                                if (!(_this5.type == 'waixiaokehu')) {
                                    _context2.next = 71;
                                    break;
                                }

                                _context2.next = 68;
                                return commonService.getWaixiaokehu(_this5.optionsObj);

                            case 68:
                                list = _context2.sent;
                                _context2.next = 74;
                                break;

                            case 71:
                                _context2.next = 73;
                                return commonService.getItems(_this5.optionsObj, _this5.type);

                            case 73:
                                list = _context2.sent;

                            case 74:
                                if (list.success) {
                                    _this5.totalTenants = list.total;
                                    _this5.loading = false;
                                    if (_this5.type == "organization" || _this5.type == "jigou") {
                                        _this5.contentOptions = list.jigous;
                                    } else if (_this5.type == "supplier" || _this5.type == "gonghuojigou") {
                                        _this5.contentOptions = list.gonghuojigous;
                                    } else if (_this5.type == 'warehouse' || _this5.type == "cangku") {
                                        _this5.contentOptions = list.cangkus;
                                    } else if (_this5.type == 'category' || _this5.type == "leibie") {
                                        _this5.contentOptions = list.leibies;
                                    } else if (_this5.type == 'bumen') {
                                        _this5.contentOptions = list.bumens;
                                    } else if (_this5.type == 'biaoqian') {
                                        _this5.contentOptions = list.biaoqians;
                                    } else if (_this5.type == 'yuanyin') {
                                        _this5.contentOptions = list.yuanyins;
                                    } else if (_this5.type == 'wupin') {
                                        _this5.contentOptions = list.wupins;
                                    } else if (_this5.type == 'caipin') {
                                        _this5.contentOptions = list.caipins;
                                    } else if (_this5.type == 'waixiaokehu') {
                                        _this5.contentOptions = list.waixiaokehus;
                                    } else {
                                        _this5.contentOptions = list.items;
                                    }
                                    current = _this5.currentValue;
                                    newvalue = void 0;

                                    if (current) {
                                        newvalue = _this5.contentOptions.findOne({ _id: current._id });
                                    }
                                    if (current && newvalue) {
                                        _this5.currentValue = newvalue;
                                        _this5.content = newvalue;
                                        _this5.label = newvalue.name;
                                        _this5.inputValue = _this5.label;
                                        _this5.current = _this5.contentOptions.findIndex(function (o) {
                                            return o._id == current._id;
                                        });
                                    } else if (_this5.contentOptions.length == list.total) {
                                        _this5.currentValue = null;
                                        _this5.content = null;
                                        _this5.label = '';
                                        _this5.inputValue = _this5.label;
                                        _this5.current = -1;
                                    }
                                }

                            case 75:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this5);
            }))();
        },

        // 下拉框内容点击事件
        contentClick: function contentClick(row, index) {
            var _this6 = this;

            if (this.multiple) {
                this.current = index;
                if (this.values.some(function (item) {
                    return (item._id || item.code) == (row._id || row.code);
                })) {
                    var i = this.values.findIndex(function (item) {
                        return (item._id || item.code) == (row._id || row.code);
                    });
                    this.values.splice(i, 1);
                } else {
                    this.values.push(row);
                }
                this.$nextTick(function () {
                    _this6.paddTop = _this6.$refs.multipleR.offsetHeight;
                });
                // this.dataChanged(this.values)
                this.currentValue = this.values;
                this.$emit('localSearchchange', this.values);
                this.multiChanged = true;
            } else {
                this.current = index;
                this.content = row;
                this.inputValue = this.content ? this.content.name : '';
                this.contentShow = false;
                this.dataChanged(row);
            }
        }
    }
});

/***/ }),

/***/ "LkXW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_mall__ = __webpack_require__("Jg8W");


/* harmony default export */ __webpack_exports__["a"] = ([{ path: '/', component: function component() {
        return __webpack_require__.e/* import() */(133).then(__webpack_require__.bind(null, "8hXn"));
    }, name: '首页', meta: { title: '首页' } }, { path: '/docs', component: function component() {
        return __webpack_require__.e/* import() */(110).then(__webpack_require__.bind(null, "bJb5"));
    }, name: '文档', meta: { title: '文档' } }, { path: '/forbidden', component: function component() {
        return __webpack_require__.e/* import() */(134).then(__webpack_require__.bind(null, "IIMP"));
    }, name: 'forbidden', meta: { title: 'forbidden' } }, { path: '/web/psgh/djlcyd', component: function component() {
        return __webpack_require__.e/* import() */(136).then(__webpack_require__.bind(null, "RubM"));
    }, name: 'djlcyd', meta: { title: 'djlcyd' } }, { path: '/web/jtsz/mdgl', component: function component() {
        return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, "MPhH"));
    }, name: '门店管理', meta: { title: '门店管理' } }, { path: '/web/jtsz/zzgl', component: function component() {
        return __webpack_require__.e/* import() */(48).then(__webpack_require__.bind(null, "rekq"));
    }, name: '组织管理', meta: { title: '组织管理' } }, { path: '/web/jtsz/yggl', component: function component() {
        return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, "s+vF"));
    }, name: '员工管理1', meta: { title: '员工管理' } }, { path: '/web/jcsz/wpgl', component: function component() {
        return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, "bdS8"));
    }, name: '物品管理', meta: { title: '物品管理' } }, { path: '/web/jcsz/gysgl', component: function component() {
        return __webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, "D6AR"));
    }, name: '供应商管理', meta: { title: '供应商管理' } }, { path: '/web/jcsz/wxkhgl', component: function component() {
        return __webpack_require__.e/* import() */(88).then(__webpack_require__.bind(null, "dJ95"));
    }, name: '外销客户管理', meta: { title: '外销客户管理' } }, { path: '/web/jcsz/ckgl', component: function component() {
        return __webpack_require__.e/* import() */(89).then(__webpack_require__.bind(null, "6ZYX"));
    }, name: '仓库管理', meta: { title: '仓库管理' } }, { path: '/web/jcsz/ckwpgz', component: function component() {
        return __webpack_require__.e/* import() */(81).then(__webpack_require__.bind(null, "jzO1"));
    }, name: '仓库物品规则', meta: { title: '仓库物品规则' } }, { path: '/web/jcsz/cbkgl', component: function component() {
        return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, "dUpJ"));
    }, name: '成本卡管理', meta: { title: '成本卡管理' } }, { path: '/web/jcsz/yygl', component: function component() {
        return __webpack_require__.e/* import() */(113).then(__webpack_require__.bind(null, "0j76"));
    }, name: '原因管理', meta: { title: '原因管理' } }, { path: '/web/jcsz/wlfs', component: function component() {
        return __webpack_require__.e/* import() */(115).then(__webpack_require__.bind(null, "8WYD"));
    }, name: '物流方式', meta: { title: '物流方式' } }, { path: '/web/jcsz/xggl', component: function component() {
        return __webpack_require__.e/* import() */(114).then(__webpack_require__.bind(null, "9vBy"));
    }, name: '箱规', meta: { title: '箱规' } }, { path: '/web/jcsz/fylx', component: function component() {
        return __webpack_require__.e/* import() */(116).then(__webpack_require__.bind(null, "e4RZ"));
    }, name: '费用类型管理', meta: { title: '费用类型管理' } }, { path: '/web/psgh/psxy', component: function component() {
        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "QdhF"));
    }, name: '配送协议1', meta: { title: '配送协议' } }, { path: '/web/psgh/pssqsh', component: function component() {
        return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "l1TS"));
    }, name: '配送申请审核', meta: { title: '配送申请审核' } }, { path: '/web/psgh/psdd', component: function component() {
        return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, "ivp/"));
    }, name: '配送订单', meta: { title: '配送订单' } }, { path: '/web/psgh/psfhd', component: function component() {
        return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, "vn+y"));
    }, name: '配送发货单', meta: { title: '配送发货单' } }, { path: '/web/psgh/psfhsh', component: function component() {
        return __webpack_require__.e/* import() */(58).then(__webpack_require__.bind(null, "Hffb"));
    }, name: '配送返货审核', meta: { title: '配送返货审核' } }, { path: '/web/psgh/sfhcycl', component: function component() {
        return __webpack_require__.e/* import() */(79).then(__webpack_require__.bind(null, "nHre"));
    }, name: '收发货差异处理', meta: { title: '收发货差异处理' } }, { path: '/web/psgh/yhgz', component: function component() {
        return __webpack_require__.e/* import() */(78).then(__webpack_require__.bind(null, "Agdg"));
    }, name: '要货规则1', meta: { title: '要货规则' } }, { path: '/web/psgh/psxl', component: function component() {
        return __webpack_require__.e/* import() */(80).then(__webpack_require__.bind(null, "K4F9"));
    }, name: '配送线路', meta: { title: '配送线路' } }, { path: '/web/psgh/pstjd', component: function component() {
        return __webpack_require__.e/* import() */(54).then(__webpack_require__.bind(null, "SMil"));
    }, name: '配送调价单', meta: { title: '配送调价单' } }, { path: '/web/psgh/psmb', component: function component() {
        return __webpack_require__.e/* import() */(68).then(__webpack_require__.bind(null, "wWaf"));
    }, name: '配送模板1', meta: { title: '配送模板' } }, { path: '/web/psgh/xsyc', component: function component() {
        return __webpack_require__.e/* import() */(109).then(__webpack_require__.bind(null, "vQ9H"));
    }, name: '销售预测', meta: { title: '销售预测' } }, { path: '/web/psgh/zndjsz', component: function component() {
        return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, "DCSD"));
    }, name: '智能定价设置', meta: { title: '智能定价设置' } }, { path: '/web/psgh/psfy', component: function component() {
        return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, "Ip9g"));
    }, name: '配送费用', meta: { title: '配送费用' } }, { path: '/web/psgh/cxhd', component: function component() {
        return __webpack_require__.e/* import() */(74).then(__webpack_require__.bind(null, "qtb3"));
    }, name: '促销活动', meta: { title: '促销活动' } }, { path: '/web/psgh/yhqgl', component: function component() {
        return __webpack_require__.e/* import() */(62).then(__webpack_require__.bind(null, "2hAp"));
    }, name: '优惠券管理', meta: { title: '优惠券管理' } }, { path: '/web/psyh/psxy', component: function component() {
        return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, "1vFZ"));
    }, name: '配送协议2', meta: { title: '配送协议' } }, { path: '/web/psyh/pssqd', component: function component() {
        return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, "pxmf"));
    }, name: '配送申请单', meta: { title: '配送申请单' } }, { path: '/web/psyh/psshd', component: function component() {
        return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, "mkvY"));
    }, name: '配送收货单', meta: { title: '配送收货单' } }, { path: '/web/psyh/psfhd', component: function component() {
        return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, "0Q94"));
    }, name: '配送返货单', meta: { title: '配送返货单' } }, { path: '/web/psyh/yhgz', component: function component() {
        return __webpack_require__.e/* import() */(77).then(__webpack_require__.bind(null, "D+If"));
    }, name: '要货规则2', meta: { title: '要货规则' } }, { path: '/web/psyh/psmb', component: function component() {
        return __webpack_require__.e/* import() */(67).then(__webpack_require__.bind(null, "bSVk"));
    }, name: '配送模板2', meta: { title: '配送模板' } }, { path: '/web/psyh/zncg', component: function component() {
        return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, "wWO1"));
    }, name: '智能采购1', meta: { title: '智能采购' } }, { path: '/web/kcgl/ckqcsz', component: function component() {
        return __webpack_require__.e/* import() */(65).then(__webpack_require__.bind(null, "6Ygn"));
    }, name: '仓库期初设置', meta: { title: '仓库期初设置' } }, { path: '/web/kcgl/wpck', component: function component() {
        return __webpack_require__.e/* import() */(59).then(__webpack_require__.bind(null, "ihYF"));
    }, name: '物品出库', meta: { title: '物品出库' } }, { path: '/web/kcgl/wprk', component: function component() {
        return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, "1u6V"));
    }, name: '物品入库', meta: { title: '物品入库' } }, { path: '/web/kcgl/wppd', component: function component() {
        return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, "0H+w"));
    }, name: '物品盘点', meta: { title: '物品盘点' } }, { path: '/web/kcgl/wpdb', component: function component() {
        return __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, "oKlW"));
    }, name: '物品调拨', meta: { title: '物品调拨' } }, { path: '/web/kcgl/wpyk', component: function component() {
        return __webpack_require__.e/* import() */(63).then(__webpack_require__.bind(null, "OR4X"));
    }, name: '物品移库', meta: { title: '物品移库' } }, { path: '/web/kcgl/qmcbtz', component: function component() {
        return __webpack_require__.e/* import() */(64).then(__webpack_require__.bind(null, "ZncR"));
    }, name: '期末成本调整', meta: { title: '期末成本调整' } }, { path: '/web/kcgl/wpxhd', component: function component() {
        return __webpack_require__.e/* import() */(85).then(__webpack_require__.bind(null, "Qcoc"));
    }, name: '物品消耗单', meta: { title: '物品消耗单' } }, { path: '/web/kcgl/kcmb', component: function component() {
        return __webpack_require__.e/* import() */(86).then(__webpack_require__.bind(null, "z4x5"));
    }, name: '库存模板', meta: { title: '库存模板' } }, { path: '/web/cggl/cgmb', component: function component() {
        return __webpack_require__.e/* import() */(90).then(__webpack_require__.bind(null, "w+UI"));
    }, name: '采购模板', meta: { title: '采购模板' } }, { path: '/web/cggl/cgxy', component: function component() {
        return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, "whGt"));
    }, name: '采购协议', meta: { title: '采购协议' } }, { path: '/web/cggl/cgxq', component: function component() {
        return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, "8jVt"));
    }, name: '采购需求', meta: { title: '采购需求' } }, { path: '/web/cggl/cgdd', component: function component() {
        return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, "cvvM"));
    }, name: '采购订单1', meta: { title: '采购订单' } }, { path: '/web/cggl/cgsh', component: function component() {
        return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, "pjTB"));
    }, name: '采购收货1', meta: { title: '采购收货' } }, { path: '/web/cggl/cgth', component: function component() {
        return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, "mBt8"));
    }, name: '采购退货1', meta: { title: '采购退货' } }, { path: '/web/cggl/mdzcddsh', component: function component() {
        return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, "6pde"));
    }, name: '门店自采订单审核', meta: { title: '门店自采订单审核' } }, { path: '/web/cggl/mdzcthsh', component: function component() {
        return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, "YrwI"));
    }, name: '门店采购退货审核', meta: { title: '门店采购退货审核' } }, { path: '/web/cggl/cgtjd', component: function component() {
        return __webpack_require__.e/* import() */(55).then(__webpack_require__.bind(null, "h2SW"));
    }, name: '采购调价单', meta: { title: '采购调价单' } }, { path: '/web/cggl/zncg', component: function component() {
        return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, "SQ8r"));
    }, name: '智能采购2', meta: { title: '智能采购' } }, { path: '/web/lygl/lydd', component: function component() {
        return __webpack_require__.e/* import() */(84).then(__webpack_require__.bind(null, "EM65"));
    }, name: '联营订单', meta: { title: '联营订单' } }, { path: '/web/lygl/lyth', component: function component() {
        return __webpack_require__.e/* import() */(83).then(__webpack_require__.bind(null, "mbmO"));
    }, name: '联营退货单', meta: { title: '联营退货单' } }, { path: '/web/wxgl/wxdd', component: function component() {
        return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, "TGRV"));
    }, name: '外销订单', meta: { title: '外销订单' } }, { path: '/web/wxgl/wxfh', component: function component() {
        return __webpack_require__.e/* import() */(76).then(__webpack_require__.bind(null, "3/jd"));
    }, name: '外销发货', meta: { title: '外销发货' } }, { path: '/web/wxgl/wxth', component: function component() {
        return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, "I2ey"));
    }, name: '外销退货', meta: { title: '外销退货' } }, { path: '/web/scgl/jgpgl', component: function component() {
        return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, "kwdn"));
    }, name: '加工品管理', meta: { title: '加工品管理' } }, { path: '/web/scgl/scpf', component: function component() {
        return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, "Sl5A"));
    }, name: '生产配方', meta: { title: '生产配方' } }, { path: '/web/scgl/scxq', component: function component() {
        return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, "Fbr5"));
    }, name: '生产需求', meta: { title: '生产需求' } }, { path: '/web/scgl/scll', component: function component() {
        return __webpack_require__.e/* import() */(61).then(__webpack_require__.bind(null, "3NCX"));
    }, name: '生产领料', meta: { title: '生产领料' } }, { path: '/web/scgl/scjg', component: function component() {
        return __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, "4HZ5"));
    }, name: '生产加工', meta: { title: '生产加工' } }, { path: '/web/scgl/scmb', component: function component() {
        return __webpack_require__.e/* import() */(71).then(__webpack_require__.bind(null, "M3XW"));
    }, name: '生产模板', meta: { title: '生产模板' } }, { path: '/web/scgl/scjhyc', component: function component() {
        return __webpack_require__.e/* import() */(108).then(__webpack_require__.bind(null, "yj7K"));
    }, name: '生产计划预测', meta: { title: '生产计划预测' } }, { path: '/web/sjbb/psgz', component: function component() {
        return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "wdRQ"));
    }, name: '配送跟踪表', meta: { title: '配送跟踪表' } }, { path: '/web/sjbb/cggz', component: function component() {
        return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, "ae2h"));
    }, name: '采购跟踪表', meta: { title: '采购跟踪表' } }, { path: '/web/sjbb/psdz', component: function component() {
        return __webpack_require__.e/* import() */(94).then(__webpack_require__.bind(null, "g9G2"));
    }, name: '配送对账表', meta: { title: '配送对账表' } }, { path: '/web/sjbb/cgdz', component: function component() {
        return __webpack_require__.e/* import() */(107).then(__webpack_require__.bind(null, "Dj1l"));
    }, name: '采购对账表', meta: { title: '采购对账表' } }, { path: '/web/sjbb/sskccx', component: function component() {
        return __webpack_require__.e/* import() */(98).then(__webpack_require__.bind(null, "/PdE"));
    }, name: '实时库存查询表', meta: { title: '实时库存查询表' } }, { path: '/web/sjbb/fzdzzb', component: function component() {
        return __webpack_require__.e/* import() */(103).then(__webpack_require__.bind(null, "o86y"));
    }, name: '分账对账总表', meta: { title: '分账对账总表' } }, { path: '/web/sjbb/xsyjcx', component: function component() {
        return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "YAU/"));
    }, name: '销售业绩查询', meta: { title: '销售业绩查询' } }, { path: '/web/sjbb/psfzdz', component: function component() {
        return __webpack_require__.e/* import() */(93).then(__webpack_require__.bind(null, "ZUgn"));
    }, name: '配送分账对账表', meta: { title: '配送分账对账表' } }, { path: '/web/sjbb/mlfx', component: function component() {
        return __webpack_require__.e/* import() */(56).then(__webpack_require__.bind(null, "qsVi"));
    }, name: '毛利分析表', meta: { title: '毛利分析表' } }, { path: '/web/sjbb/mdcxdb', component: function component() {
        return __webpack_require__.e/* import() */(102).then(__webpack_require__.bind(null, "drOG"));
    }, name: '门店采销对比表', meta: { title: '门店采销对比表' } }, { path: '/web/sjbb/wpcrkmx', component: function component() {
        return __webpack_require__.e/* import() */(96).then(__webpack_require__.bind(null, "Q9tx"));
    }, name: '物品出入库明细', meta: { title: '物品出入库明细' } }, { path: '/web/sjbb/kcpcb', component: function component() {
        return __webpack_require__.e/* import() */(82).then(__webpack_require__.bind(null, "0ANT"));
    }, name: '库存批次表', meta: { title: '库存批次表' } }, { path: '/web/sjbb/pswphz', component: function component() {
        return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "msch"));
    }, name: '配送物品汇总表', meta: { title: '配送物品汇总表' } }, { path: '/web/sjbb/cgwphz', component: function component() {
        return __webpack_require__.e/* import() */(92).then(__webpack_require__.bind(null, "5nKl"));
    }, name: '采购物品汇总表', meta: { title: '采购物品汇总表' } }, { path: '/web/sjbb/pdyk', component: function component() {
        return __webpack_require__.e/* import() */(100).then(__webpack_require__.bind(null, "YtOP"));
    }, name: '盘点盈亏表', meta: { title: '盘点盈亏表' } }, { path: '/web/sjbb/crkhz', component: function component() {
        return __webpack_require__.e/* import() */(106).then(__webpack_require__.bind(null, "EBjk"));
    }, name: '物品出入库汇总', meta: { title: '物品出入库汇总' } }, { path: '/web/sjbb/zcbb', component: function component() {
        return __webpack_require__.e/* import() */(95).then(__webpack_require__.bind(null, "VTkP"));
    }, name: '总成本表', meta: { title: '总成本表' } }, { path: '/web/sjbb/djdbmx', component: function component() {
        return __webpack_require__.e/* import() */(104).then(__webpack_require__.bind(null, "WG4A"));
    }, name: '店间调拨明细表', meta: { title: '店间调拨明细表' } }, { path: '/web/sjbb/djdbhz', component: function component() {
        return __webpack_require__.e/* import() */(105).then(__webpack_require__.bind(null, "jNcp"));
    }, name: '店间调拨汇总表', meta: { title: '店间调拨汇总表' } }, { path: '/web/sjbb/wpcbcyb', component: function component() {
        return __webpack_require__.e/* import() */(97).then(__webpack_require__.bind(null, "Ro9I"));
    }, name: '物品成本差异表', meta: { title: '物品成本差异表' } }, { path: '/web/sjbb/schz', component: function component() {
        return __webpack_require__.e/* import() */(99).then(__webpack_require__.bind(null, "yMoj"));
    }, name: '生产汇总表', meta: { title: '生产汇总表' } }, { path: '/web/sjbb/mdxsyc', component: function component() {
        return __webpack_require__.e/* import() */(101).then(__webpack_require__.bind(null, "bZx4"));
    }, name: '门店销售预测', meta: { title: '门店销售预测' } }, { path: '/web/xtsz/dymbsz', component: function component() {
        return __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, "NIf9"));
    }, name: '打印模板设置', meta: { title: '打印模板设置' } }, { path: '/web/xtsz/xxsz', component: function component() {
        return __webpack_require__.e/* import() */(111).then(__webpack_require__.bind(null, "UEM1"));
    }, name: '消息设置', meta: { title: '消息设置' } }, { path: '/web/xtsz/cssz', component: function component() {
        return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, "fwj0"));
    }, name: '参数设置1', meta: { title: '参数设置' } }, { path: '/web/xtsz/tszx', component: function component() {
        return __webpack_require__.e/* import() */(112).then(__webpack_require__.bind(null, "TWFR"));
    }, name: '推送中心', meta: { title: '推送中心' } }, { path: '/web/ghdj/cgdd', component: function component() {
        return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, "nqGN"));
    }, name: '采购订单2', meta: { title: '采购订单' } }, { path: '/web/ghdj/cgsh', component: function component() {
        return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, "xbOt"));
    }, name: '采购收货2', meta: { title: '采购收货' } }, { path: '/web/ghdj/cgth', component: function component() {
        return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, "9htr"));
    }, name: '采购退货2', meta: { title: '采购退货' } }, { path: '/web/mdsz/bmgl', component: function component() {
        return __webpack_require__.e/* import() */(66).then(__webpack_require__.bind(null, "G9a7"));
    }, name: '部门管理', meta: { title: '部门管理' } }, { path: '/web/mdsz/yggl', component: function component() {
        return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, "kNQm"));
    }, name: '员工管理2', meta: { title: '员工管理' } }, { path: '/web/gyssz/yggl', component: function component() {
        return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, "epc3"));
    }, name: '员工管理3', meta: { title: '员工管理' } }, { path: '/web/gyssz/gysda', component: function component() {
        return __webpack_require__.e/* import() */(117).then(__webpack_require__.bind(null, "QTOt"));
    }, name: '供应商档案', meta: { title: '供应商档案' } }, { path: '/web/jzgl/yj', component: function component() {
        return __webpack_require__.e/* import() */(87).then(__webpack_require__.bind(null, "hEXg"));
    }, name: '月结', meta: { title: '月结' } }, { path: '/web/cwpz/jcsz', component: function component() {
        return __webpack_require__.e/* import() */(123).then(__webpack_require__.bind(null, "H7vZ"));
    }, name: '基础设置2', meta: { title: '基础设置' } }, { path: '/web/cwpz/zbgl', component: function component() {
        return __webpack_require__.e/* import() */(119).then(__webpack_require__.bind(null, "uAbF"));
    }, name: '账簿管理', meta: { title: '账簿管理' } }, { path: '/web/cwpz/zzcwsx', component: function component() {
        return __webpack_require__.e/* import() */(118).then(__webpack_require__.bind(null, "kf7y"));
    }, name: '组织财务属性', meta: { title: '组织财务属性' } }, { path: '/web/cwpz/kjkm', component: function component() {
        return __webpack_require__.e/* import() */(122).then(__webpack_require__.bind(null, "c2uu"));
    }, name: '会计科目', meta: { title: '会计科目' } }, { path: '/web/cwpz/rzkm', component: function component() {
        return __webpack_require__.e/* import() */(69).then(__webpack_require__.bind(null, "rbmL"));
    }, name: '入账科目', meta: { title: '入账科目' } }, { path: '/web/cwpz/pzgz', component: function component() {
        return __webpack_require__.e/* import() */(70).then(__webpack_require__.bind(null, "eR9r"));
    }, name: '凭证规则', meta: { title: '凭证规则' } }, { path: '/web/cwpz/pzlb', component: function component() {
        return __webpack_require__.e/* import() */(120).then(__webpack_require__.bind(null, "XYps"));
    }, name: '凭证类别', meta: { title: '凭证类别' } }, { path: '/web/cwpz/cwlb', component: function component() {
        return __webpack_require__.e/* import() */(125).then(__webpack_require__.bind(null, "kADq"));
    }, name: '财务类别', meta: { title: '财务类别' } }, { path: '/web/cwpz/fzhs', component: function component() {
        return __webpack_require__.e/* import() */(124).then(__webpack_require__.bind(null, "jiWJ"));
    }, name: '辅助核算', meta: { title: '辅助核算' } }, { path: '/web/cwpz/pzfa', component: function component() {
        return __webpack_require__.e/* import() */(121).then(__webpack_require__.bind(null, "N6cV"));
    }, name: '凭证方案', meta: { title: '凭证方案' } }, { path: '/web/cwpz/scpz', component: function component() {
        return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, "qoMo"));
    }, name: '生成凭证', meta: { title: '生成凭证' } }, { path: '/web/cwgl/yfdzgl', component: function component() {
        return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, "WpBH"));
    }, name: '应付对账管理', meta: { title: '应付对账管理' } }, { path: '/web/cwgl/yffkgl', component: function component() {
        return __webpack_require__.e/* import() */(49).then(__webpack_require__.bind(null, "L7Rt"));
    }, name: '应付付款管理', meta: { title: '应付付款管理' } }, { path: '/web/cwgl/zhgl', component: function component() {
        return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, "9O1u"));
    }, name: '账户管理', meta: { title: '账户管理' } }, { path: '/web/cwgl/dzfpgl', component: function component() {
        return __webpack_require__.e/* import() */(126).then(__webpack_require__.bind(null, "GkXC"));
    }, name: '电子发票管理', meta: { title: '电子发票管理' } }, { path: '/admin/sjzx/sjgl', component: function component() {
        return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, "OTWj"));
    }, name: '商家管理', meta: { title: '商家管理' } }, { path: '/admin/xtsj/ddsj', component: function component() {
        return __webpack_require__.e/* import() */(131).then(__webpack_require__.bind(null, "CjvT"));
    }, name: '订单数据', meta: { title: '订单数据' } }, { path: '/admin/xtsj/hyksj', component: function component() {
        return __webpack_require__.e/* import() */(128).then(__webpack_require__.bind(null, "16//"));
    }, name: '会员卡数据', meta: { title: '会员卡数据' } }, { path: '/admin/xtsj/xnsj', component: function component() {
        return __webpack_require__.e/* import() */(52).then(__webpack_require__.bind(null, "djXZ"));
    }, name: '性能数据', meta: { title: '性能数据' } }, { path: '/admin/xtsj/jkrz', component: function component() {
        return __webpack_require__.e/* import() */(127).then(__webpack_require__.bind(null, "fPOo"));
    }, name: '接口日志', meta: { title: '接口日志' } }, { path: '/admin/xtsj/fxcz', component: function component() {
        return __webpack_require__.e/* import() */(129).then(__webpack_require__.bind(null, "cffg"));
    }, name: '风险操作', meta: { title: '风险操作' } }, { path: '/admin/xtsj/fwfx', component: function component() {
        return __webpack_require__.e/* import() */(130).then(__webpack_require__.bind(null, "icn4"));
    }, name: '访问分析', meta: { title: '访问分析' } }, { path: '/admin/system/setting', component: function component() {
        return __webpack_require__.e/* import() */(135).then(__webpack_require__.bind(null, "QDSp"));
    }, name: '参数设置2', meta: { title: '参数设置' } }, { path: '/admin/system/admins', component: function component() {
        return __webpack_require__.e/* import() */(132).then(__webpack_require__.bind(null, "Q3pj"));
    }, name: '后台用户', meta: { title: '后台用户' } }, { path: '/admin/system/open', component: function component() {
        return __webpack_require__.e/* import() */(91).then(__webpack_require__.bind(null, "+e8E"));
    }, name: '开放平台', meta: { title: '开放平台' } }, { path: '/admin/system/datafix', component: function component() {
        return __webpack_require__.e/* import() */(60).then(__webpack_require__.bind(null, "hfnW"));
    }, name: '数据修复', meta: { title: '数据修复' } }, { path: '/admin/system/updatelog', component: function component() {
        return __webpack_require__.e/* import() */(73).then(__webpack_require__.bind(null, "KGhf"));
    }, name: '更新日志', meta: { title: '更新日志' } }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_1__modules_mall__["a" /* default */])));

/***/ }),

/***/ "Lnip":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.editable) ? _c('div', [_c('Form', {
    ref: "form",
    attrs: {
      "rules": _vm.rules
    }
  }, [_vm._l((_vm.current), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticStyle: {
        "display": "flex",
        "margin-bottom": "10px",
        "align-items": "center"
      }
    }, [_c('Select', {
      staticStyle: {
        "width": "100px",
        "margin-right": "10px"
      },
      on: {
        "on-change": function($event) {
          return _vm.typeChanged(item, index)
        }
      },
      model: {
        value: (item.typeStr),
        callback: function($$v) {
          _vm.$set(item, "typeStr", $$v)
        },
        expression: "item.typeStr"
      }
    }, _vm._l((_vm.types), function(type, index) {
      return _c('Option', {
        key: index,
        staticStyle: {
          "width": "100px"
        },
        attrs: {
          "value": type.name,
          "label": type.name
        }
      }, [_c('span', [_vm._v(_vm._s(type.name))])])
    }), 1), _vm._v(" "), _c('FormItem', {
      attrs: {
        "prop": 'current[' + index + '].label'
      }
    }, [_c('Input', {
      staticStyle: {
        "width": "300px",
        "margin-right": "10px",
        "font-weight": "bold"
      },
      attrs: {
        "placeholder": "请输入标题"
      },
      model: {
        value: (item.label),
        callback: function($$v) {
          _vm.$set(item, "label", $$v)
        },
        expression: "item.label"
      }
    })], 1), _vm._v(" "), _c('Checkbox', {
      model: {
        value: (item.required),
        callback: function($$v) {
          _vm.$set(item, "required", $$v)
        },
        expression: "item.required"
      }
    }, [_vm._v("必填")]), _vm._v(" "), _c('Icon', {
      staticClass: "hover opahover",
      staticStyle: {
        "color": "red",
        "font-weight": "bold",
        "font-size": "24px",
        "margin-left": "50px"
      },
      attrs: {
        "type": "md-remove-circle"
      },
      on: {
        "click": function($event) {
          return _vm.removeItem(index)
        }
      }
    }), _vm._v(" "), _c('Icon', {
      staticClass: "hover opahover",
      staticStyle: {
        "color": "#20bf64",
        "font-weight": "bold",
        "font-size": "24px",
        "margin-left": "10px"
      },
      attrs: {
        "type": "md-add-circle"
      },
      on: {
        "click": function($event) {
          return _vm.insertItem(index)
        }
      }
    })], 1), _vm._v(" "), (item.typeStr == '单选' || item.typeStr == '多选') ? _c('div', [_vm._l((item.selections), function(selection, j) {
      return _c('div', {
        key: j,
        staticStyle: {
          "display": "flex",
          "align-items": "center",
          "margin-bottom": "10px"
        }
      }, [_c('FormItem', {
        attrs: {
          "prop": 'current[' + index + '].selections[' + j + '].name'
        }
      }, [_c('Input', {
        staticStyle: {
          "width": "200px",
          "margin-left": "110px"
        },
        attrs: {
          "placeholder": "请输入选项"
        },
        model: {
          value: (selection.name),
          callback: function($$v) {
            _vm.$set(selection, "name", $$v)
          },
          expression: "selection.name"
        }
      })], 1), _vm._v(" "), _c('Icon', {
        staticClass: "hover opahover",
        staticStyle: {
          "color": "red",
          "font-weight": "bold",
          "font-size": "24px",
          "margin-left": "20px"
        },
        attrs: {
          "type": "md-remove-circle"
        },
        on: {
          "click": function($event) {
            return _vm.removeSelection(item, index, j)
          }
        }
      }), _vm._v(" "), _c('Icon', {
        staticClass: "hover opahover",
        staticStyle: {
          "color": "#20bf64",
          "font-weight": "bold",
          "font-size": "24px",
          "margin-left": "10px"
        },
        attrs: {
          "type": "md-add-circle"
        },
        on: {
          "click": function($event) {
            return _vm.insertSelection(item, index, j)
          }
        }
      })], 1)
    }), _vm._v(" "), (item.selections.length == 0) ? _c('div', {
      staticClass: "hover",
      staticStyle: {
        "color": "#20bf64",
        "font-weight": "bold",
        "display": "block"
      },
      on: {
        "click": function($event) {
          return _vm.addSelection(item, index)
        }
      }
    }, [_vm._v("增加一个选项")]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (item.typeStr == '手机号') ? _c('div', [_c('div', {
      staticStyle: {
        "color": "#aaa",
        "margin-left": "110px",
        "margin-top": "-10px",
        "margin-bottom": "10px"
      }
    }, [_vm._v("用户填写该项时，必须填11位数字")])]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "hover",
    staticStyle: {
      "color": "#20bf64",
      "font-weight": "bold",
      "width": "100px"
    },
    on: {
      "click": _vm.addItem
    }
  }, [_vm._v("增加一项字段")])], 2)], 1) : _c('div')])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M1Tw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex",
    style: (("width: " + _vm.width + "px;" + (_vm.rootstyle||'')))
  }, _vm._l((_vm.columns), function(item, index) {
    return (!item.hide) ? _c('div', {
      key: index,
      staticClass: "flex",
      style: ('min-width: ' + item.width + 'px;color: #aaa;padding-right: 10px;')
    }, [_c('div', [_c('div', [_vm._v(_vm._s(item.title))]), _vm._v(" "), (item.label) ? _c('div', {
      staticStyle: {
        "line-height": "1",
        "font-size": "10px"
      }
    }, [_vm._v(_vm._s(item.label))]) : _vm._e()]), _vm._v(" "), (item.tip) ? _c('PageTooltip', {
      attrs: {
        "content": item.tip,
        "width": 300,
        "name": '',
        "placement": 'top-start'
      }
    }) : _vm._e()], 1) : _vm._e()
  }), 0)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_daf97d9c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("RhhK");
function injectStyle (ssrContext) {
  __webpack_require__("Q+Jy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_daf97d9c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MoiG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_view_design__ = __webpack_require__("b3L9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_view_design___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_view_design__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__iviewtheme_index_less__ = __webpack_require__("p0qc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__iviewtheme_index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__iviewtheme_index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_index__ = __webpack_require__("bGai");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__filters__ = __webpack_require__("Q0Ca");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__api_api__ = __webpack_require__("P9l9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_xe_utils__ = __webpack_require__("ZHXk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_xe_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_xe_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vxe_table__ = __webpack_require__("Ynfa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vxe_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vxe_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vxe_table_lib_style_css__ = __webpack_require__("gsbP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vxe_table_lib_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_vxe_table_lib_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__static_zh_address_parse_min_js__ = __webpack_require__("du79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__static_zh_address_parse_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__static_zh_address_parse_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_amap__ = __webpack_require__("/IwO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_amap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_vue_amap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vue_socket_io__ = __webpack_require__("hMcO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vue_socket_io___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_vue_socket_io__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__ws__ = __webpack_require__("5LYF");












var initChinapcData = function () {
    var _ref7 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var res, chinapcdata, extraGovData;
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
            while (1) {
                switch (_context6.prev = _context6.next) {
                    case 0:
                        _context6.next = 2;
                        return api.post('/web/main/chinapc/load');

                    case 2:
                        res = _context6.sent;
                        chinapcdata = res.data;
                        extraGovData = {
                            province: [],
                            city: [],
                            area: []
                        };

                        __WEBPACK_IMPORTED_MODULE_11_vue___default.a.prototype.$chinapcdata = chinapcdata;
                        chinapcdata.forEach(function (province) {
                            extraGovData.province.push({
                                code: province.code,
                                name: province.name
                            });
                            province.children.forEach(function (city) {
                                extraGovData.city.push({
                                    code: city.code,
                                    name: city.name,
                                    provinceCode: province.code
                                });
                                if (city.children) {
                                    city.children.forEach(function (area) {
                                        extraGovData.area.push({
                                            code: area.code,
                                            name: area.name,
                                            cityCode: city.code,
                                            provinceCode: province.code
                                        });
                                    });
                                }
                            });
                        });
                        __WEBPACK_IMPORTED_MODULE_11_vue___default.a.prototype.$parseAddress = function (address) {
                            return __WEBPACK_IMPORTED_MODULE_23__static_zh_address_parse_min_js___default()(address, {
                                type: 1,
                                extraGovData: extraGovData
                            });
                        };

                    case 8:
                    case 'end':
                        return _context6.stop();
                }
            }
        }, _callee6, this);
    }));

    return function initChinapcData() {
        return _ref7.apply(this, arguments);
    };
}();

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


// import 'view-design/dist/styles/iview.css';



 // 全局自定义组件
 // 全局过滤器








// import VueTinymce from "@packy-tang/vue-tinymce"
// Vue.use(VueTinymce)

window._AMapSecurityConfig = {
    securityJsCode: '476581fe3bf41a803ca78a933555d570'
};


__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_24_vue_amap___default.a);
__WEBPACK_IMPORTED_MODULE_24_vue_amap___default.a.initAMapApiLoader({
    key: '954a65e42969f3509de009bbda4f9a49',
    plugin: ['AMap.Geocoder']
});
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.prototype.VueAMap = __WEBPACK_IMPORTED_MODULE_24_vue_amap___default.a;
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.prototype.apiPort = __WEBPACK_IMPORTED_MODULE_19__api_api__;

__WEBPACK_IMPORTED_MODULE_11_vue___default.a.config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_view_design___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_21_vxe_table___default.a);

// register global utility filters.
__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_17__filters__).forEach(function (key) {
    __WEBPACK_IMPORTED_MODULE_11_vue___default.a.filter(key, __WEBPACK_IMPORTED_MODULE_17__filters__[key]);
});

__WEBPACK_IMPORTED_MODULE_11_vue___default.a.prototype.$tableScroll = function (table) {
    table.$refs.body.scrollTop = 0;
    table.$refs.body.scrollLeft = 0;
};


var queue = [];
var currentRequests = []; // 存储当前正在进行的请求

var whitelist = ['/web/session/load', '/web/session/badge/load', '/web/main/zhanghaos/load', '/web/psgh/pssqsh/querypay', '/web/psyh/pssqd/querypay', '/web/main/chaxunyue'];

function destroy(requesturl) {
    if (!requesturl || !whitelist.some(function (url) {
        return requesturl.includes(url);
    })) {
        queue.pop(); // 弹出遵循先进先出原则
    }
    setTimeout(function () {
        // 延迟100ms看看是否是否有嵌套接口
        if (!queue.length) {
            // 如果队列里还有没有完成的请求就不关闭loading效果
            __WEBPACK_IMPORTED_MODULE_12_view_design__["Spin"].hide();
            //这里解决有滚动条的同一页面切换账号后就没有滚动条了
            if (document.getElementsByClassName('ivu-modal-wrap').length == document.getElementsByClassName('ivu-modal-hidden').length) {
                document.getElementsByTagName('body')[0].style = {};
            }
        }
    }, 100);
}

// 取消所有请求的函数
function cancelAllRequests() {
    // 取消所有正在进行的请求
    currentRequests.forEach(function (request) {
        if (request.cancelSource) {
            request.cancelSource.cancel('用户取消请求');
        }
    });
    // 清空队列和请求数组
    queue = [];
    currentRequests = [];
    // 隐藏loading
    __WEBPACK_IMPORTED_MODULE_12_view_design__["Spin"].hide();
    // 显示取消提示
    __WEBPACK_IMPORTED_MODULE_12_view_design___default.a.Message.info({
        content: '已取消所有请求',
        duration: 2
    });
}

__WEBPACK_IMPORTED_MODULE_25_axios___default.a.interceptors.request.use(function (request) {
    console.log('[req] ' + request.url + '\n', request.data);

    if (__WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */].auto_update && request.url.indexOf('/list') > -1 && request.url.indexOf('/gengxinrizhi/list') == -1) {
        sessionStorage.updateTip = true;
        window.location.reload();
        //cancel request
        return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.reject('cancel request');
    }

    // 为每个请求添加cancelToken
    var CancelToken = __WEBPACK_IMPORTED_MODULE_25_axios___default.a.CancelToken;
    var source = CancelToken.source();
    request.cancelToken = source.token;
    request.cancelSource = source;

    if (!(request.data && request.data._hideLoading) && !whitelist.some(function (url) {
        return request.url.includes(url);
    })) {
        queue.unshift(request.url);
        currentRequests.push(request);
    }

    if (queue.length) {
        // 检查是否有需要显示取消按钮的接口
        var hasCancelableRequests = currentRequests.some(function (req) {
            return (
                // req.url.endsWith('/list') || req.url.endsWith('/load')
                req.url.indexOf('/list') > -1
            );
        });

        // 如果队列中有值就打开loading
        __WEBPACK_IMPORTED_MODULE_12_view_design__["Spin"].show({
            render: function render(h) {
                var loadingElements = [h('div', {
                    class: 'loading-content'
                }, [h('Icon', {
                    class: 'spin-icon-load',
                    props: {
                        type: 'ios-loading',
                        size: 30
                    }
                }), h('div', {
                    class: 'loading-text'
                }, '加载中...')])];

                // 只有在有可取消的请求时才显示取消按钮
                if (hasCancelableRequests) {
                    loadingElements.push(h('div', {
                        class: 'loading-cancel-btn',
                        on: {
                            click: cancelAllRequests
                        }
                    }, '取消'));
                }

                return h('div', {
                    class: 'loading-container'
                }, [h('div', {
                    class: 'loading-card'
                }, loadingElements)]);
            }
        });
    }
    return request;
});

function fixfloat(obj) {
    if (obj === null || obj === undefined) {
        return obj;
    }
    if (typeof obj === 'number') {
        return NumberFix(obj, 10);
    }
    if (typeof obj === 'string') {
        return obj;
    }
    if (Array.isArray(obj)) {
        for (var i = 0; i < obj.length; i++) {
            obj[i] = fixfloat(obj[i]);
        }
    } else {
        for (var key in obj) {
            if (Array.isArray(obj[key])) {
                for (var _i = 0; _i < obj[key].length; _i++) {
                    obj[key][_i] = fixfloat(obj[key][_i]);
                }
            } else {
                obj[key] = fixfloat(obj[key]);
            }
        }
    }
    return obj;
}

__WEBPACK_IMPORTED_MODULE_25_axios___default.a.defaults.headers.common['v'] = 2;

__WEBPACK_IMPORTED_MODULE_25_axios___default.a.interceptors.response.use(function (response) {
    destroy(response.request.responseURL);
    // 从currentRequests中移除已完成的请求
    var requestIndex = currentRequests.findIndex(function (req) {
        return req === response.config;
    });
    if (requestIndex > -1) {
        currentRequests.splice(requestIndex, 1);
    }
    console.log('[res] ' + response.config.url + '\n', __WEBPACK_IMPORTED_MODULE_11_vue___default.a.prototype.copy(response.data));
    if (response.data.session) {
        //session被更新时会返回
        updateSession(response.data.session);
        vue.$refs['app'].sessionChanged(response.data.session);
    }
    if (response.data.badge && vue.$refs['app'].session && vue.$refs['app'].session.badge) {
        vue.$refs['app'].session.badge = response.data.badge;
    }

    if (response.data.code == 1) {
        __WEBPACK_IMPORTED_MODULE_12_view_design___default.a.Message.error({
            content: response.data.error,
            duration: 2,
            closable: true
        });
    }
    if (response.data) {
        // let start = new Date().getTime()
        fixfloat(response.data);
        // let end = new Date().getTime()
        // console.log('fixfloat took ' + (end - start) + ' ms')
    }
    return response;
}, function (error) {
    destroy(error.config ? error.config.url : null);
    // 处理请求被取消的情况
    if (__WEBPACK_IMPORTED_MODULE_25_axios___default.a.isCancel(error)) {
        console.log('请求被取消:', error.message);
        // 从currentRequests中移除已取消的请求
        var requestIndex = currentRequests.findIndex(function (req) {
            return req === error.config;
        });
        if (requestIndex > -1) {
            currentRequests.splice(requestIndex, 1);
        }
        return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.reject(error);
    }
    if (!error.response) {
        console.log('system error', error);
        return { data: { error: '网络异常，请稍后再试' } };
    }
    if (error.response.status == 502) {
        return { data: { error: '系统升级，请稍后重试', status: 502 } };
    } else if (error.response.status == 500) {
        if (error.response.data && error.response.data.title) {
            //非prod环境会返回具体异常信息
            var e = error.response.data;
            if (e.msg == 'Cannot read property \'collection\' of null') {
                __WEBPACK_IMPORTED_MODULE_12_view_design___default.a.Message.warning('系统忙，请重试');
            } else {
                __WEBPACK_IMPORTED_MODULE_12_view_design___default.a.Message.warning({
                    closable: true,
                    background: true,
                    duration: 8,
                    render: function render(h) {
                        return h('div', {
                            style: {
                                'text-align': 'left'
                            }
                        }, [h('div', {
                            style: {
                                'font-weight': 'bold',
                                'color': 'red',
                                'font-size': '20px'
                            }
                        }, e.title), h('div', {
                            style: {
                                'color': '#333'
                            }
                        }, e.url ? e.url + e.info : '请联系服务商，建议提供当前截图以便定位问题'), h('p', {
                            style: {
                                'white-space': 'pre-wrap',
                                'font-weight': 'bold'
                            }
                        }, e.msg)]);
                    }
                });
            }
        }
        return { data: { error: error.response.data, status: error.response.status } };
    } else if (error.response.status == 401) {
        return window.location.hash = '/logout';
    } else if (error.response.status == 409) {
        __WEBPACK_IMPORTED_MODULE_12_view_design___default.a.Message.error({
            content: '会话已更新，即将刷新页面，请重试',
            duration: 4,
            closable: true
        });
        setTimeout(function () {
            window.location.reload();
        }, 2000);
    } else if (error.response.status == 403) {
        __WEBPACK_IMPORTED_MODULE_12_view_design___default.a.Message.error({
            content: '无此操作权限，请重新登录',
            duration: 4,
            closable: true
        });
    } else if (error.response.status == 413) {
        __WEBPACK_IMPORTED_MODULE_12_view_design___default.a.Message.error({
            content: '一次操作的数据太多啦，请减少数据量再试',
            duration: 4,
            closable: true
        });
    } else if (error.response.status == 400) {
        __WEBPACK_IMPORTED_MODULE_12_view_design___default.a.Message.error({
            content: error.response.data,
            duration: 4,
            closable: true
        });
    } else if (error.response.status == 404) {
        __WEBPACK_IMPORTED_MODULE_12_view_design___default.a.Message.error({
            content: '页面不存在，请刷新后再试',
            duration: 4,
            closable: true
        });
    } else {
        __WEBPACK_IMPORTED_MODULE_12_view_design___default.a.Message.error({
            content: '系统错误，请联系服务商',
            duration: 4,
            closable: true
        });
    }
    return error.response;
});

var api = {
    get: function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee(url) {
            var res;
            return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_25_axios___default.a.get('/g/api' + url);

                        case 2:
                            res = _context.sent;

                            if (!(res.data.status == 502)) {
                                _context.next = 11;
                                break;
                            }

                            _context.next = 6;
                            return new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (resolve) {
                                return setTimeout(resolve, 1000);
                            });

                        case 6:
                            _context.next = 8;
                            return api.get(url);

                        case 8:
                            return _context.abrupt('return', _context.sent);

                        case 11:
                            return _context.abrupt('return', res);

                        case 12:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function get(_x) {
            return _ref.apply(this, arguments);
        }

        return get;
    }(),
    post: function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee2(url, data) {
            var res;
            return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_25_axios___default.a.post('/g/api' + url, data);

                        case 2:
                            res = _context2.sent;

                            if (!(res.data.status == 502)) {
                                _context2.next = 11;
                                break;
                            }

                            _context2.next = 6;
                            return new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (resolve) {
                                return setTimeout(resolve, 1000);
                            });

                        case 6:
                            _context2.next = 8;
                            return api.post(url, data);

                        case 8:
                            return _context2.abrupt('return', _context2.sent);

                        case 11:
                            return _context2.abrupt('return', res);

                        case 12:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function post(_x2, _x3) {
            return _ref2.apply(this, arguments);
        }

        return post;
    }(),
    uploadFile: function () {
        var _ref3 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee3(file, token) {
            var url, formData;
            return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            url = window.location.protocol + '//upload.qiniup.com';
                            formData = new FormData();

                            formData.append('file', file);
                            formData.append('token', token);
                            _context3.next = 6;
                            return __WEBPACK_IMPORTED_MODULE_25_axios___default.a.post(url, formData);

                        case 6:
                            return _context3.abrupt('return', _context3.sent);

                        case 7:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function uploadFile(_x4, _x5) {
            return _ref3.apply(this, arguments);
        }

        return uploadFile;
    }()
};

__WEBPACK_IMPORTED_MODULE_11_vue___default.a.prototype.$http = __WEBPACK_IMPORTED_MODULE_25_axios___default.a;
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.prototype.$api = api;
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.prototype.loadSession = function () {
    var _ref4 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee4(_ref5) {
        var changes = _ref5.changes,
            dataChanged = _ref5.dataChanged,
            badgeChanged = _ref5.badgeChanged,
            cb = _ref5.cb;
        var stored_token, stored_timestamp, res, session;
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
            while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:
                        if (!__WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */].session) {
                            stored_token = sessionStorage.token;

                            if (stored_token) __WEBPACK_IMPORTED_MODULE_25_axios___default.a.defaults.headers.common['token'] = stored_token;
                            stored_timestamp = sessionStorage.timestamp;

                            if (stored_timestamp) __WEBPACK_IMPORTED_MODULE_25_axios___default.a.defaults.headers.common['timestamp'] = stored_timestamp;
                        }
                        _context4.next = 3;
                        return api.post('/web/session/load', {
                            dataChanged: dataChanged,
                            badgeChanged: badgeChanged,
                            changes: changes
                        });

                    case 3:
                        res = _context4.sent;

                        if (!res.data.error) {
                            _context4.next = 7;
                            break;
                        }

                        if (!(res.data.error == '机构不可用')) {
                            _context4.next = 7;
                            break;
                        }

                        return _context4.abrupt('return', window.location.hash = '/logout');

                    case 7:
                        session = res.data.session;

                        updateSession(session);
                        if (cb) cb(session);

                    case 10:
                    case 'end':
                        return _context4.stop();
                }
            }
        }, _callee4, this);
    }));

    return function (_x6) {
        return _ref4.apply(this, arguments);
    };
}();

__WEBPACK_IMPORTED_MODULE_11_vue___default.a.prototype.loadBadge = function () {
    var _ref6 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee5(cb) {
        var res;
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
            while (1) {
                switch (_context5.prev = _context5.next) {
                    case 0:
                        _context5.next = 2;
                        return api.post('/web/session/badge/load', {});

                    case 2:
                        res = _context5.sent;

                        __WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */].session.badge = res.data.badge;
                        if (cb) cb(res.data);
                        return _context5.abrupt('return', res.data);

                    case 6:
                    case 'end':
                        return _context5.stop();
                }
            }
        }, _callee5, this);
    }));

    return function (_x7) {
        return _ref6.apply(this, arguments);
    };
}();

__WEBPACK_IMPORTED_MODULE_11_vue___default.a.prototype.hasPermission = function (groupname, menuname, buttonname) {
    var group = __WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */].session.menuGroups.findOne({ name: groupname });
    if (group && group.menus) {
        var menu = group.menus.findOne({ name: menuname });
        if (menu) {
            if (buttonname && menu.buttons) {
                var button = menu.buttons.findOne({ name: buttonname });
                if (button && button.actived) return true;
            } else {
                return true;
            }
        }
    }
    return false;
};

__WEBPACK_IMPORTED_MODULE_11_vue___default.a.prototype.hasPermissionKey = function (groupcode, menucode, buttonkey) {
    var group = __WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */].session.menuGroups.findOne({ code: groupcode });
    if (group && group.menus) {
        var menu = group.menus.findOne({ code: menucode });
        if (menu) {
            if (buttonkey && menu.buttons) {
                var button = menu.buttons.findOne({ key: buttonkey });
                if (button && button.actived) return true;
            } else {
                return true;
            }
        }
    }
    return false;
};

__WEBPACK_IMPORTED_MODULE_12_view_design___default.a.Modal.props.maskClosable.default = false;

function updateSession(session) {
    if (session.zhanghao && session.zhanghao.jigou && session.zhanghao.jigou.actived === false) {
        __WEBPACK_IMPORTED_MODULE_12_view_design___default.a.Message.error(session.zhanghao.jigou.name + '已暂停使用供应链');
        return window.location.hash = '/logout';
    }
    if (session.zhanghao && session.zhanghao.jituan && session.zhanghao.jituan.actived === false) {
        __WEBPACK_IMPORTED_MODULE_12_view_design___default.a.Message.error(session.zhanghao.jituan.name + '已暂停使用供应链');
        return window.location.hash = '/logout';
    }
    if (session.zhanghao && (session.zhanghao.deleted || !session.zhanghao.actived)) {
        __WEBPACK_IMPORTED_MODULE_12_view_design___default.a.Message.error('账号已失效，请重新登陆');
        return window.location.hash = '/logout';
    }
    if (session.permissions) {
        session.permission = {};
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(session.permissions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var item = _step.value;

                if (item.checked) {
                    session.permission[item.key] = true;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    __WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */].session = session;
    if (session.token) __WEBPACK_IMPORTED_MODULE_25_axios___default.a.defaults.headers.common['token'] = session.token;
    __WEBPACK_IMPORTED_MODULE_25_axios___default.a.defaults.headers.common['timestamp'] = session.timestamp;
    sessionStorage.token = session.token;
    sessionStorage.timestamp = session.timestamp;
}

__WEBPACK_IMPORTED_MODULE_11_vue___default.a.prototype.copy = function (obj) {
    if (!obj) {
        return obj;
    }
    if ((typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(obj)) != 'object') {
        return obj;
    }
    return JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(obj));
};

__WEBPACK_IMPORTED_MODULE_11_vue___default.a.prototype.logout = function () {
    __WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */].session = null;
    __WEBPACK_IMPORTED_MODULE_25_axios___default.a.defaults.headers.common['token'] = null;
    __WEBPACK_IMPORTED_MODULE_25_axios___default.a.defaults.headers.common['timestamp'] = null;
};

__WEBPACK_IMPORTED_MODULE_11_vue___default.a.prototype.getAllChildren = function (node) {
    var nodes = [];
    getChildren(nodes, node);
    return nodes;
};

Number.prototype.toFixed = function (fix) {
    return NumberFix(this, fix);
};

function getChildren(nodes, node) {
    var visited = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a();

    if (visited.has(node)) {
        return;
    }
    visited.add(node);

    if (node.children && node.children.length) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(node.children), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var item = _step2.value;

                getChildren(nodes, item, visited);
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }
    } else {
        nodes.push(node);
    }
}

initChinapcData();

var qiniu = {
    token: null
};

__WEBPACK_IMPORTED_MODULE_11_vue___default.a.prototype.loadCangkuwupins = function () {
    var _ref8 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee7(body, cb) {
        var res, cangkuwupins, _loop, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, item;

        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
            while (1) {
                switch (_context7.prev = _context7.next) {
                    case 0:
                        _context7.next = 2;
                        return this.$api.post('/web/main/cangkuwupins/load', {
                            cangkuId: body.cangku ? body.cangku._id : undefined,
                            riqi: body.riqi,
                            // codes: body.wupins.map(item => { return item.code }),
                            wupins: body.wupins.map(function (item) {
                                return { code: item.code, huozhu: item.huozhu };
                            }),
                            pandian: body.pandian
                        });

                    case 2:
                        res = _context7.sent;
                        cangkuwupins = res.data.cangkuwupins;

                        _loop = function _loop(item) {
                            var cangkuwupin = cangkuwupins.find(function (o) {
                                return o.wupin.code == item.code && (!o.huozhu && !item.huozhu || o.huozhu && item.huozhu && o.huozhu._id == item.huozhu._id);
                            });
                            if (cangkuwupin) {
                                item.xiancunshuliang = cangkuwupin.wupin.xiancunshuliang;
                                item.jine = cangkuwupin.wupin.jine;
                                if (item.xiancunshuliang > 0 || item.xiancunshuliang < 0) {
                                    item.kucunjunjia = item.jine / item.xiancunshuliang;
                                } else if (cangkuwupin.wupin.zuijinkucunjunjia !== undefined) {
                                    item.zuijinkucunjunjia = cangkuwupin.wupin.zuijinkucunjunjia;
                                    item.kucunjunjia = cangkuwupin.wupin.zuijinkucunjunjia;
                                } else {
                                    item.kucunjunjia = cangkuwupin.wupin.cankaochengben || 0;
                                }
                                if (body.type === 'qimochengbentiaozheng') {
                                    item.zhangmianshuliang = cangkuwupin.wupin.zhangmianshuliang;
                                    item.zhangmianjine = cangkuwupin.wupin.zhangmianjine;
                                    item.tiaozhenghoujine = cangkuwupin.wupin.tiaozhenghoujine;
                                    item.tiaozhengjine = cangkuwupin.wupin.tiaozhengjine;
                                }
                            } else {
                                item.xiancunshuliang = 0;
                                item.jine = 0;
                                item.kucunjunjia = item.kucunjunjia || item.cankaochengben;
                                if (body.type === 'qimochengbentiaozheng') {
                                    item.zhangmianshuliang = 0;
                                }
                            }
                        };

                        _iteratorNormalCompletion3 = true;
                        _didIteratorError3 = false;
                        _iteratorError3 = undefined;
                        _context7.prev = 8;

                        for (_iterator3 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(body.wupins); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                            item = _step3.value;

                            _loop(item);
                        }
                        _context7.next = 16;
                        break;

                    case 12:
                        _context7.prev = 12;
                        _context7.t0 = _context7['catch'](8);
                        _didIteratorError3 = true;
                        _iteratorError3 = _context7.t0;

                    case 16:
                        _context7.prev = 16;
                        _context7.prev = 17;

                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }

                    case 19:
                        _context7.prev = 19;

                        if (!_didIteratorError3) {
                            _context7.next = 22;
                            break;
                        }

                        throw _iteratorError3;

                    case 22:
                        return _context7.finish(19);

                    case 23:
                        return _context7.finish(16);

                    case 24:
                        if (cb) cb(cangkuwupins);
                        return _context7.abrupt('return', cangkuwupins);

                    case 26:
                    case 'end':
                        return _context7.stop();
                }
            }
        }, _callee7, this, [[8, 12, 16, 24], [17,, 19, 23]]);
    }));

    return function (_x9, _x10) {
        return _ref8.apply(this, arguments);
    };
}();

__WEBPACK_IMPORTED_MODULE_11_vue___default.a.prototype.loadUploadToken = function (cb) {
    if (qiniu.token && new Date(qiniu.token.expiryTime) > new Date()) {
        return cb(qiniu.token.value);
    } else {
        this.$api.get('/qiniu/token').then(function (response) {
            qiniu.token = response.data;
            return cb(qiniu.token.value);
        });
    }
};


__WEBPACK_IMPORTED_MODULE_11_vue___default.a.prototype.moment = __WEBPACK_IMPORTED_MODULE_26_moment___default.a;
__WEBPACK_IMPORTED_MODULE_26_moment___default.a.locale('zh-cn');

//类似mongo的findOne
function checkKeyValue(value, item, object, field, longkey) {
    if ((object === undefined || object === null) && value !== undefined && value !== null) {
        return false;
    }
    if (field.indexOf('.') != -1 && !longkey) {
        var r = checkKeyValue(value, item, object, field, true);
        if (r) return r;
        var objectname = field.substring(0, field.indexOf('.'));
        var newField = field.substring(field.indexOf('.') + 1, field.length);
        var newObject = object[objectname];
        return checkKeyValue(value, item, newObject, newField);
    }
    if (value instanceof Array && field == '$or') {
        var ormatched = false;
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
            for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(value), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                var oritem = _step4.value;

                var orkeymatched = 0;
                var _iteratorNormalCompletion5 = true;
                var _didIteratorError5 = false;
                var _iteratorError5 = undefined;

                try {
                    for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_keys___default()(oritem)), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                        var orkey = _step5.value;

                        var _r = checkKeyValue(oritem[orkey], item, object, orkey);
                        if (_r) orkeymatched++;
                    }
                } catch (err) {
                    _didIteratorError5 = true;
                    _iteratorError5 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion5 && _iterator5.return) {
                            _iterator5.return();
                        }
                    } finally {
                        if (_didIteratorError5) {
                            throw _iteratorError5;
                        }
                    }
                }

                if (orkeymatched == __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_keys___default()(oritem).length) {
                    ormatched = true;
                }
            }
        } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                    _iterator4.return();
                }
            } finally {
                if (_didIteratorError4) {
                    throw _iteratorError4;
                }
            }
        }

        return ormatched;
    }
    if (value instanceof Array && field == '$and') {
        var _iteratorNormalCompletion6 = true;
        var _didIteratorError6 = false;
        var _iteratorError6 = undefined;

        try {
            for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(value), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                var _oritem = _step6.value;
                var _iteratorNormalCompletion7 = true;
                var _didIteratorError7 = false;
                var _iteratorError7 = undefined;

                try {
                    for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_keys___default()(_oritem)), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                        var _orkey = _step7.value;

                        var _r2 = checkKeyValue(_oritem[_orkey], item, object, _orkey);
                        if (!_r2) return false;
                    }
                } catch (err) {
                    _didIteratorError7 = true;
                    _iteratorError7 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion7 && _iterator7.return) {
                            _iterator7.return();
                        }
                    } finally {
                        if (_didIteratorError7) {
                            throw _iteratorError7;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                    _iterator6.return();
                }
            } finally {
                if (_didIteratorError6) {
                    throw _iteratorError6;
                }
            }
        }

        return true;
    }
    if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(value)) == 'object' && value !== null && value['$in'] !== undefined) {
        var invalue = value['$in'];
        return invalue.indexOf(object[field]) != -1;
    }
    if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(value)) == 'object' && value !== null && value['$nin'] !== undefined) {
        var ninvalue = value['$nin'];
        return ninvalue.indexOf(object[field]) == -1;
    }
    if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(value)) == 'object' && value !== null && value['$ne'] !== undefined) {
        var nevalue = value['$ne'];
        if (object && nevalue && object[field] === nevalue) return false;
        if (object && nevalue === null && (object[field] === null || object[field] === undefined)) return false;
        return true;
    }
    if (object && object[field] === undefined && value === undefined) return true;
    var result = object && object[field] === value ? true : false;
    return result;
}

Array.prototype.findOne = function (query) {
    var _iteratorNormalCompletion8 = true;
    var _didIteratorError8 = false;
    var _iteratorError8 = undefined;

    try {
        for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(this), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
            var item = _step8.value;

            var matched = {};
            var _iteratorNormalCompletion9 = true;
            var _didIteratorError9 = false;
            var _iteratorError9 = undefined;

            try {
                for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_keys___default()(query)), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                    var key = _step9.value;

                    var r = checkKeyValue(query[key], item, item, key);
                    if (r) matched[key] = true;
                }
            } catch (err) {
                _didIteratorError9 = true;
                _iteratorError9 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion9 && _iterator9.return) {
                        _iterator9.return();
                    }
                } finally {
                    if (_didIteratorError9) {
                        throw _iteratorError9;
                    }
                }
            }

            if (__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_keys___default()(matched).length == __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_keys___default()(query).length) {
                return item;
            }
        }
    } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion8 && _iterator8.return) {
                _iterator8.return();
            }
        } finally {
            if (_didIteratorError8) {
                throw _iteratorError8;
            }
        }
    }

    return null;
};

Array.prototype.findAll = function (query) {
    var result = [];
    var _iteratorNormalCompletion10 = true;
    var _didIteratorError10 = false;
    var _iteratorError10 = undefined;

    try {
        for (var _iterator10 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(this), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
            var item = _step10.value;

            var matched = {};
            var _iteratorNormalCompletion11 = true;
            var _didIteratorError11 = false;
            var _iteratorError11 = undefined;

            try {
                for (var _iterator11 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_keys___default()(query)), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
                    var key = _step11.value;

                    var r = checkKeyValue(query[key], item, item, key);
                    if (r) matched[key] = true;
                }
            } catch (err) {
                _didIteratorError11 = true;
                _iteratorError11 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion11 && _iterator11.return) {
                        _iterator11.return();
                    }
                } finally {
                    if (_didIteratorError11) {
                        throw _iteratorError11;
                    }
                }
            }

            if (__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_keys___default()(matched).length == __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_keys___default()(query).length) {
                result.push(item);
            }
        }
    } catch (err) {
        _didIteratorError10 = true;
        _iteratorError10 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion10 && _iterator10.return) {
                _iterator10.return();
            }
        } finally {
            if (_didIteratorError10) {
                throw _iteratorError10;
            }
        }
    }

    return result;
};

Array.prototype.remove = function (query) {
    var result = [];
    for (var i = this.length - 1; i >= 0; i--) {
        var item = this[i];
        var matched = {};
        var _iteratorNormalCompletion12 = true;
        var _didIteratorError12 = false;
        var _iteratorError12 = undefined;

        try {
            for (var _iterator12 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_keys___default()(query)), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
                var key = _step12.value;

                var r = checkKeyValue(query[key], item, item, key);
                if (r) matched[key] = true;
            }
        } catch (err) {
            _didIteratorError12 = true;
            _iteratorError12 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion12 && _iterator12.return) {
                    _iterator12.return();
                }
            } finally {
                if (_didIteratorError12) {
                    throw _iteratorError12;
                }
            }
        }

        if (__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_keys___default()(matched).length == __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_keys___default()(query).length) {
            this.splice(i, 1);
        }
    }
    return result;
};

Array.prototype.sum = function (field, fix) {
    var result = 0;
    var _iteratorNormalCompletion13 = true;
    var _didIteratorError13 = false;
    var _iteratorError13 = undefined;

    try {
        for (var _iterator13 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(this), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
            var item = _step13.value;

            var value = item;
            if (field && field.includes('.')) {
                var keys = field.split('.');
                var _iteratorNormalCompletion14 = true;
                var _didIteratorError14 = false;
                var _iteratorError14 = undefined;

                try {
                    for (var _iterator14 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(keys), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
                        var key = _step14.value;

                        if (value === null) break;
                        value = value[key];
                    }
                } catch (err) {
                    _didIteratorError14 = true;
                    _iteratorError14 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion14 && _iterator14.return) {
                            _iterator14.return();
                        }
                    } finally {
                        if (_didIteratorError14) {
                            throw _iteratorError14;
                        }
                    }
                }
            } else {
                value = item[field];
            }
            if (fix) {
                result += NumberFix(value, fix);
            } else {
                result += Number(value) || 0;
            }
        }
    } catch (err) {
        _didIteratorError13 = true;
        _iteratorError13 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion13 && _iterator13.return) {
                _iterator13.return();
            }
        } finally {
            if (_didIteratorError13) {
                throw _iteratorError13;
            }
        }
    }

    if (fix) {
        result = NumberFix(result, fix);
    }
    return result;
};

Array.prototype.lastIndexOf = function (query) {
    for (var i = this.length - 1; i >= 0; i--) {
        var item = this[i];
        var matched = {};
        var _iteratorNormalCompletion15 = true;
        var _didIteratorError15 = false;
        var _iteratorError15 = undefined;

        try {
            for (var _iterator15 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_keys___default()(query)), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
                var key = _step15.value;

                var r = checkKeyValue(query[key], item, item, key);
                if (r) matched[key] = true;
            }
        } catch (err) {
            _didIteratorError15 = true;
            _iteratorError15 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion15 && _iterator15.return) {
                    _iterator15.return();
                }
            } finally {
                if (_didIteratorError15) {
                    throw _iteratorError15;
                }
            }
        }

        if (__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_keys___default()(matched).length === __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_keys___default()(query).length) {
            return i;
        }
    }
    return -1;
};

var NumberFix = function NumberFix(value, fix) {
    if (!value) {
        return 0;
    }
    var num = Number(value);
    if (isNaN(num)) {
        return 0;
    }
    if (!fix) {
        return num;
    }
    var roundNum = Math.pow(100, fix / 2);
    num = Math.round(num * roundNum);
    // num = parseFloat(num / roundNum).toFixed(fix)
    num = String(num / roundNum).replace(/(\.\d{fix})\d+$/, '$1');
    return Number(num);
};

// 数组对象去重
Array.prototype.unique = function (query) {
    var res = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a();
    return this.filter(function (item) {
        return !res.has(item[query]) && res.set(item[query], 1);
    });
};

// 对象选部分值
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.prototype.simple = function (origin, fields) {
    if (!origin || !fields) return origin;
    if (origin instanceof Array) {
        return this.simpleArray(origin, fields);
    } else if ((typeof origin === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(origin)) == 'object') {
        return this.simpleObject(origin, fields);
    } else {
        return origin;
    }
};

__WEBPACK_IMPORTED_MODULE_11_vue___default.a.prototype.simpleArray = function (originArray, fields) {
    var newArray = [];
    var _iteratorNormalCompletion16 = true;
    var _didIteratorError16 = false;
    var _iteratorError16 = undefined;

    try {
        for (var _iterator16 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(originArray), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
            var item = _step16.value;

            var newItem = this.simpleObject(item, fields);
            newArray.push(newItem);
        }
    } catch (err) {
        _didIteratorError16 = true;
        _iteratorError16 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion16 && _iterator16.return) {
                _iterator16.return();
            }
        } finally {
            if (_didIteratorError16) {
                throw _iteratorError16;
            }
        }
    }

    return newArray;
};

// 对象选部分值
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.prototype.simpleObject = function (origin, fields) {
    if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(fields).every(function (v) {
        return v === 0;
    })) {
        var newfields = {};
        var _iteratorNormalCompletion17 = true;
        var _didIteratorError17 = false;
        var _iteratorError17 = undefined;

        try {
            for (var _iterator17 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_keys___default()(fields)), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
                var key = _step17.value;

                newfields[key] = 1;
            }
        } catch (err) {
            _didIteratorError17 = true;
            _iteratorError17 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion17 && _iterator17.return) {
                    _iterator17.return();
                }
            } finally {
                if (_didIteratorError17) {
                    throw _iteratorError17;
                }
            }
        }

        return __WEBPACK_IMPORTED_MODULE_11_vue___default.a.prototype.clearObject(origin, newfields);
    }
    var newObject = {};
    var _iteratorNormalCompletion18 = true;
    var _didIteratorError18 = false;
    var _iteratorError18 = undefined;

    try {
        for (var _iterator18 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_keys___default()(fields)), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
            var field = _step18.value;

            if (origin[field] !== undefined) {
                newObject[field] = origin[field];
                continue;
            }
            var _key = field.split('.');
            if (_key.length == 1) {
                if (fields[field] === 1) {
                    if (origin[_key[0]] !== undefined) {
                        newObject[_key[0]] = origin[_key[0]];
                    }
                } else if (fields[field] !== undefined && fields[field] !== 0) {
                    newObject[_key[0]] = fields[field];
                }
            } else {
                for (var i = 0; i < _key.length; i++) {
                    if (i < _key.length - 1) {
                        var o = newObject;
                        var v = origin;
                        for (var j = 0; j < i; j++) {
                            o = o[_key[j]];
                            v = v[_key[j]];
                        }
                        if (v === null || v && v[_key[i]] === undefined) {
                            continue;
                        }
                        if (v && v[_key[i]] === null) {
                            o[_key[i]] = null;
                            continue;
                        }
                        if (o && o[_key[i]] === undefined) {
                            if (v && v[_key[i]] instanceof Array) {
                                o[_key[i]] = [];
                                for (var _j = 0; _j < v[_key[i]].length; _j++) {
                                    o[_key[i]].push({});
                                }
                            } else {
                                o[_key[i]] = {};
                            }
                        }
                    } else {
                        var _o = newObject;
                        var _v = origin;
                        for (var _j2 = 0; _j2 < i; _j2++) {
                            _o = _o[_key[_j2]];
                            _v = _v[_key[_j2]];
                            if (_v === undefined || _v === null) {
                                _v = {};
                                break;
                            }
                        }

                        if (fields[field] === 1) {
                            if (_v && _v instanceof Array) {
                                for (var _j3 = 0; _j3 < _v.length; _j3++) {
                                    _o[_j3][_key[i]] = _v[_j3][_key[i]];
                                }
                            } else if (_v && _v[_key[i]] !== undefined) {
                                _o[_key[i]] = _v[_key[i]];
                            }
                        } else if (fields[field] !== undefined && fields[field] !== 0) {
                            if (_v && _v instanceof Array) {
                                for (var _j4 = 0; _j4 < _v.length; _j4++) {
                                    _o[_j4][_key[i]] = fields[field];
                                }
                            } else if (_v && _v[_key[i]] !== undefined) {
                                _o[_key[i]] = fields[field];
                            }
                        }
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError18 = true;
        _iteratorError18 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion18 && _iterator18.return) {
                _iterator18.return();
            }
        } finally {
            if (_didIteratorError18) {
                throw _iteratorError18;
            }
        }
    }

    return newObject;
};

__WEBPACK_IMPORTED_MODULE_11_vue___default.a.prototype.clear = function (origin, fields) {
    if (origin instanceof Array) {
        return __WEBPACK_IMPORTED_MODULE_11_vue___default.a.prototype.clearArray(origin, fields);
    } else if ((typeof origin === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(origin)) == 'object') {
        return __WEBPACK_IMPORTED_MODULE_11_vue___default.a.prototype.clearObject(origin, fields);
    } else {
        return origin;
    }
};

__WEBPACK_IMPORTED_MODULE_11_vue___default.a.prototype.clearObject = function (origin, fields) {
    var newObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, origin);
    var _iteratorNormalCompletion19 = true;
    var _didIteratorError19 = false;
    var _iteratorError19 = undefined;

    try {
        for (var _iterator19 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_keys___default()(fields)), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
            var field = _step19.value;

            var key = field.split('.');
            if (key.length == 1) {
                delete newObject[key[0]];
            } else {
                for (var i = 0; i < key.length; i++) {
                    if (i < key.length - 1) {
                        var o = newObject;
                        for (var j = 0; j < i; j++) {
                            o = o[key[j]];
                        }
                        if (!o[key[i]]) {
                            continue;
                        }
                    } else {
                        var _o2 = newObject;
                        var v = origin;
                        for (var _j5 = 0; _j5 < i; _j5++) {
                            _o2 = _o2[key[_j5]];
                            v = v[key[_j5]];
                            if (!v) {
                                continue;
                            }
                        }
                        delete _o2[key[i]];
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError19 = true;
        _iteratorError19 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion19 && _iterator19.return) {
                _iterator19.return();
            }
        } finally {
            if (_didIteratorError19) {
                throw _iteratorError19;
            }
        }
    }

    return newObject;
};

__WEBPACK_IMPORTED_MODULE_11_vue___default.a.prototype.clearArray = function (originArray, fields) {
    var newArray = [];
    var _iteratorNormalCompletion20 = true;
    var _didIteratorError20 = false;
    var _iteratorError20 = undefined;

    try {
        for (var _iterator20 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(originArray), _step20; !(_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done); _iteratorNormalCompletion20 = true) {
            var item = _step20.value;

            var newItem = __WEBPACK_IMPORTED_MODULE_11_vue___default.a.prototype.clearObject(item, fields);
            newArray.push(newItem);
        }
    } catch (err) {
        _didIteratorError20 = true;
        _iteratorError20 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion20 && _iterator20.return) {
                _iterator20.return();
            }
        } finally {
            if (_didIteratorError20) {
                throw _iteratorError20;
            }
        }
    }

    return newArray;
};

__WEBPACK_IMPORTED_MODULE_11_vue___default.a.prototype.copy = function (obj) {
    return clone(obj);
};

function clone(obj) {
    // Handle the 3 simple types, and null or undefined
    if (null === obj || 'object' != (typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(obj))) return obj;

    // Handle Date
    if (obj instanceof Date) {
        var copy1 = new Date();
        copy1.setTime(obj.getTime());
        return copy1;
    }

    // Handle Array
    if (obj instanceof Array) {
        var copy2 = [];
        for (var i = 0, len = obj.length; i < len; ++i) {
            copy2[i] = clone(obj[i]);
        }
        return copy2;
    }

    // Handle Object
    if (obj instanceof Object) {
        var copy3 = {};
        for (var attr in obj) {
            if (obj.hasOwnProperty(attr)) copy3[attr] = clone(obj[attr]);
        }
        return copy3;
    }

    throw new Error("Unable to copy obj! Its type isn't supported.");
}

// 确认弹窗
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.prototype.showSuccessModal = function () {
    var _this = this;

    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var title = data.title || '';
    var okText = data.okText || '知道了';
    var success = data.success;
    this.$Modal.success({
        title: title,
        okText: okText,
        render: function render(h) {
            return h('div', renderText(h, data.content, _this));
        },
        onOk: function onOk() {
            success();
        }
    });
};

// 获取render函数
function renderText(h, content, _self) {
    var renderArr = [];

    var _loop2 = function _loop2(i) {
        renderArr.push(h('div', [h('span', {
            domProps: { innerHTML: i.content || '' }
        }), h('a', {
            domProps: { innerHTML: i.linkText === undefined ? '点击查看' : '' },
            on: {
                click: function click() {
                    _self.$Modal.remove();
                    if (i.linkCallback) {
                        i.linkCallback();
                    } else {
                        window.location.hash = i.path; // 适用window才能触发onhashchange事件
                    }
                }
            }
        })]));
    };

    var _iteratorNormalCompletion21 = true;
    var _didIteratorError21 = false;
    var _iteratorError21 = undefined;

    try {
        for (var _iterator21 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(content), _step21; !(_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done); _iteratorNormalCompletion21 = true) {
            var i = _step21.value;

            _loop2(i);
        }
    } catch (err) {
        _didIteratorError21 = true;
        _iteratorError21 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion21 && _iterator21.return) {
                _iterator21.return();
            }
        } finally {
            if (_didIteratorError21) {
                throw _iteratorError21;
            }
        }
    }

    return renderArr;
}



// eslint-disable-next-line no-undef
if (true) {
    __WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_27_vue_socket_io___default.a, __WEBPACK_IMPORTED_MODULE_28__ws__["a" /* SOCKET_PATH */]);
} else {
    // eslint-disable-next-line no-undef
    console.log('SOCKET OFF @ ', process.env.NODE_ENV);
}

/* eslint-disable no-new */
var vue = new __WEBPACK_IMPORTED_MODULE_11_vue___default.a({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_15__router__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */],
    template: '<App ref="app"/>',
    components: {
        App: __WEBPACK_IMPORTED_MODULE_14__App__["a" /* default */]
    }
});

/***/ }),

/***/ "O30v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        type: String,
        dataId: String
    },
    data: function data() {
        return {
            query: {
                keywords: "",
                sort: null,
                init: true
            },
            total: 0,
            page: {
                size: 10,
                current: 1
            },
            mendians: [],
            columns: [{ title: '商户号', key: 'code' }, { title: '门店名称', key: 'name' }]
        };
    },
    mounted: function mounted() {
        this.loadData();
    },

    methods: {
        loadData: function loadData() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var res;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.loading = true;
                                _context.next = 3;
                                return _this.$api.post('/web/main/keyongmendians/load', {
                                    query: _this.query,
                                    type: _this.type,
                                    dataId: _this.dataId,
                                    fields: {
                                        "name": 1,
                                        "code": 1,
                                        "level": 1,
                                        "parent": 1,
                                        "parentStr": 1,
                                        "relations": 1,
                                        "type": 1
                                    },
                                    page: _this.page
                                });

                            case 3:
                                res = _context.sent;

                                _this.loading = false;
                                if (res.data.mendians) {
                                    _this.mendians = res.data.mendians;
                                    _this.total = res.data.total;
                                }

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        pageSizeChanged: function pageSizeChanged(value) {
            this.page.size = value;
            // sessionStorage.pagesize = value
            if (this.page.current == 1) this.loadData();
        },
        pageChanged: function pageChanged(value) {
            this.page.current = value;
            this.loadData();
        },
        keywordsChanged: function keywordsChanged() {
            this.usedKeywords = this.query.keywords;
            this.page.current = 1;
            this.loadData();
        },
        sortChanged: function sortChanged() {
            this.page.current = 1;
            this.loadData();
        }
    }
});

/***/ }),

/***/ "Ofuf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tooltip"
  }, [(_vm.isResponse === false) ? _c('Tooltip', {
    attrs: {
      "placement": _vm.placement,
      "content": _vm.content,
      "theme": _vm.theme,
      "max-width": "300"
    }
  }, [_vm._t("content", null, {
    "slot": "content"
  }), _vm._v(" "), (_vm.showIcon) ? _c('Icon', {
    attrs: {
      "type": "ios-help-circle"
    }
  }) : _c('div', [_vm._t("text")], 2)], 2) : _c('Icon', {
    attrs: {
      "type": "ios-help-circle"
    },
    on: {
      "click": _vm.response
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "P9A2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        current: Object
    },
    data: function data() {
        var _this = this;

        return {
            loading: false,
            query: {
                keywords: '',
                init: true
            },
            usedKeywords: '',
            amap: {
                zoom: 14,
                center: [104.065778, 30.657487],
                lng: 0,
                lat: 0,
                address: '',
                events: {},
                dragoffset: {
                    x: 0,
                    y: 0
                },
                marker: {
                    position: [104.065778, 30.657487],
                    events: {
                        dragstart: function dragstart(e) {
                            _this.amap.dragoffset.x = e.lnglat.lng - _this.amap.marker.position[0];
                            _this.amap.dragoffset.y = e.lnglat.lat - _this.amap.marker.position[1];
                        },
                        dragend: function dragend(e) {
                            _this.amap.lng = e.lnglat.lng - _this.amap.dragoffset.x;
                            _this.amap.lat = e.lnglat.lat - _this.amap.dragoffset.y;
                            _this.amap.marker.position = [_this.amap.lng, _this.amap.lat];
                        }
                    }
                },
                searchOption: {
                    city: '成都',
                    citylimit: false
                }
            },
            location: null
        };
    },
    mounted: function mounted() {
        this.loadData();
        if (this.current) {
            this.amap.center = this.current;
            this.amap.marker.position = this.current;
        }
    },

    methods: {
        locationConfirm: function locationConfirm() {
            if (!this.amap.lng) {
                this.location = this.amap.center;
            } else {
                this.location = [this.amap.lng, this.amap.lat];
            }
            this.$emit('locationSelected', this.location);
        },
        locationCancel: function locationCancel() {
            if (this.location) {
                this.amap.center = this.location;
                this.amap.marker.position = this.location;
            }
        },
        onSearchResult: function onSearchResult(pois) {
            var latSum = 0;
            var lngSum = 0;
            if (pois.length > 0) {
                pois.forEach(function (poi) {
                    var lng = poi.lng,
                        lat = poi.lat;

                    lngSum += lng;
                    latSum += lat;
                });
                var center = {
                    lng: lngSum / pois.length,
                    lat: latSum / pois.length
                };
                this.amap.center = [center.lng, center.lat];
                this.amap.marker.position = [center.lng, center.lat];
                this.amap.lng = center.lng;
                this.amap.lat = center.lat;
            }
        },
        loadData: function loadData() {
            var that = this;
            that.loading = true;
            that.$api.post('/web/main/locationselector/load', {
                query: this.query
            }).then(function (res) {
                that.loading = false;
                if (res.data.success) {
                    if (that.query.init) {
                        that.query.init = false;
                    }
                    that.usedKeywords = that.query.keywords;
                }
            }, function () {
                that.loading = false;
            });
        },
        search: function search() {
            this.loadData();
        },
        cancel: function cancel() {
            this.$emit('cancel');
        }
    }
});

/***/ }),

/***/ "P9l9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deliveryGoodsLsit", function() { return deliveryGoodsLsit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deliveryGoodsDetails", function() { return deliveryGoodsDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deliveryGoodsSave", function() { return deliveryGoodsSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deliveryGoodsDelete", function() { return deliveryGoodsDelete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "distributionSupplyLsit", function() { return distributionSupplyLsit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "distributionSupplyDetails", function() { return distributionSupplyDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "distributionSupplySave", function() { return distributionSupplySave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "distributionSupplyDelete", function() { return distributionSupplyDelete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "templateGoods", function() { return templateGoods; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "templateSelectList", function() { return templateSelectList; });
var deliveryGoodsLsit = "/web/psyh/psmb/peisongmoban/list"; //配送要货-配送模板列表查询
var deliveryGoodsDetails = "/web/psyh/psmb/peisongmoban/load"; //配送要货-配送模板查看单条数据的详情
var deliveryGoodsSave = "/web/psyh/psmb/peisongmoban/save"; //配送要货-配送模板保存
var deliveryGoodsDelete = "/web/psyh/psmb/peisongmoban/delete"; //配送要货-配送模板删除
var distributionSupplyLsit = "/web/psgh/psmb/peisongmoban/list"; //配送供货-配送模板列表查询
var distributionSupplyDetails = "/web/psgh/psmb/peisongmoban/load"; //配送供货-配送模板查看单条数据的详情
var distributionSupplySave = "/web/psgh/psmb/peisongmoban/save"; //配送供货-配送模板保存
var distributionSupplyDelete = "/web/psgh/psmb/peisongmoban/delete"; //配送供货-配送模板删除
var templateGoods = "/web/main/peisongmobanselector/wupins/load"; //配送供货、配送要货-新建配送申请单读取指定模板的物品列表
var templateSelectList = "/web/main/peisongmobanselector/load"; //配送供货、配送要货-新建配送申请单配送模板选择窗口



/***/ }),

/***/ "Poms":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Query_vue__ = __webpack_require__("KF/o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72b1eee4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Query_vue__ = __webpack_require__("h2E7");
function injectStyle (ssrContext) {
  __webpack_require__("MoiG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-72b1eee4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Query_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72b1eee4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Query_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PvwE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.multi) ? _c('div', [(_vm.editable) ? _c('div', [(_vm.unimode) ? _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n                已选 "), _c('span', {
    staticStyle: {
      "color": "#20bf64",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.result.length))]), _vm._v(" 个 "), _c('a', {
    staticStyle: {
      "color": "#20bf64",
      "font-weight": "bold",
      "margin-left": "10px"
    },
    on: {
      "click": function($event) {
        return _vm.resultSelector.show()
      }
    }
  }, [_vm._v("编辑")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.result), function(item, index) {
    return (_vm.showAll || _vm.result.length <= 5 || index < 5) ? _c('div', {
      key: index,
      staticStyle: {
        "margin-bottom": "10px"
      }
    }, [_c('div', {
      staticStyle: {
        "display": "flex",
        "position": "relative"
      }
    }, [(_vm.clearable) ? _c('Icon', {
      staticClass: "hover clearBtn",
      staticStyle: {
        "position": "absolute",
        "top": "6px",
        "right": "6px"
      },
      attrs: {
        "type": "ios-remove-circle",
        "size": "20",
        "color": "#20bf64"
      },
      on: {
        "click": function($event) {
          return _vm.toClear(index)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.moveable) ? _c('Icon', {
      staticClass: "hover clearBtn",
      staticStyle: {
        "position": "absolute",
        "top": "6px",
        "right": "54px"
      },
      attrs: {
        "type": "ios-arrow-dropdown-circle",
        "size": "20",
        "color": "#32a14b"
      },
      on: {
        "click": function($event) {
          return _vm.moveDown(index)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.moveable) ? _c('Icon', {
      staticClass: "hover clearBtn",
      staticStyle: {
        "position": "absolute",
        "top": "6px",
        "right": "30px"
      },
      attrs: {
        "type": "ios-arrow-dropup-circle",
        "size": "20",
        "color": "#32a14b"
      },
      on: {
        "click": function($event) {
          return _vm.moveUp(index)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('Button', {
      staticClass: "item nowrap",
      attrs: {
        "type": "dashed"
      },
      on: {
        "click": function($event) {
          return _vm.resultSelector.show(index)
        }
      }
    }, [(_vm.$scopedSlots.name) ? [_vm._t("name", null, {
      "item": item
    })] : _c('span', [_vm._v(_vm._s(item.name))])], 2)], 1)]) : _vm._e()
  }), _vm._v(" "), (_vm.result.length > 5 && !_vm.showAll) ? _c('div', {
    staticStyle: {
      "font-size": "12px",
      "margin-top": "-8px",
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "showAll",
    on: {
      "click": function($event) {
        _vm.showAll = true
      }
    }
  }, [_vm._v("\n                    展示全部"), (!_vm.unimode) ? _c('span', [_vm._v("（共"), _c('span', {
    staticStyle: {
      "color": "#20bf64"
    }
  }, [_vm._v(_vm._s(_vm.result.length))]), _vm._v("个）")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (!_vm.unimode) ? _c('div', [(!_vm.max || _vm.result.length < _vm.max) ? _c('Button', {
    staticClass: "item",
    attrs: {
      "type": "dashed"
    },
    on: {
      "click": function($event) {
        return _vm.resultSelector.show()
      }
    }
  }, [_vm._v("+" + _vm._s(_vm.label ? (" " + _vm.label) : ''))]) : _vm._e()], 1) : _vm._e()], 2) : _c('div', [_vm._l((_vm.result), function(item, index) {
    return (_vm.showAll || _vm.result.length <= 5 || index < 5) ? _c('div', {
      key: index,
      staticClass: "readonlyitem"
    }, [(_vm.$scopedSlots.name) ? [_vm._t("name", null, {
      "item": item
    })] : _c('span', [_vm._v(_vm._s(item.name))])], 2) : _vm._e()
  }), _vm._v(" "), (_vm.result.length > 5 && !_vm.showAll) ? _c('div', {
    staticStyle: {
      "font-size": "12px",
      "margin-top": "-8px",
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "showAll",
    on: {
      "click": function($event) {
        _vm.showAll = true
      }
    }
  }, [_vm._v("\n                    展示全部（共"), _c('span', {
    staticStyle: {
      "color": "#20bf64"
    }
  }, [_vm._v(_vm._s(_vm.result.length))]), _vm._v("个）\n                ")])]) : _vm._e()], 2)]) : _c('div', [(_vm.editable) ? _c('div', [(_vm.result) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "position": "relative"
    }
  }, [(_vm.clearable) ? _c('Icon', {
    staticClass: "hover clearBtn",
    staticStyle: {
      "position": "absolute",
      "top": "6px",
      "right": "6px"
    },
    attrs: {
      "type": "ios-remove-circle",
      "size": "20",
      "color": "#20bf64"
    },
    on: {
      "click": function($event) {
        return _vm.toClear()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('Button', {
    staticClass: "item",
    attrs: {
      "type": "dashed"
    },
    on: {
      "click": function($event) {
        return _vm.resultSelector.show()
      }
    }
  }, [(_vm.$scopedSlots.name) ? [_vm._t("name", null, {
    "item": _vm.item
  })] : _c('span', [_vm._v(_vm._s(_vm.result.name))])], 2)], 1) : _c('Button', {
    staticClass: "item",
    attrs: {
      "type": "dashed"
    },
    on: {
      "click": function($event) {
        return _vm.resultSelector.show()
      }
    }
  }, [_vm._v("+" + _vm._s(_vm.label ? (" " + _vm.label) : ''))])], 1) : _c('div', {
    staticClass: "readonlyitem"
  }, [(_vm.$scopedSlots.name) ? [_vm._t("name", null, {
    "item": _vm.item
  })] : _c('span', [_vm._v(_vm._s(_vm.result ? _vm.result.name : ''))])], 2)]), _vm._v(" "), _c('Modal', {
    staticClass: "nopadding",
    attrs: {
      "footer-hide": "",
      "width": _vm.useMendianSelector ? 1200 : 800
    },
    model: {
      value: (_vm.resultSelector.display),
      callback: function($$v) {
        _vm.$set(_vm.resultSelector, "display", $$v)
      },
      expression: "resultSelector.display"
    }
  }, [(_vm.resultSelector.display) ? [(_vm.datatype == 'jigou' && _vm.useMendianSelector) ? _c('MendianSelector', {
    attrs: {
      "current": _vm.current
    },
    on: {
      "cancel": function($event) {
        _vm.resultSelector.display = false
      },
      "mendianSelected": _vm.resultSelector.confirm
    }
  }) : _c('DataSelector', {
    attrs: {
      "options": _vm.resultSelector.options,
      "nopage": _vm.nopage
    },
    on: {
      "cancel": function($event) {
        _vm.resultSelector.display = false
      },
      "confirm": _vm.resultSelector.confirm
    }
  })] : _vm._e()], 2)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Q+Jy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q0Ca":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["Amount"] = Amount;
/* harmony export (immutable) */ __webpack_exports__["AmountDecimal"] = AmountDecimal;
/* harmony export (immutable) */ __webpack_exports__["getWeekDay"] = getWeekDay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_price__ = __webpack_require__("rlYW");


// 保留小数(精度截取)
function Amount(data) {
  var fix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var int = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  return __WEBPACK_IMPORTED_MODULE_1__utils_price__["b" /* Amount */](data, fix, int);
}

// 保留小数(计算)
function AmountDecimal(data) {
  var fix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

  return __WEBPACK_IMPORTED_MODULE_1__utils_price__["a" /* AmountDecimal */](data, fix);
}

// 获取星期
function getWeekDay(weekDay) {
  var week = [];
  var result = '';
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(weekDay), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var i = _step.value;

      switch (Number(i)) {
        case 1:
          week.push('周一');
          break;
        case 2:
          week.push('周二');
          break;
        case 3:
          week.push('周三');
          break;
        case 4:
          week.push('周四');
          break;
        case 5:
          week.push('周五');
          break;
        case 6:
          week.push('周六');
          break;
        case 7:
          week.push('周日');
          break;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  if (week.length) {
    result = week.join('、');
  }
  return result;
}

/***/ }),

/***/ "Quz9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    width: {
      type: [Number, String],
      default: '400px'
    },
    title: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close: function close() {
      this.$emit('close', false);
    }
  }
});

/***/ }),

/***/ "R+fs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RhhK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "min-height": "calc(100vh - 261px)"
    },
    attrs: {
      "id": "app"
    }
  }, [(_vm.loading) ? _c('div', {
    staticStyle: {
      "width": "100vw",
      "height": "100vh",
      "z-index": "999",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center",
      "position": "fixed",
      "left": "0",
      "top": "0",
      "background-color": "rgba(255, 255, 255, 0.8)"
    }
  }, [_c('Spin')], 1) : _vm._e(), _vm._v(" "), (_vm.gengxinrizhiModal.displayed) ? [_c('Drawer', {
    staticStyle: {
      "z-index": "999"
    },
    attrs: {
      "placement": "right",
      "width": "440",
      "closable": false,
      "scrollable": false
    },
    on: {
      "on-visible-change": _vm.gengxinrizhiModal.displayChanged
    },
    model: {
      value: (_vm.gengxinrizhiModal.display),
      callback: function($$v) {
        _vm.$set(_vm.gengxinrizhiModal, "display", $$v)
      },
      expression: "gengxinrizhiModal.display"
    }
  }, [_c('Updatelog', {
    ref: "updatelogref",
    attrs: {
      "current": _vm.gengxinrizhiModal.current
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.isDocsRoute) ? [_c('router-view')] : [_c('div', {
    staticStyle: {
      "height": "60px",
      "width": "100%",
      "z-index": "9",
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center",
      "background-color": "#fff",
      "border-bottom": "1px solid #f1f1f1"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "24px",
      "font-weight": "bold",
      "line-height": "60px",
      "padding-left": "20px",
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "32px",
      "height": "32px",
      "display": "block",
      "border-radius": "4px",
      "margin-right": "12px"
    },
    attrs: {
      "src": "//cdn.igyl.com/vendor-statics/k.png"
    }
  }), _vm._v(" "), _c('div', [_vm._v("供应链 · " + _vm._s((_vm.session && _vm.session.jigou) ? '智能版' : '总后台'))]), _vm._v(" "), _c('div', {
    staticClass: "admintag center",
    staticStyle: {
      "background-color": "#f5f5f5",
      "border-radius": "16px",
      "margin-left": "20px",
      "padding": "4px 8px",
      "height": "30px",
      "color": "#333"
    },
    on: {
      "click": _vm.gengxinrizhiModal.show
    }
  }, [(_vm.session) ? _c('Badge', {
    attrs: {
      "dot": _vm.newversiontip,
      "offset": [20, -6]
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-list-box"
    }
  }), _vm._v(" " + _vm._s(_vm.localcv || '1.0.0') + "\n                ")], 1) : _vm._e()], 1)]), _vm._v(" "), (_vm.session && _vm.session.zhanghao) ? _c('div', {
    staticStyle: {
      "padding-right": "20px",
      "display": "flex",
      "align-items": "center"
    }
  }, [(_vm.session.sysadmin) ? _c('div', {
    staticClass: "admintag"
  }, [_vm._v("超级管理员：" + _vm._s(_vm.session.sysadmin))]) : _vm._e(), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "placement": "bottom-end",
      "trigger": "click"
    },
    on: {
      "on-visible-change": _vm.loadZhanghaos
    }
  }, [_c('div', {
    staticClass: "hover",
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "margin-right": "20px"
    },
    attrs: {
      "id": "current_jigou"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.session.jigou ? _vm.session.jigou.name : '总后台'))])]), _vm._v(" "), _c('Icon', {
    staticStyle: {
      "margin-left": "4px"
    },
    attrs: {
      "type": "ios-arrow-down"
    }
  })], 1), _vm._v(" "), _c('DropdownMenu', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "#aaa",
      "padding-top": "10px"
    }
  }, [_vm._v("切换身份")]), _vm._v(" "), (_vm.session.sysadmin) ? _c('div', {
    staticStyle: {
      "padding": "7px 16px"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "更换到手机号",
      "search": ""
    },
    on: {
      "on-enter": _vm.loadZhanghaos
    },
    model: {
      value: (_vm.sysadminphone),
      callback: function($$v) {
        _vm.sysadminphone = $$v
      },
      expression: "sysadminphone"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "7px 16px"
    },
    attrs: {
      "id": "account_search_wapper"
    }
  }, [_c('Input', {
    ref: "account_search",
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "搜索",
      "search": ""
    },
    on: {
      "input": _vm.shopInput
    },
    model: {
      value: (_vm.shopsName),
      callback: function($$v) {
        _vm.shopsName = $$v
      },
      expression: "shopsName"
    }
  })], 1), _vm._v(" "), (_vm.accounts.length >= 1) ? _c('div', {
    staticStyle: {
      "max-height": "500px",
      "overflow-y": "auto"
    }
  }, _vm._l((_vm.accounts), function(item, index) {
    return _c('div', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.toSwitch(item)
        }
      }
    }, [(item._id != _vm.session.zhanghao._id && item.actived && !item.deleted && (!item.jituan || item.jituan.actived !== false) && (!item.jigou || (item.jigou.actived === undefined || item.jigou.actived))) ? _c('DropdownItem', {
      key: index
    }, [_c('div', [_c('div', {
      staticClass: "nowrap",
      staticStyle: {
        "max-width": "300px"
      }
    }, [_vm._v(_vm._s(item.jigou ? item.jigou.name : '总后台'))]), _vm._v(" "), (item.jueses && item.jueses[0]) ? _c('div', {
      staticStyle: {
        "color": "#aaa"
      }
    }, [_vm._v(_vm._s(item.jueses.map(function (i) {
      return i.name
    }).join(',')))]) : _vm._e(), _vm._v(" "), (_vm.session.sysadmin) ? _c('div', {
      staticStyle: {
        "color": "#aaa"
      }
    }, [_vm._v(_vm._s(item.name) + "(" + _vm._s(item.user ? item.user.phone : '') + ")")]) : _vm._e()])]) : _vm._e()], 1)
  }), 0) : _c('div', {
    staticStyle: {
      "padding": "16px",
      "text-align": "center"
    }
  }, [_vm._v("\n                        暂无数据\n                    ")])])], 1), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "placement": "bottom-end",
      "trigger": "click"
    }
  }, [_c('div', {
    staticClass: "hover",
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    },
    attrs: {
      "id": "current_account"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.session.zhanghao.name) + "\n                    "), _c('Icon', {
    staticStyle: {
      "margin-left": "4px"
    },
    attrs: {
      "type": "ios-arrow-down"
    }
  })], 1), _vm._v(" "), _c('DropdownMenu', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [(_vm.session.jigou) ? _c('DropdownItem', [_c('div', {
    on: {
      "click": _vm.toProfile
    }
  }, [_vm._v("\n                            个人中心\n                        ")])]) : _vm._e(), _vm._v(" "), _c('DropdownItem', [_c('div', {
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("\n                            退出\n                        ")])])], 1)], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', [(_vm.session && _vm.session.zhanghao) ? _c('div', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "id": "container"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "200px",
      "height": "calc(100vh - 60px)",
      "overflow-y": "scroll"
    }
  }, [_c('Menu', {
    ref: "menus",
    staticStyle: {
      "min-height": "calc(100vh - 60px)"
    },
    attrs: {
      "active-name": _vm.active_menu,
      "theme": "light",
      "width": "auto",
      "open-names": _vm.active_menugroup,
      "accordion": ""
    },
    on: {
      "on-select": _vm.mendSelect
    }
  }, [_c('Menu-item', {
    staticClass: "menu-item",
    attrs: {
      "name": "0",
      "to": "/"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-grid-outline",
      "size": "16"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "2px"
    }
  }, [_vm._v("首页")])], 1), _vm._v(" "), _vm._l((_vm.session.menuGroups), function(item, index) {
    return _c('Submenu', {
      key: index,
      attrs: {
        "name": item.key
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('Icon', {
      attrs: {
        "type": "ios-grid-outline",
        "size": "16"
      }
    }), _vm._v(" "), (_vm.groupbadge) ? _c('Badge', {
      attrs: {
        "count": _vm.groupbadge[item.code],
        "overflow-count": "99"
      }
    }, [_vm._v("\n                                " + _vm._s(item.name) + "\n                            ")]) : _c('span', [_vm._v(_vm._s(item.name))])], 1), _vm._v(" "), _vm._l((item.menus), function(menu, index) {
      return _c('Menu-item', {
        key: index,
        staticClass: "menu-item",
        staticStyle: {
          "background-color": "#fafafa",
          "margin-left": "16px"
        },
        attrs: {
          "to": menu.path,
          "name": menu.key
        }
      }, [(_vm.session.badge) ? _c('Badge', {
        attrs: {
          "count": _vm.session.badge[item.code] ? _vm.session.badge[item.code][menu.code] : 0,
          "overflow-count": "99"
        }
      }, [_c('span', [_vm._v(_vm._s(menu.name))])]) : _c('span', [_vm._v(_vm._s(menu.name))])], 1)
    })], 2)
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "calc(100vw - 200px)",
      "height": "calc(100vh - 60px)",
      "overflow-y": "scroll"
    }
  }, [_c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "app-nav",
    staticStyle: {
      "height": "40px",
      "position": "fixed",
      "background": "#fff",
      "top": "60px",
      "left": "200px",
      "width": "calc(100vw - 216px)",
      "z-index": "99"
    }
  }, [_c('tags-nav', {
    attrs: {
      "value": _vm.$route,
      "list": _vm.tagNavList
    },
    on: {
      "input": _vm.handleClick,
      "on-close": _vm.handleCloseTag
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "app-nav-padding",
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('keep-alive', {
    attrs: {
      "exclude": _vm.excludeCache,
      "max": 15
    }
  }, [_c('router-view', {
    ref: "main",
    attrs: {
      "activeMenu": _vm.active_menu
    }
  })], 1)], 1)])]) : _vm._e()]), _vm._v(" "), (_vm.session && !_vm.session.zhanghao) ? _c('div', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "200px"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "background-color": "#fff",
      "border": "1px solid rgb(241, 241, 241)",
      "min-height": "392px",
      "width": "415px"
    }
  }, [_c('div', {
    staticStyle: {
      "background-color": "#f7f8fa",
      "font-weight": "bold",
      "padding": "10px",
      "font-size": "20px"
    }
  }, [_vm._v("系统登录")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "hover",
    style: ('width:50%;padding: 10px 0;' + (_vm.form.type == 'scan' ? 'border-bottom:4px solid #20bf64;font-weight:bold;' : 'border-bottom:1px solid #f1f1f1')),
    on: {
      "click": function($event) {
        _vm.form.type = 'scan';
        _vm.loadLoginCode()
      }
    }
  }, [_vm._v("扫码登录")]), _vm._v(" "), _c('div', {
    staticClass: "hover",
    style: ('width:50%;padding: 10px 0;' + (_vm.form.type == 'phone' ? 'border-bottom:4px solid #20bf64;font-weight:bold;' : 'border-bottom:1px solid #f1f1f1')),
    on: {
      "click": function($event) {
        _vm.form.type = 'phone'
      }
    }
  }, [_vm._v("手机登录")])]), _vm._v(" "), (_vm.form.type == 'phone') ? _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('Input', {
    attrs: {
      "size": "large",
      "placeholder": "请输入手机号"
    },
    model: {
      value: (_vm.form.phone),
      callback: function($$v) {
        _vm.$set(_vm.form, "phone", $$v)
      },
      expression: "form.phone"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "jcsb",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('Input', {
    attrs: {
      "size": "large",
      "placeholder": "请输入验证码"
    },
    model: {
      value: (_vm.form.code),
      callback: function($$v) {
        _vm.$set(_vm.form, "code", $$v)
      },
      expression: "form.code"
    }
  }), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "10px",
      "width": "200px"
    },
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.logining,
      "disabled": !!(!_vm.form.phone || _vm.codeCD)
    },
    on: {
      "click": _vm.getCode
    }
  }, [_vm._v(_vm._s(_vm.codeCD ? ('重新获取（' + _vm.codeCD + '）') : '获取验证码'))])], 1), _vm._v(" "), _c('Button', {
    staticStyle: {
      "width": "380px",
      "margin-top": "40px",
      "margin-bottom": "20px"
    },
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.logining,
      "disabled": !_vm.codeSend
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("登录")])], 1) : _vm._e(), _vm._v(" "), (_vm.form.type == 'scan') ? _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [(!_vm.scanSuccess) ? _c('div', [_c('div', {
    staticClass: "center",
    staticStyle: {
      "padding": "10px"
    }
  }, [(_vm.loginCode) ? _c('img', {
    staticStyle: {
      "width": "200px",
      "height": "200px"
    },
    attrs: {
      "src": _vm.loginCode.url
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.loginCode) ? _c('div', {
    staticStyle: {
      "color": "#aaa"
    }
  }, [_vm._v("请使用微信扫码")]) : _vm._e(), _vm._v(" "), (!_vm.loginCode) ? _c('div', {
    staticStyle: {
      "color": "#aaa"
    }
  }, [_vm._v("正在加载二维码")]) : _vm._e()]) : _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "20px 0"
    }
  }, [_c('Icon', {
    staticStyle: {
      "color": "#20bf64",
      "font-size": "80px"
    },
    attrs: {
      "type": "ios-checkmark-circle"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("已完成扫码")]), _vm._v(" "), _c('div', {
    staticClass: "hover",
    staticStyle: {
      "color": "#20bf64",
      "font-weight": "bold"
    },
    on: {
      "click": _vm.resetQrcode
    }
  }, [_vm._v("重新获取")])], 1)]) : _vm._e()]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), _c('Modal', {
    staticClass: "nopadding",
    attrs: {
      "footer-hide": "",
      "width": 750
    },
    model: {
      value: (_vm.profileModal),
      callback: function($$v) {
        _vm.profileModal = $$v
      },
      expression: "profileModal"
    }
  }, [(_vm.profileModal) ? _c('ProfileForm', {
    ref: "profileForm",
    on: {
      "cancel": function($event) {
        _vm.profileModal = false;
      },
      "dataChanged": function($event) {
        _vm.profileModal = false;
      }
    }
  }) : _vm._e()], 1)]], 2)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "absolute",
      "bottom": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "display": "flex",
      "flex-direction": "column",
      "align-items": "center"
    }
  }, [_c('p'), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#8d8d8d",
      "margin": "0 0 5px 0"
    }
  }, [_vm._v("Copyright © 2020-2030 All rights reserved.")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "#8d8d8d",
      "text-decoration": "none",
      "margin": "0 0 5px 0"
    },
    attrs: {
      "href": "http://beian.miit.gov.cn/"
    }
  }, [_vm._v("浙ICP备18054766号")]), _vm._v(" "), _c('p')])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SKIw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MendianSelector_vue__ = __webpack_require__("pi+Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06fd45e6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_MendianSelector_vue__ = __webpack_require__("TlX3");
function injectStyle (ssrContext) {
  __webpack_require__("LJOd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-06fd45e6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MendianSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06fd45e6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_MendianSelector_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SRib":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__entities_optimize__ = __webpack_require__("XvyQ");






var CommonService = function () {
    function CommonService() {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, CommonService);

        this.entities = new __WEBPACK_IMPORTED_MODULE_4__entities_optimize__["a" /* default */]();
    }
    /**获取机构（供货、要货、管辖机构等）  */


    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(CommonService, [{
        key: 'getOrganiztion',
        value: function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(params) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.entities.getOrganiztion(params);

                            case 2:
                                return _context.abrupt('return', _context.sent);

                            case 3:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function getOrganiztion(_x) {
                return _ref.apply(this, arguments);
            }

            return getOrganiztion;
        }()

        /**供货机构（供应商）下拉框 - 加载数据 */

    }, {
        key: 'getSublevel',
        value: function () {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(params) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.entities.getSublevel(params);

                            case 2:
                                return _context2.abrupt('return', _context2.sent);

                            case 3:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function getSublevel(_x2) {
                return _ref2.apply(this, arguments);
            }

            return getSublevel;
        }()
        /**仓库下拉框 - 加载数据 */

    }, {
        key: 'getwarehouse',
        value: function () {
            var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(params) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.entities.getwarehouse(params);

                            case 2:
                                return _context3.abrupt('return', _context3.sent);

                            case 3:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function getwarehouse(_x3) {
                return _ref3.apply(this, arguments);
            }

            return getwarehouse;
        }()
        /**类别下拉框或树节点分段加载 - 加载数据 */

    }, {
        key: 'getCategory',
        value: function () {
            var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(params) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.entities.getCategory(params);

                            case 2:
                                return _context4.abrupt('return', _context4.sent);

                            case 3:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function getCategory(_x4) {
                return _ref4.apply(this, arguments);
            }

            return getCategory;
        }()
    }, {
        key: 'getBumen',
        value: function () {
            var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(params) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.entities.getBumen(params);

                            case 2:
                                return _context5.abrupt('return', _context5.sent);

                            case 3:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function getBumen(_x5) {
                return _ref5.apply(this, arguments);
            }

            return getBumen;
        }()
    }, {
        key: 'getBiaoqian',
        value: function () {
            var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(params) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.entities.getBiaoqian(params);

                            case 2:
                                return _context6.abrupt('return', _context6.sent);

                            case 3:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function getBiaoqian(_x6) {
                return _ref6.apply(this, arguments);
            }

            return getBiaoqian;
        }()
    }, {
        key: 'getYuanyin',
        value: function () {
            var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(params) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.entities.getYuanyin(params);

                            case 2:
                                return _context7.abrupt('return', _context7.sent);

                            case 3:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function getYuanyin(_x7) {
                return _ref7.apply(this, arguments);
            }

            return getYuanyin;
        }()
    }, {
        key: 'getWupin',
        value: function () {
            var _ref8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(params) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.entities.getWupin(params);

                            case 2:
                                return _context8.abrupt('return', _context8.sent);

                            case 3:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function getWupin(_x8) {
                return _ref8.apply(this, arguments);
            }

            return getWupin;
        }()
    }, {
        key: 'getCaipin',
        value: function () {
            var _ref9 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(params) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.entities.getCaipin(params);

                            case 2:
                                return _context9.abrupt('return', _context9.sent);

                            case 3:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function getCaipin(_x9) {
                return _ref9.apply(this, arguments);
            }

            return getCaipin;
        }()
    }, {
        key: 'getWaixiaokehu',
        value: function () {
            var _ref10 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(params) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this.entities.getWaixiaokehu(params);

                            case 2:
                                return _context10.abrupt('return', _context10.sent);

                            case 3:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function getWaixiaokehu(_x10) {
                return _ref10.apply(this, arguments);
            }

            return getWaixiaokehu;
        }()
    }, {
        key: 'getItems',
        value: function () {
            var _ref11 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(params, type) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                _context11.next = 2;
                                return this.entities.getItems(params, type);

                            case 2:
                                return _context11.abrupt('return', _context11.sent);

                            case 3:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function getItems(_x11, _x12) {
                return _ref11.apply(this, arguments);
            }

            return getItems;
        }()
    }]);

    return CommonService;
}();

/* harmony default export */ __webpack_exports__["a"] = (CommonService);

/***/ }),

/***/ "Sqqx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  computed: {
    pageTitle: function pageTitle() {
      return this.title || this.$route.meta.title;
    }
  }
});

/***/ }),

/***/ "Svrw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T43E":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T9ui":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LocationSelector_vue__ = __webpack_require__("P9A2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3513e15e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_LocationSelector_vue__ = __webpack_require__("tLal");
function injectStyle (ssrContext) {
  __webpack_require__("+At6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3513e15e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LocationSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3513e15e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_LocationSelector_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TOFE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("VHFm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0091abc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("9bjM");
function injectStyle (ssrContext) {
  __webpack_require__("f3aI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d0091abc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0091abc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TWOI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    leftColumns: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    edit: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    itemList: function itemList() {
      return this.copy(this.leftColumns);
    }
  },
  methods: {
    selectorchange: function selectorchange(index, value) {
      this.itemList[index].value = value;
      this.change(index);
    },
    change: function change(index) {
      var _itemList$index = this.itemList[index],
          key = _itemList$index.key,
          value = _itemList$index.value;

      this.$emit('change', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, key, value));
    },
    fahuoriqiChanged: function fahuoriqiChanged(val) {
      this.$emit('fahuoriqiChanged', val);
    }
  }
});

/***/ }),

/***/ "TlX3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "20px 0"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "border-top": "1px solid #f1f1f1",
      "border-bottom": "1px solid #f1f1f1",
      "margin-top": "20px",
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "0 20px",
      "min-height": "200px",
      "min-width": "280px",
      "border-right": "1px solid #f1f1f1"
    }
  }, [(!_vm.jigous.length) ? _c('div', [_vm._m(1)]) : _c('div', [_c('div', {
    staticClass: "df"
  }, [_c('Tabs', {
    attrs: {
      "animated": false
    },
    on: {
      "on-click": _vm.querytypeChanged
    },
    model: {
      value: (_vm.querytype),
      callback: function($$v) {
        _vm.querytype = $$v
      },
      expression: "querytype"
    }
  }, [_c('TabPane', {
    attrs: {
      "label": "按组织筛选",
      "name": "anzuzhi"
    }
  }), _vm._v(" "), (_vm.biaoqianleixing != 'none') ? _c('TabPane', {
    attrs: {
      "label": "按标签筛选",
      "name": "anbiaoqian"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.querytype == 'anzuzhi') ? _c('div', [_c('div', {
    staticStyle: {
      "padding": "5px 16px"
    }
  }, [_c('Tree', {
    attrs: {
      "data": _vm.treeData,
      "show-checkbox": "",
      "expand-node": ""
    },
    on: {
      "on-check-change": _vm.treeSelected
    }
  })], 1)]) : (_vm.querytype == 'anbiaoqian') ? _c('div', [(_vm.biaoqians) ? _c('div', {
    staticStyle: {
      "padding": "5px 16px"
    }
  }, [_c('Tree', {
    attrs: {
      "data": _vm.biaoqiantree,
      "show-checkbox": "",
      "expand-node": ""
    },
    on: {
      "on-check-change": _vm.biaoqiantreeSelected
    }
  })], 1) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "icon": "ios-search",
      "placeholder": "输入名称/编码/地址查询..."
    },
    on: {
      "on-enter": _vm.keywordsChanged
    },
    model: {
      value: (_vm.query.keywords),
      callback: function($$v) {
        _vm.$set(_vm.query, "keywords", $$v)
      },
      expression: "query.keywords"
    }
  }), _vm._v(" "), (_vm.usedKeywords) ? _c('Tag', {
    staticStyle: {
      "height": "32px",
      "line-height": "32px",
      "margin": "0"
    },
    attrs: {
      "closable": ""
    },
    on: {
      "on-close": _vm.clearKeywords
    }
  }, [_vm._v("\n                    搜索：" + _vm._s(_vm.usedKeywords))]) : _vm._e(), _vm._v(" "), (_vm.query.selections) ? _c('Tag', {
    staticStyle: {
      "height": "32px",
      "line-height": "32px",
      "margin": "0"
    },
    attrs: {
      "closable": ""
    },
    on: {
      "on-close": function($event) {
        _vm.query.selections = null;
        _vm.loadData()
      }
    }
  }, [_vm._v("\n                    仅查看包含在 "), _c('span', {
    staticStyle: {
      "color": "#20bf64"
    }
  }, [_vm._v(" " + _vm._s(_vm.query.selections.filter(function (o) { return (o.actived === undefined || o.actived) && o.type != 'JG' && o.type != 'BM'; }).length))]), _vm._v(" 个已选项中的内容")]) : _vm._e()], 1), _vm._v(" "), (_vm.mendians.length) ? _c('div', [_c('Table', {
    attrs: {
      "columns": _vm.columns1,
      "loading": _vm.loading,
      "data": _vm.mendians
    },
    on: {
      "on-select": _vm.itemSelected,
      "on-select-cancel": _vm.itemSelectedCancel,
      "on-select-all": _vm.allSelected,
      "on-select-all-cancel": _vm.allSelectedCancel
    }
  }), _vm._v(" "), (_vm.mendians.length < _vm.total) ? _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('Page', {
    staticStyle: {
      "padding": "16px"
    },
    attrs: {
      "size": "small",
      "placement": "top",
      "total": _vm.total,
      "current": _vm.page.current,
      "show-sizer": "",
      "page-size-opts": [10, 20, 40, 100],
      "page-size": _vm.page.size,
      "show-total": ""
    },
    on: {
      "on-page-size-change": _vm.pageSizeChanged,
      "on-change": _vm.pageChanged
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.mendians.length) ? _c('div', {
    staticClass: "center",
    staticStyle: {
      "color": "#aaa",
      "min-height": "200px"
    }
  }, [_vm._v("暂无数据")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "16px 20px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_vm._v("\n                    已选"), _c('span', {
    staticStyle: {
      "color": "#20bf64",
      "margin": "0 4px"
    }
  }, [_vm._v(_vm._s(_vm.selections.filter(function (o) { return (o.actived === undefined || o.actived) && o.type != 'JG' && o.type != 'BM'; }).length))]), _vm._v("项\n                    "), _c('Poptip', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('Icon', {
    staticStyle: {
      "color": "#aaa",
      "margin-left": "2px"
    },
    attrs: {
      "type": "ios-information-circle-outline"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#aaa"
    },
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticStyle: {
      "width": "520px",
      "word-wrap": "break-word",
      "white-space": "normal"
    }
  }, [_vm._v("\n                                列表中的数据仅显示了当前登录账号有权限管辖且启用中的机构，已选总数则统计的是被编辑的账号完整管辖机构数据，不受当前登录账号的权限和查询条件等限制。\n                            ")])])], 1), _vm._v(" "), (_vm.selections.length) ? _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "hover",
    staticStyle: {
      "color": "#20bf64",
      "margin-left": "10px"
    },
    on: {
      "click": _vm.showSelections
    }
  }, [_vm._v("查看")]), _vm._v(" "), _c('div', {
    staticClass: "hover",
    staticStyle: {
      "color": "#20bf64",
      "margin-left": "10px"
    },
    on: {
      "click": _vm.clearSelections
    }
  }, [_vm._v("取消选择")]), _vm._v(" "), (_vm.selections.length != _vm.total) ? _c('div', {
    staticClass: "hover",
    staticStyle: {
      "color": "#20bf64",
      "margin-left": "10px"
    },
    on: {
      "click": _vm.selectall
    }
  }, [_vm._v("选择全部" + _vm._s(_vm.total) + "项")]) : _vm._e()]) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "foot jcsb",
    staticStyle: {
      "padding": "0 20px"
    }
  }, [_c('div'), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('Button', {
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.mendianSelected
    }
  }, [_vm._v("确定")])], 1)])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "font-size": "20px",
      "padding": "0 20px"
    }
  }, [_c('div', [_vm._v("选择机构")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center",
    staticStyle: {
      "color": "#aaa",
      "min-height": "200px"
    }
  }, [_c('div', [_vm._v("暂无数据")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TrXq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("xdmG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ee50225_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("Wpj6");
function injectStyle (ssrContext) {
  __webpack_require__("FdG9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6ee50225"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ee50225_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Tvnc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U0h6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: _vm.printerCls,
    style: (_vm.paperType)
  }, [_c('div', {
    staticStyle: {
      "position": "relative",
      "width": "100%",
      "height": "100%",
      "padding": "0"
    }
  }, [_c('div', {
    staticStyle: {
      "textAlign": "center",
      "paddingBottom": "5px",
      "marginTop": "9px"
    },
    style: ({
      marginRight: _vm.showBarcode ? '60px' : ''
    })
  }, [_c('span', {
    style: ({
      borderBottom: '1px solid #000',
      fontSize: '16px',
      padding: _vm.thin ? '0' : '3px 6px',
      lineHeight: _vm.thin ? 1 : 1.5
    })
  }, [_vm._v(_vm._s(_vm.showChainName ? _vm.chainName : '') + " " + _vm._s(_vm.layout.danjuleixing))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBarcode),
      expression: "showBarcode"
    }],
    staticClass: "barcode-container",
    staticStyle: {
      "position": "absolute",
      "top": "-25px",
      "right": "-0px"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.drawBarcode()
    }
  })]), _vm._v(" "), (_vm.page === 1 || (_vm.page > 1 && _vm.layout.yetoudayin === '每页打印')) ? _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, _vm._l((_vm.headItems), function(item, index) {
    return _c('div', {
      key: index,
      class: {
        'print-addr': item.key && _vm.alones.includes(item.key),
        'print-ellipsis': true
      },
      style: ({
        float: 'left',
        width: _vm.alones.includes(item.key) ? '100%' : '33.33%',
        height: _vm.thin ? _vm.height.thin : _vm.height.base,
        lineHeight: _vm.thin ? _vm.height.thin : _vm.height.base,
        fontSize: _vm.layout.zitidaxiao || '12px'
      })
    }, [_vm._v("\n                    " + _vm._s(_vm.tempFmt(item, item.key)) + "\n                ")])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    class: [{
      'table-empty': _vm.printData.length === 0,
      'table-thin': _vm.thin
    }, 'table-' + _vm.layout.zitidaxiao || '12px'],
    staticStyle: {
      "clear": "both",
      "padding": "3px 0"
    }
  }, [_c('vxe-table', {
    ref: "table",
    attrs: {
      "border": 'none',
      "column-config": {
        resizable: true
      },
      "resizable-config": {
        minWidth: _vm.getMinWidth
      },
      "data": _vm.printData,
      "header-cell-style": _vm.cellStyle,
      "cell-style": _vm.cellStyle
    },
    on: {
      "resizable-change": _vm.changeWidth
    }
  }, _vm._l((_vm.printColumns), function(item, idx) {
    return _c('vxe-column', {
      key: idx,
      attrs: {
        "field": item.field,
        "title": item.title,
        "width": item.width
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.page === _vm.pages || (_vm.page !== _vm.pages && _vm.layout.yeweidayin === '每页打印')) ? _c('div', _vm._l((_vm.footItems), function(item, index) {
    return _c('div', {
      key: index,
      class: {
        'print-addr': item.key && _vm.alones.includes(item.key),
        'print-ellipsis': true
      },
      style: ({
        float: 'left',
        height: _vm.thin ? _vm.height.thin : _vm.height.base,
        lineHeight: _vm.thin ? _vm.height.thin : _vm.height.base,
        width: _vm.alones.includes(item.key) ? '100%' : '33.33%',
        fontSize: _vm.layout.zitidaxiao || '12px'
      })
    }, [_vm._v("\n                    " + _vm._s(_vm.tempFmt(item, item.key)) + "\n                ")])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.layout.dayinyema === 'true' || _vm.layout.dayinyema === true) ? _c('div', {
    style: ({
      position: 'absolute',
      bottom: 0,
      right: 0,
      fontSize: _vm.layout.zitidaxiao || '12px'
    })
  }, [_vm._v("第" + _vm._s(_vm.page || 1) + "页/共" + _vm._s(_vm.pages || 1) + "页")]) : _vm._e()])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UyV6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VEJa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VHFm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_upload__ = __webpack_require__("3z2j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_constants_common__ = __webpack_require__("x9kB");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_upload__["a" /* default */]],
  props: {
    /**行内配置 */
    formItem: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    /**规则 */
    rules: {
      type: Object,
      default: function _default() {}
    },
    /**表单额外配置 */
    formExtraConfig: {
      type: Object,
      default: function _default() {}
    },
    /**form内容 */
    form: {
      type: Object,
      default: function _default() {}
    },
    /**label位置 */
    labelPosition: {
      type: String,
      default: 'right'
    },
    /**是否显示button */
    showButton: {
      type: Boolean,
      default: true
    },
    /** 确认按钮文字*/
    confirmText: {
      type: String,
      default: '保存'
    },
    /**取消按钮文字 */
    cancelText: {
      type: String,
      default: '取消'
    },
    /**按钮显示位置 */
    btnAlign: {
      type: String,
      default: 'left'
    },
    /**是否一行展示 */
    inline: {
      type: Boolean,
      default: false
    },
    /**label宽度 */
    labelWidth: {
      type: Number,
      default: 170
    }
  },
  methods: {
    /**表单内容切换 */
    change: function change(v, key) {
      this.$emit('change', { form: this.form, key: key, value: v });
    },
    deleteImage: function deleteImage(key) {
      this.form[key] = '';
      this.change('', key);
    },


    /**图片上传成功*/
    uploadSuccess: function uploadSuccess(res) {
      var url = __WEBPACK_IMPORTED_MODULE_1__helpers_constants_common__["d" /* HOST */].FILE_HOST + '/' + res.key;
      this.form[this.uploadKey] = url;
      this.change(url, this.uploadKey);
    },


    /**input-enter */
    inputEnterSearch: function inputEnterSearch(v, key, inputEnter) {
      if (inputEnter) {
        this.$emit('change', { form: this.form, key: key, value: v });
      }
    },


    /**保存 */
    onSave: function onSave() {
      var _this = this;

      this.$refs['form'].validate(function (valid) {
        if (valid) {
          _this.$emit('save');
        } else {
          _this.$Message.warning('请检查输入');
        }
      });
    },


    /**检查图片大小 */
    checkImageSize: function checkImageSize(file, maxSize) {
      this.$Message.error('\u8BF7\u4E0A\u4F20\u5927\u5C0F\u4E3A' + maxSize / 1024 + 'M\u4EE5\u5185\u7684\u56FE\u7247');
    },

    /**取消 */
    onCancel: function onCancel() {
      this.$emit('cancel');
    }
  }
});

/***/ }),

/***/ "VL7Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VMgG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "20px 0"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "border-top": "1px solid #f1f1f1",
      "margin-top": "20px",
      "padding-bottom": "40px"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "icon": "ios-search",
      "placeholder": "输入名称或编号查询..."
    },
    on: {
      "on-enter": _vm.keywordsChanged
    },
    model: {
      value: (_vm.query.keywords),
      callback: function($$v) {
        _vm.$set(_vm.query, "keywords", $$v)
      },
      expression: "query.keywords"
    }
  }), _vm._v(" "), (_vm.usedKeywords) ? _c('Tag', {
    staticStyle: {
      "height": "32px",
      "line-height": "32px",
      "margin": "0"
    },
    attrs: {
      "closable": ""
    },
    on: {
      "on-close": _vm.clearKeywords
    }
  }, [_vm._v("\n                搜索：" + _vm._s(_vm.usedKeywords))]) : _vm._e()], 1), _vm._v(" "), (_vm.caigoumobans.length) ? _c('div', [_c('Table', {
    attrs: {
      "columns": _vm.columns1,
      "loading": _vm.loading,
      "data": _vm.caigoumobans
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('Page', {
    staticStyle: {
      "padding": "16px"
    },
    attrs: {
      "size": "small",
      "placement": "top",
      "total": _vm.total,
      "current": _vm.page.current,
      "page-size": _vm.page.size,
      "show-total": ""
    },
    on: {
      "on-change": _vm.pageChanged
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.caigoumobans.length) ? _c('div', {
    staticClass: "center",
    staticStyle: {
      "color": "#aaa",
      "min-height": "200px"
    }
  }, [_vm._v("暂无数据")]) : _vm._e()])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "font-size": "20px",
      "padding": "0 20px"
    }
  }, [_c('div', [_vm._v("选择要使用的模板")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Vip+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Printer_vue__ = __webpack_require__("Dcjb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dd62b60_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Printer_vue__ = __webpack_require__("9jHG");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Printer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dd62b60_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Printer_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Wpj6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Modal', {
    attrs: {
      "value": true,
      "width": _vm.width,
      "mask-closable": false,
      "closable": false,
      "transfer": _vm.transfer,
      "footer-hide": _vm.footerHide
    }
  }, [_c('div', {
    staticClass: "header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('Icon', {
    attrs: {
      "type": "ios-close",
      "size": "32"
    },
    on: {
      "click": _vm.close
    }
  })], 1), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.cancelText))]), _vm._v(" "), _c('Button', {
    staticClass: " ml-20",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v(_vm._s(_vm.confirmText))])], 1)], 2)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Wq/E":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Xl+7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "padding": "20px"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.config.data ? _vm.config.data.name : ''))]), _vm._v(" "), (_vm.options.history) ? _c('div', {
    staticStyle: {
      "color": "#aaa",
      "font-size": "12px"
    }
  }, [_vm._v("当前正在浏览历史版本，创建于 " + _vm._s(_vm.options.history.version))]) : _vm._e(), _vm._v(" "), (_vm.config.tips) ? _c('div', {
    staticStyle: {
      "color": "#aaa",
      "font-size": "12px"
    }
  }, [_vm._v("* " + _vm._s(_vm.config.tips))]) : _vm._e()]), _vm._v(" "), (_vm.form) ? _c('Form', {
    ref: "form",
    staticStyle: {
      "border-top": "1px solid #f1f1f1"
    },
    attrs: {
      "model": _vm.form,
      "hide-required-mark": "",
      "rules": _vm.rules,
      "label-position": "top"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, _vm._l((_vm.config.form.cols), function(col, colIndex) {
    return _c('div', {
      key: colIndex,
      style: (("padding:20px;width:" + (col.width?(col.width + 40):300) + "px;word-break:break-all;box-sizing: border-box;" + (colIndex==_vm.config.form.cols.length-1?'':'border-right: 1px solid #f1f1f1;')))
    }, [(col.slot) ? _vm._t(col.slot) : _c('div', _vm._l((col.items), function(item, index) {
      return (item.vif ? item.vif(_vm.form) : !item.hide) ? _c('div', {
        key: index
      }, [(item.type == 'title') ? _c('div', {
        staticStyle: {
          "font-size": "18px",
          "margin-bottom": "20px"
        }
      }, [_vm._v(_vm._s(item.value))]) : _vm._e(), _vm._v(" "), (item.type == 'text') ? _c('FormItem', {
        attrs: {
          "prop": item.key,
          "label": item.name
        }
      }, [_c('FormItemLabel', {
        attrs: {
          "slot": "label",
          "item": item
        },
        slot: "label"
      }), _vm._v(" "), (_vm.config.editable && !item.readonly && !(item.constant && _vm.config.current)) ? _c('Input', {
        staticStyle: {
          "width": "100%"
        },
        attrs: {
          "placeholder": item.placeholder || '请输入',
          "maxlength": item.maxlength || 500,
          "show-word-limit": item['show-word-limit'] || false,
          "disabled": item.disabledif ? item.disabledif(_vm.form) : false
        },
        model: {
          value: (_vm.form[item.key]),
          callback: function($$v) {
            _vm.$set(_vm.form, item.key, $$v)
          },
          expression: "form[item.key]"
        }
      }) : (item.render) ? _c('div', {
        style: (((item.style) + ";"))
      }, [_vm._v(_vm._s(item.render(item.key ? _vm.form[item.key] : (item.readonly ? _vm.config.current : _vm.form))))]) : (_vm.form[item.key]) ? _c('div', {
        style: (((item.style) + ";"))
      }, [_vm._v(_vm._s(_vm.form[item.key]))]) : _c('div', {
        staticStyle: {
          "color": "#aaa"
        }
      }, [_vm._v("无")])], 1) : (item.type == 'number') ? _c('FormItem', {
        attrs: {
          "prop": item.key,
          "label": item.name
        }
      }, [_c('FormItemLabel', {
        attrs: {
          "slot": "label",
          "item": item
        },
        slot: "label"
      }), _vm._v(" "), _c('div', {
        staticStyle: {
          "display": "flex"
        }
      }, [(item.slot && item.slot.prepend) ? _c('div', [_vm._v(_vm._s(item.slot.prepend(_vm.form)))]) : _vm._e(), _vm._v(" "), (_vm.config.editable && !item.readonly && !(item.constant && _vm.config.current)) ? _c('div', {
        staticStyle: {
          "position": "relative",
          "width": "100%"
        }
      }, [_c('Input', {
        staticStyle: {
          "width": "100%"
        },
        attrs: {
          "placeholder": item.placeholder || '请输入',
          "disabled": item.disabledif ? item.disabledif(_vm.form) : false,
          "min": item.min,
          "max": item.max
        },
        model: {
          value: (_vm.form[item.key]),
          callback: function($$v) {
            _vm.$set(_vm.form, item.key, _vm._n($$v))
          },
          expression: "form[item.key]"
        }
      }, [(item.unit && item.unit.type == 'selector') ? _c('Select', {
        staticStyle: {
          "width": "70px"
        },
        attrs: {
          "slot": "append",
          "disabled": item.disabledif ? item.disabledif(_vm.form) : false
        },
        slot: "append",
        model: {
          value: (_vm.form[item.unit.key]),
          callback: function($$v) {
            _vm.$set(_vm.form, item.unit.key, $$v)
          },
          expression: "form[item.unit.key]"
        }
      }, _vm._l((item.unit.selections), function(u, idx) {
        return _c('Option', {
          key: u.value || u,
          attrs: {
            "value": u.value || u
          }
        }, [_vm._v(_vm._s(u.name || u))])
      }), 1) : _vm._e()], 1)], 1) : _c('div', [_vm._v(_vm._s(_vm.form[item.key])), (item.unit) ? _c('span', [_vm._v(_vm._s((item.unit.selections.find(function (s) { return s == _vm.form[item.unit.key] || s.value == _vm.form[item.unit.key]; })) ? (item.unit.selections.find(function (s) { return s == _vm.form[item.unit.key] || s.value == _vm.form[item.unit.key]; }).name || item.unit.selections.find(function (s) { return s == _vm.form[item.unit.key] || s.value == _vm.form[item.unit.key]; })) : ''))]) : _vm._e()]), _vm._v(" "), (item.slot && item.slot.append) ? _c('div', [_vm._v(_vm._s(item.slot.append(_vm.form)))]) : _vm._e()])], 1) : (item.type == 'image') ? _c('FormItem', {
        attrs: {
          "prop": item.key,
          "label": item.name
        }
      }, [_c('FormItemLabel', {
        attrs: {
          "slot": "label",
          "item": item
        },
        slot: "label"
      }), _vm._v(" "), (!_vm.form[item.key]) ? _c('div', {
        staticStyle: {
          "font-size": "12px",
          "margin-left": "4px"
        }
      }, [_vm._v(_vm._s(item.description))]) : _vm._e(), _vm._v(" "), _c('Uploader', {
        attrs: {
          "current": _vm.form[item.key],
          "editable": _vm.config.editable && !item.readonly && !(item.constant && _vm.config.current),
          "multi": item.multi,
          "max": item.max
        },
        on: {
          "confirm": function($event) {
            _vm.form[item.key] = $event
          }
        }
      })], 1) : (item.type == 'textarea') ? _c('FormItem', {
        attrs: {
          "prop": item.key,
          "label": item.name
        }
      }, [_c('FormItemLabel', {
        attrs: {
          "slot": "label",
          "item": item
        },
        slot: "label"
      }), _vm._v(" "), (_vm.config.editable && !item.readonly && !(item.constant && _vm.config.current)) ? _c('Input', {
        attrs: {
          "type": "textarea",
          "rows": item.rows || 4,
          "placeholder": item.placeholder || '请输入',
          "maxlength": item.maxlength || 500,
          "show-word-limit": item['show-word-limit'] || false,
          "disabled": item.disabledif ? item.disabledif(_vm.form) : false
        },
        model: {
          value: (_vm.form[item.key]),
          callback: function($$v) {
            _vm.$set(_vm.form, item.key, $$v)
          },
          expression: "form[item.key]"
        }
      }) : _c('div', [_vm._v(_vm._s(_vm.form[item.key]))])], 1) : (item.type == 'label') ? _c('div', {
        style: (((item.style) + ";"))
      }, [_vm._v("\n                            " + _vm._s(item.render ? item.render(_vm.form) : item.value) + "\n                            "), _c('div', {
        staticStyle: {
          "height": "20px"
        }
      })]) : (item.type == 'switch') ? _c('FormItem', {
        attrs: {
          "prop": item.key,
          "label": item.name
        }
      }, [_c('FormItemLabel', {
        attrs: {
          "slot": "label",
          "item": item
        },
        slot: "label"
      }), _vm._v(" "), _c('i-switch', {
        attrs: {
          "disabled": !(_vm.config.editable && !item.readonly && !(item.constant && _vm.config.current))
        },
        model: {
          value: (_vm.form[item.key]),
          callback: function($$v) {
            _vm.$set(_vm.form, item.key, $$v)
          },
          expression: "form[item.key]"
        }
      }, [_c('span', {
        attrs: {
          "slot": "open"
        },
        slot: "open"
      }, [_vm._v("是")]), _vm._v(" "), _c('span', {
        attrs: {
          "slot": "close"
        },
        slot: "close"
      }, [_vm._v("否")])])], 1) : (item.type == 'daterange') ? _c('FormItem', {
        attrs: {
          "prop": item.key,
          "label": item.name
        }
      }, [_c('FormItemLabel', {
        attrs: {
          "slot": "label",
          "item": item
        },
        slot: "label"
      }), _vm._v(" "), (_vm.config.editable && !item.readonly && !(item.constant && _vm.config.current)) ? _c('DatePicker', {
        staticStyle: {
          "width": "100%"
        },
        attrs: {
          "clearable": item.clearable || false,
          "value": _vm.form[item.key],
          "format": item.format || 'yyyy-MM-dd',
          "type": "daterange",
          "placement": "bottom-end",
          "placeholder": "请选择",
          "disabled": item.disabledif ? item.disabledif(_vm.form) : false
        },
        on: {
          "on-change": function($event) {
            return _vm.daterangeChanged(item, $event)
          }
        }
      }) : (_vm.form[item.key] && _vm.form[item.key][0]) ? _c('div', [_vm._v(_vm._s(_vm.form[item.key][0]) + " - " + _vm._s(_vm.form[item.key][1]))]) : _c('div', {
        staticStyle: {
          "color": "#aaa"
        }
      }, [_vm._v("无")])], 1) : (item.type == 'time') ? _c('FormItem', {
        attrs: {
          "prop": item.key,
          "label": item.name
        }
      }, [_c('FormItemLabel', {
        attrs: {
          "slot": "label",
          "item": item
        },
        slot: "label"
      }), _vm._v(" "), (_vm.config.editable && !item.readonly && !(item.constant && _vm.config.current)) ? _c('TimePicker', {
        staticStyle: {
          "width": "112px"
        },
        attrs: {
          "format": "HH:mm",
          "value": _vm.form[item.key],
          "placeholder": "请选择",
          "disabled": item.disabledif ? item.disabledif(_vm.form) : false
        },
        on: {
          "on-change": function($event) {
            _vm.form[item.key] = $event
          }
        }
      }) : (_vm.form[item.key]) ? _c('div', [_vm._v(_vm._s(_vm.form[item.key]))]) : _c('div', {
        staticStyle: {
          "color": "#aaa"
        }
      }, [_vm._v("无")])], 1) : (item.type == 'date') ? _c('FormItem', {
        attrs: {
          "prop": item.key,
          "label": item.name
        }
      }, [_c('FormItemLabel', {
        attrs: {
          "slot": "label",
          "item": item
        },
        slot: "label"
      }), _vm._v(" "), (_vm.config.editable && !item.readonly && !(item.constant && _vm.config.current)) ? _c('DatePicker', {
        staticStyle: {
          "width": "100%"
        },
        attrs: {
          "format": item.format || 'yyyy-MM-dd',
          "value": _vm.form[item.key],
          "placeholder": "请选择",
          "disabled": item.disabledif ? item.disabledif(_vm.form) : false
        },
        on: {
          "on-change": function($event) {
            _vm.form[item.key] = $event
          }
        }
      }) : (_vm.form[item.key]) ? _c('div', [_vm._v(_vm._s(_vm.form[item.key]))]) : _c('div', {
        staticStyle: {
          "color": "#aaa"
        }
      }, [_vm._v("无")])], 1) : (item.type == 'datetime') ? _c('FormItem', {
        attrs: {
          "prop": item.key,
          "label": item.name
        }
      }, [_c('FormItemLabel', {
        attrs: {
          "slot": "label",
          "item": item
        },
        slot: "label"
      }), _vm._v(" "), (_vm.config.editable && !item.readonly && !(item.constant && _vm.config.current)) ? _c('DatePicker', {
        staticStyle: {
          "width": "100%"
        },
        attrs: {
          "format": item.format || 'yyyy-MM-dd HH:mm:ss',
          "type": "datetime",
          "value": _vm.form[item.key],
          "placeholder": "请选择",
          "disabled": item.disabledif ? item.disabledif(_vm.form) : false
        },
        on: {
          "on-change": function($event) {
            return _vm.datePickerChanged(_vm.form, item, $event)
          }
        }
      }) : (_vm.form[item.key]) ? _c('div', [_vm._v(_vm._s(_vm.form[item.key]))]) : _c('div', {
        staticStyle: {
          "color": "#aaa"
        }
      }, [_vm._v("无")])], 1) : (item.type == 'custom') ? _c('FormItem', {
        attrs: {
          "prop": item.key,
          "label": item.name
        }
      }, [_c('FormItemLabel', {
        attrs: {
          "slot": "label",
          "item": item
        },
        slot: "label"
      }), _vm._v(" "), (!_vm.form[item.key]) ? _c('div', {
        staticStyle: {
          "font-size": "12px",
          "margin-left": "4px"
        }
      }, [_vm._v(_vm._s(item.description))]) : _vm._e(), _vm._v(" "), _c('CustomData', {
        attrs: {
          "current": _vm.form[item.key],
          "editable": _vm.config.editable && !item.readonly && !(item.constant && _vm.config.current),
          "multi": item.multi,
          "moveable": item.moveable,
          "max": item.max,
          "datatype": item.datatype,
          "unimode": item.unimode,
          "query": item.query,
          "fields": item.fields,
          "columns": item.columns,
          "useMendianSelector": item.useMendianSelector
        },
        on: {
          "confirm": function($event) {
            _vm.form[item.key] = $event
          }
        }
      })], 1) : (item.type == 'biaodanziduan') ? _c('FormItem', {
        attrs: {
          "prop": item.key,
          "label": item.name
        }
      }, [_c('FormItemLabel', {
        attrs: {
          "slot": "label",
          "item": item
        },
        slot: "label"
      }), _vm._v(" "), (!_vm.form[item.key]) ? _c('div', {
        staticStyle: {
          "font-size": "12px",
          "margin-left": "4px"
        }
      }, [_vm._v(_vm._s(item.description))]) : _vm._e(), _vm._v(" "), _c('FormItemEditor', {
        attrs: {
          "current": _vm.form[item.key],
          "editable": _vm.config.editable && !item.readonly && !(item.constant && _vm.config.current),
          "max": item.max
        },
        on: {
          "confirm": function($event) {
            _vm.form[item.key] = $event
          }
        }
      })], 1) : (item.type == 'checkbox') ? _c('FormItem', {
        attrs: {
          "prop": item.key,
          "label": item.name
        }
      }, [_c('FormItemLabel', {
        attrs: {
          "slot": "label",
          "item": item
        },
        slot: "label"
      }), _vm._v(" "), (!_vm.form[item.key]) ? _c('div', {
        staticStyle: {
          "font-size": "12px",
          "margin-left": "4px"
        }
      }, [_vm._v(_vm._s(item.description))]) : _vm._e(), _vm._v(" "), _c('CheckboxGroup', {
        model: {
          value: (_vm.form[item.key]),
          callback: function($$v) {
            _vm.$set(_vm.form, item.key, $$v)
          },
          expression: "form[item.key]"
        }
      }, _vm._l((item.loader ? item.loader(_vm.form) : item.selections), function(selection) {
        return _c('Checkbox', {
          key: selection,
          attrs: {
            "label": selection
          }
        }, [_vm._v(_vm._s(selection))])
      }), 1)], 1) : (item.type == 'list') ? _c('FormItem', {
        attrs: {
          "prop": item.key,
          "label": item.name
        }
      }, [_c('FormItemLabel', {
        attrs: {
          "slot": "label",
          "item": item
        },
        slot: "label"
      }), _vm._v(" "), (!_vm.form[item.key]) ? _c('div', {
        staticStyle: {
          "font-size": "12px",
          "margin-left": "4px"
        }
      }, [_vm._v(_vm._s(item.description))]) : _vm._e(), _vm._v(" "), _c('TextList', {
        attrs: {
          "options": item,
          "current": _vm.form[item.key]
        }
      })], 1) : (item.type == 'radio') ? _c('FormItem', {
        attrs: {
          "prop": item.key,
          "label": item.name
        }
      }, [_c('FormItemLabel', {
        attrs: {
          "slot": "label",
          "item": item
        },
        slot: "label"
      }), _vm._v(" "), (!_vm.form[item.key]) ? _c('div', {
        staticStyle: {
          "font-size": "12px",
          "margin-left": "4px"
        }
      }, [_vm._v(_vm._s(item.description))]) : _vm._e(), _vm._v(" "), (_vm.config.editable && !item.readonly && !(item.constant && _vm.config.current)) ? _c('RadioGroup', {
        attrs: {
          "disabled": item.disabledif ? item.disabledif(_vm.form) : false
        },
        on: {
          "on-change": function($event) {
            item.change ? item.change({
              form: _vm.form
            }) : null
          }
        },
        model: {
          value: (_vm.form[item.key]),
          callback: function($$v) {
            _vm.$set(_vm.form, item.key, $$v)
          },
          expression: "form[item.key]"
        }
      }, _vm._l((item.loader ? item.loader(_vm.form) : item.selections), function(r, i) {
        return _c('Radio', {
          key: i,
          attrs: {
            "label": r.value,
            "disabled": r.disabled
          }
        }, [_c('span', [_vm._v(_vm._s(r.name))])])
      }), 1) : _c('div', [_c('span', [_vm._v(_vm._s(item.selections.find(function (o) { return o.value == _vm.form[item.key]; }) ? item.selections.find(function (o) { return o.value == _vm.form[item.key]; }).name : ''))])])], 1) : (item.type == 'selector') ? _c('FormItem', {
        attrs: {
          "prop": item.key,
          "label": item.name
        }
      }, [_c('FormItemLabel', {
        attrs: {
          "slot": "label",
          "item": item
        },
        slot: "label"
      }), _vm._v(" "), (!_vm.form[item.key]) ? _c('div', {
        staticStyle: {
          "font-size": "12px",
          "margin-left": "4px"
        }
      }, [_vm._v(_vm._s(item.description))]) : _vm._e(), _vm._v(" "), (item.multi) ? _c('div', [(_vm.config.editable && !item.readonly && !(item.constant && _vm.config.current)) ? _c('div', [_c('Select', {
        attrs: {
          "value": _vm.form[item.key].map(function (i) {
            return item.render(i)
          }),
          "filterable": item.filterable || false,
          "clearable": item.clearable || false,
          "multiple": "",
          "placeholder": item.placeholder || '请选择',
          "disabled": item.disabledif ? item.disabledif(_vm.form) : false
        },
        on: {
          "on-change": function($event) {
            return _vm.selectorChanged(item, $event)
          }
        }
      }, _vm._l((item.loader ? item.loader(_vm.form) : item.selections), function(selection, selectionindex) {
        return _c('Option', {
          key: selectionindex,
          attrs: {
            "value": item.render(selection)
          }
        }, [_vm._v(_vm._s(item.render(selection)))])
      }), 1)], 1) : _c('div', [_vm._v(_vm._s(item.render(_vm.form[item.key])))])]) : _c('div', [(_vm.config.editable && !item.readonly && !(item.constant && _vm.config.current)) ? _c('div', [_c('Select', {
        attrs: {
          "value": item.render(_vm.form[item.key]),
          "filterable": item.filterable || false,
          "clearable": item.clearable || false,
          "placeholder": item.placeholder || '请选择',
          "disabled": item.disabledif ? item.disabledif(_vm.form) : false
        },
        on: {
          "on-change": function($event) {
            return _vm.selectorChanged(item, $event)
          }
        }
      }, _vm._l((item.loader ? item.loader(_vm.form) : item.selections), function(selection, selectionindex) {
        return _c('Option', {
          key: selectionindex,
          staticClass: "nowrap",
          style: (("" + (item.width?('width:'+item.width+'px'):''))),
          attrs: {
            "value": item.render(selection)
          }
        }, [_vm._v(_vm._s(item.render(selection)))])
      }), 1)], 1) : _c('div', [_vm._v(_vm._s(item.render(_vm.form[item.key])))])])], 1) : (item.type == 'location') ? _c('FormItem', {
        attrs: {
          "prop": item.key,
          "label": item.name
        }
      }, [_c('FormItemLabel', {
        attrs: {
          "slot": "label",
          "item": item
        },
        slot: "label"
      }), _vm._v(" "), (!_vm.form[item.key]) ? _c('div', {
        staticStyle: {
          "font-size": "12px",
          "margin-left": "4px"
        }
      }, [_vm._v(_vm._s(item.description))]) : _vm._e(), _vm._v(" "), (_vm.form[item.key]) ? _c('div', {
        staticClass: "center hover",
        staticStyle: {
          "color": "#20bf64",
          "font-weight": "bold",
          "height": "80px",
          "border-radius": "6px",
          "text-align": "center",
          "background": "url('http://cdn.igyl.com/vendor-statics/mapbg.png')"
        },
        on: {
          "click": function($event) {
            return _vm.locationSelector.show(item.key)
          }
        }
      }, [_c('div', [_vm._v(_vm._s(_vm.form[item.key].name))])]) : _c('div', {
        staticClass: "center hover",
        staticStyle: {
          "color": "#20bf64",
          "font-weight": "bold",
          "height": "80px",
          "border-radius": "6px",
          "text-align": "center",
          "background": "url('http://cdn.igyl.com/vendor-statics/mapbg.png')"
        },
        on: {
          "click": function($event) {
            return _vm.locationSelector.show(item.key)
          }
        }
      }, [_c('div', [_vm._v("在地图中选择")])])], 1) : (item.type == 'jigou' || item.type == 'gonghuojigou') ? _c('FormItem', {
        attrs: {
          "prop": item.key,
          "label": item.name
        }
      }, [_c('FormItemLabel', {
        attrs: {
          "slot": "label",
          "item": item
        },
        slot: "label"
      }), _vm._v(" "), (!_vm.form[item.key]) ? _c('div', {
        staticStyle: {
          "font-size": "12px",
          "margin-left": "4px"
        }
      }, [_vm._v(_vm._s(item.description))]) : _vm._e(), _vm._v(" "), (_vm.config.editable && !item.readonly && !(item.constant && _vm.config.current)) ? _c('BaseSelect', {
        attrs: {
          "value": _vm.form[item.key],
          "autoload": "",
          "multiple": item.multi,
          "type": item.type,
          "width": "100%",
          "parameter": item.query,
          "placeholder": item.placeholder,
          "disabled": item.disabledif ? item.disabledif(_vm.form) : false
        },
        on: {
          "change": function($event) {
            return _vm.jigouChanged(item, $event)
          }
        }
      }) : _c('BaseSelect', {
        attrs: {
          "readonly": "",
          "value": _vm.form[item.key],
          "multiple": item.multi,
          "type": item.type
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type == 'slot') ? _c('FormItem', {
        attrs: {
          "prop": item.key,
          "label": item.name
        }
      }, [_c('FormItemLabel', {
        attrs: {
          "slot": "label",
          "item": item
        },
        slot: "label"
      }), _vm._v(" "), (item.slot) ? _c('div', [(item.slot) ? _vm._t(item.slot) : _vm._e()], 2) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (item.type == 'a') ? _c('FormItem', {
        attrs: {
          "prop": item.key,
          "label": item.name
        }
      }, [_c('FormItemLabel', {
        attrs: {
          "slot": "label",
          "item": item
        },
        slot: "label"
      }), _vm._v(" "), _c('div', [_c('a', {
        on: {
          "click": function($event) {
            return item.onclick({
              form: _vm.form,
              item: item
            })
          }
        }
      }, [_vm._v(_vm._s(item.render ? item.render(item.key ? _vm.form[item.key] : _vm.form) : _vm.form[item.key]))])])], 1) : _vm._e(), _vm._v(" "), (item.tip) ? _c('div', [_c('div', {
        staticStyle: {
          "font-size": "12px",
          "color": "#aaa",
          "margin-top": "-20px",
          "margin-bottom": "20px"
        }
      }, [_vm._v(_vm._s(item.tip))])]) : _vm._e(), _vm._v(" "), (col.spacer) ? _c('div', [_c('div', {
        style: (("height: " + (col.spacer) + "px;"))
      })]) : _vm._e()], 1) : _vm._e()
    }), 0)], 2)
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "20px",
      "border-top": "1px solid #f1f1f1"
    }
  }, [(_vm.config.current && _vm.config.caozuojiluOn) ? _c('Caozuojilu', {
    attrs: {
      "items": _vm.caozuojilus
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "jcsb"
  }, [(_vm.config.mode != 'page') ? _c('div', [(_vm.config.current && _vm.config.editable && _vm.config.delete && _vm.deleteable) ? _c('div', {
    staticClass: "hover",
    staticStyle: {
      "color": "red"
    },
    on: {
      "click": _vm.toDelete
    }
  }, [_vm._v("删除")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('Button', {
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), (_vm.config.editable) ? _c('Button', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.toSave({})
      }
    }
  }, [_vm._v("保存")]) : _vm._e(), _vm._v(" "), (_vm.config.submitable) ? _c('Button', {
    staticStyle: {
      "width": "100px",
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.toSave({
          tijiao: true
        })
      }
    }
  }, [_vm._v("保存并提交")]) : _vm._e(), _vm._v(" "), _vm._t("menus")], 2)])], 1), _vm._v(" "), _c('Modal', {
    staticClass: "nopadding",
    attrs: {
      "footer-hide": "",
      "width": 500
    },
    model: {
      value: (_vm.locationSelector.display),
      callback: function($$v) {
        _vm.$set(_vm.locationSelector, "display", $$v)
      },
      expression: "locationSelector.display"
    }
  }, [(_vm.locationSelector.display) ? _c('LocationSelector', {
    attrs: {
      "current": _vm.locationSelector.current
    },
    on: {
      "cancel": function($event) {
        _vm.locationSelector.display = false;
      },
      "locationSelected": _vm.locationSelector.confirm
    }
  }) : _vm._e()], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XvyQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_optimize__ = __webpack_require__("F9TA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common__ = __webpack_require__("c2r0");





var OptimizeEntities = function () {
    function OptimizeEntities() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, OptimizeEntities);

        this.api = new __WEBPACK_IMPORTED_MODULE_2__api_optimize__["a" /* default */]();
    }
    /**获取机构（供货、要货、管辖机构等） */


    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(OptimizeEntities, [{
        key: 'getOrganiztion',
        value: function getOrganiztion(params) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common__["a" /* publicFun */])(this.api.getOrganiztion, params);
        }

        /**供货机构（供应商）下拉框 - 加载数据  */

    }, {
        key: 'getSublevel',
        value: function getSublevel(params) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common__["a" /* publicFun */])(this.api.getSublevel, params);
        }

        /**仓库下拉框 - 加载数据 */

    }, {
        key: 'getwarehouse',
        value: function getwarehouse(params) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common__["a" /* publicFun */])(this.api.getwarehouse, params);
        }
        /**类别下拉框或树节点分段加载 - 加载数据  */

    }, {
        key: 'getCategory',
        value: function getCategory(params) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common__["a" /* publicFun */])(this.api.getCategory, params);
        }
        /**类别下拉框或树节点分段加载 - 加载数据  */

    }, {
        key: 'getBumen',
        value: function getBumen(params) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common__["a" /* publicFun */])(this.api.getBumen, params);
        }
        /**类别下拉框或树节点分段加载 - 加载数据  */

    }, {
        key: 'getBiaoqian',
        value: function getBiaoqian(params) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common__["a" /* publicFun */])(this.api.getBiaoqian, params);
        }
        /**类别下拉框或树节点分段加载 - 加载数据  */

    }, {
        key: 'getYuanyin',
        value: function getYuanyin(params) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common__["a" /* publicFun */])(this.api.getYuanyin, params);
        }
        /**类别下拉框或树节点分段加载 - 加载数据  */

    }, {
        key: 'getWupin',
        value: function getWupin(params) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common__["a" /* publicFun */])(this.api.getWupin, params);
        }
        /**类别下拉框或树节点分段加载 - 加载数据  */

    }, {
        key: 'getCaipin',
        value: function getCaipin(params) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common__["a" /* publicFun */])(this.api.getCaipin, params);
        }
        /**类别下拉框或树节点分段加载 - 加载数据  */

    }, {
        key: 'getWaixiaokehu',
        value: function getWaixiaokehu(params) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common__["a" /* publicFun */])(this.api.getWaixiaokehu, params);
        }
    }, {
        key: 'getItems',
        value: function getItems(params, type) {
            params._type = type;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common__["a" /* publicFun */])(this.api.getItems, params);
        }
    }]);

    return OptimizeEntities;
}();

/* harmony default export */ __webpack_exports__["a"] = (OptimizeEntities);

/***/ }),

/***/ "Xx8X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {},
  data: function data() {
    return {
      levelList: [],
      contentTitle: '',
      showLeve: false
    };
  },

  watch: {
    $route: function $route() {
      this.getBreadcrumb();
    }
  },
  created: function created() {
    this.getBreadcrumb();
  },

  methods: {
    getBreadcrumb: function getBreadcrumb() {
      var _this = this;

      /**由于路由用了重定向,重定向的路由没有name,所以这里改用meta中的title来过滤 */
      this.levelList = this.$route.matched.filter(function (item) {
        return item.meta.title;
      });
      var queryArr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$route.query);
      this.levelList.forEach(function (i, iIndex) {
        // 暂定5级
        switch (iIndex) {
          case 0:
            _this.levelList[iIndex].query = '';
            break;
          case 1:
            _this.levelList[iIndex].query = queryArr[iIndex - 1] + '=' + _this.$route.query[queryArr[iIndex - 1]];
            break;
          case 2:
            _this.levelList[iIndex].query = queryArr[iIndex - 2] + '=' + _this.$route.query[queryArr[iIndex - 2]] + '&' + queryArr[iIndex - 1] + '=' + _this.$route.query[queryArr[iIndex - 1]];
            break;
          case 3:
            _this.levelList[iIndex].query = queryArr[iIndex - 3] + '=' + _this.$route.query[queryArr[iIndex - 3]] + '&' + queryArr[iIndex - 2] + '=' + _this.$route.query[queryArr[iIndex - 2]] + '&' + queryArr[iIndex - 1] + '=' + _this.$route.query[queryArr[iIndex - 1]];
            break;
          default:
            _this.levelList[iIndex].query = queryArr[iIndex - 4] + '=' + _this.$route.query[queryArr[iIndex - 4]] + '&' + queryArr[iIndex - 3] + '=' + _this.$route.query[queryArr[iIndex - 3]] + '&' + queryArr[iIndex - 2] + '=' + _this.$route.query[queryArr[iIndex - 2]] + '&' + queryArr[iIndex - 1] + '=' + _this.$route.query[queryArr[iIndex - 1]];

        }
      });
      this.showLeve = this.levelList.length > 1;
      this.contentTitle = this.levelList[this.levelList.length - 1].meta.title;
    }
  }
});

/***/ }),

/***/ "Y3pB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        current: Array,
        jigou: Object,
        type: {
            type: String,
            default: 'caigou'
        },
        gonghuojigou: {
            type: Object,
            default: function _default() {}
        }
    },
    data: function data() {
        var _this = this;

        return {
            loading: false,
            query: {
                // keywords: this.gonghuojigou? this.gonghuojigou.name:'',
                keywords: '',
                init: true,
                gonghuojigouId: this.gonghuojigou ? this.gonghuojigou._id : null
            },
            usedKeywords: '',
            page: {
                current: 1,
                size: 5
            },
            total: 0,
            caigoumobans: [],
            columns1: [{
                title: '模板编号',
                key: 'code',
                minWidth: 180
            }, {
                title: '模板名称',
                minWidth: 100,
                render: function render(h, params) {
                    return h('div', params.row.name);
                }
            }, {
                title: '操作',
                width: 180,
                align: 'center',
                fixed: 'right',
                render: function render(h, params) {
                    var that = _this;
                    var item = params.row;
                    var ops = [];
                    var op1 = h('div', {
                        class: 'hover',
                        style: {
                            color: '#20bf64'
                        },
                        on: {
                            'click': function click(e) {
                                that.selection = item;
                                that.$emit('caigoumobanSelected', that.selection);
                                e.stopPropagation();
                            }
                        }
                    }, '确定');
                    ops.push(op1);
                    return h('div', { class: 'center' }, ops);
                }
            }],
            yaohuojigous: []
        };
    },
    mounted: function mounted() {
        this.loadData();
        if (this.type === 'peisong') {
            var item = {
                title: '供货机构',
                minWidth: 100,
                render: function render(h, params) {
                    return h('div', params.row.gonghuojigouStr);
                }
            };
            this.columns1.splice(2, 0, item);
        }
    },

    methods: {
        clearKeywords: function clearKeywords() {
            this.query.keywords = '';
            this.usedKeywords = '';
            this.loadData();
        },
        keywordsChanged: function keywordsChanged() {
            this.usedKeywords = this.query.keywords;
            this.page.current = 1;
            this.loadData();
        },
        pageChanged: function pageChanged(value) {
            this.page.current = value;
            this.loadData();
        },
        loadData: function loadData() {
            var _this2 = this;

            var that = this;
            that.loading = true;
            var url = void 0;
            if (this.type === 'peisong') {
                url = this.apiPort.templateSelectList;
            } else {
                url = '/web/main/caigoumobanselector/load';
            }
            that.$api.post(url, {
                jigouId: this.jigou ? this.jigou._id : null,
                query: this.query,
                page: this.page,
                fields: {
                    _id: 1,
                    code: 1,
                    name: 1,
                    'wupins._id': 1,
                    'wupins.name': 1,
                    'wupins.code': 1,
                    "gonghuojigouStr": 1,
                    "tiqiantianshu": 1,
                    "gonghuojigou": 1
                }
            }).then(function (res) {
                that.loading = false;
                if (that.query.init) {
                    that.query.init = false;
                    // that.shouhuojigous = res.data.shouhuojigous
                }
                that.total = res.data.total;
                that.usedKeywords = that.query.keywords;
                var caigoumobans = void 0;
                if (_this2.type === 'peisong') {
                    caigoumobans = res.data.peisongmobans;
                } else {
                    caigoumobans = res.data.caigoumobans;
                }
                // for (let caigoumoban of caigoumobans) {}
                that.caigoumobans = caigoumobans;
            }, function () {
                that.loading = false;
            });
        },
        search: function search() {
            this.loadData();
        },
        cancel: function cancel() {
            this.$emit('cancel');
        }
    }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routers_js__ = __webpack_require__("LkXW");



__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_router___default.a);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router___default.a({
    routes: __WEBPACK_IMPORTED_MODULE_2__routers_js__["a" /* default */]
}));

/***/ }),

/***/ "YcOt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TablePage_vue__ = __webpack_require__("1G29");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14d4c1c3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_TablePage_vue__ = __webpack_require__("0Drh");
function injectStyle (ssrContext) {
  __webpack_require__("gomf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-14d4c1c3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TablePage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14d4c1c3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_TablePage_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Z7KV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "20px 0"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "border-top": "1px solid #f1f1f1",
      "margin-top": "20px",
      "padding-bottom": "40px"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "icon": "ios-search",
      "placeholder": "输入名称或编号查询..."
    },
    on: {
      "on-enter": _vm.keywordsChanged
    },
    model: {
      value: (_vm.query.keywords),
      callback: function($$v) {
        _vm.$set(_vm.query, "keywords", $$v)
      },
      expression: "query.keywords"
    }
  }), _vm._v(" "), (_vm.usedKeywords) ? _c('Tag', {
    staticStyle: {
      "height": "32px",
      "line-height": "32px",
      "margin": "0"
    },
    attrs: {
      "closable": ""
    },
    on: {
      "on-close": _vm.clearKeywords
    }
  }, [_vm._v("\n                搜索：" + _vm._s(_vm.usedKeywords))]) : _vm._e()], 1), _vm._v(" "), (_vm.shengchanmobans.length) ? _c('div', [_c('Table', {
    attrs: {
      "columns": _vm.columns1,
      "loading": _vm.loading,
      "data": _vm.shengchanmobans
    },
    on: {
      "on-select": _vm.itemSelected,
      "on-select-cancel": _vm.itemSelectedCancel,
      "on-select-all": _vm.allSelected,
      "on-select-all-cancel": _vm.allSelectedCancel
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('Page', {
    staticStyle: {
      "padding": "16px"
    },
    attrs: {
      "size": "small",
      "placement": "top",
      "total": _vm.total,
      "current": _vm.page.current,
      "page-size": _vm.page.size,
      "show-total": ""
    },
    on: {
      "on-change": _vm.pageChanged
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.shengchanmobans.length) ? _c('div', {
    staticClass: "center",
    staticStyle: {
      "color": "#aaa",
      "min-height": "200px"
    }
  }, [_vm._v("暂无数据")]) : _vm._e()])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "font-size": "20px",
      "padding": "0 20px"
    }
  }, [_c('div', [_vm._v("选择要使用的模板")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZVj6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "20px 0"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "padding": "0 20px"
    }
  }, [(_vm.zengpin) ? _c('div', [_vm._v("选择赠品")]) : _vm._e(), _vm._v(" "), (!_vm.zengpin) ? _c('div', [_vm._v("选择物品")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border-top": "1px solid #f1f1f1",
      "border-bottom": "1px solid #f1f1f1",
      "margin-top": "20px",
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "0 20px",
      "min-height": "200px",
      "min-width": "150px",
      "border-right": "1px solid #f1f1f1"
    }
  }, [(!_vm.loadDataTree.length) ? _c('div', [_c('div', {
    staticStyle: {
      "padding": "14px 16px",
      "font-weight": "bold",
      "border-bottom": "1px solid #eaeaea"
    }
  }, [_vm._v("按类别筛选")]), _vm._v(" "), _vm._m(0)]) : _c('div', [_c('div', {
    staticStyle: {
      "padding": "14px 16px",
      "font-weight": "bold",
      "border-bottom": "1px solid #eaeaea"
    }
  }, [_vm._v("按类别筛选")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "5px 16px",
      "max-height": "70vh",
      "overflow": "scroll"
    }
  }, [_c('Tree', {
    attrs: {
      "data": _vm.treeData,
      "load-data": _vm.loadDataTree,
      "show-checkbox": "",
      "expand-node": ""
    },
    on: {
      "on-check-change": _vm.treeSelected
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "overflow": "scroll"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "icon": "ios-search",
      "placeholder": "输入名称/编码查询..."
    },
    on: {
      "on-enter": _vm.keywordsChanged
    },
    model: {
      value: (_vm.query.keywords),
      callback: function($$v) {
        _vm.$set(_vm.query, "keywords", $$v)
      },
      expression: "query.keywords"
    }
  }), _vm._v(" "), (_vm.usedKeywords) ? _c('Tag', {
    staticStyle: {
      "height": "32px",
      "line-height": "32px",
      "margin": "0"
    },
    attrs: {
      "closable": ""
    },
    on: {
      "on-close": _vm.clearKeywords
    }
  }, [_vm._v("\n                    搜索：" + _vm._s(_vm.usedKeywords))]) : _vm._e(), _vm._v(" "), (_vm.query.relations && _vm.query.relations.length) ? _c('Tag', {
    staticStyle: {
      "height": "32px",
      "line-height": "32px",
      "margin": "0"
    },
    attrs: {
      "closable": ""
    },
    on: {
      "on-close": _vm.resetTree
    }
  }, [_vm._v("\n                    仅查看勾选的"), _c('span', {
    staticStyle: {
      "color": "#20bf64"
    }
  }, [_vm._v(_vm._s(_vm.query.relations.length))]), _vm._v("个类别")]) : _vm._e(), _vm._v(" "), (_vm.query.selections) ? _c('Tag', {
    staticStyle: {
      "height": "32px",
      "line-height": "32px",
      "margin": "0"
    },
    attrs: {
      "closable": ""
    },
    on: {
      "on-close": function($event) {
        _vm.query.selections = null;
        _vm.loadData()
      }
    }
  }, [_vm._v("\n                    仅查看包含在 "), _c('span', {
    staticStyle: {
      "color": "#20bf64"
    }
  }, [_vm._v(_vm._s(_vm.querySelectionLength))]), _vm._v(" 个已选项中的内容")]) : _vm._e()], 1), _vm._v(" "), (_vm.wupins.length) ? _c('div', [_c('Table', {
    attrs: {
      "columns": _vm.columns1,
      "loading": _vm.loading,
      "row-class-name": _vm.tableRowClass,
      "data": _vm.wupins
    },
    on: {
      "on-select": _vm.itemSelected,
      "on-select-cancel": _vm.itemSelectedCancel,
      "on-select-all": _vm.allSelected,
      "on-select-all-cancel": _vm.allSelectedCancel
    },
    scopedSlots: _vm._u([{
      key: "radio",
      fn: function(ref) {
        var row = ref.row;

        return [_c('Radio', {
          staticClass: " mr-20",
          attrs: {
            "disabled": row._disabled
          },
          on: {
            "on-change": function($event) {
              return _vm.handleSelSingle($event, row)
            }
          },
          model: {
            value: (row._checked),
            callback: function($$v) {
              _vm.$set(row, "_checked", $$v)
            },
            expression: "row._checked"
          }
        })]
      }
    }], null, false, 2281763208)
  }), _vm._v(" "), _c('div', [_c('Page', {
    staticStyle: {
      "padding": "16px"
    },
    attrs: {
      "size": "small",
      "placement": "top",
      "total": _vm.total,
      "current": _vm.page.current,
      "show-sizer": "",
      "page-size-opts": [10, 20, 40, 100],
      "page-size": _vm.page.size,
      "show-total": ""
    },
    on: {
      "on-page-size-change": _vm.pageSizeChanged,
      "on-change": _vm.pageChanged
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.wupins.length) ? _c('div', {
    staticClass: "center",
    staticStyle: {
      "color": "#aaa",
      "min-height": "200px"
    }
  }, [_vm._v("暂无数据")]) : _vm._e(), _vm._v(" "), (_vm.selectionLength || _vm.wupins.length) ? _c('div', {
    staticStyle: {
      "padding": "16px 20px",
      "display": "flex",
      "align-items": "center"
    }
  }, [_vm._v("\n                已选"), _c('span', {
    staticStyle: {
      "color": "#20bf64",
      "margin": "0 4px"
    }
  }, [_vm._v(_vm._s(_vm.selectionLength))]), _vm._v("项\n                "), (_vm.selectionLength) ? _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "hover",
    staticStyle: {
      "color": "#20bf64",
      "margin-left": "10px"
    },
    on: {
      "click": _vm.showSelections
    }
  }, [_vm._v("查看")]), _vm._v(" "), _c('div', {
    staticClass: "hover",
    staticStyle: {
      "color": "#20bf64",
      "margin-left": "10px"
    },
    on: {
      "click": _vm.clearSelections
    }
  }, [_vm._v("取消选择")])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "foot jcsb",
    staticStyle: {
      "padding": "16px 24px 0 24px"
    }
  }, [_c('div'), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('Button', {
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.wupinSelected
    }
  }, [_vm._v("确定")])], 1)])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center",
    staticStyle: {
      "color": "#aaa",
      "min-height": "200px"
    }
  }, [_c('div', [_vm._v("暂无数据")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Zdle":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zdz5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "a/zU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomTableColumns_vue__ = __webpack_require__("bM0v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09e77a6a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_CustomTableColumns_vue__ = __webpack_require__("M1Tw");
function injectStyle (ssrContext) {
  __webpack_require__("Zdle")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-09e77a6a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomTableColumns_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09e77a6a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_CustomTableColumns_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "a9CP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.options.editable !== false) ? _c('div', [_vm._l((_vm.current), function(item, index) {
    return _c('div', {
      key: index
    }, [(_vm.editIndex == index) ? _c('div', {
      staticClass: "list_editing"
    }, [_c('Input', {
      ref: ("input_" + index),
      refInFor: true,
      staticStyle: {
        "width": "260px"
      },
      attrs: {
        "suffix": "ios-return-left",
        "placeholder": _vm.options.placeholder || ''
      },
      on: {
        "on-enter": function($event) {
          return _vm.saveItem(item, index)
        },
        "on-blur": function($event) {
          return _vm.saveItem(item, index)
        }
      },
      model: {
        value: (_vm.current[index]),
        callback: function($$v) {
          _vm.$set(_vm.current, index, $$v)
        },
        expression: "current[index]"
      }
    })], 1) : _c('div', {
      staticClass: "list jcsb"
    }, [_c('div', {
      staticClass: "nowrap",
      staticStyle: {
        "width": "200px"
      },
      on: {
        "click": function($event) {
          return _vm.toEdit(index)
        }
      }
    }, [_vm._v(_vm._s(item))]), _vm._v(" "), _c('div', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.removeItem(index)
        }
      }
    }, [_c('Icon', {
      staticStyle: {
        "color": "#20bf64"
      },
      attrs: {
        "type": "ios-remove-circle"
      }
    })], 1)])])
  }), _vm._v(" "), (!_vm.options.max || _vm.current.length < _vm.options.max) ? _c('Input', {
    ref: "input",
    staticStyle: {
      "width": "260px"
    },
    attrs: {
      "suffix": "ios-add",
      "placeholder": _vm.options.placeholder || ''
    },
    on: {
      "on-enter": _vm.addItem
    },
    model: {
      value: (_vm.form.value),
      callback: function($$v) {
        _vm.$set(_vm.form, "value", $$v)
      },
      expression: "form.value"
    }
  }) : _vm._e()], 2) : _c('div', _vm._l((_vm.current), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "list"
    }, [_vm._v("\n            " + _vm._s(item) + "\n        ")])
  }), 0)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "apBt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('FormItem', {
    staticStyle: {
      "margin-top": "40px"
    },
    attrs: {
      "prop": "shouhuoxinxi",
      "label": "收货信息"
    }
  }, [(!_vm.editable && _vm.data && ((!_vm.data.shouhuodiqu || !_vm.data.shouhuodiqu[0]) && !_vm.data.shouhuodizhi && !_vm.data.shouhuorenxingming && !_vm.data.shouhuodianhua)) ? _c('div', {
    staticStyle: {
      "color": "#aaa",
      "margin-bottom": "20px"
    }
  }, [_vm._v("\n            未填写\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [(_vm.editable || _vm.data.shouhuodizhi) ? _c('FormItem', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "prop": "shouhuodiqu",
      "label": "地区"
    }
  }, [(_vm.editable) ? _c('div', {
    staticStyle: {
      "margin-top": "2px",
      "min-width": "200px"
    }
  }, [_c('Cascader', {
    attrs: {
      "data": _vm.diqudata,
      "filterable": ""
    },
    on: {
      "on-change": _vm.diquChanged
    },
    model: {
      value: (_vm.form.shouhuodiqu),
      callback: function($$v) {
        _vm.$set(_vm.form, "shouhuodiqu", $$v)
      },
      expression: "form.shouhuodiqu"
    }
  })], 1) : _c('div', [_vm._v(_vm._s(_vm.data.shouhuodiqu ? _vm.data.shouhuodiqu.join('/') : ''))])]) : _vm._e(), _vm._v(" "), (_vm.editable || _vm.data.shouhuodizhi) ? _c('FormItem', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "prop": "shouhuodizhi",
      "label": "详细地址"
    }
  }, [(_vm.editable) ? _c('Input', {
    style: (("width: " + (_vm.data && _vm.data.menpaihao?220:280) + "px;")),
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.form.shouhuodizhi),
      callback: function($$v) {
        _vm.$set(_vm.form, "shouhuodizhi", $$v)
      },
      expression: "form.shouhuodizhi"
    }
  }) : _c('div', [_vm._v(_vm._s(_vm.data.shouhuodizhi))])], 1) : _vm._e(), _vm._v(" "), (_vm.data && _vm.data.menpaihao) ? _c('FormItem', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "prop": "menpaihao",
      "label": "门牌号"
    }
  }, [(_vm.editable) ? _c('Input', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.form.menpaihao),
      callback: function($$v) {
        _vm.$set(_vm.form, "menpaihao", $$v)
      },
      expression: "form.menpaihao"
    }
  }) : _c('div', [_vm._v(_vm._s(_vm.data.menpaihao || ''))])], 1) : _vm._e(), _vm._v(" "), (_vm.editable || _vm.data.shouhuorenxingming) ? _c('FormItem', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "prop": "shouhuorenxingming",
      "label": "收货人姓名"
    }
  }, [(_vm.editable) ? _c('Input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.form.shouhuorenxingming),
      callback: function($$v) {
        _vm.$set(_vm.form, "shouhuorenxingming", $$v)
      },
      expression: "form.shouhuorenxingming"
    }
  }) : _c('div', [_vm._v(_vm._s(_vm.data.shouhuorenxingming))])], 1) : _vm._e(), _vm._v(" "), (_vm.editable || _vm.data.shouhuodianhua) ? _c('FormItem', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "prop": "shouhuodianhua",
      "label": "收货电话"
    }
  }, [(_vm.editable) ? _c('Input', {
    style: (("width: " + (_vm.data && _vm.data.menpaihao?110:140) + "px;")),
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.form.shouhuodianhua),
      callback: function($$v) {
        _vm.$set(_vm.form, "shouhuodianhua", $$v)
      },
      expression: "form.shouhuodianhua"
    }
  }) : _c('div', [_vm._v(_vm._s(_vm.data.shouhuodianhua))])], 1) : _vm._e(), _vm._v(" "), (_vm.options && _vm.options.beizhuOn) ? _c('FormItem', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "prop": "beizhu",
      "label": "备注"
    }
  }, [(_vm.editable) ? _c('Input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.form.beizhu),
      callback: function($$v) {
        _vm.$set(_vm.form, "beizhu", $$v)
      },
      expression: "form.beizhu"
    }
  }) : _c('div', [_vm._v(_vm._s(_vm.data.beizhu))]), _vm._v(" "), (!_vm.editable && !_vm.data.beizhu) ? _c('div', {
    staticStyle: {
      "color": "#aaa"
    }
  }, [_vm._v("无")]) : _vm._e()], 1) : _vm._e()], 1)]), _vm._v(" "), (_vm.editable) ? _c('Poptip', {
    attrs: {
      "trigger": "hover",
      "placement": "right-start",
      "transfer": ""
    }
  }, [_c('div', {
    staticClass: "hover",
    staticStyle: {
      "color": "#20bf64",
      "font-weight": "bold"
    }
  }, [_vm._v("智能识别地址")]), _vm._v(" "), (_vm.addressParseModal) ? _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticStyle: {
      "height": "10px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "df"
  }, [_c('Input', {
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "placeholder": "请输入待识别文字"
    },
    on: {
      "input": function($event) {
        return _vm.addressParseModal.calculate()
      },
      "on-enter": _vm.addressParseModal.confirm
    },
    model: {
      value: (_vm.addressParseModal.content),
      callback: function($$v) {
        _vm.$set(_vm.addressParseModal, "content", $$v)
      },
      expression: "addressParseModal.content"
    }
  }), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "12px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addressParseModal.confirm
    }
  }, [_vm._v("应用")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "110px"
    }
  }, [(_vm.addressParseModal.result && _vm.addressParseModal.result.shouhuodizhi) ? _c('div', {
    staticStyle: {
      "color": "#aaa"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "10px"
    }
  }), _vm._v(" "), (_vm.addressParseModal.result.shouhuodiqu && _vm.addressParseModal.result.shouhuodiqu[0]) ? _c('div', [_c('Icon', {
    attrs: {
      "type": "md-checkmark",
      "color": "#20bf64"
    }
  }), _vm._v(" " + _vm._s(_vm.addressParseModal.result.shouhuodiqu.join('/')) + "\n                    ")], 1) : _vm._e(), _vm._v(" "), (_vm.addressParseModal.result.shouhuodizhi) ? _c('div', [_c('Icon', {
    attrs: {
      "type": "md-checkmark",
      "color": "#20bf64"
    }
  }), _vm._v(" " + _vm._s(_vm.addressParseModal.result.shouhuodizhi) + "\n                    ")], 1) : _vm._e(), _vm._v(" "), (_vm.addressParseModal.result.shouhuorenxingming) ? _c('div', [_c('Icon', {
    attrs: {
      "type": "md-checkmark",
      "color": "#20bf64"
    }
  }), _vm._v(" " + _vm._s(_vm.addressParseModal.result.shouhuorenxingming) + "\n                    ")], 1) : _vm._e(), _vm._v(" "), (_vm.addressParseModal.result.shouhuodianhua) ? _c('div', [_c('Icon', {
    attrs: {
      "type": "md-checkmark",
      "color": "#20bf64"
    }
  }), _vm._v(" " + _vm._s(_vm.addressParseModal.result.shouhuodianhua) + "\n                    ")], 1) : _vm._e()]) : _c('div', {
    staticClass: "center",
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "color": "#aaa"
    }
  }, [_vm._v("\n                    暂无识别结果\n                ")])])]) : _vm._e()]) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bGai":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_PageTooltip_vue__ = __webpack_require__("lV2/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_WupinSelector_vue__ = __webpack_require__("xl10");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_CaigoumobanSelector_vue__ = __webpack_require__("sB98");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_ShengchanmobanSelector_vue__ = __webpack_require__("8rhJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_KucunmobanSelector_vue__ = __webpack_require__("sexz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_CustomTableColumns_vue__ = __webpack_require__("a/zU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_CustomTable_vue__ = __webpack_require__("q6sT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_Caozuojilu_vue__ = __webpack_require__("gS2X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_AddressInput_vue__ = __webpack_require__("ANfu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_XiafaMendianView_vue__ = __webpack_require__("4Cfx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_MendianSelector_vue__ = __webpack_require__("SKIw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_ShiyongjigouTable_vue__ = __webpack_require__("cEeY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_Printer_vue__ = __webpack_require__("Vip+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_CustomInput_vue__ = __webpack_require__("xfZz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_Layout_breadcrumb_index_vue__ = __webpack_require__("bTT1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_Layout_baseLayout_vue__ = __webpack_require__("gYAa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_Layout_blockLayout_vue__ = __webpack_require__("r5br");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__common_BaseTooltip_index_vue__ = __webpack_require__("cXyZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__common_BaseForm_index_vue__ = __webpack_require__("TOFE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__common_BaseModal_index_vue__ = __webpack_require__("TrXq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__common_MoneyTotal_index_vue__ = __webpack_require__("5jv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__common_ImgUpload_index_vue__ = __webpack_require__("7yAi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__common_FormDetailLeft_index_vue__ = __webpack_require__("c8Ct");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__common_Searching_index_vue__ = __webpack_require__("dWtg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__common_BaseSelect_index_vue__ = __webpack_require__("xVKL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__common_TablePage_vue__ = __webpack_require__("YcOt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__common_DefaultForm_vue__ = __webpack_require__("xEPM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__common_Uploader_vue__ = __webpack_require__("DEdE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__common_DataSelector_vue__ = __webpack_require__("ddF3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__common_CustomData_vue__ = __webpack_require__("rA0i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__common_FormItemEditor_vue__ = __webpack_require__("ruvo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__common_TextList_vue__ = __webpack_require__("48ci");
// // 按需加载iView组件
// import {
//     Button,
//     Table,
//     Page,
//     Modal,
//     Form,
//     Input,
//     Select,
//     Option,
//     DatePicker,
//     FormItem,
//     Message,
//     Menu,
//     MenuItem,
//     Submenu,
//     Icon,
//     Avatar,
//     Steps,
//     Step,
//     Card,
//     Tag,
//     InputNumber,
//     Tooltip,
//     Poptip,
//     Switch,
//     TimePicker,
//     Collapse,
//     Panel,
//     Dropdown,
//     DropdownMenu,
//     Spin,
//     Row,
//     Col,
//     Divider,
//     Tabs,
//     TabPane,
//     Radio,
//     Checkbox,
//     CheckboxGroup,
//     Upload,
//     Tree,
// } from 'view-design';
// Vue.component('Button', Button);
// Vue.component('Table', Table);
// Vue.component('DatePicker', DatePicker);
// Vue.component('Modal', Modal);
// Vue.component('Input', Input);
// Vue.component('Select', Select);
// Vue.component('Option', Option);
// Vue.component('Page', Page);
// Vue.component('Form', Form);
// Vue.component('FormItem', FormItem);
// Vue.component('Message', Message);
// Vue.component('Menu',Menu)
// Vue.component('MenuItem',MenuItem)
// Vue.component('Submenu',Submenu)
// Vue.component('Icon',Icon)
// Vue.component('Avatar',Avatar)
// Vue.component('Steps',Steps)
// Vue.component('Step',Step)
// Vue.component('Card',Card)
// Vue.component('Tag',Tag)
// Vue.component('InputNumber',InputNumber)
// Vue.component('Tooltip',Tooltip)
// Vue.component('Poptip',Poptip)
// Vue.component('Switch',Switch)
// Vue.component('TimePicker',TimePicker)
// Vue.component('Collapse',Collapse)
// Vue.component('Panel',Panel)
// Vue.component('Dropdown',Dropdown)
// Vue.component('DropdownMenu',DropdownMenu)
// Vue.component('Spin',Spin)
// Vue.component('Row',Row)
// Vue.component('Col',Col)
// Vue.component('Divider',Divider)
// Vue.component('Tabs',Tabs)
// Vue.component('TabPane',TabPane)
// Vue.component('Radio',Radio)
// Vue.component('Checkbox',Checkbox)
// Vue.component('CheckboxGroup',CheckboxGroup)
// Vue.component('Upload',Upload)
// Vue.component('Tree',Tree)


// 自定义公用组件，全局可用，页面无需二次引入


































__WEBPACK_IMPORTED_MODULE_25_vue___default.a.component('TablePage', __WEBPACK_IMPORTED_MODULE_26__common_TablePage_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_25_vue___default.a.component('DefaultForm', __WEBPACK_IMPORTED_MODULE_27__common_DefaultForm_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_25_vue___default.a.component('Uploader', __WEBPACK_IMPORTED_MODULE_28__common_Uploader_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_25_vue___default.a.component('DataSelector', __WEBPACK_IMPORTED_MODULE_29__common_DataSelector_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_25_vue___default.a.component('CustomData', __WEBPACK_IMPORTED_MODULE_30__common_CustomData_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_25_vue___default.a.component('FormItemEditor', __WEBPACK_IMPORTED_MODULE_31__common_FormItemEditor_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_25_vue___default.a.component('TextList', __WEBPACK_IMPORTED_MODULE_32__common_TextList_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_25_vue___default.a.component('PageTooltip', __WEBPACK_IMPORTED_MODULE_0__common_PageTooltip_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_25_vue___default.a.component('WupinSelector', __WEBPACK_IMPORTED_MODULE_1__common_WupinSelector_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_25_vue___default.a.component('CaigoumobanSelector', __WEBPACK_IMPORTED_MODULE_2__common_CaigoumobanSelector_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_25_vue___default.a.component('KucunmobanSelector', __WEBPACK_IMPORTED_MODULE_4__common_KucunmobanSelector_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_25_vue___default.a.component('ShengchanmobanSelector', __WEBPACK_IMPORTED_MODULE_3__common_ShengchanmobanSelector_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_25_vue___default.a.component('CustomTableColumns', __WEBPACK_IMPORTED_MODULE_5__common_CustomTableColumns_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_25_vue___default.a.component('CustomTable', __WEBPACK_IMPORTED_MODULE_6__common_CustomTable_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_25_vue___default.a.component('Caozuojilu', __WEBPACK_IMPORTED_MODULE_7__common_Caozuojilu_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_25_vue___default.a.component('AddressInput', __WEBPACK_IMPORTED_MODULE_8__common_AddressInput_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_25_vue___default.a.component('XiafaMendianView', __WEBPACK_IMPORTED_MODULE_9__common_XiafaMendianView_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_25_vue___default.a.component('MendianSelector', __WEBPACK_IMPORTED_MODULE_10__common_MendianSelector_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_25_vue___default.a.component('ShiyongjigouTable', __WEBPACK_IMPORTED_MODULE_11__common_ShiyongjigouTable_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_25_vue___default.a.component('Printer', __WEBPACK_IMPORTED_MODULE_12__common_Printer_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_25_vue___default.a.component('CustomInput', __WEBPACK_IMPORTED_MODULE_13__common_CustomInput_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_25_vue___default.a.component('Breadcrumb', __WEBPACK_IMPORTED_MODULE_14__common_Layout_breadcrumb_index_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_25_vue___default.a.component('BaseLayout', __WEBPACK_IMPORTED_MODULE_15__common_Layout_baseLayout_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_25_vue___default.a.component('BlockLayout', __WEBPACK_IMPORTED_MODULE_16__common_Layout_blockLayout_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_25_vue___default.a.component('BaseTooltip', __WEBPACK_IMPORTED_MODULE_17__common_BaseTooltip_index_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_25_vue___default.a.component('BaseForm', __WEBPACK_IMPORTED_MODULE_18__common_BaseForm_index_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_25_vue___default.a.component('BaseModal', __WEBPACK_IMPORTED_MODULE_19__common_BaseModal_index_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_25_vue___default.a.component('MoneyTotal', __WEBPACK_IMPORTED_MODULE_20__common_MoneyTotal_index_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_25_vue___default.a.component('FormDetailLeft', __WEBPACK_IMPORTED_MODULE_22__common_FormDetailLeft_index_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_25_vue___default.a.component('Searching', __WEBPACK_IMPORTED_MODULE_23__common_Searching_index_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_25_vue___default.a.component('BaseSelect', __WEBPACK_IMPORTED_MODULE_24__common_BaseSelect_index_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_25_vue___default.a.component('MoneyTotal', __WEBPACK_IMPORTED_MODULE_20__common_MoneyTotal_index_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_25_vue___default.a.component('ImgUpload', __WEBPACK_IMPORTED_MODULE_21__common_ImgUpload_index_vue__["a" /* default */]);

/***/ }),

/***/ "bM0v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        columns: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        rootstyle: {
            type: String
        }
    },
    data: function data() {
        return { width: 100 };
    },
    mounted: function mounted() {
        this.updateUI();
    },

    watch: {
        columns: function columns() {
            this.updateUI();
        }
    },
    methods: {
        updateUI: function updateUI() {
            this.width = this.columns.sum('width') + 40;
        }
    }
});

/***/ }),

/***/ "bTT1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("Xx8X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7189f6d1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("rJpw");
function injectStyle (ssrContext) {
  __webpack_require__("nqNX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7189f6d1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bash":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c2r0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = publicFun;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

/**entities公用方法 */
function publicFun(api, params) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        api(params).then(function (res) {
            resolve(res.data);
            return;
        }).catch(function (err) {
            reject(err);
        });
    });
}

/***/ }),

/***/ "c8Ct":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("TWOI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15a80109_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("GrSP");
function injectStyle (ssrContext) {
  __webpack_require__("rzXh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15a80109_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cEeY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShiyongjigouTable_vue__ = __webpack_require__("HSXY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b994cdee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ShiyongjigouTable_vue__ = __webpack_require__("5wAk");
function injectStyle (ssrContext) {
  __webpack_require__("0iaW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShiyongjigouTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b994cdee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ShiyongjigouTable_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cSsU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: _vm.customTableClass,
    style: (_vm.customTableStyle)
  }, [(_vm.loading) ? _c('div', {
    staticStyle: {
      "color": "#aaa",
      "font-size": "14px"
    }
  }, [_vm._v("\n            数据加载中\n        ")]) : _c('div', [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "flex-start"
    }
  }, [(_vm.checkable && _vm.option.editable) ? _c('div', {
    staticStyle: {
      "width": "60px"
    }
  }, [_c('checkbox', {
    attrs: {
      "value": _vm.allitemChecked
    },
    on: {
      "on-change": _vm.checkAllChanged
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.option.editable) ? _c('div', {
    staticStyle: {
      "width": "60px"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.columns), function(c, index) {
    return (!c.hide) ? _c('div', {
      key: index,
      staticClass: "flex",
      style: ('width: ' + c.width + 'px;color: #aaa;padding-right: 10px;')
    }, [_c('div', [_c('div', [_vm._v(_vm._s(c.title))]), _vm._v(" "), (c.label) ? _c('div', {
      staticStyle: {
        "line-height": "1",
        "font-size": "10px"
      }
    }, [_vm._v(_vm._s(c.label))]) : _vm._e()]), _vm._v(" "), (c.tip) ? _c('PageTooltip', {
      attrs: {
        "content": c.tip,
        "width": 300,
        "name": '',
        "placement": 'top-start'
      }
    }) : _vm._e()], 1) : _vm._e()
  })], 2), _vm._v(" "), (_vm.checkable && _vm.option.editable && _vm.newItems.filter(function (o) {
    return o._checked
  })[0]) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "flex-start"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "60px",
      "margin-top": "10px",
      "display": "flex",
      "align-items": "center"
    }
  }), _vm._v(" "), (_vm.option.editable && _vm.quickedit) ? _c('div', {
    staticStyle: {
      "width": "60px",
      "margin-top": "10px",
      "display": "flex",
      "align-items": "center"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "margin-top": "10px",
      "align-items": "center"
    }
  }, _vm._l((_vm.columns), function(c, i) {
    return _c('div', {
      key: i,
      style: ('width: ' + _vm.columns[i].width + 'px;padding-right:10px;')
    }, [(!c.batchset) ? _c('div', [_vm._v("--")]) : _c('div', [(c.type == 'xieyi') ? _c('div', [_c('Button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.columns[i].onclick(-1, _vm.batchitem)
        }
      }
    }, [_vm._v("批量选择协议")])], 1) : _vm._e(), _vm._v(" "), (c.type == 'button') ? _c('div', [_c('Button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.columns[i].onclick(-1, _vm.batchitem)
        }
      }
    }, [_vm._v("批量设置")])], 1) : _vm._e(), _vm._v(" "), (c.type == 'wupin') ? _c('div') : (c.type == 'selection') ? _c('div', [(c.editable) ? _c('div', [(c.version == 2 || c.batchset) ? _c('Select', {
      style: ('width: ' + (c.width - 10) + 'px;'),
      attrs: {
        "placeholder": "批量设置",
        "value": _vm.batchitem[c.keyStr || (c.key + 'Str')]
      },
      on: {
        "on-change": function($event) {
          return _vm.dataChanged(_vm.batchitem, c, $event, 'batch')
        }
      }
    }, _vm._l((c.selections(_vm.batchitem)), function(s, si) {
      return _c('Option', {
        key: si,
        attrs: {
          "value": c.selectionvalue ? c.selectionvalue(s) : s[c.selectionKey]
        }
      }, [_vm._v("\n                                            " + _vm._s(c.selectionrender ? c.selectionrender(_vm.batchitem, s) : s[c.selectionKey]) + "\n                                        ")])
    }), 1) : _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.batchitem[c.keyStr || (c.key + 'Str')]),
        expression: "batchitem[c.keyStr || (c.key+'Str')]"
      }],
      staticClass: "wupin-select",
      style: ('width: ' + (c.width - 20) + 'px;'),
      attrs: {
        "placeholder": "批量设置"
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.batchitem, c.keyStr || (c.key + 'Str'), $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          _vm.dataChanged(_vm.batchitem, c, _vm.batchitem[c.keyStr || (c.key + 'Str')], 'batch')
        }]
      }
    }, _vm._l((c.selections(_vm.batchitem)), function(s, si) {
      return _c('option', {
        key: si,
        staticClass: "wupin-option",
        domProps: {
          "value": c.selectionvalue ? c.selectionvalue(s) : s[c.selectionKey]
        }
      }, [_vm._v("\n                                            " + _vm._s(c.selectionrender ? c.selectionrender(_vm.batchitem, s) : s[c.selectionKey]))])
    }), 0)], 1) : _c('div', [_vm._v(_vm._s(_vm.batchitem[c.keyStr || (c.key + 'Str')]))])]) : (c.type == 'danjia') ? _c('div', [(c.permission && !_vm.session.permission[c.permission]) ? _c('div', [_vm._v("--")]) : _c('div', [(c.editable) ? _c('custom-input', {
      attrs: {
        "value": _vm.batchitem[c.key],
        "fix": c.fixAppend ? c.fixAppend(_vm.batchitem) : 6,
        "min": c.min,
        "max": c.max,
        "placeholder": "批量设置",
        "width": _vm.columns[i].width - 10,
        "unit": c.append ? c.append(_vm.batchitem) : ''
      },
      on: {
        "input": function($event) {
          return _vm.getInput($event, _vm.batchitem, c, 'batch')
        }
      }
    }) : (c.calculate) ? _c('div', [_vm._v(_vm._s(_vm._f("AmountDecimal")(c.calculate(_vm.batchitem), c.fixAppend ? c.fixAppend(_vm.batchitem) : 6)))]) : _c('div', [_vm._v(_vm._s(_vm._f("AmountDecimal")(_vm.batchitem[c.key], c.fixAppend ? c.fixAppend(_vm.batchitem) : 6)))])], 1)]) : (c.type == 'jine') ? _c('div', [(c.permission && !_vm.session.permission[c.permission]) ? _c('div', [_vm._v("--")]) : _c('div', [(c.editable) ? _c('custom-input', {
      attrs: {
        "value": _vm.batchitem[c.key],
        "fix": 2,
        "min": c.min,
        "max": c.max,
        "placeholder": "批量设置",
        "width": _vm.columns[i].width - 10,
        "unit": c.append ? c.append(_vm.batchitem) : ''
      },
      on: {
        "input": function($event) {
          return _vm.getInput($event, _vm.batchitem, c, 'batch')
        }
      }
    }) : (c.calculate) ? _c('div', [_vm._v(_vm._s(_vm._f("AmountDecimal")(c.calculate(_vm.batchitem), 2)))]) : _c('div', [_vm._v(_vm._s(_vm._f("AmountDecimal")(_vm.batchitem[c.key], 2)))])], 1)]) : (c.type == 'shuilv') ? _c('div', [(c.permission && !_vm.session.permission[c.permission]) ? _c('div', [_vm._v("--")]) : _c('div', [(c.editable) ? _c('custom-input', {
      attrs: {
        "value": _vm.batchitem[c.key],
        "fix": 4,
        "min": c.min,
        "max": c.max,
        "placeholder": "批量设置",
        "width": _vm.columns[i].width - 10,
        "unit": c.append ? c.append(_vm.batchitem) : ''
      },
      on: {
        "input": function($event) {
          return _vm.getInput($event, _vm.batchitem, c, 'batch')
        }
      }
    }) : (c.calculate) ? _c('div', [_vm._v(_vm._s(_vm._f("AmountDecimal")(c.calculate(_vm.batchitem), 4)))]) : _c('div', [_vm._v(_vm._s(_vm._f("AmountDecimal")(_vm.batchitem[c.key], 4)))])], 1)]) : (c.type == 'shuliang') ? _c('div', [(c.permission && !_vm.session.permission[c.permission]) ? _c('div', [_vm._v("--")]) : _c('div', [(c.editable) ? _c('custom-input', {
      attrs: {
        "value": _vm.batchitem[c.key],
        "fix": 6,
        "min": c.min,
        "max": c.max,
        "placeholder": "批量设置",
        "width": _vm.columns[i].width - 10,
        "unit": c.append ? c.append(_vm.batchitem) : ''
      },
      on: {
        "input": function($event) {
          return _vm.getInput($event, _vm.batchitem, c, 'batch')
        }
      }
    }) : (c.calculate) ? _c('div', [_vm._v(_vm._s(_vm._f("AmountDecimal")(c.calculate(_vm.batchitem), 6)))]) : _c('div', [_vm._v(_vm._s(_vm._f("AmountDecimal")(_vm.batchitem[c.key], 6)))])], 1)]) : (c.type === 'text' || c.type === 'beizhu') ? _c('div', [(c.editable) ? _c('div', [_c('Input', {
      attrs: {
        "placeholder": "批量设置"
      },
      model: {
        value: (_vm.batchitem[c.key]),
        callback: function($$v) {
          _vm.$set(_vm.batchitem, c.key, $$v)
        },
        expression: "batchitem[c.key]"
      }
    })], 1) : _c('div', [_vm._v(_vm._s(_vm.batchitem[c.key]))])]) : _c('div', [_c('div', [_vm._v(_vm._s((_vm.batchitem[c.key] && c.subKey) ? _vm.batchitem[c.key][c.subKey] : _vm.batchitem[c.key]))])])])])
  }), 0)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.newItems), function(item, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "display": "flex",
        "align-items": "center"
      }
    }, [(_vm.checkable && _vm.option.editable) ? _c('div', {
      staticStyle: {
        "width": "60px",
        "margin-top": "10px",
        "display": "flex",
        "align-items": "center"
      }
    }, [_c('checkbox', {
      on: {
        "on-change": _vm.checkChanged
      },
      model: {
        value: (item._checked),
        callback: function($$v) {
          _vm.$set(item, "_checked", $$v)
        },
        expression: "item._checked"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.option.editable && _vm.quickedit) ? _c('div', {
      staticStyle: {
        "width": "60px",
        "margin-top": "10px",
        "display": "flex",
        "align-items": "center"
      }
    }, [(item._readonly) ? _c('div', [_c('Icon', {
      attrs: {
        "type": "md-add",
        "size": "20",
        "color": "#ccc"
      }
    }), _vm._v(" "), _c('Icon', {
      attrs: {
        "type": "md-remove",
        "size": "20",
        "color": "#ccc"
      }
    })], 1) : _c('div', [_c('Icon', {
      staticClass: "hover",
      attrs: {
        "type": "md-add",
        "size": "20",
        "color": "#20bf64"
      },
      on: {
        "click": function($event) {
          return _vm.addItem(item, index)
        }
      }
    }), _vm._v(" "), _c('Icon', {
      staticClass: "hover",
      attrs: {
        "type": "md-remove",
        "size": "20",
        "color": "#20bf64"
      },
      on: {
        "click": function($event) {
          return _vm.removeItem(item, index)
        }
      }
    })], 1)]) : _vm._e(), _vm._v(" "), (item.disabled) ? _c('div', [_c('div', {
      staticStyle: {
        "font-weight": "bold",
        "word-wrap": "break-word"
      },
      attrs: {
        "title": item.name
      }
    }, [_vm._v(_vm._s(item.name) + " ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "font-size": "11px",
        "color": "#aaa",
        "line-height": "1"
      }
    }, [_vm._v(_vm._s(item.code) + " ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex",
        "line-height": "1",
        "font-size": "11px",
        "color": "#aaa"
      }
    }, [(item.guigexinghao) ? _c('div', [_vm._v(_vm._s(item.guigexinghao))]) : _vm._e(), _vm._v(" "), (item.wupinpinpai) ? _c('div', [_vm._v(_vm._s(item.wupinpinpai))]) : _vm._e()]), _vm._v(" "), (item.actived === false) ? _c('div', {
      staticStyle: {
        "font-size": "11px",
        "color": "red",
        "line-height": "1",
        "margin-top": "8px"
      }
    }, [_vm._v("已停用")]) : _vm._e(), _vm._v(" "), (item.weixiafa) ? _c('div', {
      staticStyle: {
        "font-size": "11px",
        "color": "red",
        "line-height": "1",
        "margin-top": "8px"
      }
    }, [_vm._v("未下发")]) : _vm._e(), _vm._v(" "), (item.error) ? _c('div', {
      staticStyle: {
        "font-size": "11px",
        "color": "red",
        "line-height": "1",
        "margin-top": "8px"
      }
    }, [_vm._v(_vm._s(item.error))]) : _vm._e(), _vm._v(" "), _vm._t("disableText")], 2) : _c('div', {
      staticStyle: {
        "display": "flex",
        "margin-top": "10px",
        "align-items": "center"
      }
    }, _vm._l((_vm.columns), function(c, i) {
      return _c('div', {
        key: i,
        style: ('width: ' + _vm.columns[i].width + 'px;padding-right:10px;')
      }, [(c.vif && !c.vif(item)) ? _c('div', [_vm._v("--")]) : _c('div', [(c.type == 'xieyi') ? _c('div', {
        style: (item.error ? 'color:red' : ''),
        attrs: {
          "title": item.name
        }
      }, [(item.xieyi) ? _c('div', [_vm._v("\n                                    " + _vm._s(item.xieyi.name) + "\n                                    "), _c('div', {
        style: (((item.error?'color:red;':'color: #aaa;') + "font-size: 11px;line-height: 1;"))
      }, [_vm._v(_vm._s(item.xieyi.code) + " ")])]) : _c('div', [_c('Button', {
        attrs: {
          "type": "primary"
        },
        on: {
          "click": function($event) {
            return _vm.columns[i].onclick(index, item)
          }
        }
      }, [_vm._v("选择协议")])], 1)]) : _vm._e(), _vm._v(" "), (c.type == 'button') ? _c('div', {
        style: (item.error ? 'color:red' : '')
      }, [(c.editable) ? _c('div', [(item[c.key] && c.html) ? _c('div', [_c('div', {
        on: {
          "click": function($event) {
            return _vm.columns[i].onclick(index, item)
          }
        }
      }, [_c('div', {
        domProps: {
          "innerHTML": _vm._s(c.html(item, index))
        }
      })])]) : _c('div', [_c('Button', {
        attrs: {
          "type": "primary"
        },
        on: {
          "click": function($event) {
            return _vm.columns[i].onclick(index, item)
          }
        }
      }, [_vm._v(_vm._s(c.name))])], 1)]) : _c('div', [(item[c.key] && c.html) ? _c('div', [_c('div', {
        domProps: {
          "innerHTML": _vm._s(c.html(item, index))
        }
      })]) : _c('div', [_vm._v("-")])])]) : (c.type == 'wupin') ? _c('div', {
        style: (item.error ? 'color:red' : ''),
        attrs: {
          "title": item.name
        }
      }, [_c('div', {
        staticStyle: {
          "font-weight": "bold",
          "word-wrap": "break-word"
        },
        attrs: {
          "title": item.name
        }
      }, [_vm._v(_vm._s(item.name) + " ")]), _vm._v(" "), _c('div', {
        style: (((item.error?'color:red;':'color: #aaa;') + "font-size: 11px;line-height: 1;"))
      }, [_vm._v(_vm._s(item.code) + " ")]), _vm._v(" "), _c('div', {
        style: (((item.error?'color:red;':'color: #aaa;') + "display: flex;line-height: 1;font-size: 11px;"))
      }, [(item.guigexinghao) ? _c('div', [_vm._v(_vm._s(item.guigexinghao))]) : _vm._e(), _vm._v(" "), (item.wupinpinpai) ? _c('div', [_vm._v(_vm._s(item.wupinpinpai))]) : _vm._e()]), _vm._v(" "), (item.actived === false) ? _c('div', {
        staticStyle: {
          "font-size": "11px",
          "color": "red",
          "line-height": "1",
          "margin-top": "8px"
        }
      }, [_vm._v("已停用")]) : _vm._e(), _vm._v(" "), (item.weixiafa) ? _c('div', {
        staticStyle: {
          "font-size": "11px",
          "color": "red",
          "line-height": "1",
          "margin-top": "8px"
        }
      }, [_vm._v("未下发")]) : _vm._e(), _vm._v(" "), (item.error) ? _c('div', {
        staticStyle: {
          "font-size": "11px",
          "color": "red",
          "line-height": "1",
          "margin-top": "8px"
        }
      }, [_vm._v(_vm._s(item.error))]) : _vm._e()]) : (c.type == 'selection') ? _c('div', [(c.editable) ? _c('div', [(c.version == 2 || c.batchset) ? _c('Select', {
        style: ('width: ' + (c.width - 10) + 'px;'),
        attrs: {
          "value": item[c.keyStr || (c.key + 'Str')],
          "name": item[c.keyStr || (c.key + 'Str')] + index
        },
        on: {
          "on-change": function($event) {
            return _vm.dataChanged(item, c, $event, index)
          }
        }
      }, _vm._l((c.selections(item)), function(s, si) {
        return _c('Option', {
          key: si,
          attrs: {
            "value": c.selectionvalue ? c.selectionvalue(s) : s[c.selectionKey]
          }
        }, [_vm._v("\n                                            " + _vm._s(c.selectionrender ? c.selectionrender(item, s) : s[c.selectionKey]) + "\n                                        ")])
      }), 1) : _c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item[c.keyStr || (c.key + 'Str')]),
          expression: "item[c.keyStr || (c.key+'Str')]"
        }],
        staticClass: "wupin-select",
        style: ('width: ' + (c.width - 20) + 'px;'),
        attrs: {
          "name": item[c.keyStr || (c.key + 'Str')] + index
        },
        on: {
          "change": [function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(item, c.keyStr || (c.key + 'Str'), $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }, function($event) {
            _vm.dataChanged(item, c, item[c.keyStr || (c.key + 'Str')], index)
          }]
        }
      }, _vm._l((c.selections(item)), function(s, si) {
        return _c('option', {
          key: si,
          staticClass: "wupin-option",
          domProps: {
            "value": c.selectionvalue ? c.selectionvalue(s) : s[c.selectionKey]
          }
        }, [_vm._v("\n                                            " + _vm._s(c.selectionrender ? c.selectionrender(item, s) : s[c.selectionKey]))])
      }), 0)], 1) : _c('div', [_vm._v(_vm._s(item[c.keyStr || (c.key + 'Str')]))])]) : (c.type == 'danjia') ? _c('div', [(c.permission && !_vm.session.permission[c.permission]) ? _c('div', [_vm._v("--")]) : _c('div', [(c.editable) ? _c('custom-input', {
        attrs: {
          "value": item[c.key],
          "fix": c.fixAppend ? c.fixAppend(item) : 6,
          "min": c.min,
          "max": c.max,
          "required": c.required,
          "width": _vm.columns[i].width - 10,
          "unit": c.append ? c.append(item) : ''
        },
        on: {
          "input": function($event) {
            return _vm.getInput($event, item, c, index)
          }
        }
      }) : (c.calculate) ? _c('div', [_vm._v(_vm._s(_vm._f("AmountDecimal")(c.calculate(item), c.fixAppend ? c.fixAppend(item) : 6)))]) : _c('div', [_vm._v(_vm._s(_vm._f("AmountDecimal")(item[c.key], c.fixAppend ? c.fixAppend(item) : 6)))])], 1)]) : (c.type == 'jine') ? _c('div', [(c.permission && !_vm.session.permission[c.permission]) ? _c('div', [_vm._v("--")]) : _c('div', [(c.editable) ? _c('custom-input', {
        attrs: {
          "value": item[c.key],
          "fix": 2,
          "min": c.min,
          "max": c.max,
          "required": c.required,
          "width": _vm.columns[i].width - 10,
          "unit": c.append ? c.append(item) : ''
        },
        on: {
          "input": function($event) {
            return _vm.getInput($event, item, c, index)
          }
        }
      }) : (c.calculate) ? _c('div', [_vm._v(_vm._s(_vm._f("AmountDecimal")(c.calculate(item), 2)))]) : _c('div', [_vm._v(_vm._s(_vm._f("AmountDecimal")(item[c.key], 2)))])], 1)]) : (c.type == 'shuilv') ? _c('div', [(c.permission && !_vm.session.permission[c.permission]) ? _c('div', [_vm._v("--")]) : _c('div', [(c.editable) ? _c('custom-input', {
        attrs: {
          "value": item[c.key],
          "fix": 4,
          "min": c.min,
          "max": c.max,
          "required": c.required,
          "width": _vm.columns[i].width - 10,
          "unit": c.append ? c.append(item) : ''
        },
        on: {
          "input": function($event) {
            return _vm.getInput($event, item, c, index)
          }
        }
      }) : (c.calculate) ? _c('div', [_vm._v(_vm._s(_vm._f("AmountDecimal")(c.calculate(item), 4)))]) : _c('div', [_vm._v(_vm._s(_vm._f("AmountDecimal")(item[c.key], 4)))])], 1)]) : (c.type == 'shuliang') ? _c('div', [(c.permission && !_vm.session.permission[c.permission]) ? _c('div', [_vm._v("--")]) : _c('div', [(c.editable) ? _c('custom-input', {
        attrs: {
          "value": item[c.key],
          "fix": 6,
          "min": c.min,
          "max": c.max,
          "width": _vm.columns[i].width - 10,
          "unit": c.append ? c.append(item) : ''
        },
        on: {
          "input": function($event) {
            return _vm.getInput($event, item, c, index)
          }
        }
      }) : (c.calculate) ? _c('div', [_vm._v(_vm._s(_vm._f("AmountDecimal")(c.calculate(item), 6)))]) : _c('div', [_vm._v(_vm._s(_vm._f("AmountDecimal")(item[c.key], 6)))])], 1)]) : (c.type === 'beizhu') ? _c('div', [(c.editable) ? _c('div', [_c('Input', {
        attrs: {
          "placeholder": "请输入"
        },
        model: {
          value: (item[c.key]),
          callback: function($$v) {
            _vm.$set(item, c.key, $$v)
          },
          expression: "item[c.key]"
        }
      })], 1) : _c('div', [_vm._v(_vm._s(item[c.key]))])]) : _c('div', [(c.html) ? _c('div', [_c('div', {
        domProps: {
          "innerHTML": _vm._s(c.html(item, index))
        }
      })]) : _c('div', [_vm._v(_vm._s((item[c.key] && c.subKey) ? item[c.key][c.subKey] : item[c.key]))])])])])
    }), 0)])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), ((!_vm.newItems.length || _vm.option.alwaysShowAddButton) && _vm.editable) ? _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "center",
    staticStyle: {
      "position": "absolute",
      "left": "calc(50% - 50px)",
      "height": "40px"
    }
  }, [_c('Button', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "default"
    },
    on: {
      "click": _vm.addItem
    }
  }, [_vm._v(_vm._s(_vm.option.buttonLabel || '新增') + "\n                        "), _c('Icon', {
    attrs: {
      "type": "ios-add"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "40px"
    }
  })]) : _vm._e()], 2)]), _vm._v(" "), (!_vm.editable && !_vm.onepagemode && (_vm.total > _vm.page.size || _vm.page.size > 10)) ? _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('Page', {
    attrs: {
      "placement": "top",
      "page-size-opts": [10, 20, 50, 100, 200],
      "total": _vm.total,
      "current": _vm.page.current,
      "page-size": _vm.page.size,
      "show-sizer": "",
      "show-total": "",
      "size": "small"
    },
    on: {
      "on-change": _vm.pageChanged,
      "on-page-size-change": _vm.pageSizeChanged
    }
  })], 1) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cXyZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("u+K/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04301e8a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("Ofuf");
function injectStyle (ssrContext) {
  __webpack_require__("56hx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-04301e8a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04301e8a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dWtg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("4rdx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc4950fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("GU67");
function injectStyle (ssrContext) {
  __webpack_require__("H18h")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc4950fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ddF3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataSelector_vue__ = __webpack_require__("ghPf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_497bc2d3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_DataSelector_vue__ = __webpack_require__("kQSw");
function injectStyle (ssrContext) {
  __webpack_require__("Tvnc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-497bc2d3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_497bc2d3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_DataSelector_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dkQH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.items && _vm.items.length) ? _c('div', [(!_vm.nohead) ? _c('div', {
    staticStyle: {
      "color": "#aaa",
      "margin-bottom": "10px"
    }
  }, [_vm._v("操作日志")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "scroll-none",
    staticStyle: {
      "overflow": "scroll",
      "overflow-y": "hidden",
      "display": "grid",
      "width": "100%",
      "padding-bottom": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "border-radius": "4px",
        "border": "1px solid #eee",
        "width": "200px",
        "margin-right": "10px"
      }
    }, [_c('div', {
      staticStyle: {
        "background-color": "#f8f8f8",
        "padding": "10px",
        "font-weight": "bold",
        "border-bottom": "1px solid #eee"
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding": "10px"
      }
    }, [_c('div', [_vm._v("操作者：" + _vm._s(item.zhanghao.name))]), _vm._v(" "), _c('div', [_vm._v("时间：" + _vm._s(item.createTimeStr))]), _vm._v(" "), (item.beizhu) ? _c('div', [_vm._v("备注：" + _vm._s(item.beizhu))]) : _vm._e()])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "20px"
    }
  })]) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "du79":
/***/ (function(module, exports, __webpack_require__) {

!function (e, n) {
   true ? module.exports = n() : "function" == typeof define && define.amd ? define([], n) : "object" == typeof exports ? exports.ZhAddressParse = n() : e.ZhAddressParse = n();
}(this, function () {
  return function (e) {
    var n = {};
    function c(d) {
      if (n[d]) return n[d].exports;
      var o = n[d] = {
        i: d,
        l: !1,
        exports: {}
      };
      return e[d].call(o.exports, o, o.exports, c), o.l = !0, o.exports;
    }
    return c.m = e, c.c = n, c.d = function (e, n, d) {
      c.o(e, n) || Object.defineProperty(e, n, {
        enumerable: !0,
        get: d
      });
    }, c.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, c.t = function (e, n) {
      if (1 & n && (e = c(e)), 8 & n) return e;
      if (4 & n && "object" == typeof e && e && e.__esModule) return e;
      var d = Object.create(null);
      if (c.r(d), Object.defineProperty(d, "default", {
        enumerable: !0,
        value: e
      }), 2 & n && "string" != typeof e) for (var o in e) c.d(d, o, function (n) {
        return e[n];
      }.bind(null, o));
      return d;
    }, c.n = function (e) {
      var n = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return c.d(n, "a", n), n;
    }, c.o = function (e, n) {
      return Object.prototype.hasOwnProperty.call(e, n);
    }, c.p = "", c(c.s = 2);
  }([function (e) {
    e.exports = JSON.parse('[{"code": "11","name": "北京市","children": [{"code": "1101","name": "市辖区","children": [{"code": "110101","name": "东城区"},{"code": "110102","name": "西城区"},{"code": "110105","name": "朝阳区"},{"code": "110106","name": "丰台区"},{"code": "110107","name": "石景山区"},{"code": "110108","name": "海淀区"},{"code": "110109","name": "门头沟区"},{"code": "110111","name": "房山区"},{"code": "110112","name": "通州区"},{"code": "110113","name": "顺义区"},{"code": "110114","name": "昌平区"},{"code": "110115","name": "大兴区"},{"code": "110116","name": "怀柔区"},{"code": "110117","name": "平谷区"},{"code": "110118","name": "密云区"},{"code": "110119","name": "延庆区"}]}]},{"code": "12","name": "天津市","children": [{"code": "1201","name": "市辖区","children": [{"code": "120101","name": "和平区"},{"code": "120102","name": "河东区"},{"code": "120103","name": "河西区"},{"code": "120104","name": "南开区"},{"code": "120105","name": "河北区"},{"code": "120106","name": "红桥区"},{"code": "120110","name": "东丽区"},{"code": "120111","name": "西青区"},{"code": "120112","name": "津南区"},{"code": "120113","name": "北辰区"},{"code": "120114","name": "武清区"},{"code": "120115","name": "宝坻区"},{"code": "120116","name": "滨海新区"},{"code": "120117","name": "宁河区"},{"code": "120118","name": "静海区"},{"code": "120119","name": "蓟州区"}]}]},{"code": "13","name": "河北省","children": [{"code": "1301","name": "石家庄市","children": [{"code": "130102","name": "长安区"},{"code": "130104","name": "桥西区"},{"code": "130105","name": "新华区"},{"code": "130107","name": "井陉矿区"},{"code": "130108","name": "裕华区"},{"code": "130109","name": "藁城区"},{"code": "130110","name": "鹿泉区"},{"code": "130111","name": "栾城区"},{"code": "130121","name": "井陉县"},{"code": "130123","name": "正定县"},{"code": "130125","name": "行唐县"},{"code": "130126","name": "灵寿县"},{"code": "130127","name": "高邑县"},{"code": "130128","name": "深泽县"},{"code": "130129","name": "赞皇县"},{"code": "130130","name": "无极县"},{"code": "130131","name": "平山县"},{"code": "130132","name": "元氏县"},{"code": "130133","name": "赵县"},{"code": "130171","name": "石家庄高新技术产业开发区"},{"code": "130172","name": "石家庄循环化工园区"},{"code": "130181","name": "辛集市"},{"code": "130183","name": "晋州市"},{"code": "130184","name": "新乐市"}]},{"code": "1302","name": "唐山市","children": [{"code": "130202","name": "路南区"},{"code": "130203","name": "路北区"},{"code": "130204","name": "古冶区"},{"code": "130205","name": "开平区"},{"code": "130207","name": "丰南区"},{"code": "130208","name": "丰润区"},{"code": "130209","name": "曹妃甸区"},{"code": "130224","name": "滦南县"},{"code": "130225","name": "乐亭县"},{"code": "130227","name": "迁西县"},{"code": "130229","name": "玉田县"},{"code": "130271","name": "河北唐山芦台经济开发区"},{"code": "130272","name": "唐山市汉沽管理区"},{"code": "130273","name": "唐山高新技术产业开发区"},{"code": "130274","name": "河北唐山海港经济开发区"},{"code": "130281","name": "遵化市"},{"code": "130283","name": "迁安市"},{"code": "130284","name": "滦州市"}]},{"code": "1303","name": "秦皇岛市","children": [{"code": "130302","name": "海港区"},{"code": "130303","name": "山海关区"},{"code": "130304","name": "北戴河区"},{"code": "130306","name": "抚宁区"},{"code": "130321","name": "青龙满族自治县"},{"code": "130322","name": "昌黎县"},{"code": "130324","name": "卢龙县"},{"code": "130371","name": "秦皇岛市经济技术开发区"},{"code": "130372","name": "北戴河新区"}]},{"code": "1304","name": "邯郸市","children": [{"code": "130402","name": "邯山区"},{"code": "130403","name": "丛台区"},{"code": "130404","name": "复兴区"},{"code": "130406","name": "峰峰矿区"},{"code": "130407","name": "肥乡区"},{"code": "130408","name": "永年区"},{"code": "130423","name": "临漳县"},{"code": "130424","name": "成安县"},{"code": "130425","name": "大名县"},{"code": "130426","name": "涉县"},{"code": "130427","name": "磁县"},{"code": "130430","name": "邱县"},{"code": "130431","name": "鸡泽县"},{"code": "130432","name": "广平县"},{"code": "130433","name": "馆陶县"},{"code": "130434","name": "魏县"},{"code": "130435","name": "曲周县"},{"code": "130471","name": "邯郸经济技术开发区"},{"code": "130473","name": "邯郸冀南新区"},{"code": "130481","name": "武安市"}]},{"code": "1305","name": "邢台市","children": [{"code": "130502","name": "桥东区"},{"code": "130503","name": "桥西区"},{"code": "130521","name": "邢台县"},{"code": "130522","name": "临城县"},{"code": "130523","name": "内丘县"},{"code": "130524","name": "柏乡县"},{"code": "130525","name": "隆尧县"},{"code": "130526","name": "任县"},{"code": "130527","name": "南和县"},{"code": "130528","name": "宁晋县"},{"code": "130529","name": "巨鹿县"},{"code": "130530","name": "新河县"},{"code": "130531","name": "广宗县"},{"code": "130532","name": "平乡县"},{"code": "130533","name": "威县"},{"code": "130534","name": "清河县"},{"code": "130535","name": "临西县"},{"code": "130571","name": "河北邢台经济开发区"},{"code": "130581","name": "南宫市"},{"code": "130582","name": "沙河市"}]},{"code": "1306","name": "保定市","children": [{"code": "130602","name": "竞秀区"},{"code": "130606","name": "莲池区"},{"code": "130607","name": "满城区"},{"code": "130608","name": "清苑区"},{"code": "130609","name": "徐水区"},{"code": "130623","name": "涞水县"},{"code": "130624","name": "阜平县"},{"code": "130626","name": "定兴县"},{"code": "130627","name": "唐县"},{"code": "130628","name": "高阳县"},{"code": "130629","name": "容城县"},{"code": "130630","name": "涞源县"},{"code": "130631","name": "望都县"},{"code": "130632","name": "安新县"},{"code": "130633","name": "易县"},{"code": "130634","name": "曲阳县"},{"code": "130635","name": "蠡县"},{"code": "130636","name": "顺平县"},{"code": "130637","name": "博野县"},{"code": "130638","name": "雄县"},{"code": "130671","name": "保定高新技术产业开发区"},{"code": "130672","name": "保定白沟新城"},{"code": "130681","name": "涿州市"},{"code": "130682","name": "定州市"},{"code": "130683","name": "安国市"},{"code": "130684","name": "高碑店市"}]},{"code": "1307","name": "张家口市","children": [{"code": "130702","name": "桥东区"},{"code": "130703","name": "桥西区"},{"code": "130705","name": "宣化区"},{"code": "130706","name": "下花园区"},{"code": "130708","name": "万全区"},{"code": "130709","name": "崇礼区"},{"code": "130722","name": "张北县"},{"code": "130723","name": "康保县"},{"code": "130724","name": "沽源县"},{"code": "130725","name": "尚义县"},{"code": "130726","name": "蔚县"},{"code": "130727","name": "阳原县"},{"code": "130728","name": "怀安县"},{"code": "130730","name": "怀来县"},{"code": "130731","name": "涿鹿县"},{"code": "130732","name": "赤城县"},{"code": "130771","name": "张家口经济开发区"},{"code": "130772","name": "张家口市察北管理区"},{"code": "130773","name": "张家口市塞北管理区"}]},{"code": "1308","name": "承德市","children": [{"code": "130802","name": "双桥区"},{"code": "130803","name": "双滦区"},{"code": "130804","name": "鹰手营子矿区"},{"code": "130821","name": "承德县"},{"code": "130822","name": "兴隆县"},{"code": "130824","name": "滦平县"},{"code": "130825","name": "隆化县"},{"code": "130826","name": "丰宁满族自治县"},{"code": "130827","name": "宽城满族自治县"},{"code": "130828","name": "围场满族蒙古族自治县"},{"code": "130871","name": "承德高新技术产业开发区"},{"code": "130881","name": "平泉市"}]},{"code": "1309","name": "沧州市","children": [{"code": "130902","name": "新华区"},{"code": "130903","name": "运河区"},{"code": "130921","name": "沧县"},{"code": "130922","name": "青县"},{"code": "130923","name": "东光县"},{"code": "130924","name": "海兴县"},{"code": "130925","name": "盐山县"},{"code": "130926","name": "肃宁县"},{"code": "130927","name": "南皮县"},{"code": "130928","name": "吴桥县"},{"code": "130929","name": "献县"},{"code": "130930","name": "孟村回族自治县"},{"code": "130971","name": "河北沧州经济开发区"},{"code": "130972","name": "沧州高新技术产业开发区"},{"code": "130973","name": "沧州渤海新区"},{"code": "130981","name": "泊头市"},{"code": "130982","name": "任丘市"},{"code": "130983","name": "黄骅市"},{"code": "130984","name": "河间市"}]},{"code": "1310","name": "廊坊市","children": [{"code": "131002","name": "安次区"},{"code": "131003","name": "广阳区"},{"code": "131022","name": "固安县"},{"code": "131023","name": "永清县"},{"code": "131024","name": "香河县"},{"code": "131025","name": "大城县"},{"code": "131026","name": "文安县"},{"code": "131028","name": "大厂回族自治县"},{"code": "131071","name": "廊坊经济技术开发区"},{"code": "131081","name": "霸州市"},{"code": "131082","name": "三河市"}]},{"code": "1311","name": "衡水市","children": [{"code": "131102","name": "桃城区"},{"code": "131103","name": "冀州区"},{"code": "131121","name": "枣强县"},{"code": "131122","name": "武邑县"},{"code": "131123","name": "武强县"},{"code": "131124","name": "饶阳县"},{"code": "131125","name": "安平县"},{"code": "131126","name": "故城县"},{"code": "131127","name": "景县"},{"code": "131128","name": "阜城县"},{"code": "131171","name": "河北衡水高新技术产业开发区"},{"code": "131172","name": "衡水滨湖新区"},{"code": "131182","name": "深州市"}]}]},{"code": "14","name": "山西省","children": [{"code": "1401","name": "太原市","children": [{"code": "140105","name": "小店区"},{"code": "140106","name": "迎泽区"},{"code": "140107","name": "杏花岭区"},{"code": "140108","name": "尖草坪区"},{"code": "140109","name": "万柏林区"},{"code": "140110","name": "晋源区"},{"code": "140121","name": "清徐县"},{"code": "140122","name": "阳曲县"},{"code": "140123","name": "娄烦县"},{"code": "140171","name": "山西转型综合改革示范区"},{"code": "140181","name": "古交市"}]},{"code": "1402","name": "大同市","children": [{"code": "140212","name": "新荣区"},{"code": "140213","name": "平城区"},{"code": "140214","name": "云冈区"},{"code": "140215","name": "云州区"},{"code": "140221","name": "阳高县"},{"code": "140222","name": "天镇县"},{"code": "140223","name": "广灵县"},{"code": "140224","name": "灵丘县"},{"code": "140225","name": "浑源县"},{"code": "140226","name": "左云县"},{"code": "140271","name": "山西大同经济开发区"}]},{"code": "1403","name": "阳泉市","children": [{"code": "140302","name": "城区"},{"code": "140303","name": "矿区"},{"code": "140311","name": "郊区"},{"code": "140321","name": "平定县"},{"code": "140322","name": "盂县"}]},{"code": "1404","name": "长治市","children": [{"code": "140403","name": "潞州区"},{"code": "140404","name": "上党区"},{"code": "140405","name": "屯留区"},{"code": "140406","name": "潞城区"},{"code": "140423","name": "襄垣县"},{"code": "140425","name": "平顺县"},{"code": "140426","name": "黎城县"},{"code": "140427","name": "壶关县"},{"code": "140428","name": "长子县"},{"code": "140429","name": "武乡县"},{"code": "140430","name": "沁县"},{"code": "140431","name": "沁源县"},{"code": "140471","name": "山西长治高新技术产业园区"}]},{"code": "1405","name": "晋城市","children": [{"code": "140502","name": "城区"},{"code": "140521","name": "沁水县"},{"code": "140522","name": "阳城县"},{"code": "140524","name": "陵川县"},{"code": "140525","name": "泽州县"},{"code": "140581","name": "高平市"}]},{"code": "1406","name": "朔州市","children": [{"code": "140602","name": "朔城区"},{"code": "140603","name": "平鲁区"},{"code": "140621","name": "山阴县"},{"code": "140622","name": "应县"},{"code": "140623","name": "右玉县"},{"code": "140671","name": "山西朔州经济开发区"},{"code": "140681","name": "怀仁市"}]},{"code": "1407","name": "晋中市","children": [{"code": "140702","name": "榆次区"},{"code": "140721","name": "榆社县"},{"code": "140722","name": "左权县"},{"code": "140723","name": "和顺县"},{"code": "140724","name": "昔阳县"},{"code": "140725","name": "寿阳县"},{"code": "140726","name": "太谷县"},{"code": "140727","name": "祁县"},{"code": "140728","name": "平遥县"},{"code": "140729","name": "灵石县"},{"code": "140781","name": "介休市"}]},{"code": "1408","name": "运城市","children": [{"code": "140802","name": "盐湖区"},{"code": "140821","name": "临猗县"},{"code": "140822","name": "万荣县"},{"code": "140823","name": "闻喜县"},{"code": "140824","name": "稷山县"},{"code": "140825","name": "新绛县"},{"code": "140826","name": "绛县"},{"code": "140827","name": "垣曲县"},{"code": "140828","name": "夏县"},{"code": "140829","name": "平陆县"},{"code": "140830","name": "芮城县"},{"code": "140881","name": "永济市"},{"code": "140882","name": "河津市"}]},{"code": "1409","name": "忻州市","children": [{"code": "140902","name": "忻府区"},{"code": "140921","name": "定襄县"},{"code": "140922","name": "五台县"},{"code": "140923","name": "代县"},{"code": "140924","name": "繁峙县"},{"code": "140925","name": "宁武县"},{"code": "140926","name": "静乐县"},{"code": "140927","name": "神池县"},{"code": "140928","name": "五寨县"},{"code": "140929","name": "岢岚县"},{"code": "140930","name": "河曲县"},{"code": "140931","name": "保德县"},{"code": "140932","name": "偏关县"},{"code": "140971","name": "五台山风景名胜区"},{"code": "140981","name": "原平市"}]},{"code": "1410","name": "临汾市","children": [{"code": "141002","name": "尧都区"},{"code": "141021","name": "曲沃县"},{"code": "141022","name": "翼城县"},{"code": "141023","name": "襄汾县"},{"code": "141024","name": "洪洞县"},{"code": "141025","name": "古县"},{"code": "141026","name": "安泽县"},{"code": "141027","name": "浮山县"},{"code": "141028","name": "吉县"},{"code": "141029","name": "乡宁县"},{"code": "141030","name": "大宁县"},{"code": "141031","name": "隰县"},{"code": "141032","name": "永和县"},{"code": "141033","name": "蒲县"},{"code": "141034","name": "汾西县"},{"code": "141081","name": "侯马市"},{"code": "141082","name": "霍州市"}]},{"code": "1411","name": "吕梁市","children": [{"code": "141102","name": "离石区"},{"code": "141121","name": "文水县"},{"code": "141122","name": "交城县"},{"code": "141123","name": "兴县"},{"code": "141124","name": "临县"},{"code": "141125","name": "柳林县"},{"code": "141126","name": "石楼县"},{"code": "141127","name": "岚县"},{"code": "141128","name": "方山县"},{"code": "141129","name": "中阳县"},{"code": "141130","name": "交口县"},{"code": "141181","name": "孝义市"},{"code": "141182","name": "汾阳市"}]}]},{"code": "15","name": "内蒙古自治区","children": [{"code": "1501","name": "呼和浩特市","children": [{"code": "150102","name": "新城区"},{"code": "150103","name": "回民区"},{"code": "150104","name": "玉泉区"},{"code": "150105","name": "赛罕区"},{"code": "150121","name": "土默特左旗"},{"code": "150122","name": "托克托县"},{"code": "150123","name": "和林格尔县"},{"code": "150124","name": "清水河县"},{"code": "150125","name": "武川县"},{"code": "150171","name": "呼和浩特金海工业园区"},{"code": "150172","name": "呼和浩特经济技术开发区"}]},{"code": "1502","name": "包头市","children": [{"code": "150202","name": "东河区"},{"code": "150203","name": "昆都仑区"},{"code": "150204","name": "青山区"},{"code": "150205","name": "石拐区"},{"code": "150206","name": "白云鄂博矿区"},{"code": "150207","name": "九原区"},{"code": "150221","name": "土默特右旗"},{"code": "150222","name": "固阳县"},{"code": "150223","name": "达尔罕茂明安联合旗"},{"code": "150271","name": "包头稀土高新技术产业开发区"}]},{"code": "1503","name": "乌海市","children": [{"code": "150302","name": "海勃湾区"},{"code": "150303","name": "海南区"},{"code": "150304","name": "乌达区"}]},{"code": "1504","name": "赤峰市","children": [{"code": "150402","name": "红山区"},{"code": "150403","name": "元宝山区"},{"code": "150404","name": "松山区"},{"code": "150421","name": "阿鲁科尔沁旗"},{"code": "150422","name": "巴林左旗"},{"code": "150423","name": "巴林右旗"},{"code": "150424","name": "林西县"},{"code": "150425","name": "克什克腾旗"},{"code": "150426","name": "翁牛特旗"},{"code": "150428","name": "喀喇沁旗"},{"code": "150429","name": "宁城县"},{"code": "150430","name": "敖汉旗"}]},{"code": "1505","name": "通辽市","children": [{"code": "150502","name": "科尔沁区"},{"code": "150521","name": "科尔沁左翼中旗"},{"code": "150522","name": "科尔沁左翼后旗"},{"code": "150523","name": "开鲁县"},{"code": "150524","name": "库伦旗"},{"code": "150525","name": "奈曼旗"},{"code": "150526","name": "扎鲁特旗"},{"code": "150571","name": "通辽经济技术开发区"},{"code": "150581","name": "霍林郭勒市"}]},{"code": "1506","name": "鄂尔多斯市","children": [{"code": "150602","name": "东胜区"},{"code": "150603","name": "康巴什区"},{"code": "150621","name": "达拉特旗"},{"code": "150622","name": "准格尔旗"},{"code": "150623","name": "鄂托克前旗"},{"code": "150624","name": "鄂托克旗"},{"code": "150625","name": "杭锦旗"},{"code": "150626","name": "乌审旗"},{"code": "150627","name": "伊金霍洛旗"}]},{"code": "1507","name": "呼伦贝尔市","children": [{"code": "150702","name": "海拉尔区"},{"code": "150703","name": "扎赉诺尔区"},{"code": "150721","name": "阿荣旗"},{"code": "150722","name": "莫力达瓦达斡尔族自治旗"},{"code": "150723","name": "鄂伦春自治旗"},{"code": "150724","name": "鄂温克族自治旗"},{"code": "150725","name": "陈巴尔虎旗"},{"code": "150726","name": "新巴尔虎左旗"},{"code": "150727","name": "新巴尔虎右旗"},{"code": "150781","name": "满洲里市"},{"code": "150782","name": "牙克石市"},{"code": "150783","name": "扎兰屯市"},{"code": "150784","name": "额尔古纳市"},{"code": "150785","name": "根河市"}]},{"code": "1508","name": "巴彦淖尔市","children": [{"code": "150802","name": "临河区"},{"code": "150821","name": "五原县"},{"code": "150822","name": "磴口县"},{"code": "150823","name": "乌拉特前旗"},{"code": "150824","name": "乌拉特中旗"},{"code": "150825","name": "乌拉特后旗"},{"code": "150826","name": "杭锦后旗"}]},{"code": "1509","name": "乌兰察布市","children": [{"code": "150902","name": "集宁区"},{"code": "150921","name": "卓资县"},{"code": "150922","name": "化德县"},{"code": "150923","name": "商都县"},{"code": "150924","name": "兴和县"},{"code": "150925","name": "凉城县"},{"code": "150926","name": "察哈尔右翼前旗"},{"code": "150927","name": "察哈尔右翼中旗"},{"code": "150928","name": "察哈尔右翼后旗"},{"code": "150929","name": "四子王旗"},{"code": "150981","name": "丰镇市"}]},{"code": "1522","name": "兴安盟","children": [{"code": "152201","name": "乌兰浩特市"},{"code": "152202","name": "阿尔山市"},{"code": "152221","name": "科尔沁右翼前旗"},{"code": "152222","name": "科尔沁右翼中旗"},{"code": "152223","name": "扎赉特旗"},{"code": "152224","name": "突泉县"}]},{"code": "1525","name": "锡林郭勒盟","children": [{"code": "152501","name": "二连浩特市"},{"code": "152502","name": "锡林浩特市"},{"code": "152522","name": "阿巴嘎旗"},{"code": "152523","name": "苏尼特左旗"},{"code": "152524","name": "苏尼特右旗"},{"code": "152525","name": "东乌珠穆沁旗"},{"code": "152526","name": "西乌珠穆沁旗"},{"code": "152527","name": "太仆寺旗"},{"code": "152528","name": "镶黄旗"},{"code": "152529","name": "正镶白旗"},{"code": "152530","name": "正蓝旗"},{"code": "152531","name": "多伦县"},{"code": "152571","name": "乌拉盖管委会"}]},{"code": "1529","name": "阿拉善盟","children": [{"code": "152921","name": "阿拉善左旗"},{"code": "152922","name": "阿拉善右旗"},{"code": "152923","name": "额济纳旗"},{"code": "152971","name": "内蒙古阿拉善经济开发区"}]}]},{"code": "21","name": "辽宁省","children": [{"code": "2101","name": "沈阳市","children": [{"code": "210102","name": "和平区"},{"code": "210103","name": "沈河区"},{"code": "210104","name": "大东区"},{"code": "210105","name": "皇姑区"},{"code": "210106","name": "铁西区"},{"code": "210111","name": "苏家屯区"},{"code": "210112","name": "浑南区"},{"code": "210113","name": "沈北新区"},{"code": "210114","name": "于洪区"},{"code": "210115","name": "辽中区"},{"code": "210123","name": "康平县"},{"code": "210124","name": "法库县"},{"code": "210181","name": "新民市"}]},{"code": "2102","name": "大连市","children": [{"code": "210202","name": "中山区"},{"code": "210203","name": "西岗区"},{"code": "210204","name": "沙河口区"},{"code": "210211","name": "甘井子区"},{"code": "210212","name": "旅顺口区"},{"code": "210213","name": "金州区"},{"code": "210214","name": "普兰店区"},{"code": "210224","name": "长海县"},{"code": "210281","name": "瓦房店市"},{"code": "210283","name": "庄河市"}]},{"code": "2103","name": "鞍山市","children": [{"code": "210302","name": "铁东区"},{"code": "210303","name": "铁西区"},{"code": "210304","name": "立山区"},{"code": "210311","name": "千山区"},{"code": "210321","name": "台安县"},{"code": "210323","name": "岫岩满族自治县"},{"code": "210381","name": "海城市"}]},{"code": "2104","name": "抚顺市","children": [{"code": "210402","name": "新抚区"},{"code": "210403","name": "东洲区"},{"code": "210404","name": "望花区"},{"code": "210411","name": "顺城区"},{"code": "210421","name": "抚顺县"},{"code": "210422","name": "新宾满族自治县"},{"code": "210423","name": "清原满族自治县"}]},{"code": "2105","name": "本溪市","children": [{"code": "210502","name": "平山区"},{"code": "210503","name": "溪湖区"},{"code": "210504","name": "明山区"},{"code": "210505","name": "南芬区"},{"code": "210521","name": "本溪满族自治县"},{"code": "210522","name": "桓仁满族自治县"}]},{"code": "2106","name": "丹东市","children": [{"code": "210602","name": "元宝区"},{"code": "210603","name": "振兴区"},{"code": "210604","name": "振安区"},{"code": "210624","name": "宽甸满族自治县"},{"code": "210681","name": "东港市"},{"code": "210682","name": "凤城市"}]},{"code": "2107","name": "锦州市","children": [{"code": "210702","name": "古塔区"},{"code": "210703","name": "凌河区"},{"code": "210711","name": "太和区"},{"code": "210726","name": "黑山县"},{"code": "210727","name": "义县"},{"code": "210781","name": "凌海市"},{"code": "210782","name": "北镇市"}]},{"code": "2108","name": "营口市","children": [{"code": "210802","name": "站前区"},{"code": "210803","name": "西市区"},{"code": "210804","name": "鲅鱼圈区"},{"code": "210811","name": "老边区"},{"code": "210881","name": "盖州市"},{"code": "210882","name": "大石桥市"}]},{"code": "2109","name": "阜新市","children": [{"code": "210902","name": "海州区"},{"code": "210903","name": "新邱区"},{"code": "210904","name": "太平区"},{"code": "210905","name": "清河门区"},{"code": "210911","name": "细河区"},{"code": "210921","name": "阜新蒙古族自治县"},{"code": "210922","name": "彰武县"}]},{"code": "2110","name": "辽阳市","children": [{"code": "211002","name": "白塔区"},{"code": "211003","name": "文圣区"},{"code": "211004","name": "宏伟区"},{"code": "211005","name": "弓长岭区"},{"code": "211011","name": "太子河区"},{"code": "211021","name": "辽阳县"},{"code": "211081","name": "灯塔市"}]},{"code": "2111","name": "盘锦市","children": [{"code": "211102","name": "双台子区"},{"code": "211103","name": "兴隆台区"},{"code": "211104","name": "大洼区"},{"code": "211122","name": "盘山县"}]},{"code": "2112","name": "铁岭市","children": [{"code": "211202","name": "银州区"},{"code": "211204","name": "清河区"},{"code": "211221","name": "铁岭县"},{"code": "211223","name": "西丰县"},{"code": "211224","name": "昌图县"},{"code": "211281","name": "调兵山市"},{"code": "211282","name": "开原市"}]},{"code": "2113","name": "朝阳市","children": [{"code": "211302","name": "双塔区"},{"code": "211303","name": "龙城区"},{"code": "211321","name": "朝阳县"},{"code": "211322","name": "建平县"},{"code": "211324","name": "喀喇沁左翼蒙古族自治县"},{"code": "211381","name": "北票市"},{"code": "211382","name": "凌源市"}]},{"code": "2114","name": "葫芦岛市","children": [{"code": "211402","name": "连山区"},{"code": "211403","name": "龙港区"},{"code": "211404","name": "南票区"},{"code": "211421","name": "绥中县"},{"code": "211422","name": "建昌县"},{"code": "211481","name": "兴城市"}]}]},{"code": "22","name": "吉林省","children": [{"code": "2201","name": "长春市","children": [{"code": "220102","name": "南关区"},{"code": "220103","name": "宽城区"},{"code": "220104","name": "朝阳区"},{"code": "220105","name": "二道区"},{"code": "220106","name": "绿园区"},{"code": "220112","name": "双阳区"},{"code": "220113","name": "九台区"},{"code": "220122","name": "农安县"},{"code": "220171","name": "长春经济技术开发区"},{"code": "220172","name": "长春净月高新技术产业开发区"},{"code": "220173","name": "长春高新技术产业开发区"},{"code": "220174","name": "长春汽车经济技术开发区"},{"code": "220182","name": "榆树市"},{"code": "220183","name": "德惠市"}]},{"code": "2202","name": "吉林市","children": [{"code": "220202","name": "昌邑区"},{"code": "220203","name": "龙潭区"},{"code": "220204","name": "船营区"},{"code": "220211","name": "丰满区"},{"code": "220221","name": "永吉县"},{"code": "220271","name": "吉林经济开发区"},{"code": "220272","name": "吉林高新技术产业开发区"},{"code": "220273","name": "吉林中国新加坡食品区"},{"code": "220281","name": "蛟河市"},{"code": "220282","name": "桦甸市"},{"code": "220283","name": "舒兰市"},{"code": "220284","name": "磐石市"}]},{"code": "2203","name": "四平市","children": [{"code": "220302","name": "铁西区"},{"code": "220303","name": "铁东区"},{"code": "220322","name": "梨树县"},{"code": "220323","name": "伊通满族自治县"},{"code": "220381","name": "公主岭市"},{"code": "220382","name": "双辽市"}]},{"code": "2204","name": "辽源市","children": [{"code": "220402","name": "龙山区"},{"code": "220403","name": "西安区"},{"code": "220421","name": "东丰县"},{"code": "220422","name": "东辽县"}]},{"code": "2205","name": "通化市","children": [{"code": "220502","name": "东昌区"},{"code": "220503","name": "二道江区"},{"code": "220521","name": "通化县"},{"code": "220523","name": "辉南县"},{"code": "220524","name": "柳河县"},{"code": "220581","name": "梅河口市"},{"code": "220582","name": "集安市"}]},{"code": "2206","name": "白山市","children": [{"code": "220602","name": "浑江区"},{"code": "220605","name": "江源区"},{"code": "220621","name": "抚松县"},{"code": "220622","name": "靖宇县"},{"code": "220623","name": "长白朝鲜族自治县"},{"code": "220681","name": "临江市"}]},{"code": "2207","name": "松原市","children": [{"code": "220702","name": "宁江区"},{"code": "220721","name": "前郭尔罗斯蒙古族自治县"},{"code": "220722","name": "长岭县"},{"code": "220723","name": "乾安县"},{"code": "220771","name": "吉林松原经济开发区"},{"code": "220781","name": "扶余市"}]},{"code": "2208","name": "白城市","children": [{"code": "220802","name": "洮北区"},{"code": "220821","name": "镇赉县"},{"code": "220822","name": "通榆县"},{"code": "220871","name": "吉林白城经济开发区"},{"code": "220881","name": "洮南市"},{"code": "220882","name": "大安市"}]},{"code": "2224","name": "延边朝鲜族自治州","children": [{"code": "222401","name": "延吉市"},{"code": "222402","name": "图们市"},{"code": "222403","name": "敦化市"},{"code": "222404","name": "珲春市"},{"code": "222405","name": "龙井市"},{"code": "222406","name": "和龙市"},{"code": "222424","name": "汪清县"},{"code": "222426","name": "安图县"}]}]},{"code": "23","name": "黑龙江省","children": [{"code": "2301","name": "哈尔滨市","children": [{"code": "230102","name": "道里区"},{"code": "230103","name": "南岗区"},{"code": "230104","name": "道外区"},{"code": "230108","name": "平房区"},{"code": "230109","name": "松北区"},{"code": "230110","name": "香坊区"},{"code": "230111","name": "呼兰区"},{"code": "230112","name": "阿城区"},{"code": "230113","name": "双城区"},{"code": "230123","name": "依兰县"},{"code": "230124","name": "方正县"},{"code": "230125","name": "宾县"},{"code": "230126","name": "巴彦县"},{"code": "230127","name": "木兰县"},{"code": "230128","name": "通河县"},{"code": "230129","name": "延寿县"},{"code": "230183","name": "尚志市"},{"code": "230184","name": "五常市"}]},{"code": "2302","name": "齐齐哈尔市","children": [{"code": "230202","name": "龙沙区"},{"code": "230203","name": "建华区"},{"code": "230204","name": "铁锋区"},{"code": "230205","name": "昂昂溪区"},{"code": "230206","name": "富拉尔基区"},{"code": "230207","name": "碾子山区"},{"code": "230208","name": "梅里斯达斡尔族区"},{"code": "230221","name": "龙江县"},{"code": "230223","name": "依安县"},{"code": "230224","name": "泰来县"},{"code": "230225","name": "甘南县"},{"code": "230227","name": "富裕县"},{"code": "230229","name": "克山县"},{"code": "230230","name": "克东县"},{"code": "230231","name": "拜泉县"},{"code": "230281","name": "讷河市"}]},{"code": "2303","name": "鸡西市","children": [{"code": "230302","name": "鸡冠区"},{"code": "230303","name": "恒山区"},{"code": "230304","name": "滴道区"},{"code": "230305","name": "梨树区"},{"code": "230306","name": "城子河区"},{"code": "230307","name": "麻山区"},{"code": "230321","name": "鸡东县"},{"code": "230381","name": "虎林市"},{"code": "230382","name": "密山市"}]},{"code": "2304","name": "鹤岗市","children": [{"code": "230402","name": "向阳区"},{"code": "230403","name": "工农区"},{"code": "230404","name": "南山区"},{"code": "230405","name": "兴安区"},{"code": "230406","name": "东山区"},{"code": "230407","name": "兴山区"},{"code": "230421","name": "萝北县"},{"code": "230422","name": "绥滨县"}]},{"code": "2305","name": "双鸭山市","children": [{"code": "230502","name": "尖山区"},{"code": "230503","name": "岭东区"},{"code": "230505","name": "四方台区"},{"code": "230506","name": "宝山区"},{"code": "230521","name": "集贤县"},{"code": "230522","name": "友谊县"},{"code": "230523","name": "宝清县"},{"code": "230524","name": "饶河县"}]},{"code": "2306","name": "大庆市","children": [{"code": "230602","name": "萨尔图区"},{"code": "230603","name": "龙凤区"},{"code": "230604","name": "让胡路区"},{"code": "230605","name": "红岗区"},{"code": "230606","name": "大同区"},{"code": "230621","name": "肇州县"},{"code": "230622","name": "肇源县"},{"code": "230623","name": "林甸县"},{"code": "230624","name": "杜尔伯特蒙古族自治县"},{"code": "230671","name": "大庆高新技术产业开发区"}]},{"code": "2307","name": "伊春市","children": [{"code": "230717","name": "伊美区"},{"code": "230718","name": "乌翠区"},{"code": "230719","name": "友好区"},{"code": "230722","name": "嘉荫县"},{"code": "230723","name": "汤旺县"},{"code": "230724","name": "丰林县"},{"code": "230725","name": "大箐山县"},{"code": "230726","name": "南岔县"},{"code": "230751","name": "金林区"},{"code": "230781","name": "铁力市"}]},{"code": "2308","name": "佳木斯市","children": [{"code": "230803","name": "向阳区"},{"code": "230804","name": "前进区"},{"code": "230805","name": "东风区"},{"code": "230811","name": "郊区"},{"code": "230822","name": "桦南县"},{"code": "230826","name": "桦川县"},{"code": "230828","name": "汤原县"},{"code": "230881","name": "同江市"},{"code": "230882","name": "富锦市"},{"code": "230883","name": "抚远市"}]},{"code": "2309","name": "七台河市","children": [{"code": "230902","name": "新兴区"},{"code": "230903","name": "桃山区"},{"code": "230904","name": "茄子河区"},{"code": "230921","name": "勃利县"}]},{"code": "2310","name": "牡丹江市","children": [{"code": "231002","name": "东安区"},{"code": "231003","name": "阳明区"},{"code": "231004","name": "爱民区"},{"code": "231005","name": "西安区"},{"code": "231025","name": "林口县"},{"code": "231071","name": "牡丹江经济技术开发区"},{"code": "231081","name": "绥芬河市"},{"code": "231083","name": "海林市"},{"code": "231084","name": "宁安市"},{"code": "231085","name": "穆棱市"},{"code": "231086","name": "东宁市"}]},{"code": "2311","name": "黑河市","children": [{"code": "231102","name": "爱辉区"},{"code": "231123","name": "逊克县"},{"code": "231124","name": "孙吴县"},{"code": "231181","name": "北安市"},{"code": "231182","name": "五大连池市"},{"code": "231183","name": "嫩江市"}]},{"code": "2312","name": "绥化市","children": [{"code": "231202","name": "北林区"},{"code": "231221","name": "望奎县"},{"code": "231222","name": "兰西县"},{"code": "231223","name": "青冈县"},{"code": "231224","name": "庆安县"},{"code": "231225","name": "明水县"},{"code": "231226","name": "绥棱县"},{"code": "231281","name": "安达市"},{"code": "231282","name": "肇东市"},{"code": "231283","name": "海伦市"}]},{"code": "2327","name": "大兴安岭地区","children": [{"code": "232701","name": "漠河市"},{"code": "232721","name": "呼玛县"},{"code": "232722","name": "塔河县"},{"code": "232761","name": "加格达奇区"},{"code": "232762","name": "松岭区"},{"code": "232763","name": "新林区"},{"code": "232764","name": "呼中区"}]}]},{"code": "31","name": "上海市","children": [{"code": "3101","name": "市辖区","children": [{"code": "310101","name": "黄浦区"},{"code": "310104","name": "徐汇区"},{"code": "310105","name": "长宁区"},{"code": "310106","name": "静安区"},{"code": "310107","name": "普陀区"},{"code": "310109","name": "虹口区"},{"code": "310110","name": "杨浦区"},{"code": "310112","name": "闵行区"},{"code": "310113","name": "宝山区"},{"code": "310114","name": "嘉定区"},{"code": "310115","name": "浦东新区"},{"code": "310116","name": "金山区"},{"code": "310117","name": "松江区"},{"code": "310118","name": "青浦区"},{"code": "310120","name": "奉贤区"},{"code": "310151","name": "崇明区"}]}]},{"code": "32","name": "江苏省","children": [{"code": "3201","name": "南京市","children": [{"code": "320102","name": "玄武区"},{"code": "320104","name": "秦淮区"},{"code": "320105","name": "建邺区"},{"code": "320106","name": "鼓楼区"},{"code": "320111","name": "浦口区"},{"code": "320113","name": "栖霞区"},{"code": "320114","name": "雨花台区"},{"code": "320115","name": "江宁区"},{"code": "320116","name": "六合区"},{"code": "320117","name": "溧水区"},{"code": "320118","name": "高淳区"}]},{"code": "3202","name": "无锡市","children": [{"code": "320205","name": "锡山区"},{"code": "320206","name": "惠山区"},{"code": "320211","name": "滨湖区"},{"code": "320213","name": "梁溪区"},{"code": "320214","name": "新吴区"},{"code": "320281","name": "江阴市"},{"code": "320282","name": "宜兴市"}]},{"code": "3203","name": "徐州市","children": [{"code": "320302","name": "鼓楼区"},{"code": "320303","name": "云龙区"},{"code": "320305","name": "贾汪区"},{"code": "320311","name": "泉山区"},{"code": "320312","name": "铜山区"},{"code": "320321","name": "丰县"},{"code": "320322","name": "沛县"},{"code": "320324","name": "睢宁县"},{"code": "320371","name": "徐州经济技术开发区"},{"code": "320381","name": "新沂市"},{"code": "320382","name": "邳州市"}]},{"code": "3204","name": "常州市","children": [{"code": "320402","name": "天宁区"},{"code": "320404","name": "钟楼区"},{"code": "320411","name": "新北区"},{"code": "320412","name": "武进区"},{"code": "320413","name": "金坛区"},{"code": "320481","name": "溧阳市"}]},{"code": "3205","name": "苏州市","children": [{"code": "320505","name": "虎丘区"},{"code": "320506","name": "吴中区"},{"code": "320507","name": "相城区"},{"code": "320508","name": "姑苏区"},{"code": "320509","name": "吴江区"},{"code": "320571","name": "苏州工业园区"},{"code": "320581","name": "常熟市"},{"code": "320582","name": "张家港市"},{"code": "320583","name": "昆山市"},{"code": "320585","name": "太仓市"}]},{"code": "3206","name": "南通市","children": [{"code": "320602","name": "崇川区"},{"code": "320611","name": "港闸区"},{"code": "320612","name": "通州区"},{"code": "320623","name": "如东县"},{"code": "320671","name": "南通经济技术开发区"},{"code": "320681","name": "启东市"},{"code": "320682","name": "如皋市"},{"code": "320684","name": "海门市"},{"code": "320685","name": "海安市"}]},{"code": "3207","name": "连云港市","children": [{"code": "320703","name": "连云区"},{"code": "320706","name": "海州区"},{"code": "320707","name": "赣榆区"},{"code": "320722","name": "东海县"},{"code": "320723","name": "灌云县"},{"code": "320724","name": "灌南县"},{"code": "320771","name": "连云港经济技术开发区"},{"code": "320772","name": "连云港高新技术产业开发区"}]},{"code": "3208","name": "淮安市","children": [{"code": "320803","name": "淮安区"},{"code": "320804","name": "淮阴区"},{"code": "320812","name": "清江浦区"},{"code": "320813","name": "洪泽区"},{"code": "320826","name": "涟水县"},{"code": "320830","name": "盱眙县"},{"code": "320831","name": "金湖县"},{"code": "320871","name": "淮安经济技术开发区"}]},{"code": "3209","name": "盐城市","children": [{"code": "320902","name": "亭湖区"},{"code": "320903","name": "盐都区"},{"code": "320904","name": "大丰区"},{"code": "320921","name": "响水县"},{"code": "320922","name": "滨海县"},{"code": "320923","name": "阜宁县"},{"code": "320924","name": "射阳县"},{"code": "320925","name": "建湖县"},{"code": "320971","name": "盐城经济技术开发区"},{"code": "320981","name": "东台市"}]},{"code": "3210","name": "扬州市","children": [{"code": "321002","name": "广陵区"},{"code": "321003","name": "邗江区"},{"code": "321012","name": "江都区"},{"code": "321023","name": "宝应县"},{"code": "321071","name": "扬州经济技术开发区"},{"code": "321081","name": "仪征市"},{"code": "321084","name": "高邮市"}]},{"code": "3211","name": "镇江市","children": [{"code": "321102","name": "京口区"},{"code": "321111","name": "润州区"},{"code": "321112","name": "丹徒区"},{"code": "321171","name": "镇江新区"},{"code": "321181","name": "丹阳市"},{"code": "321182","name": "扬中市"},{"code": "321183","name": "句容市"}]},{"code": "3212","name": "泰州市","children": [{"code": "321202","name": "海陵区"},{"code": "321203","name": "高港区"},{"code": "321204","name": "姜堰区"},{"code": "321271","name": "泰州医药高新技术产业开发区"},{"code": "321281","name": "兴化市"},{"code": "321282","name": "靖江市"},{"code": "321283","name": "泰兴市"}]},{"code": "3213","name": "宿迁市","children": [{"code": "321302","name": "宿城区"},{"code": "321311","name": "宿豫区"},{"code": "321322","name": "沭阳县"},{"code": "321323","name": "泗阳县"},{"code": "321324","name": "泗洪县"},{"code": "321371","name": "宿迁经济技术开发区"}]}]},{"code": "33","name": "浙江省","children": [{"code": "3301","name": "杭州市","children": [{"code": "330102","name": "上城区"},{"code": "330103","name": "下城区"},{"code": "330104","name": "江干区"},{"code": "330105","name": "拱墅区"},{"code": "330106","name": "西湖区"},{"code": "330108","name": "滨江区"},{"code": "330109","name": "萧山区"},{"code": "330110","name": "余杭区"},{"code": "330111","name": "富阳区"},{"code": "330112","name": "临安区"},{"code": "330122","name": "桐庐县"},{"code": "330127","name": "淳安县"},{"code": "330182","name": "建德市"}]},{"code": "3302","name": "宁波市","children": [{"code": "330203","name": "海曙区"},{"code": "330205","name": "江北区"},{"code": "330206","name": "北仑区"},{"code": "330211","name": "镇海区"},{"code": "330212","name": "鄞州区"},{"code": "330213","name": "奉化区"},{"code": "330225","name": "象山县"},{"code": "330226","name": "宁海县"},{"code": "330281","name": "余姚市"},{"code": "330282","name": "慈溪市"}]},{"code": "3303","name": "温州市","children": [{"code": "330302","name": "鹿城区"},{"code": "330303","name": "龙湾区"},{"code": "330304","name": "瓯海区"},{"code": "330305","name": "洞头区"},{"code": "330324","name": "永嘉县"},{"code": "330326","name": "平阳县"},{"code": "330327","name": "苍南县"},{"code": "330328","name": "文成县"},{"code": "330329","name": "泰顺县"},{"code": "330371","name": "温州经济技术开发区"},{"code": "330381","name": "瑞安市"},{"code": "330382","name": "乐清市"},{"code": "330383","name": "龙港市"}]},{"code": "3304","name": "嘉兴市","children": [{"code": "330402","name": "南湖区"},{"code": "330411","name": "秀洲区"},{"code": "330421","name": "嘉善县"},{"code": "330424","name": "海盐县"},{"code": "330481","name": "海宁市"},{"code": "330482","name": "平湖市"},{"code": "330483","name": "桐乡市"}]},{"code": "3305","name": "湖州市","children": [{"code": "330502","name": "吴兴区"},{"code": "330503","name": "南浔区"},{"code": "330521","name": "德清县"},{"code": "330522","name": "长兴县"},{"code": "330523","name": "安吉县"}]},{"code": "3306","name": "绍兴市","children": [{"code": "330602","name": "越城区"},{"code": "330603","name": "柯桥区"},{"code": "330604","name": "上虞区"},{"code": "330624","name": "新昌县"},{"code": "330681","name": "诸暨市"},{"code": "330683","name": "嵊州市"}]},{"code": "3307","name": "金华市","children": [{"code": "330702","name": "婺城区"},{"code": "330703","name": "金东区"},{"code": "330723","name": "武义县"},{"code": "330726","name": "浦江县"},{"code": "330727","name": "磐安县"},{"code": "330781","name": "兰溪市"},{"code": "330782","name": "义乌市"},{"code": "330783","name": "东阳市"},{"code": "330784","name": "永康市"}]},{"code": "3308","name": "衢州市","children": [{"code": "330802","name": "柯城区"},{"code": "330803","name": "衢江区"},{"code": "330822","name": "常山县"},{"code": "330824","name": "开化县"},{"code": "330825","name": "龙游县"},{"code": "330881","name": "江山市"}]},{"code": "3309","name": "舟山市","children": [{"code": "330902","name": "定海区"},{"code": "330903","name": "普陀区"},{"code": "330921","name": "岱山县"},{"code": "330922","name": "嵊泗县"}]},{"code": "3310","name": "台州市","children": [{"code": "331002","name": "椒江区"},{"code": "331003","name": "黄岩区"},{"code": "331004","name": "路桥区"},{"code": "331022","name": "三门县"},{"code": "331023","name": "天台县"},{"code": "331024","name": "仙居县"},{"code": "331081","name": "温岭市"},{"code": "331082","name": "临海市"},{"code": "331083","name": "玉环市"}]},{"code": "3311","name": "丽水市","children": [{"code": "331102","name": "莲都区"},{"code": "331121","name": "青田县"},{"code": "331122","name": "缙云县"},{"code": "331123","name": "遂昌县"},{"code": "331124","name": "松阳县"},{"code": "331125","name": "云和县"},{"code": "331126","name": "庆元县"},{"code": "331127","name": "景宁畲族自治县"},{"code": "331181","name": "龙泉市"}]}]},{"code": "34","name": "安徽省","children": [{"code": "3401","name": "合肥市","children": [{"code": "340102","name": "瑶海区"},{"code": "340103","name": "庐阳区"},{"code": "340104","name": "蜀山区"},{"code": "340111","name": "包河区"},{"code": "340121","name": "长丰县"},{"code": "340122","name": "肥东县"},{"code": "340123","name": "肥西县"},{"code": "340124","name": "庐江县"},{"code": "340171","name": "合肥高新技术产业开发区"},{"code": "340172","name": "合肥经济技术开发区"},{"code": "340173","name": "合肥新站高新技术产业开发区"},{"code": "340181","name": "巢湖市"}]},{"code": "3402","name": "芜湖市","children": [{"code": "340202","name": "镜湖区"},{"code": "340203","name": "弋江区"},{"code": "340207","name": "鸠江区"},{"code": "340208","name": "三山区"},{"code": "340221","name": "芜湖县"},{"code": "340222","name": "繁昌县"},{"code": "340223","name": "南陵县"},{"code": "340225","name": "无为县"},{"code": "340271","name": "芜湖经济技术开发区"},{"code": "340272","name": "安徽芜湖长江大桥经济开发区"}]},{"code": "3403","name": "蚌埠市","children": [{"code": "340302","name": "龙子湖区"},{"code": "340303","name": "蚌山区"},{"code": "340304","name": "禹会区"},{"code": "340311","name": "淮上区"},{"code": "340321","name": "怀远县"},{"code": "340322","name": "五河县"},{"code": "340323","name": "固镇县"},{"code": "340371","name": "蚌埠市高新技术开发区"},{"code": "340372","name": "蚌埠市经济开发区"}]},{"code": "3404","name": "淮南市","children": [{"code": "340402","name": "大通区"},{"code": "340403","name": "田家庵区"},{"code": "340404","name": "谢家集区"},{"code": "340405","name": "八公山区"},{"code": "340406","name": "潘集区"},{"code": "340421","name": "凤台县"},{"code": "340422","name": "寿县"}]},{"code": "3405","name": "马鞍山市","children": [{"code": "340503","name": "花山区"},{"code": "340504","name": "雨山区"},{"code": "340506","name": "博望区"},{"code": "340521","name": "当涂县"},{"code": "340522","name": "含山县"},{"code": "340523","name": "和县"}]},{"code": "3406","name": "淮北市","children": [{"code": "340602","name": "杜集区"},{"code": "340603","name": "相山区"},{"code": "340604","name": "烈山区"},{"code": "340621","name": "濉溪县"}]},{"code": "3407","name": "铜陵市","children": [{"code": "340705","name": "铜官区"},{"code": "340706","name": "义安区"},{"code": "340711","name": "郊区"},{"code": "340722","name": "枞阳县"}]},{"code": "3408","name": "安庆市","children": [{"code": "340802","name": "迎江区"},{"code": "340803","name": "大观区"},{"code": "340811","name": "宜秀区"},{"code": "340822","name": "怀宁县"},{"code": "340825","name": "太湖县"},{"code": "340826","name": "宿松县"},{"code": "340827","name": "望江县"},{"code": "340828","name": "岳西县"},{"code": "340871","name": "安徽安庆经济开发区"},{"code": "340881","name": "桐城市"},{"code": "340882","name": "潜山市"}]},{"code": "3410","name": "黄山市","children": [{"code": "341002","name": "屯溪区"},{"code": "341003","name": "黄山区"},{"code": "341004","name": "徽州区"},{"code": "341021","name": "歙县"},{"code": "341022","name": "休宁县"},{"code": "341023","name": "黟县"},{"code": "341024","name": "祁门县"}]},{"code": "3411","name": "滁州市","children": [{"code": "341102","name": "琅琊区"},{"code": "341103","name": "南谯区"},{"code": "341122","name": "来安县"},{"code": "341124","name": "全椒县"},{"code": "341125","name": "定远县"},{"code": "341126","name": "凤阳县"},{"code": "341171","name": "苏滁现代产业园"},{"code": "341172","name": "滁州经济技术开发区"},{"code": "341181","name": "天长市"},{"code": "341182","name": "明光市"}]},{"code": "3412","name": "阜阳市","children": [{"code": "341202","name": "颍州区"},{"code": "341203","name": "颍东区"},{"code": "341204","name": "颍泉区"},{"code": "341221","name": "临泉县"},{"code": "341222","name": "太和县"},{"code": "341225","name": "阜南县"},{"code": "341226","name": "颍上县"},{"code": "341271","name": "阜阳合肥现代产业园区"},{"code": "341272","name": "阜阳经济技术开发区"},{"code": "341282","name": "界首市"}]},{"code": "3413","name": "宿州市","children": [{"code": "341302","name": "埇桥区"},{"code": "341321","name": "砀山县"},{"code": "341322","name": "萧县"},{"code": "341323","name": "灵璧县"},{"code": "341324","name": "泗县"},{"code": "341371","name": "宿州马鞍山现代产业园区"},{"code": "341372","name": "宿州经济技术开发区"}]},{"code": "3415","name": "六安市","children": [{"code": "341502","name": "金安区"},{"code": "341503","name": "裕安区"},{"code": "341504","name": "叶集区"},{"code": "341522","name": "霍邱县"},{"code": "341523","name": "舒城县"},{"code": "341524","name": "金寨县"},{"code": "341525","name": "霍山县"}]},{"code": "3416","name": "亳州市","children": [{"code": "341602","name": "谯城区"},{"code": "341621","name": "涡阳县"},{"code": "341622","name": "蒙城县"},{"code": "341623","name": "利辛县"}]},{"code": "3417","name": "池州市","children": [{"code": "341702","name": "贵池区"},{"code": "341721","name": "东至县"},{"code": "341722","name": "石台县"},{"code": "341723","name": "青阳县"}]},{"code": "3418","name": "宣城市","children": [{"code": "341802","name": "宣州区"},{"code": "341821","name": "郎溪县"},{"code": "341823","name": "泾县"},{"code": "341824","name": "绩溪县"},{"code": "341825","name": "旌德县"},{"code": "341871","name": "宣城市经济开发区"},{"code": "341881","name": "宁国市"},{"code": "341882","name": "广德市"}]}]},{"code": "35","name": "福建省","children": [{"code": "3501","name": "福州市","children": [{"code": "350102","name": "鼓楼区"},{"code": "350103","name": "台江区"},{"code": "350104","name": "仓山区"},{"code": "350105","name": "马尾区"},{"code": "350111","name": "晋安区"},{"code": "350112","name": "长乐区"},{"code": "350121","name": "闽侯县"},{"code": "350122","name": "连江县"},{"code": "350123","name": "罗源县"},{"code": "350124","name": "闽清县"},{"code": "350125","name": "永泰县"},{"code": "350128","name": "平潭县"},{"code": "350181","name": "福清市"}]},{"code": "3502","name": "厦门市","children": [{"code": "350203","name": "思明区"},{"code": "350205","name": "海沧区"},{"code": "350206","name": "湖里区"},{"code": "350211","name": "集美区"},{"code": "350212","name": "同安区"},{"code": "350213","name": "翔安区"}]},{"code": "3503","name": "莆田市","children": [{"code": "350302","name": "城厢区"},{"code": "350303","name": "涵江区"},{"code": "350304","name": "荔城区"},{"code": "350305","name": "秀屿区"},{"code": "350322","name": "仙游县"}]},{"code": "3504","name": "三明市","children": [{"code": "350402","name": "梅列区"},{"code": "350403","name": "三元区"},{"code": "350421","name": "明溪县"},{"code": "350423","name": "清流县"},{"code": "350424","name": "宁化县"},{"code": "350425","name": "大田县"},{"code": "350426","name": "尤溪县"},{"code": "350427","name": "沙县"},{"code": "350428","name": "将乐县"},{"code": "350429","name": "泰宁县"},{"code": "350430","name": "建宁县"},{"code": "350481","name": "永安市"}]},{"code": "3505","name": "泉州市","children": [{"code": "350502","name": "鲤城区"},{"code": "350503","name": "丰泽区"},{"code": "350504","name": "洛江区"},{"code": "350505","name": "泉港区"},{"code": "350521","name": "惠安县"},{"code": "350524","name": "安溪县"},{"code": "350525","name": "永春县"},{"code": "350526","name": "德化县"},{"code": "350527","name": "金门县"},{"code": "350581","name": "石狮市"},{"code": "350582","name": "晋江市"},{"code": "350583","name": "南安市"}]},{"code": "3506","name": "漳州市","children": [{"code": "350602","name": "芗城区"},{"code": "350603","name": "龙文区"},{"code": "350622","name": "云霄县"},{"code": "350623","name": "漳浦县"},{"code": "350624","name": "诏安县"},{"code": "350625","name": "长泰县"},{"code": "350626","name": "东山县"},{"code": "350627","name": "南靖县"},{"code": "350628","name": "平和县"},{"code": "350629","name": "华安县"},{"code": "350681","name": "龙海市"}]},{"code": "3507","name": "南平市","children": [{"code": "350702","name": "延平区"},{"code": "350703","name": "建阳区"},{"code": "350721","name": "顺昌县"},{"code": "350722","name": "浦城县"},{"code": "350723","name": "光泽县"},{"code": "350724","name": "松溪县"},{"code": "350725","name": "政和县"},{"code": "350781","name": "邵武市"},{"code": "350782","name": "武夷山市"},{"code": "350783","name": "建瓯市"}]},{"code": "3508","name": "龙岩市","children": [{"code": "350802","name": "新罗区"},{"code": "350803","name": "永定区"},{"code": "350821","name": "长汀县"},{"code": "350823","name": "上杭县"},{"code": "350824","name": "武平县"},{"code": "350825","name": "连城县"},{"code": "350881","name": "漳平市"}]},{"code": "3509","name": "宁德市","children": [{"code": "350902","name": "蕉城区"},{"code": "350921","name": "霞浦县"},{"code": "350922","name": "古田县"},{"code": "350923","name": "屏南县"},{"code": "350924","name": "寿宁县"},{"code": "350925","name": "周宁县"},{"code": "350926","name": "柘荣县"},{"code": "350981","name": "福安市"},{"code": "350982","name": "福鼎市"}]}]},{"code": "36","name": "江西省","children": [{"code": "3601","name": "南昌市","children": [{"code": "360102","name": "东湖区"},{"code": "360103","name": "西湖区"},{"code": "360104","name": "青云谱区"},{"code": "360105","name": "湾里区"},{"code": "360111","name": "青山湖区"},{"code": "360112","name": "新建区"},{"code": "360121","name": "南昌县"},{"code": "360123","name": "安义县"},{"code": "360124","name": "进贤县"}]},{"code": "3602","name": "景德镇市","children": [{"code": "360202","name": "昌江区"},{"code": "360203","name": "珠山区"},{"code": "360222","name": "浮梁县"},{"code": "360281","name": "乐平市"}]},{"code": "3603","name": "萍乡市","children": [{"code": "360302","name": "安源区"},{"code": "360313","name": "湘东区"},{"code": "360321","name": "莲花县"},{"code": "360322","name": "上栗县"},{"code": "360323","name": "芦溪县"}]},{"code": "3604","name": "九江市","children": [{"code": "360402","name": "濂溪区"},{"code": "360403","name": "浔阳区"},{"code": "360404","name": "柴桑区"},{"code": "360423","name": "武宁县"},{"code": "360424","name": "修水县"},{"code": "360425","name": "永修县"},{"code": "360426","name": "德安县"},{"code": "360428","name": "都昌县"},{"code": "360429","name": "湖口县"},{"code": "360430","name": "彭泽县"},{"code": "360481","name": "瑞昌市"},{"code": "360482","name": "共青城市"},{"code": "360483","name": "庐山市"}]},{"code": "3605","name": "新余市","children": [{"code": "360502","name": "渝水区"},{"code": "360521","name": "分宜县"}]},{"code": "3606","name": "鹰潭市","children": [{"code": "360602","name": "月湖区"},{"code": "360603","name": "余江区"},{"code": "360681","name": "贵溪市"}]},{"code": "3607","name": "赣州市","children": [{"code": "360702","name": "章贡区"},{"code": "360703","name": "南康区"},{"code": "360704","name": "赣县区"},{"code": "360722","name": "信丰县"},{"code": "360723","name": "大余县"},{"code": "360724","name": "上犹县"},{"code": "360725","name": "崇义县"},{"code": "360726","name": "安远县"},{"code": "360727","name": "龙南县"},{"code": "360728","name": "定南县"},{"code": "360729","name": "全南县"},{"code": "360730","name": "宁都县"},{"code": "360731","name": "于都县"},{"code": "360732","name": "兴国县"},{"code": "360733","name": "会昌县"},{"code": "360734","name": "寻乌县"},{"code": "360735","name": "石城县"},{"code": "360781","name": "瑞金市"}]},{"code": "3608","name": "吉安市","children": [{"code": "360802","name": "吉州区"},{"code": "360803","name": "青原区"},{"code": "360821","name": "吉安县"},{"code": "360822","name": "吉水县"},{"code": "360823","name": "峡江县"},{"code": "360824","name": "新干县"},{"code": "360825","name": "永丰县"},{"code": "360826","name": "泰和县"},{"code": "360827","name": "遂川县"},{"code": "360828","name": "万安县"},{"code": "360829","name": "安福县"},{"code": "360830","name": "永新县"},{"code": "360881","name": "井冈山市"}]},{"code": "3609","name": "宜春市","children": [{"code": "360902","name": "袁州区"},{"code": "360921","name": "奉新县"},{"code": "360922","name": "万载县"},{"code": "360923","name": "上高县"},{"code": "360924","name": "宜丰县"},{"code": "360925","name": "靖安县"},{"code": "360926","name": "铜鼓县"},{"code": "360981","name": "丰城市"},{"code": "360982","name": "樟树市"},{"code": "360983","name": "高安市"}]},{"code": "3610","name": "抚州市","children": [{"code": "361002","name": "临川区"},{"code": "361003","name": "东乡区"},{"code": "361021","name": "南城县"},{"code": "361022","name": "黎川县"},{"code": "361023","name": "南丰县"},{"code": "361024","name": "崇仁县"},{"code": "361025","name": "乐安县"},{"code": "361026","name": "宜黄县"},{"code": "361027","name": "金溪县"},{"code": "361028","name": "资溪县"},{"code": "361030","name": "广昌县"}]},{"code": "3611","name": "上饶市","children": [{"code": "361102","name": "信州区"},{"code": "361103","name": "广丰区"},{"code": "361104","name": "广信区"},{"code": "361123","name": "玉山县"},{"code": "361124","name": "铅山县"},{"code": "361125","name": "横峰县"},{"code": "361126","name": "弋阳县"},{"code": "361127","name": "余干县"},{"code": "361128","name": "鄱阳县"},{"code": "361129","name": "万年县"},{"code": "361130","name": "婺源县"},{"code": "361181","name": "德兴市"}]}]},{"code": "37","name": "山东省","children": [{"code": "3701","name": "济南市","children": [{"code": "370102","name": "历下区"},{"code": "370103","name": "市中区"},{"code": "370104","name": "槐荫区"},{"code": "370105","name": "天桥区"},{"code": "370112","name": "历城区"},{"code": "370113","name": "长清区"},{"code": "370114","name": "章丘区"},{"code": "370115","name": "济阳区"},{"code": "370116","name": "莱芜区"},{"code": "370117","name": "钢城区"},{"code": "370124","name": "平阴县"},{"code": "370126","name": "商河县"},{"code": "370171","name": "济南高新技术产业开发区"}]},{"code": "3702","name": "青岛市","children": [{"code": "370202","name": "市南区"},{"code": "370203","name": "市北区"},{"code": "370211","name": "黄岛区"},{"code": "370212","name": "崂山区"},{"code": "370213","name": "李沧区"},{"code": "370214","name": "城阳区"},{"code": "370215","name": "即墨区"},{"code": "370271","name": "青岛高新技术产业开发区"},{"code": "370281","name": "胶州市"},{"code": "370283","name": "平度市"},{"code": "370285","name": "莱西市"}]},{"code": "3703","name": "淄博市","children": [{"code": "370302","name": "淄川区"},{"code": "370303","name": "张店区"},{"code": "370304","name": "博山区"},{"code": "370305","name": "临淄区"},{"code": "370306","name": "周村区"},{"code": "370321","name": "桓台县"},{"code": "370322","name": "高青县"},{"code": "370323","name": "沂源县"}]},{"code": "3704","name": "枣庄市","children": [{"code": "370402","name": "市中区"},{"code": "370403","name": "薛城区"},{"code": "370404","name": "峄城区"},{"code": "370405","name": "台儿庄区"},{"code": "370406","name": "山亭区"},{"code": "370481","name": "滕州市"}]},{"code": "3705","name": "东营市","children": [{"code": "370502","name": "东营区"},{"code": "370503","name": "河口区"},{"code": "370505","name": "垦利区"},{"code": "370522","name": "利津县"},{"code": "370523","name": "广饶县"},{"code": "370571","name": "东营经济技术开发区"},{"code": "370572","name": "东营港经济开发区"}]},{"code": "3706","name": "烟台市","children": [{"code": "370602","name": "芝罘区"},{"code": "370611","name": "福山区"},{"code": "370612","name": "牟平区"},{"code": "370613","name": "莱山区"},{"code": "370634","name": "长岛县"},{"code": "370671","name": "烟台高新技术产业开发区"},{"code": "370672","name": "烟台经济技术开发区"},{"code": "370681","name": "龙口市"},{"code": "370682","name": "莱阳市"},{"code": "370683","name": "莱州市"},{"code": "370684","name": "蓬莱市"},{"code": "370685","name": "招远市"},{"code": "370686","name": "栖霞市"},{"code": "370687","name": "海阳市"}]},{"code": "3707","name": "潍坊市","children": [{"code": "370702","name": "潍城区"},{"code": "370703","name": "寒亭区"},{"code": "370704","name": "坊子区"},{"code": "370705","name": "奎文区"},{"code": "370724","name": "临朐县"},{"code": "370725","name": "昌乐县"},{"code": "370772","name": "潍坊滨海经济技术开发区"},{"code": "370781","name": "青州市"},{"code": "370782","name": "诸城市"},{"code": "370783","name": "寿光市"},{"code": "370784","name": "安丘市"},{"code": "370785","name": "高密市"},{"code": "370786","name": "昌邑市"}]},{"code": "3708","name": "济宁市","children": [{"code": "370811","name": "任城区"},{"code": "370812","name": "兖州区"},{"code": "370826","name": "微山县"},{"code": "370827","name": "鱼台县"},{"code": "370828","name": "金乡县"},{"code": "370829","name": "嘉祥县"},{"code": "370830","name": "汶上县"},{"code": "370831","name": "泗水县"},{"code": "370832","name": "梁山县"},{"code": "370871","name": "济宁高新技术产业开发区"},{"code": "370881","name": "曲阜市"},{"code": "370883","name": "邹城市"}]},{"code": "3709","name": "泰安市","children": [{"code": "370902","name": "泰山区"},{"code": "370911","name": "岱岳区"},{"code": "370921","name": "宁阳县"},{"code": "370923","name": "东平县"},{"code": "370982","name": "新泰市"},{"code": "370983","name": "肥城市"}]},{"code": "3710","name": "威海市","children": [{"code": "371002","name": "环翠区"},{"code": "371003","name": "文登区"},{"code": "371071","name": "威海火炬高技术产业开发区"},{"code": "371072","name": "威海经济技术开发区"},{"code": "371073","name": "威海临港经济技术开发区"},{"code": "371082","name": "荣成市"},{"code": "371083","name": "乳山市"}]},{"code": "3711","name": "日照市","children": [{"code": "371102","name": "东港区"},{"code": "371103","name": "岚山区"},{"code": "371121","name": "五莲县"},{"code": "371122","name": "莒县"},{"code": "371171","name": "日照经济技术开发区"}]},{"code": "3713","name": "临沂市","children": [{"code": "371302","name": "兰山区"},{"code": "371311","name": "罗庄区"},{"code": "371312","name": "河东区"},{"code": "371321","name": "沂南县"},{"code": "371322","name": "郯城县"},{"code": "371323","name": "沂水县"},{"code": "371324","name": "兰陵县"},{"code": "371325","name": "费县"},{"code": "371326","name": "平邑县"},{"code": "371327","name": "莒南县"},{"code": "371328","name": "蒙阴县"},{"code": "371329","name": "临沭县"},{"code": "371371","name": "临沂高新技术产业开发区"},{"code": "371372","name": "临沂经济技术开发区"},{"code": "371373","name": "临沂临港经济开发区"}]},{"code": "3714","name": "德州市","children": [{"code": "371402","name": "德城区"},{"code": "371403","name": "陵城区"},{"code": "371422","name": "宁津县"},{"code": "371423","name": "庆云县"},{"code": "371424","name": "临邑县"},{"code": "371425","name": "齐河县"},{"code": "371426","name": "平原县"},{"code": "371427","name": "夏津县"},{"code": "371428","name": "武城县"},{"code": "371471","name": "德州经济技术开发区"},{"code": "371472","name": "德州运河经济开发区"},{"code": "371481","name": "乐陵市"},{"code": "371482","name": "禹城市"}]},{"code": "3715","name": "聊城市","children": [{"code": "371502","name": "东昌府区"},{"code": "371503","name": "茌平区"},{"code": "371521","name": "阳谷县"},{"code": "371522","name": "莘县"},{"code": "371524","name": "东阿县"},{"code": "371525","name": "冠县"},{"code": "371526","name": "高唐县"},{"code": "371581","name": "临清市"}]},{"code": "3716","name": "滨州市","children": [{"code": "371602","name": "滨城区"},{"code": "371603","name": "沾化区"},{"code": "371621","name": "惠民县"},{"code": "371622","name": "阳信县"},{"code": "371623","name": "无棣县"},{"code": "371625","name": "博兴县"},{"code": "371681","name": "邹平市"}]},{"code": "3717","name": "菏泽市","children": [{"code": "371702","name": "牡丹区"},{"code": "371703","name": "定陶区"},{"code": "371721","name": "曹县"},{"code": "371722","name": "单县"},{"code": "371723","name": "成武县"},{"code": "371724","name": "巨野县"},{"code": "371725","name": "郓城县"},{"code": "371726","name": "鄄城县"},{"code": "371728","name": "东明县"},{"code": "371771","name": "菏泽经济技术开发区"},{"code": "371772","name": "菏泽高新技术开发区"}]}]},{"code": "41","name": "河南省","children": [{"code": "4101","name": "郑州市","children": [{"code": "410102","name": "中原区"},{"code": "410103","name": "二七区"},{"code": "410104","name": "管城回族区"},{"code": "410105","name": "金水区"},{"code": "410106","name": "上街区"},{"code": "410108","name": "惠济区"},{"code": "410122","name": "中牟县"},{"code": "410171","name": "郑州经济技术开发区"},{"code": "410172","name": "郑州高新技术产业开发区"},{"code": "410173","name": "郑州航空港经济综合实验区"},{"code": "410181","name": "巩义市"},{"code": "410182","name": "荥阳市"},{"code": "410183","name": "新密市"},{"code": "410184","name": "新郑市"},{"code": "410185","name": "登封市"}]},{"code": "4102","name": "开封市","children": [{"code": "410202","name": "龙亭区"},{"code": "410203","name": "顺河回族区"},{"code": "410204","name": "鼓楼区"},{"code": "410205","name": "禹王台区"},{"code": "410212","name": "祥符区"},{"code": "410221","name": "杞县"},{"code": "410222","name": "通许县"},{"code": "410223","name": "尉氏县"},{"code": "410225","name": "兰考县"}]},{"code": "4103","name": "洛阳市","children": [{"code": "410302","name": "老城区"},{"code": "410303","name": "西工区"},{"code": "410304","name": "瀍河回族区"},{"code": "410305","name": "涧西区"},{"code": "410306","name": "吉利区"},{"code": "410311","name": "洛龙区"},{"code": "410322","name": "孟津县"},{"code": "410323","name": "新安县"},{"code": "410324","name": "栾川县"},{"code": "410325","name": "嵩县"},{"code": "410326","name": "汝阳县"},{"code": "410327","name": "宜阳县"},{"code": "410328","name": "洛宁县"},{"code": "410329","name": "伊川县"},{"code": "410371","name": "洛阳高新技术产业开发区"},{"code": "410381","name": "偃师市"}]},{"code": "4104","name": "平顶山市","children": [{"code": "410402","name": "新华区"},{"code": "410403","name": "卫东区"},{"code": "410404","name": "石龙区"},{"code": "410411","name": "湛河区"},{"code": "410421","name": "宝丰县"},{"code": "410422","name": "叶县"},{"code": "410423","name": "鲁山县"},{"code": "410425","name": "郏县"},{"code": "410471","name": "平顶山高新技术产业开发区"},{"code": "410472","name": "平顶山市城乡一体化示范区"},{"code": "410481","name": "舞钢市"},{"code": "410482","name": "汝州市"}]},{"code": "4105","name": "安阳市","children": [{"code": "410502","name": "文峰区"},{"code": "410503","name": "北关区"},{"code": "410505","name": "殷都区"},{"code": "410506","name": "龙安区"},{"code": "410522","name": "安阳县"},{"code": "410523","name": "汤阴县"},{"code": "410526","name": "滑县"},{"code": "410527","name": "内黄县"},{"code": "410571","name": "安阳高新技术产业开发区"},{"code": "410581","name": "林州市"}]},{"code": "4106","name": "鹤壁市","children": [{"code": "410602","name": "鹤山区"},{"code": "410603","name": "山城区"},{"code": "410611","name": "淇滨区"},{"code": "410621","name": "浚县"},{"code": "410622","name": "淇县"},{"code": "410671","name": "鹤壁经济技术开发区"}]},{"code": "4107","name": "新乡市","children": [{"code": "410702","name": "红旗区"},{"code": "410703","name": "卫滨区"},{"code": "410704","name": "凤泉区"},{"code": "410711","name": "牧野区"},{"code": "410721","name": "新乡县"},{"code": "410724","name": "获嘉县"},{"code": "410725","name": "原阳县"},{"code": "410726","name": "延津县"},{"code": "410727","name": "封丘县"},{"code": "410771","name": "新乡高新技术产业开发区"},{"code": "410772","name": "新乡经济技术开发区"},{"code": "410773","name": "新乡市平原城乡一体化示范区"},{"code": "410781","name": "卫辉市"},{"code": "410782","name": "辉县市"},{"code": "410783","name": "长垣市"}]},{"code": "4108","name": "焦作市","children": [{"code": "410802","name": "解放区"},{"code": "410803","name": "中站区"},{"code": "410804","name": "马村区"},{"code": "410811","name": "山阳区"},{"code": "410821","name": "修武县"},{"code": "410822","name": "博爱县"},{"code": "410823","name": "武陟县"},{"code": "410825","name": "温县"},{"code": "410871","name": "焦作城乡一体化示范区"},{"code": "410882","name": "沁阳市"},{"code": "410883","name": "孟州市"}]},{"code": "4109","name": "濮阳市","children": [{"code": "410902","name": "华龙区"},{"code": "410922","name": "清丰县"},{"code": "410923","name": "南乐县"},{"code": "410926","name": "范县"},{"code": "410927","name": "台前县"},{"code": "410928","name": "濮阳县"},{"code": "410971","name": "河南濮阳工业园区"},{"code": "410972","name": "濮阳经济技术开发区"}]},{"code": "4110","name": "许昌市","children": [{"code": "411002","name": "魏都区"},{"code": "411003","name": "建安区"},{"code": "411024","name": "鄢陵县"},{"code": "411025","name": "襄城县"},{"code": "411071","name": "许昌经济技术开发区"},{"code": "411081","name": "禹州市"},{"code": "411082","name": "长葛市"}]},{"code": "4111","name": "漯河市","children": [{"code": "411102","name": "源汇区"},{"code": "411103","name": "郾城区"},{"code": "411104","name": "召陵区"},{"code": "411121","name": "舞阳县"},{"code": "411122","name": "临颍县"},{"code": "411171","name": "漯河经济技术开发区"}]},{"code": "4112","name": "三门峡市","children": [{"code": "411202","name": "湖滨区"},{"code": "411203","name": "陕州区"},{"code": "411221","name": "渑池县"},{"code": "411224","name": "卢氏县"},{"code": "411271","name": "河南三门峡经济开发区"},{"code": "411281","name": "义马市"},{"code": "411282","name": "灵宝市"}]},{"code": "4113","name": "南阳市","children": [{"code": "411302","name": "宛城区"},{"code": "411303","name": "卧龙区"},{"code": "411321","name": "南召县"},{"code": "411322","name": "方城县"},{"code": "411323","name": "西峡县"},{"code": "411324","name": "镇平县"},{"code": "411325","name": "内乡县"},{"code": "411326","name": "淅川县"},{"code": "411327","name": "社旗县"},{"code": "411328","name": "唐河县"},{"code": "411329","name": "新野县"},{"code": "411330","name": "桐柏县"},{"code": "411371","name": "南阳高新技术产业开发区"},{"code": "411372","name": "南阳市城乡一体化示范区"},{"code": "411381","name": "邓州市"}]},{"code": "4114","name": "商丘市","children": [{"code": "411402","name": "梁园区"},{"code": "411403","name": "睢阳区"},{"code": "411421","name": "民权县"},{"code": "411422","name": "睢县"},{"code": "411423","name": "宁陵县"},{"code": "411424","name": "柘城县"},{"code": "411425","name": "虞城县"},{"code": "411426","name": "夏邑县"},{"code": "411471","name": "豫东综合物流产业聚集区"},{"code": "411472","name": "河南商丘经济开发区"},{"code": "411481","name": "永城市"}]},{"code": "4115","name": "信阳市","children": [{"code": "411502","name": "浉河区"},{"code": "411503","name": "平桥区"},{"code": "411521","name": "罗山县"},{"code": "411522","name": "光山县"},{"code": "411523","name": "新县"},{"code": "411524","name": "商城县"},{"code": "411525","name": "固始县"},{"code": "411526","name": "潢川县"},{"code": "411527","name": "淮滨县"},{"code": "411528","name": "息县"},{"code": "411571","name": "信阳高新技术产业开发区"}]},{"code": "4116","name": "周口市","children": [{"code": "411602","name": "川汇区"},{"code": "411603","name": "淮阳区"},{"code": "411621","name": "扶沟县"},{"code": "411622","name": "西华县"},{"code": "411623","name": "商水县"},{"code": "411624","name": "沈丘县"},{"code": "411625","name": "郸城县"},{"code": "411627","name": "太康县"},{"code": "411628","name": "鹿邑县"},{"code": "411671","name": "河南周口经济开发区"},{"code": "411681","name": "项城市"}]},{"code": "4117","name": "驻马店市","children": [{"code": "411702","name": "驿城区"},{"code": "411721","name": "西平县"},{"code": "411722","name": "上蔡县"},{"code": "411723","name": "平舆县"},{"code": "411724","name": "正阳县"},{"code": "411725","name": "确山县"},{"code": "411726","name": "泌阳县"},{"code": "411727","name": "汝南县"},{"code": "411728","name": "遂平县"},{"code": "411729","name": "新蔡县"},{"code": "411771","name": "河南驻马店经济开发区"}]},{"code": "4190","name": "省直辖县级行政区划","children": [{"code": "419001","name": "济源市"}]}]},{"code": "42","name": "湖北省","children": [{"code": "4201","name": "武汉市","children": [{"code": "420102","name": "江岸区"},{"code": "420103","name": "江汉区"},{"code": "420104","name": "硚口区"},{"code": "420105","name": "汉阳区"},{"code": "420106","name": "武昌区"},{"code": "420107","name": "青山区"},{"code": "420111","name": "洪山区"},{"code": "420112","name": "东西湖区"},{"code": "420113","name": "汉南区"},{"code": "420114","name": "蔡甸区"},{"code": "420115","name": "江夏区"},{"code": "420116","name": "黄陂区"},{"code": "420117","name": "新洲区"}]},{"code": "4202","name": "黄石市","children": [{"code": "420202","name": "黄石港区"},{"code": "420203","name": "西塞山区"},{"code": "420204","name": "下陆区"},{"code": "420205","name": "铁山区"},{"code": "420222","name": "阳新县"},{"code": "420281","name": "大冶市"}]},{"code": "4203","name": "十堰市","children": [{"code": "420302","name": "茅箭区"},{"code": "420303","name": "张湾区"},{"code": "420304","name": "郧阳区"},{"code": "420322","name": "郧西县"},{"code": "420323","name": "竹山县"},{"code": "420324","name": "竹溪县"},{"code": "420325","name": "房县"},{"code": "420381","name": "丹江口市"}]},{"code": "4205","name": "宜昌市","children": [{"code": "420502","name": "西陵区"},{"code": "420503","name": "伍家岗区"},{"code": "420504","name": "点军区"},{"code": "420505","name": "猇亭区"},{"code": "420506","name": "夷陵区"},{"code": "420525","name": "远安县"},{"code": "420526","name": "兴山县"},{"code": "420527","name": "秭归县"},{"code": "420528","name": "长阳土家族自治县"},{"code": "420529","name": "五峰土家族自治县"},{"code": "420581","name": "宜都市"},{"code": "420582","name": "当阳市"},{"code": "420583","name": "枝江市"}]},{"code": "4206","name": "襄阳市","children": [{"code": "420602","name": "襄城区"},{"code": "420606","name": "樊城区"},{"code": "420607","name": "襄州区"},{"code": "420624","name": "南漳县"},{"code": "420625","name": "谷城县"},{"code": "420626","name": "保康县"},{"code": "420682","name": "老河口市"},{"code": "420683","name": "枣阳市"},{"code": "420684","name": "宜城市"}]},{"code": "4207","name": "鄂州市","children": [{"code": "420702","name": "梁子湖区"},{"code": "420703","name": "华容区"},{"code": "420704","name": "鄂城区"}]},{"code": "4208","name": "荆门市","children": [{"code": "420802","name": "东宝区"},{"code": "420804","name": "掇刀区"},{"code": "420822","name": "沙洋县"},{"code": "420881","name": "钟祥市"},{"code": "420882","name": "京山市"}]},{"code": "4209","name": "孝感市","children": [{"code": "420902","name": "孝南区"},{"code": "420921","name": "孝昌县"},{"code": "420922","name": "大悟县"},{"code": "420923","name": "云梦县"},{"code": "420981","name": "应城市"},{"code": "420982","name": "安陆市"},{"code": "420984","name": "汉川市"}]},{"code": "4210","name": "荆州市","children": [{"code": "421002","name": "沙市区"},{"code": "421003","name": "荆州区"},{"code": "421022","name": "公安县"},{"code": "421023","name": "监利县"},{"code": "421024","name": "江陵县"},{"code": "421071","name": "荆州经济技术开发区"},{"code": "421081","name": "石首市"},{"code": "421083","name": "洪湖市"},{"code": "421087","name": "松滋市"}]},{"code": "4211","name": "黄冈市","children": [{"code": "421102","name": "黄州区"},{"code": "421121","name": "团风县"},{"code": "421122","name": "红安县"},{"code": "421123","name": "罗田县"},{"code": "421124","name": "英山县"},{"code": "421125","name": "浠水县"},{"code": "421126","name": "蕲春县"},{"code": "421127","name": "黄梅县"},{"code": "421171","name": "龙感湖管理区"},{"code": "421181","name": "麻城市"},{"code": "421182","name": "武穴市"}]},{"code": "4212","name": "咸宁市","children": [{"code": "421202","name": "咸安区"},{"code": "421221","name": "嘉鱼县"},{"code": "421222","name": "通城县"},{"code": "421223","name": "崇阳县"},{"code": "421224","name": "通山县"},{"code": "421281","name": "赤壁市"}]},{"code": "4213","name": "随州市","children": [{"code": "421303","name": "曾都区"},{"code": "421321","name": "随县"},{"code": "421381","name": "广水市"}]},{"code": "4228","name": "恩施土家族苗族自治州","children": [{"code": "422801","name": "恩施市"},{"code": "422802","name": "利川市"},{"code": "422822","name": "建始县"},{"code": "422823","name": "巴东县"},{"code": "422825","name": "宣恩县"},{"code": "422826","name": "咸丰县"},{"code": "422827","name": "来凤县"},{"code": "422828","name": "鹤峰县"}]},{"code": "4290","name": "省直辖县级行政区划","children": [{"code": "429004","name": "仙桃市"},{"code": "429005","name": "潜江市"},{"code": "429006","name": "天门市"},{"code": "429021","name": "神农架林区"}]}]},{"code": "43","name": "湖南省","children": [{"code": "4301","name": "长沙市","children": [{"code": "430102","name": "芙蓉区"},{"code": "430103","name": "天心区"},{"code": "430104","name": "岳麓区"},{"code": "430105","name": "开福区"},{"code": "430111","name": "雨花区"},{"code": "430112","name": "望城区"},{"code": "430121","name": "长沙县"},{"code": "430181","name": "浏阳市"},{"code": "430182","name": "宁乡市"}]},{"code": "4302","name": "株洲市","children": [{"code": "430202","name": "荷塘区"},{"code": "430203","name": "芦淞区"},{"code": "430204","name": "石峰区"},{"code": "430211","name": "天元区"},{"code": "430212","name": "渌口区"},{"code": "430223","name": "攸县"},{"code": "430224","name": "茶陵县"},{"code": "430225","name": "炎陵县"},{"code": "430271","name": "云龙示范区"},{"code": "430281","name": "醴陵市"}]},{"code": "4303","name": "湘潭市","children": [{"code": "430302","name": "雨湖区"},{"code": "430304","name": "岳塘区"},{"code": "430321","name": "湘潭县"},{"code": "430371","name": "湖南湘潭高新技术产业园区"},{"code": "430372","name": "湘潭昭山示范区"},{"code": "430373","name": "湘潭九华示范区"},{"code": "430381","name": "湘乡市"},{"code": "430382","name": "韶山市"}]},{"code": "4304","name": "衡阳市","children": [{"code": "430405","name": "珠晖区"},{"code": "430406","name": "雁峰区"},{"code": "430407","name": "石鼓区"},{"code": "430408","name": "蒸湘区"},{"code": "430412","name": "南岳区"},{"code": "430421","name": "衡阳县"},{"code": "430422","name": "衡南县"},{"code": "430423","name": "衡山县"},{"code": "430424","name": "衡东县"},{"code": "430426","name": "祁东县"},{"code": "430471","name": "衡阳综合保税区"},{"code": "430472","name": "湖南衡阳高新技术产业园区"},{"code": "430473","name": "湖南衡阳松木经济开发区"},{"code": "430481","name": "耒阳市"},{"code": "430482","name": "常宁市"}]},{"code": "4305","name": "邵阳市","children": [{"code": "430502","name": "双清区"},{"code": "430503","name": "大祥区"},{"code": "430511","name": "北塔区"},{"code": "430522","name": "新邵县"},{"code": "430523","name": "邵阳县"},{"code": "430524","name": "隆回县"},{"code": "430525","name": "洞口县"},{"code": "430527","name": "绥宁县"},{"code": "430528","name": "新宁县"},{"code": "430529","name": "城步苗族自治县"},{"code": "430581","name": "武冈市"},{"code": "430582","name": "邵东市"}]},{"code": "4306","name": "岳阳市","children": [{"code": "430602","name": "岳阳楼区"},{"code": "430603","name": "云溪区"},{"code": "430611","name": "君山区"},{"code": "430621","name": "岳阳县"},{"code": "430623","name": "华容县"},{"code": "430624","name": "湘阴县"},{"code": "430626","name": "平江县"},{"code": "430671","name": "岳阳市屈原管理区"},{"code": "430681","name": "汨罗市"},{"code": "430682","name": "临湘市"}]},{"code": "4307","name": "常德市","children": [{"code": "430702","name": "武陵区"},{"code": "430703","name": "鼎城区"},{"code": "430721","name": "安乡县"},{"code": "430722","name": "汉寿县"},{"code": "430723","name": "澧县"},{"code": "430724","name": "临澧县"},{"code": "430725","name": "桃源县"},{"code": "430726","name": "石门县"},{"code": "430771","name": "常德市西洞庭管理区"},{"code": "430781","name": "津市市"}]},{"code": "4308","name": "张家界市","children": [{"code": "430802","name": "永定区"},{"code": "430811","name": "武陵源区"},{"code": "430821","name": "慈利县"},{"code": "430822","name": "桑植县"}]},{"code": "4309","name": "益阳市","children": [{"code": "430902","name": "资阳区"},{"code": "430903","name": "赫山区"},{"code": "430921","name": "南县"},{"code": "430922","name": "桃江县"},{"code": "430923","name": "安化县"},{"code": "430971","name": "益阳市大通湖管理区"},{"code": "430972","name": "湖南益阳高新技术产业园区"},{"code": "430981","name": "沅江市"}]},{"code": "4310","name": "郴州市","children": [{"code": "431002","name": "北湖区"},{"code": "431003","name": "苏仙区"},{"code": "431021","name": "桂阳县"},{"code": "431022","name": "宜章县"},{"code": "431023","name": "永兴县"},{"code": "431024","name": "嘉禾县"},{"code": "431025","name": "临武县"},{"code": "431026","name": "汝城县"},{"code": "431027","name": "桂东县"},{"code": "431028","name": "安仁县"},{"code": "431081","name": "资兴市"}]},{"code": "4311","name": "永州市","children": [{"code": "431102","name": "零陵区"},{"code": "431103","name": "冷水滩区"},{"code": "431121","name": "祁阳县"},{"code": "431122","name": "东安县"},{"code": "431123","name": "双牌县"},{"code": "431124","name": "道县"},{"code": "431125","name": "江永县"},{"code": "431126","name": "宁远县"},{"code": "431127","name": "蓝山县"},{"code": "431128","name": "新田县"},{"code": "431129","name": "江华瑶族自治县"},{"code": "431171","name": "永州经济技术开发区"},{"code": "431172","name": "永州市金洞管理区"},{"code": "431173","name": "永州市回龙圩管理区"}]},{"code": "4312","name": "怀化市","children": [{"code": "431202","name": "鹤城区"},{"code": "431221","name": "中方县"},{"code": "431222","name": "沅陵县"},{"code": "431223","name": "辰溪县"},{"code": "431224","name": "溆浦县"},{"code": "431225","name": "会同县"},{"code": "431226","name": "麻阳苗族自治县"},{"code": "431227","name": "新晃侗族自治县"},{"code": "431228","name": "芷江侗族自治县"},{"code": "431229","name": "靖州苗族侗族自治县"},{"code": "431230","name": "通道侗族自治县"},{"code": "431271","name": "怀化市洪江管理区"},{"code": "431281","name": "洪江市"}]},{"code": "4313","name": "娄底市","children": [{"code": "431302","name": "娄星区"},{"code": "431321","name": "双峰县"},{"code": "431322","name": "新化县"},{"code": "431381","name": "冷水江市"},{"code": "431382","name": "涟源市"}]},{"code": "4331","name": "湘西土家族苗族自治州","children": [{"code": "433101","name": "吉首市"},{"code": "433122","name": "泸溪县"},{"code": "433123","name": "凤凰县"},{"code": "433124","name": "花垣县"},{"code": "433125","name": "保靖县"},{"code": "433126","name": "古丈县"},{"code": "433127","name": "永顺县"},{"code": "433130","name": "龙山县"},{"code": "433173","name": "湖南永顺经济开发区"}]}]},{"code": "44","name": "广东省","children": [{"code": "4401","name": "广州市","children": [{"code": "440103","name": "荔湾区"},{"code": "440104","name": "越秀区"},{"code": "440105","name": "海珠区"},{"code": "440106","name": "天河区"},{"code": "440111","name": "白云区"},{"code": "440112","name": "黄埔区"},{"code": "440113","name": "番禺区"},{"code": "440114","name": "花都区"},{"code": "440115","name": "南沙区"},{"code": "440117","name": "从化区"},{"code": "440118","name": "增城区"}]},{"code": "4402","name": "韶关市","children": [{"code": "440203","name": "武江区"},{"code": "440204","name": "浈江区"},{"code": "440205","name": "曲江区"},{"code": "440222","name": "始兴县"},{"code": "440224","name": "仁化县"},{"code": "440229","name": "翁源县"},{"code": "440232","name": "乳源瑶族自治县"},{"code": "440233","name": "新丰县"},{"code": "440281","name": "乐昌市"},{"code": "440282","name": "南雄市"}]},{"code": "4403","name": "深圳市","children": [{"code": "440303","name": "罗湖区"},{"code": "440304","name": "福田区"},{"code": "440305","name": "南山区"},{"code": "440306","name": "宝安区"},{"code": "440307","name": "龙岗区"},{"code": "440308","name": "盐田区"},{"code": "440309","name": "龙华区"},{"code": "440310","name": "坪山区"},{"code": "440311","name": "光明区"}]},{"code": "4404","name": "珠海市","children": [{"code": "440402","name": "香洲区"},{"code": "440403","name": "斗门区"},{"code": "440404","name": "金湾区"}]},{"code": "4405","name": "汕头市","children": [{"code": "440507","name": "龙湖区"},{"code": "440511","name": "金平区"},{"code": "440512","name": "濠江区"},{"code": "440513","name": "潮阳区"},{"code": "440514","name": "潮南区"},{"code": "440515","name": "澄海区"},{"code": "440523","name": "南澳县"}]},{"code": "4406","name": "佛山市","children": [{"code": "440604","name": "禅城区"},{"code": "440605","name": "南海区"},{"code": "440606","name": "顺德区"},{"code": "440607","name": "三水区"},{"code": "440608","name": "高明区"}]},{"code": "4407","name": "江门市","children": [{"code": "440703","name": "蓬江区"},{"code": "440704","name": "江海区"},{"code": "440705","name": "新会区"},{"code": "440781","name": "台山市"},{"code": "440783","name": "开平市"},{"code": "440784","name": "鹤山市"},{"code": "440785","name": "恩平市"}]},{"code": "4408","name": "湛江市","children": [{"code": "440802","name": "赤坎区"},{"code": "440803","name": "霞山区"},{"code": "440804","name": "坡头区"},{"code": "440811","name": "麻章区"},{"code": "440823","name": "遂溪县"},{"code": "440825","name": "徐闻县"},{"code": "440881","name": "廉江市"},{"code": "440882","name": "雷州市"},{"code": "440883","name": "吴川市"}]},{"code": "4409","name": "茂名市","children": [{"code": "440902","name": "茂南区"},{"code": "440904","name": "电白区"},{"code": "440981","name": "高州市"},{"code": "440982","name": "化州市"},{"code": "440983","name": "信宜市"}]},{"code": "4412","name": "肇庆市","children": [{"code": "441202","name": "端州区"},{"code": "441203","name": "鼎湖区"},{"code": "441204","name": "高要区"},{"code": "441223","name": "广宁县"},{"code": "441224","name": "怀集县"},{"code": "441225","name": "封开县"},{"code": "441226","name": "德庆县"},{"code": "441284","name": "四会市"}]},{"code": "4413","name": "惠州市","children": [{"code": "441302","name": "惠城区"},{"code": "441303","name": "惠阳区"},{"code": "441322","name": "博罗县"},{"code": "441323","name": "惠东县"},{"code": "441324","name": "龙门县"}]},{"code": "4414","name": "梅州市","children": [{"code": "441402","name": "梅江区"},{"code": "441403","name": "梅县区"},{"code": "441422","name": "大埔县"},{"code": "441423","name": "丰顺县"},{"code": "441424","name": "五华县"},{"code": "441426","name": "平远县"},{"code": "441427","name": "蕉岭县"},{"code": "441481","name": "兴宁市"}]},{"code": "4415","name": "汕尾市","children": [{"code": "441502","name": "城区"},{"code": "441521","name": "海丰县"},{"code": "441523","name": "陆河县"},{"code": "441581","name": "陆丰市"}]},{"code": "4416","name": "河源市","children": [{"code": "441602","name": "源城区"},{"code": "441621","name": "紫金县"},{"code": "441622","name": "龙川县"},{"code": "441623","name": "连平县"},{"code": "441624","name": "和平县"},{"code": "441625","name": "东源县"}]},{"code": "4417","name": "阳江市","children": [{"code": "441702","name": "江城区"},{"code": "441704","name": "阳东区"},{"code": "441721","name": "阳西县"},{"code": "441781","name": "阳春市"}]},{"code": "4418","name": "清远市","children": [{"code": "441802","name": "清城区"},{"code": "441803","name": "清新区"},{"code": "441821","name": "佛冈县"},{"code": "441823","name": "阳山县"},{"code": "441825","name": "连山壮族瑶族自治县"},{"code": "441826","name": "连南瑶族自治县"},{"code": "441881","name": "英德市"},{"code": "441882","name": "连州市"}]},{"code": "4419","name": "东莞市","children": [{"code": "441900003","name": "东城街道"},{"code": "441900004","name": "南城街道"},{"code": "441900005","name": "万江街道"},{"code": "441900006","name": "莞城街道"},{"code": "441900101","name": "石碣镇"},{"code": "441900102","name": "石龙镇"},{"code": "441900103","name": "茶山镇"},{"code": "441900104","name": "石排镇"},{"code": "441900105","name": "企石镇"},{"code": "441900106","name": "横沥镇"},{"code": "441900107","name": "桥头镇"},{"code": "441900108","name": "谢岗镇"},{"code": "441900109","name": "东坑镇"},{"code": "441900110","name": "常平镇"},{"code": "441900111","name": "寮步镇"},{"code": "441900112","name": "樟木头镇"},{"code": "441900113","name": "大朗镇"},{"code": "441900114","name": "黄江镇"},{"code": "441900115","name": "清溪镇"},{"code": "441900116","name": "塘厦镇"},{"code": "441900117","name": "凤岗镇"},{"code": "441900118","name": "大岭山镇"},{"code": "441900119","name": "长安镇"},{"code": "441900121","name": "虎门镇"},{"code": "441900122","name": "厚街镇"},{"code": "441900123","name": "沙田镇"},{"code": "441900124","name": "道滘镇"},{"code": "441900125","name": "洪梅镇"},{"code": "441900126","name": "麻涌镇"},{"code": "441900127","name": "望牛墩镇"},{"code": "441900128","name": "中堂镇"},{"code": "441900129","name": "高埗镇"},{"code": "441900401","name": "松山湖"},{"code": "441900402","name": "东莞港"},{"code": "441900403","name": "东莞生态园"}]},{"code": "4420","name": "中山市","children": [{"code": "442000001","name": "石岐街道"},{"code": "442000002","name": "东区街道"},{"code": "442000003","name": "中山港街道"},{"code": "442000004","name": "西区街道"},{"code": "442000005","name": "南区街道"},{"code": "442000006","name": "五桂山街道"},{"code": "442000100","name": "小榄镇"},{"code": "442000101","name": "黄圃镇"},{"code": "442000102","name": "民众镇"},{"code": "442000103","name": "东凤镇"},{"code": "442000104","name": "东升镇"},{"code": "442000105","name": "古镇镇"},{"code": "442000106","name": "沙溪镇"},{"code": "442000107","name": "坦洲镇"},{"code": "442000108","name": "港口镇"},{"code": "442000109","name": "三角镇"},{"code": "442000110","name": "横栏镇"},{"code": "442000111","name": "南头镇"},{"code": "442000112","name": "阜沙镇"},{"code": "442000113","name": "南朗镇"},{"code": "442000114","name": "三乡镇"},{"code": "442000115","name": "板芙镇"},{"code": "442000116","name": "大涌镇"},{"code": "442000117","name": "神湾镇"}]},{"code": "4451","name": "潮州市","children": [{"code": "445102","name": "湘桥区"},{"code": "445103","name": "潮安区"},{"code": "445122","name": "饶平县"}]},{"code": "4452","name": "揭阳市","children": [{"code": "445202","name": "榕城区"},{"code": "445203","name": "揭东区"},{"code": "445222","name": "揭西县"},{"code": "445224","name": "惠来县"},{"code": "445281","name": "普宁市"}]},{"code": "4453","name": "云浮市","children": [{"code": "445302","name": "云城区"},{"code": "445303","name": "云安区"},{"code": "445321","name": "新兴县"},{"code": "445322","name": "郁南县"},{"code": "445381","name": "罗定市"}]}]},{"code": "45","name": "广西壮族自治区","children": [{"code": "4501","name": "南宁市","children": [{"code": "450102","name": "兴宁区"},{"code": "450103","name": "青秀区"},{"code": "450105","name": "江南区"},{"code": "450107","name": "西乡塘区"},{"code": "450108","name": "良庆区"},{"code": "450109","name": "邕宁区"},{"code": "450110","name": "武鸣区"},{"code": "450123","name": "隆安县"},{"code": "450124","name": "马山县"},{"code": "450125","name": "上林县"},{"code": "450126","name": "宾阳县"},{"code": "450127","name": "横县"}]},{"code": "4502","name": "柳州市","children": [{"code": "450202","name": "城中区"},{"code": "450203","name": "鱼峰区"},{"code": "450204","name": "柳南区"},{"code": "450205","name": "柳北区"},{"code": "450206","name": "柳江区"},{"code": "450222","name": "柳城县"},{"code": "450223","name": "鹿寨县"},{"code": "450224","name": "融安县"},{"code": "450225","name": "融水苗族自治县"},{"code": "450226","name": "三江侗族自治县"}]},{"code": "4503","name": "桂林市","children": [{"code": "450302","name": "秀峰区"},{"code": "450303","name": "叠彩区"},{"code": "450304","name": "象山区"},{"code": "450305","name": "七星区"},{"code": "450311","name": "雁山区"},{"code": "450312","name": "临桂区"},{"code": "450321","name": "阳朔县"},{"code": "450323","name": "灵川县"},{"code": "450324","name": "全州县"},{"code": "450325","name": "兴安县"},{"code": "450326","name": "永福县"},{"code": "450327","name": "灌阳县"},{"code": "450328","name": "龙胜各族自治县"},{"code": "450329","name": "资源县"},{"code": "450330","name": "平乐县"},{"code": "450332","name": "恭城瑶族自治县"},{"code": "450381","name": "荔浦市"}]},{"code": "4504","name": "梧州市","children": [{"code": "450403","name": "万秀区"},{"code": "450405","name": "长洲区"},{"code": "450406","name": "龙圩区"},{"code": "450421","name": "苍梧县"},{"code": "450422","name": "藤县"},{"code": "450423","name": "蒙山县"},{"code": "450481","name": "岑溪市"}]},{"code": "4505","name": "北海市","children": [{"code": "450502","name": "海城区"},{"code": "450503","name": "银海区"},{"code": "450512","name": "铁山港区"},{"code": "450521","name": "合浦县"}]},{"code": "4506","name": "防城港市","children": [{"code": "450602","name": "港口区"},{"code": "450603","name": "防城区"},{"code": "450621","name": "上思县"},{"code": "450681","name": "东兴市"}]},{"code": "4507","name": "钦州市","children": [{"code": "450702","name": "钦南区"},{"code": "450703","name": "钦北区"},{"code": "450721","name": "灵山县"},{"code": "450722","name": "浦北县"}]},{"code": "4508","name": "贵港市","children": [{"code": "450802","name": "港北区"},{"code": "450803","name": "港南区"},{"code": "450804","name": "覃塘区"},{"code": "450821","name": "平南县"},{"code": "450881","name": "桂平市"}]},{"code": "4509","name": "玉林市","children": [{"code": "450902","name": "玉州区"},{"code": "450903","name": "福绵区"},{"code": "450921","name": "容县"},{"code": "450922","name": "陆川县"},{"code": "450923","name": "博白县"},{"code": "450924","name": "兴业县"},{"code": "450981","name": "北流市"}]},{"code": "4510","name": "百色市","children": [{"code": "451002","name": "右江区"},{"code": "451003","name": "田阳区"},{"code": "451022","name": "田东县"},{"code": "451023","name": "平果县"},{"code": "451024","name": "德保县"},{"code": "451026","name": "那坡县"},{"code": "451027","name": "凌云县"},{"code": "451028","name": "乐业县"},{"code": "451029","name": "田林县"},{"code": "451030","name": "西林县"},{"code": "451031","name": "隆林各族自治县"},{"code": "451081","name": "靖西市"}]},{"code": "4511","name": "贺州市","children": [{"code": "451102","name": "八步区"},{"code": "451103","name": "平桂区"},{"code": "451121","name": "昭平县"},{"code": "451122","name": "钟山县"},{"code": "451123","name": "富川瑶族自治县"}]},{"code": "4512","name": "河池市","children": [{"code": "451202","name": "金城江区"},{"code": "451203","name": "宜州区"},{"code": "451221","name": "南丹县"},{"code": "451222","name": "天峨县"},{"code": "451223","name": "凤山县"},{"code": "451224","name": "东兰县"},{"code": "451225","name": "罗城仫佬族自治县"},{"code": "451226","name": "环江毛南族自治县"},{"code": "451227","name": "巴马瑶族自治县"},{"code": "451228","name": "都安瑶族自治县"},{"code": "451229","name": "大化瑶族自治县"}]},{"code": "4513","name": "来宾市","children": [{"code": "451302","name": "兴宾区"},{"code": "451321","name": "忻城县"},{"code": "451322","name": "象州县"},{"code": "451323","name": "武宣县"},{"code": "451324","name": "金秀瑶族自治县"},{"code": "451381","name": "合山市"}]},{"code": "4514","name": "崇左市","children": [{"code": "451402","name": "江州区"},{"code": "451421","name": "扶绥县"},{"code": "451422","name": "宁明县"},{"code": "451423","name": "龙州县"},{"code": "451424","name": "大新县"},{"code": "451425","name": "天等县"},{"code": "451481","name": "凭祥市"}]}]},{"code": "46","name": "海南省","children": [{"code": "4601","name": "海口市","children": [{"code": "460105","name": "秀英区"},{"code": "460106","name": "龙华区"},{"code": "460107","name": "琼山区"},{"code": "460108","name": "美兰区"}]},{"code": "4602","name": "三亚市","children": [{"code": "460202","name": "海棠区"},{"code": "460203","name": "吉阳区"},{"code": "460204","name": "天涯区"},{"code": "460205","name": "崖州区"}]},{"code": "4603","name": "三沙市","children": [{"code": "460321","name": "西沙群岛"},{"code": "460322","name": "南沙群岛"},{"code": "460323","name": "中沙群岛的岛礁及其海域"}]},{"code": "4604","name": "儋州市","children": [{"code": "460400100","name": "那大镇"},{"code": "460400101","name": "和庆镇"},{"code": "460400102","name": "南丰镇"},{"code": "460400103","name": "大成镇"},{"code": "460400104","name": "雅星镇"},{"code": "460400105","name": "兰洋镇"},{"code": "460400106","name": "光村镇"},{"code": "460400107","name": "木棠镇"},{"code": "460400108","name": "海头镇"},{"code": "460400109","name": "峨蔓镇"},{"code": "460400111","name": "王五镇"},{"code": "460400112","name": "白马井镇"},{"code": "460400113","name": "中和镇"},{"code": "460400114","name": "排浦镇"},{"code": "460400115","name": "东成镇"},{"code": "460400116","name": "新州镇"},{"code": "460400499","name": "洋浦经济开发区"},{"code": "460400500","name": "华南热作学院"}]},{"code": "4690","name": "省直辖县级行政区划","children": [{"code": "469001","name": "五指山市"},{"code": "469002","name": "琼海市"},{"code": "469005","name": "文昌市"},{"code": "469006","name": "万宁市"},{"code": "469007","name": "东方市"},{"code": "469021","name": "定安县"},{"code": "469022","name": "屯昌县"},{"code": "469023","name": "澄迈县"},{"code": "469024","name": "临高县"},{"code": "469025","name": "白沙黎族自治县"},{"code": "469026","name": "昌江黎族自治县"},{"code": "469027","name": "乐东黎族自治县"},{"code": "469028","name": "陵水黎族自治县"},{"code": "469029","name": "保亭黎族苗族自治县"},{"code": "469030","name": "琼中黎族苗族自治县"}]}]},{"code": "50","name": "重庆市","children": [{"code": "5001","name": "市辖区","children": [{"code": "500101","name": "万州区"},{"code": "500102","name": "涪陵区"},{"code": "500103","name": "渝中区"},{"code": "500104","name": "大渡口区"},{"code": "500105","name": "江北区"},{"code": "500106","name": "沙坪坝区"},{"code": "500107","name": "九龙坡区"},{"code": "500108","name": "南岸区"},{"code": "500109","name": "北碚区"},{"code": "500110","name": "綦江区"},{"code": "500111","name": "大足区"},{"code": "500112","name": "渝北区"},{"code": "500113","name": "巴南区"},{"code": "500114","name": "黔江区"},{"code": "500115","name": "长寿区"},{"code": "500116","name": "江津区"},{"code": "500117","name": "合川区"},{"code": "500118","name": "永川区"},{"code": "500119","name": "南川区"},{"code": "500120","name": "璧山区"},{"code": "500151","name": "铜梁区"},{"code": "500152","name": "潼南区"},{"code": "500153","name": "荣昌区"},{"code": "500154","name": "开州区"},{"code": "500155","name": "梁平区"},{"code": "500156","name": "武隆区"}]},{"code": "5002","name": "县","children": [{"code": "500229","name": "城口县"},{"code": "500230","name": "丰都县"},{"code": "500231","name": "垫江县"},{"code": "500233","name": "忠县"},{"code": "500235","name": "云阳县"},{"code": "500236","name": "奉节县"},{"code": "500237","name": "巫山县"},{"code": "500238","name": "巫溪县"},{"code": "500240","name": "石柱土家族自治县"},{"code": "500241","name": "秀山土家族苗族自治县"},{"code": "500242","name": "酉阳土家族苗族自治县"},{"code": "500243","name": "彭水苗族土家族自治县"}]}]},{"code": "51","name": "四川省","children": [{"code": "5101","name": "成都市","children": [{"code": "510102","name": "高新区"},{"code": "510156","name": "天府新区"},{"code": "510104","name": "锦江区"},{"code": "510105","name": "青羊区"},{"code": "510106","name": "金牛区"},{"code": "510107","name": "武侯区"},{"code": "510108","name": "成华区"},{"code": "510112","name": "龙泉驿区"},{"code": "510113","name": "青白江区"},{"code": "510114","name": "新都区"},{"code": "510115","name": "温江区"},{"code": "510116","name": "双流区"},{"code": "510117","name": "郫都区"},{"code": "510121","name": "金堂县"},{"code": "510129","name": "大邑县"},{"code": "510131","name": "蒲江县"},{"code": "510132","name": "新津县"},{"code": "510181","name": "都江堰市"},{"code": "510182","name": "彭州市"},{"code": "510183","name": "邛崃市"},{"code": "510184","name": "崇州市"},{"code": "510185","name": "简阳市"}]},{"code": "5103","name": "自贡市","children": [{"code": "510302","name": "自流井区"},{"code": "510303","name": "贡井区"},{"code": "510304","name": "大安区"},{"code": "510311","name": "沿滩区"},{"code": "510321","name": "荣县"},{"code": "510322","name": "富顺县"}]},{"code": "5104","name": "攀枝花市","children": [{"code": "510402","name": "东区"},{"code": "510403","name": "西区"},{"code": "510411","name": "仁和区"},{"code": "510421","name": "米易县"},{"code": "510422","name": "盐边县"}]},{"code": "5105","name": "泸州市","children": [{"code": "510502","name": "江阳区"},{"code": "510503","name": "纳溪区"},{"code": "510504","name": "龙马潭区"},{"code": "510521","name": "泸县"},{"code": "510522","name": "合江县"},{"code": "510524","name": "叙永县"},{"code": "510525","name": "古蔺县"}]},{"code": "5106","name": "德阳市","children": [{"code": "510603","name": "旌阳区"},{"code": "510604","name": "罗江区"},{"code": "510623","name": "中江县"},{"code": "510681","name": "广汉市"},{"code": "510682","name": "什邡市"},{"code": "510683","name": "绵竹市"}]},{"code": "5107","name": "绵阳市","children": [{"code": "510703","name": "涪城区"},{"code": "510704","name": "游仙区"},{"code": "510705","name": "安州区"},{"code": "510722","name": "三台县"},{"code": "510723","name": "盐亭县"},{"code": "510725","name": "梓潼县"},{"code": "510726","name": "北川羌族自治县"},{"code": "510727","name": "平武县"},{"code": "510781","name": "江油市"}]},{"code": "5108","name": "广元市","children": [{"code": "510802","name": "利州区"},{"code": "510811","name": "昭化区"},{"code": "510812","name": "朝天区"},{"code": "510821","name": "旺苍县"},{"code": "510822","name": "青川县"},{"code": "510823","name": "剑阁县"},{"code": "510824","name": "苍溪县"}]},{"code": "5109","name": "遂宁市","children": [{"code": "510903","name": "船山区"},{"code": "510904","name": "安居区"},{"code": "510921","name": "蓬溪县"},{"code": "510923","name": "大英县"},{"code": "510981","name": "射洪市"}]},{"code": "5110","name": "内江市","children": [{"code": "511002","name": "市中区"},{"code": "511011","name": "东兴区"},{"code": "511024","name": "威远县"},{"code": "511025","name": "资中县"},{"code": "511071","name": "内江经济开发区"},{"code": "511083","name": "隆昌市"}]},{"code": "5111","name": "乐山市","children": [{"code": "511102","name": "市中区"},{"code": "511111","name": "沙湾区"},{"code": "511112","name": "五通桥区"},{"code": "511113","name": "金口河区"},{"code": "511123","name": "犍为县"},{"code": "511124","name": "井研县"},{"code": "511126","name": "夹江县"},{"code": "511129","name": "沐川县"},{"code": "511132","name": "峨边彝族自治县"},{"code": "511133","name": "马边彝族自治县"},{"code": "511181","name": "峨眉山市"}]},{"code": "5113","name": "南充市","children": [{"code": "511302","name": "顺庆区"},{"code": "511303","name": "高坪区"},{"code": "511304","name": "嘉陵区"},{"code": "511321","name": "南部县"},{"code": "511322","name": "营山县"},{"code": "511323","name": "蓬安县"},{"code": "511324","name": "仪陇县"},{"code": "511325","name": "西充县"},{"code": "511381","name": "阆中市"}]},{"code": "5114","name": "眉山市","children": [{"code": "511402","name": "东坡区"},{"code": "511403","name": "彭山区"},{"code": "511421","name": "仁寿县"},{"code": "511423","name": "洪雅县"},{"code": "511424","name": "丹棱县"},{"code": "511425","name": "青神县"}]},{"code": "5115","name": "宜宾市","children": [{"code": "511502","name": "翠屏区"},{"code": "511503","name": "南溪区"},{"code": "511504","name": "叙州区"},{"code": "511523","name": "江安县"},{"code": "511524","name": "长宁县"},{"code": "511525","name": "高县"},{"code": "511526","name": "珙县"},{"code": "511527","name": "筠连县"},{"code": "511528","name": "兴文县"},{"code": "511529","name": "屏山县"}]},{"code": "5116","name": "广安市","children": [{"code": "511602","name": "广安区"},{"code": "511603","name": "前锋区"},{"code": "511621","name": "岳池县"},{"code": "511622","name": "武胜县"},{"code": "511623","name": "邻水县"},{"code": "511681","name": "华蓥市"}]},{"code": "5117","name": "达州市","children": [{"code": "511702","name": "通川区"},{"code": "511703","name": "达川区"},{"code": "511722","name": "宣汉县"},{"code": "511723","name": "开江县"},{"code": "511724","name": "大竹县"},{"code": "511725","name": "渠县"},{"code": "511771","name": "达州经济开发区"},{"code": "511781","name": "万源市"}]},{"code": "5118","name": "雅安市","children": [{"code": "511802","name": "雨城区"},{"code": "511803","name": "名山区"},{"code": "511822","name": "荥经县"},{"code": "511823","name": "汉源县"},{"code": "511824","name": "石棉县"},{"code": "511825","name": "天全县"},{"code": "511826","name": "芦山县"},{"code": "511827","name": "宝兴县"}]},{"code": "5119","name": "巴中市","children": [{"code": "511902","name": "巴州区"},{"code": "511903","name": "恩阳区"},{"code": "511921","name": "通江县"},{"code": "511922","name": "南江县"},{"code": "511923","name": "平昌县"},{"code": "511971","name": "巴中经济开发区"}]},{"code": "5120","name": "资阳市","children": [{"code": "512002","name": "雁江区"},{"code": "512021","name": "安岳县"},{"code": "512022","name": "乐至县"}]},{"code": "5132","name": "阿坝藏族羌族自治州","children": [{"code": "513201","name": "马尔康市"},{"code": "513221","name": "汶川县"},{"code": "513222","name": "理县"},{"code": "513223","name": "茂县"},{"code": "513224","name": "松潘县"},{"code": "513225","name": "九寨沟县"},{"code": "513226","name": "金川县"},{"code": "513227","name": "小金县"},{"code": "513228","name": "黑水县"},{"code": "513230","name": "壤塘县"},{"code": "513231","name": "阿坝县"},{"code": "513232","name": "若尔盖县"},{"code": "513233","name": "红原县"}]},{"code": "5133","name": "甘孜藏族自治州","children": [{"code": "513301","name": "康定市"},{"code": "513322","name": "泸定县"},{"code": "513323","name": "丹巴县"},{"code": "513324","name": "九龙县"},{"code": "513325","name": "雅江县"},{"code": "513326","name": "道孚县"},{"code": "513327","name": "炉霍县"},{"code": "513328","name": "甘孜县"},{"code": "513329","name": "新龙县"},{"code": "513330","name": "德格县"},{"code": "513331","name": "白玉县"},{"code": "513332","name": "石渠县"},{"code": "513333","name": "色达县"},{"code": "513334","name": "理塘县"},{"code": "513335","name": "巴塘县"},{"code": "513336","name": "乡城县"},{"code": "513337","name": "稻城县"},{"code": "513338","name": "得荣县"}]},{"code": "5134","name": "凉山彝族自治州","children": [{"code": "513401","name": "西昌市"},{"code": "513422","name": "木里藏族自治县"},{"code": "513423","name": "盐源县"},{"code": "513424","name": "德昌县"},{"code": "513425","name": "会理县"},{"code": "513426","name": "会东县"},{"code": "513427","name": "宁南县"},{"code": "513428","name": "普格县"},{"code": "513429","name": "布拖县"},{"code": "513430","name": "金阳县"},{"code": "513431","name": "昭觉县"},{"code": "513432","name": "喜德县"},{"code": "513433","name": "冕宁县"},{"code": "513434","name": "越西县"},{"code": "513435","name": "甘洛县"},{"code": "513436","name": "美姑县"},{"code": "513437","name": "雷波县"}]}]},{"code": "52","name": "贵州省","children": [{"code": "5201","name": "贵阳市","children": [{"code": "520102","name": "南明区"},{"code": "520103","name": "云岩区"},{"code": "520111","name": "花溪区"},{"code": "520112","name": "乌当区"},{"code": "520113","name": "白云区"},{"code": "520115","name": "观山湖区"},{"code": "520121","name": "开阳县"},{"code": "520122","name": "息烽县"},{"code": "520123","name": "修文县"},{"code": "520181","name": "清镇市"}]},{"code": "5202","name": "六盘水市","children": [{"code": "520201","name": "钟山区"},{"code": "520203","name": "六枝特区"},{"code": "520221","name": "水城县"},{"code": "520281","name": "盘州市"}]},{"code": "5203","name": "遵义市","children": [{"code": "520302","name": "红花岗区"},{"code": "520303","name": "汇川区"},{"code": "520304","name": "播州区"},{"code": "520322","name": "桐梓县"},{"code": "520323","name": "绥阳县"},{"code": "520324","name": "正安县"},{"code": "520325","name": "道真仡佬族苗族自治县"},{"code": "520326","name": "务川仡佬族苗族自治县"},{"code": "520327","name": "凤冈县"},{"code": "520328","name": "湄潭县"},{"code": "520329","name": "余庆县"},{"code": "520330","name": "习水县"},{"code": "520381","name": "赤水市"},{"code": "520382","name": "仁怀市"}]},{"code": "5204","name": "安顺市","children": [{"code": "520402","name": "西秀区"},{"code": "520403","name": "平坝区"},{"code": "520422","name": "普定县"},{"code": "520423","name": "镇宁布依族苗族自治县"},{"code": "520424","name": "关岭布依族苗族自治县"},{"code": "520425","name": "紫云苗族布依族自治县"}]},{"code": "5205","name": "毕节市","children": [{"code": "520502","name": "七星关区"},{"code": "520521","name": "大方县"},{"code": "520522","name": "黔西县"},{"code": "520523","name": "金沙县"},{"code": "520524","name": "织金县"},{"code": "520525","name": "纳雍县"},{"code": "520526","name": "威宁彝族回族苗族自治县"},{"code": "520527","name": "赫章县"}]},{"code": "5206","name": "铜仁市","children": [{"code": "520602","name": "碧江区"},{"code": "520603","name": "万山区"},{"code": "520621","name": "江口县"},{"code": "520622","name": "玉屏侗族自治县"},{"code": "520623","name": "石阡县"},{"code": "520624","name": "思南县"},{"code": "520625","name": "印江土家族苗族自治县"},{"code": "520626","name": "德江县"},{"code": "520627","name": "沿河土家族自治县"},{"code": "520628","name": "松桃苗族自治县"}]},{"code": "5223","name": "黔西南布依族苗族自治州","children": [{"code": "522301","name": "兴义市"},{"code": "522302","name": "兴仁市"},{"code": "522323","name": "普安县"},{"code": "522324","name": "晴隆县"},{"code": "522325","name": "贞丰县"},{"code": "522326","name": "望谟县"},{"code": "522327","name": "册亨县"},{"code": "522328","name": "安龙县"}]},{"code": "5226","name": "黔东南苗族侗族自治州","children": [{"code": "522601","name": "凯里市"},{"code": "522622","name": "黄平县"},{"code": "522623","name": "施秉县"},{"code": "522624","name": "三穗县"},{"code": "522625","name": "镇远县"},{"code": "522626","name": "岑巩县"},{"code": "522627","name": "天柱县"},{"code": "522628","name": "锦屏县"},{"code": "522629","name": "剑河县"},{"code": "522630","name": "台江县"},{"code": "522631","name": "黎平县"},{"code": "522632","name": "榕江县"},{"code": "522633","name": "从江县"},{"code": "522634","name": "雷山县"},{"code": "522635","name": "麻江县"},{"code": "522636","name": "丹寨县"}]},{"code": "5227","name": "黔南布依族苗族自治州","children": [{"code": "522701","name": "都匀市"},{"code": "522702","name": "福泉市"},{"code": "522722","name": "荔波县"},{"code": "522723","name": "贵定县"},{"code": "522725","name": "瓮安县"},{"code": "522726","name": "独山县"},{"code": "522727","name": "平塘县"},{"code": "522728","name": "罗甸县"},{"code": "522729","name": "长顺县"},{"code": "522730","name": "龙里县"},{"code": "522731","name": "惠水县"},{"code": "522732","name": "三都水族自治县"}]}]},{"code": "53","name": "云南省","children": [{"code": "5301","name": "昆明市","children": [{"code": "530102","name": "五华区"},{"code": "530103","name": "盘龙区"},{"code": "530111","name": "官渡区"},{"code": "530112","name": "西山区"},{"code": "530113","name": "东川区"},{"code": "530114","name": "呈贡区"},{"code": "530115","name": "晋宁区"},{"code": "530124","name": "富民县"},{"code": "530125","name": "宜良县"},{"code": "530126","name": "石林彝族自治县"},{"code": "530127","name": "嵩明县"},{"code": "530128","name": "禄劝彝族苗族自治县"},{"code": "530129","name": "寻甸回族彝族自治县"},{"code": "530181","name": "安宁市"}]},{"code": "5303","name": "曲靖市","children": [{"code": "530302","name": "麒麟区"},{"code": "530303","name": "沾益区"},{"code": "530304","name": "马龙区"},{"code": "530322","name": "陆良县"},{"code": "530323","name": "师宗县"},{"code": "530324","name": "罗平县"},{"code": "530325","name": "富源县"},{"code": "530326","name": "会泽县"},{"code": "530381","name": "宣威市"}]},{"code": "5304","name": "玉溪市","children": [{"code": "530402","name": "红塔区"},{"code": "530403","name": "江川区"},{"code": "530422","name": "澄江县"},{"code": "530423","name": "通海县"},{"code": "530424","name": "华宁县"},{"code": "530425","name": "易门县"},{"code": "530426","name": "峨山彝族自治县"},{"code": "530427","name": "新平彝族傣族自治县"},{"code": "530428","name": "元江哈尼族彝族傣族自治县"}]},{"code": "5305","name": "保山市","children": [{"code": "530502","name": "隆阳区"},{"code": "530521","name": "施甸县"},{"code": "530523","name": "龙陵县"},{"code": "530524","name": "昌宁县"},{"code": "530581","name": "腾冲市"}]},{"code": "5306","name": "昭通市","children": [{"code": "530602","name": "昭阳区"},{"code": "530621","name": "鲁甸县"},{"code": "530622","name": "巧家县"},{"code": "530623","name": "盐津县"},{"code": "530624","name": "大关县"},{"code": "530625","name": "永善县"},{"code": "530626","name": "绥江县"},{"code": "530627","name": "镇雄县"},{"code": "530628","name": "彝良县"},{"code": "530629","name": "威信县"},{"code": "530681","name": "水富市"}]},{"code": "5307","name": "丽江市","children": [{"code": "530702","name": "古城区"},{"code": "530721","name": "玉龙纳西族自治县"},{"code": "530722","name": "永胜县"},{"code": "530723","name": "华坪县"},{"code": "530724","name": "宁蒗彝族自治县"}]},{"code": "5308","name": "普洱市","children": [{"code": "530802","name": "思茅区"},{"code": "530821","name": "宁洱哈尼族彝族自治县"},{"code": "530822","name": "墨江哈尼族自治县"},{"code": "530823","name": "景东彝族自治县"},{"code": "530824","name": "景谷傣族彝族自治县"},{"code": "530825","name": "镇沅彝族哈尼族拉祜族自治县"},{"code": "530826","name": "江城哈尼族彝族自治县"},{"code": "530827","name": "孟连傣族拉祜族佤族自治县"},{"code": "530828","name": "澜沧拉祜族自治县"},{"code": "530829","name": "西盟佤族自治县"}]},{"code": "5309","name": "临沧市","children": [{"code": "530902","name": "临翔区"},{"code": "530921","name": "凤庆县"},{"code": "530922","name": "云县"},{"code": "530923","name": "永德县"},{"code": "530924","name": "镇康县"},{"code": "530925","name": "双江拉祜族佤族布朗族傣族自治县"},{"code": "530926","name": "耿马傣族佤族自治县"},{"code": "530927","name": "沧源佤族自治县"}]},{"code": "5323","name": "楚雄彝族自治州","children": [{"code": "532301","name": "楚雄市"},{"code": "532322","name": "双柏县"},{"code": "532323","name": "牟定县"},{"code": "532324","name": "南华县"},{"code": "532325","name": "姚安县"},{"code": "532326","name": "大姚县"},{"code": "532327","name": "永仁县"},{"code": "532328","name": "元谋县"},{"code": "532329","name": "武定县"},{"code": "532331","name": "禄丰县"}]},{"code": "5325","name": "红河哈尼族彝族自治州","children": [{"code": "532501","name": "个旧市"},{"code": "532502","name": "开远市"},{"code": "532503","name": "蒙自市"},{"code": "532504","name": "弥勒市"},{"code": "532523","name": "屏边苗族自治县"},{"code": "532524","name": "建水县"},{"code": "532525","name": "石屏县"},{"code": "532527","name": "泸西县"},{"code": "532528","name": "元阳县"},{"code": "532529","name": "红河县"},{"code": "532530","name": "金平苗族瑶族傣族自治县"},{"code": "532531","name": "绿春县"},{"code": "532532","name": "河口瑶族自治县"}]},{"code": "5326","name": "文山壮族苗族自治州","children": [{"code": "532601","name": "文山市"},{"code": "532622","name": "砚山县"},{"code": "532623","name": "西畴县"},{"code": "532624","name": "麻栗坡县"},{"code": "532625","name": "马关县"},{"code": "532626","name": "丘北县"},{"code": "532627","name": "广南县"},{"code": "532628","name": "富宁县"}]},{"code": "5328","name": "西双版纳傣族自治州","children": [{"code": "532801","name": "景洪市"},{"code": "532822","name": "勐海县"},{"code": "532823","name": "勐腊县"}]},{"code": "5329","name": "大理白族自治州","children": [{"code": "532901","name": "大理市"},{"code": "532922","name": "漾濞彝族自治县"},{"code": "532923","name": "祥云县"},{"code": "532924","name": "宾川县"},{"code": "532925","name": "弥渡县"},{"code": "532926","name": "南涧彝族自治县"},{"code": "532927","name": "巍山彝族回族自治县"},{"code": "532928","name": "永平县"},{"code": "532929","name": "云龙县"},{"code": "532930","name": "洱源县"},{"code": "532931","name": "剑川县"},{"code": "532932","name": "鹤庆县"}]},{"code": "5331","name": "德宏傣族景颇族自治州","children": [{"code": "533102","name": "瑞丽市"},{"code": "533103","name": "芒市"},{"code": "533122","name": "梁河县"},{"code": "533123","name": "盈江县"},{"code": "533124","name": "陇川县"}]},{"code": "5333","name": "怒江傈僳族自治州","children": [{"code": "533301","name": "泸水市"},{"code": "533323","name": "福贡县"},{"code": "533324","name": "贡山独龙族怒族自治县"},{"code": "533325","name": "兰坪白族普米族自治县"}]},{"code": "5334","name": "迪庆藏族自治州","children": [{"code": "533401","name": "香格里拉市"},{"code": "533422","name": "德钦县"},{"code": "533423","name": "维西傈僳族自治县"}]}]},{"code": "54","name": "西藏自治区","children": [{"code": "5401","name": "拉萨市","children": [{"code": "540102","name": "城关区"},{"code": "540103","name": "堆龙德庆区"},{"code": "540104","name": "达孜区"},{"code": "540121","name": "林周县"},{"code": "540122","name": "当雄县"},{"code": "540123","name": "尼木县"},{"code": "540124","name": "曲水县"},{"code": "540127","name": "墨竹工卡县"},{"code": "540171","name": "格尔木藏青工业园区"},{"code": "540172","name": "拉萨经济技术开发区"},{"code": "540173","name": "西藏文化旅游创意园区"},{"code": "540174","name": "达孜工业园区"}]},{"code": "5402","name": "日喀则市","children": [{"code": "540202","name": "桑珠孜区"},{"code": "540221","name": "南木林县"},{"code": "540222","name": "江孜县"},{"code": "540223","name": "定日县"},{"code": "540224","name": "萨迦县"},{"code": "540225","name": "拉孜县"},{"code": "540226","name": "昂仁县"},{"code": "540227","name": "谢通门县"},{"code": "540228","name": "白朗县"},{"code": "540229","name": "仁布县"},{"code": "540230","name": "康马县"},{"code": "540231","name": "定结县"},{"code": "540232","name": "仲巴县"},{"code": "540233","name": "亚东县"},{"code": "540234","name": "吉隆县"},{"code": "540235","name": "聂拉木县"},{"code": "540236","name": "萨嘎县"},{"code": "540237","name": "岗巴县"}]},{"code": "5403","name": "昌都市","children": [{"code": "540302","name": "卡若区"},{"code": "540321","name": "江达县"},{"code": "540322","name": "贡觉县"},{"code": "540323","name": "类乌齐县"},{"code": "540324","name": "丁青县"},{"code": "540325","name": "察雅县"},{"code": "540326","name": "八宿县"},{"code": "540327","name": "左贡县"},{"code": "540328","name": "芒康县"},{"code": "540329","name": "洛隆县"},{"code": "540330","name": "边坝县"}]},{"code": "5404","name": "林芝市","children": [{"code": "540402","name": "巴宜区"},{"code": "540421","name": "工布江达县"},{"code": "540422","name": "米林县"},{"code": "540423","name": "墨脱县"},{"code": "540424","name": "波密县"},{"code": "540425","name": "察隅县"},{"code": "540426","name": "朗县"}]},{"code": "5405","name": "山南市","children": [{"code": "540502","name": "乃东区"},{"code": "540521","name": "扎囊县"},{"code": "540522","name": "贡嘎县"},{"code": "540523","name": "桑日县"},{"code": "540524","name": "琼结县"},{"code": "540525","name": "曲松县"},{"code": "540526","name": "措美县"},{"code": "540527","name": "洛扎县"},{"code": "540528","name": "加查县"},{"code": "540529","name": "隆子县"},{"code": "540530","name": "错那县"},{"code": "540531","name": "浪卡子县"}]},{"code": "5406","name": "那曲市","children": [{"code": "540602","name": "色尼区"},{"code": "540621","name": "嘉黎县"},{"code": "540622","name": "比如县"},{"code": "540623","name": "聂荣县"},{"code": "540624","name": "安多县"},{"code": "540625","name": "申扎县"},{"code": "540626","name": "索县"},{"code": "540627","name": "班戈县"},{"code": "540628","name": "巴青县"},{"code": "540629","name": "尼玛县"},{"code": "540630","name": "双湖县"}]},{"code": "5425","name": "阿里地区","children": [{"code": "542521","name": "普兰县"},{"code": "542522","name": "札达县"},{"code": "542523","name": "噶尔县"},{"code": "542524","name": "日土县"},{"code": "542525","name": "革吉县"},{"code": "542526","name": "改则县"},{"code": "542527","name": "措勤县"}]}]},{"code": "61","name": "陕西省","children": [{"code": "6101","name": "西安市","children": [{"code": "610102","name": "新城区"},{"code": "610103","name": "碑林区"},{"code": "610104","name": "莲湖区"},{"code": "610111","name": "灞桥区"},{"code": "610112","name": "未央区"},{"code": "610113","name": "雁塔区"},{"code": "610114","name": "阎良区"},{"code": "610115","name": "临潼区"},{"code": "610116","name": "长安区"},{"code": "610117","name": "高陵区"},{"code": "610118","name": "鄠邑区"},{"code": "610122","name": "蓝田县"},{"code": "610124","name": "周至县"}]},{"code": "6102","name": "铜川市","children": [{"code": "610202","name": "王益区"},{"code": "610203","name": "印台区"},{"code": "610204","name": "耀州区"},{"code": "610222","name": "宜君县"}]},{"code": "6103","name": "宝鸡市","children": [{"code": "610302","name": "渭滨区"},{"code": "610303","name": "金台区"},{"code": "610304","name": "陈仓区"},{"code": "610322","name": "凤翔县"},{"code": "610323","name": "岐山县"},{"code": "610324","name": "扶风县"},{"code": "610326","name": "眉县"},{"code": "610327","name": "陇县"},{"code": "610328","name": "千阳县"},{"code": "610329","name": "麟游县"},{"code": "610330","name": "凤县"},{"code": "610331","name": "太白县"}]},{"code": "6104","name": "咸阳市","children": [{"code": "610402","name": "秦都区"},{"code": "610403","name": "杨陵区"},{"code": "610404","name": "渭城区"},{"code": "610422","name": "三原县"},{"code": "610423","name": "泾阳县"},{"code": "610424","name": "乾县"},{"code": "610425","name": "礼泉县"},{"code": "610426","name": "永寿县"},{"code": "610428","name": "长武县"},{"code": "610429","name": "旬邑县"},{"code": "610430","name": "淳化县"},{"code": "610431","name": "武功县"},{"code": "610481","name": "兴平市"},{"code": "610482","name": "彬州市"}]},{"code": "6105","name": "渭南市","children": [{"code": "610502","name": "临渭区"},{"code": "610503","name": "华州区"},{"code": "610522","name": "潼关县"},{"code": "610523","name": "大荔县"},{"code": "610524","name": "合阳县"},{"code": "610525","name": "澄城县"},{"code": "610526","name": "蒲城县"},{"code": "610527","name": "白水县"},{"code": "610528","name": "富平县"},{"code": "610581","name": "韩城市"},{"code": "610582","name": "华阴市"}]},{"code": "6106","name": "延安市","children": [{"code": "610602","name": "宝塔区"},{"code": "610603","name": "安塞区"},{"code": "610621","name": "延长县"},{"code": "610622","name": "延川县"},{"code": "610625","name": "志丹县"},{"code": "610626","name": "吴起县"},{"code": "610627","name": "甘泉县"},{"code": "610628","name": "富县"},{"code": "610629","name": "洛川县"},{"code": "610630","name": "宜川县"},{"code": "610631","name": "黄龙县"},{"code": "610632","name": "黄陵县"},{"code": "610681","name": "子长市"}]},{"code": "6107","name": "汉中市","children": [{"code": "610702","name": "汉台区"},{"code": "610703","name": "南郑区"},{"code": "610722","name": "城固县"},{"code": "610723","name": "洋县"},{"code": "610724","name": "西乡县"},{"code": "610725","name": "勉县"},{"code": "610726","name": "宁强县"},{"code": "610727","name": "略阳县"},{"code": "610728","name": "镇巴县"},{"code": "610729","name": "留坝县"},{"code": "610730","name": "佛坪县"}]},{"code": "6108","name": "榆林市","children": [{"code": "610802","name": "榆阳区"},{"code": "610803","name": "横山区"},{"code": "610822","name": "府谷县"},{"code": "610824","name": "靖边县"},{"code": "610825","name": "定边县"},{"code": "610826","name": "绥德县"},{"code": "610827","name": "米脂县"},{"code": "610828","name": "佳县"},{"code": "610829","name": "吴堡县"},{"code": "610830","name": "清涧县"},{"code": "610831","name": "子洲县"},{"code": "610881","name": "神木市"}]},{"code": "6109","name": "安康市","children": [{"code": "610902","name": "汉滨区"},{"code": "610921","name": "汉阴县"},{"code": "610922","name": "石泉县"},{"code": "610923","name": "宁陕县"},{"code": "610924","name": "紫阳县"},{"code": "610925","name": "岚皋县"},{"code": "610926","name": "平利县"},{"code": "610927","name": "镇坪县"},{"code": "610928","name": "旬阳县"},{"code": "610929","name": "白河县"}]},{"code": "6110","name": "商洛市","children": [{"code": "611002","name": "商州区"},{"code": "611021","name": "洛南县"},{"code": "611022","name": "丹凤县"},{"code": "611023","name": "商南县"},{"code": "611024","name": "山阳县"},{"code": "611025","name": "镇安县"},{"code": "611026","name": "柞水县"}]}]},{"code": "62","name": "甘肃省","children": [{"code": "6201","name": "兰州市","children": [{"code": "620102","name": "城关区"},{"code": "620103","name": "七里河区"},{"code": "620104","name": "西固区"},{"code": "620105","name": "安宁区"},{"code": "620111","name": "红古区"},{"code": "620121","name": "永登县"},{"code": "620122","name": "皋兰县"},{"code": "620123","name": "榆中县"},{"code": "620171","name": "兰州新区"}]},{"code": "6202","name": "嘉峪关市","children": [{"code": "620201100","name": "新城镇"},{"code": "620201101","name": "峪泉镇"},{"code": "620201102","name": "文殊镇"},{"code": "620201401","name": "雄关区"},{"code": "620201402","name": "镜铁区"},{"code": "620201403","name": "长城区"}]},{"code": "6203","name": "金昌市","children": [{"code": "620302","name": "金川区"},{"code": "620321","name": "永昌县"}]},{"code": "6204","name": "白银市","children": [{"code": "620402","name": "白银区"},{"code": "620403","name": "平川区"},{"code": "620421","name": "靖远县"},{"code": "620422","name": "会宁县"},{"code": "620423","name": "景泰县"}]},{"code": "6205","name": "天水市","children": [{"code": "620502","name": "秦州区"},{"code": "620503","name": "麦积区"},{"code": "620521","name": "清水县"},{"code": "620522","name": "秦安县"},{"code": "620523","name": "甘谷县"},{"code": "620524","name": "武山县"},{"code": "620525","name": "张家川回族自治县"}]},{"code": "6206","name": "武威市","children": [{"code": "620602","name": "凉州区"},{"code": "620621","name": "民勤县"},{"code": "620622","name": "古浪县"},{"code": "620623","name": "天祝藏族自治县"}]},{"code": "6207","name": "张掖市","children": [{"code": "620702","name": "甘州区"},{"code": "620721","name": "肃南裕固族自治县"},{"code": "620722","name": "民乐县"},{"code": "620723","name": "临泽县"},{"code": "620724","name": "高台县"},{"code": "620725","name": "山丹县"}]},{"code": "6208","name": "平凉市","children": [{"code": "620802","name": "崆峒区"},{"code": "620821","name": "泾川县"},{"code": "620822","name": "灵台县"},{"code": "620823","name": "崇信县"},{"code": "620825","name": "庄浪县"},{"code": "620826","name": "静宁县"},{"code": "620881","name": "华亭市"}]},{"code": "6209","name": "酒泉市","children": [{"code": "620902","name": "肃州区"},{"code": "620921","name": "金塔县"},{"code": "620922","name": "瓜州县"},{"code": "620923","name": "肃北蒙古族自治县"},{"code": "620924","name": "阿克塞哈萨克族自治县"},{"code": "620981","name": "玉门市"},{"code": "620982","name": "敦煌市"}]},{"code": "6210","name": "庆阳市","children": [{"code": "621002","name": "西峰区"},{"code": "621021","name": "庆城县"},{"code": "621022","name": "环县"},{"code": "621023","name": "华池县"},{"code": "621024","name": "合水县"},{"code": "621025","name": "正宁县"},{"code": "621026","name": "宁县"},{"code": "621027","name": "镇原县"}]},{"code": "6211","name": "定西市","children": [{"code": "621102","name": "安定区"},{"code": "621121","name": "通渭县"},{"code": "621122","name": "陇西县"},{"code": "621123","name": "渭源县"},{"code": "621124","name": "临洮县"},{"code": "621125","name": "漳县"},{"code": "621126","name": "岷县"}]},{"code": "6212","name": "陇南市","children": [{"code": "621202","name": "武都区"},{"code": "621221","name": "成县"},{"code": "621222","name": "文县"},{"code": "621223","name": "宕昌县"},{"code": "621224","name": "康县"},{"code": "621225","name": "西和县"},{"code": "621226","name": "礼县"},{"code": "621227","name": "徽县"},{"code": "621228","name": "两当县"}]},{"code": "6229","name": "临夏回族自治州","children": [{"code": "622901","name": "临夏市"},{"code": "622921","name": "临夏县"},{"code": "622922","name": "康乐县"},{"code": "622923","name": "永靖县"},{"code": "622924","name": "广河县"},{"code": "622925","name": "和政县"},{"code": "622926","name": "东乡族自治县"},{"code": "622927","name": "积石山保安族东乡族撒拉族自治县"}]},{"code": "6230","name": "甘南藏族自治州","children": [{"code": "623001","name": "合作市"},{"code": "623021","name": "临潭县"},{"code": "623022","name": "卓尼县"},{"code": "623023","name": "舟曲县"},{"code": "623024","name": "迭部县"},{"code": "623025","name": "玛曲县"},{"code": "623026","name": "碌曲县"},{"code": "623027","name": "夏河县"}]}]},{"code": "63","name": "青海省","children": [{"code": "6301","name": "西宁市","children": [{"code": "630102","name": "城东区"},{"code": "630103","name": "城中区"},{"code": "630104","name": "城西区"},{"code": "630105","name": "城北区"},{"code": "630121","name": "大通回族土族自治县"},{"code": "630122","name": "湟中县"},{"code": "630123","name": "湟源县"}]},{"code": "6302","name": "海东市","children": [{"code": "630202","name": "乐都区"},{"code": "630203","name": "平安区"},{"code": "630222","name": "民和回族土族自治县"},{"code": "630223","name": "互助土族自治县"},{"code": "630224","name": "化隆回族自治县"},{"code": "630225","name": "循化撒拉族自治县"}]},{"code": "6322","name": "海北藏族自治州","children": [{"code": "632221","name": "门源回族自治县"},{"code": "632222","name": "祁连县"},{"code": "632223","name": "海晏县"},{"code": "632224","name": "刚察县"}]},{"code": "6323","name": "黄南藏族自治州","children": [{"code": "632321","name": "同仁县"},{"code": "632322","name": "尖扎县"},{"code": "632323","name": "泽库县"},{"code": "632324","name": "河南蒙古族自治县"}]},{"code": "6325","name": "海南藏族自治州","children": [{"code": "632521","name": "共和县"},{"code": "632522","name": "同德县"},{"code": "632523","name": "贵德县"},{"code": "632524","name": "兴海县"},{"code": "632525","name": "贵南县"}]},{"code": "6326","name": "果洛藏族自治州","children": [{"code": "632621","name": "玛沁县"},{"code": "632622","name": "班玛县"},{"code": "632623","name": "甘德县"},{"code": "632624","name": "达日县"},{"code": "632625","name": "久治县"},{"code": "632626","name": "玛多县"}]},{"code": "6327","name": "玉树藏族自治州","children": [{"code": "632701","name": "玉树市"},{"code": "632722","name": "杂多县"},{"code": "632723","name": "称多县"},{"code": "632724","name": "治多县"},{"code": "632725","name": "囊谦县"},{"code": "632726","name": "曲麻莱县"}]},{"code": "6328","name": "海西蒙古族藏族自治州","children": [{"code": "632801","name": "格尔木市"},{"code": "632802","name": "德令哈市"},{"code": "632803","name": "茫崖市"},{"code": "632821","name": "乌兰县"},{"code": "632822","name": "都兰县"},{"code": "632823","name": "天峻县"},{"code": "632857","name": "大柴旦行政委员会"}]}]},{"code": "64","name": "宁夏回族自治区","children": [{"code": "6401","name": "银川市","children": [{"code": "640104","name": "兴庆区"},{"code": "640105","name": "西夏区"},{"code": "640106","name": "金凤区"},{"code": "640121","name": "永宁县"},{"code": "640122","name": "贺兰县"},{"code": "640181","name": "灵武市"}]},{"code": "6402","name": "石嘴山市","children": [{"code": "640202","name": "大武口区"},{"code": "640205","name": "惠农区"},{"code": "640221","name": "平罗县"}]},{"code": "6403","name": "吴忠市","children": [{"code": "640302","name": "利通区"},{"code": "640303","name": "红寺堡区"},{"code": "640323","name": "盐池县"},{"code": "640324","name": "同心县"},{"code": "640381","name": "青铜峡市"}]},{"code": "6404","name": "固原市","children": [{"code": "640402","name": "原州区"},{"code": "640422","name": "西吉县"},{"code": "640423","name": "隆德县"},{"code": "640424","name": "泾源县"},{"code": "640425","name": "彭阳县"}]},{"code": "6405","name": "中卫市","children": [{"code": "640502","name": "沙坡头区"},{"code": "640521","name": "中宁县"},{"code": "640522","name": "海原县"}]}]},{"code": "65","name": "新疆维吾尔自治区","children": [{"code": "6501","name": "乌鲁木齐市","children": [{"code": "650102","name": "天山区"},{"code": "650103","name": "沙依巴克区"},{"code": "650104","name": "新市区"},{"code": "650105","name": "水磨沟区"},{"code": "650106","name": "头屯河区"},{"code": "650107","name": "达坂城区"},{"code": "650109","name": "米东区"},{"code": "650121","name": "乌鲁木齐县"}]},{"code": "6502","name": "克拉玛依市","children": [{"code": "650202","name": "独山子区"},{"code": "650203","name": "克拉玛依区"},{"code": "650204","name": "白碱滩区"},{"code": "650205","name": "乌尔禾区"}]},{"code": "6504","name": "吐鲁番市","children": [{"code": "650402","name": "高昌区"},{"code": "650421","name": "鄯善县"},{"code": "650422","name": "托克逊县"}]},{"code": "6505","name": "哈密市","children": [{"code": "650502","name": "伊州区"},{"code": "650521","name": "巴里坤哈萨克自治县"},{"code": "650522","name": "伊吾县"}]},{"code": "6523","name": "昌吉回族自治州","children": [{"code": "652301","name": "昌吉市"},{"code": "652302","name": "阜康市"},{"code": "652323","name": "呼图壁县"},{"code": "652324","name": "玛纳斯县"},{"code": "652325","name": "奇台县"},{"code": "652327","name": "吉木萨尔县"},{"code": "652328","name": "木垒哈萨克自治县"}]},{"code": "6527","name": "博尔塔拉蒙古自治州","children": [{"code": "652701","name": "博乐市"},{"code": "652702","name": "阿拉山口市"},{"code": "652722","name": "精河县"},{"code": "652723","name": "温泉县"}]},{"code": "6528","name": "巴音郭楞蒙古自治州","children": [{"code": "652801","name": "库尔勒市"},{"code": "652822","name": "轮台县"},{"code": "652823","name": "尉犁县"},{"code": "652824","name": "若羌县"},{"code": "652825","name": "且末县"},{"code": "652826","name": "焉耆回族自治县"},{"code": "652827","name": "和静县"},{"code": "652828","name": "和硕县"},{"code": "652829","name": "博湖县"},{"code": "652871","name": "库尔勒经济技术开发区"}]},{"code": "6529","name": "阿克苏地区","children": [{"code": "652901","name": "阿克苏市"},{"code": "652922","name": "温宿县"},{"code": "652923","name": "库车县"},{"code": "652924","name": "沙雅县"},{"code": "652925","name": "新和县"},{"code": "652926","name": "拜城县"},{"code": "652927","name": "乌什县"},{"code": "652928","name": "阿瓦提县"},{"code": "652929","name": "柯坪县"}]},{"code": "6530","name": "克孜勒苏柯尔克孜自治州","children": [{"code": "653001","name": "阿图什市"},{"code": "653022","name": "阿克陶县"},{"code": "653023","name": "阿合奇县"},{"code": "653024","name": "乌恰县"}]},{"code": "6531","name": "喀什地区","children": [{"code": "653101","name": "喀什市"},{"code": "653121","name": "疏附县"},{"code": "653122","name": "疏勒县"},{"code": "653123","name": "英吉沙县"},{"code": "653124","name": "泽普县"},{"code": "653125","name": "莎车县"},{"code": "653126","name": "叶城县"},{"code": "653127","name": "麦盖提县"},{"code": "653128","name": "岳普湖县"},{"code": "653129","name": "伽师县"},{"code": "653130","name": "巴楚县"},{"code": "653131","name": "塔什库尔干塔吉克自治县"}]},{"code": "6532","name": "和田地区","children": [{"code": "653201","name": "和田市"},{"code": "653221","name": "和田县"},{"code": "653222","name": "墨玉县"},{"code": "653223","name": "皮山县"},{"code": "653224","name": "洛浦县"},{"code": "653225","name": "策勒县"},{"code": "653226","name": "于田县"},{"code": "653227","name": "民丰县"}]},{"code": "6540","name": "伊犁哈萨克自治州","children": [{"code": "654002","name": "伊宁市"},{"code": "654003","name": "奎屯市"},{"code": "654004","name": "霍尔果斯市"},{"code": "654021","name": "伊宁县"},{"code": "654022","name": "察布查尔锡伯自治县"},{"code": "654023","name": "霍城县"},{"code": "654024","name": "巩留县"},{"code": "654025","name": "新源县"},{"code": "654026","name": "昭苏县"},{"code": "654027","name": "特克斯县"},{"code": "654028","name": "尼勒克县"}]},{"code": "6542","name": "塔城地区","children": [{"code": "654201","name": "塔城市"},{"code": "654202","name": "乌苏市"},{"code": "654221","name": "额敏县"},{"code": "654223","name": "沙湾县"},{"code": "654224","name": "托里县"},{"code": "654225","name": "裕民县"},{"code": "654226","name": "和布克赛尔蒙古自治县"}]},{"code": "6543","name": "阿勒泰地区","children": [{"code": "654301","name": "阿勒泰市"},{"code": "654321","name": "布尔津县"},{"code": "654322","name": "富蕴县"},{"code": "654323","name": "福海县"},{"code": "654324","name": "哈巴河县"},{"code": "654325","name": "青河县"},{"code": "654326","name": "吉木乃县"}]},{"code": "6590","name": "自治区直辖县级行政区划","children": [{"code": "659001","name": "石河子市"},{"code": "659002","name": "阿拉尔市"},{"code": "659003","name": "图木舒克市"},{"code": "659004","name": "五家渠市"},{"code": "659005","name": "北屯市"},{"code": "659006","name": "铁门关市"},{"code": "659007","name": "双河市"},{"code": "659008","name": "可克达拉市"},{"code": "659009","name": "昆玉市"},{"code": "659010","name": "胡杨河市"},{"code": "659011","name": "新星市"},{"code": "659012","name": "白杨市"}]}]}]');
  }, function (e) {
    e.exports = JSON.parse('["赵","钱","孙","李","周","吴","郑","王","冯","陈","楮","卫","蒋","沈","韩","杨","朱","秦","尤","许","何","吕","施","张","孔","曹","严","华","金","魏","陶","姜","戚","谢","邹","喻","柏","水","窦","章","云","苏","潘","葛","奚","范","彭","郎","鲁","韦","昌","马","苗","凤","花","方","俞","任","袁","柳","酆","鲍","史","唐","费","廉","岑","薛","雷","贺","倪","汤","滕","殷","罗","毕","郝","邬","安","常","乐","于","时","傅","皮","卞","齐","康","伍","余","元","卜","顾","孟","平","黄","和","穆","萧","尹","姚","邵","湛","汪","祁","毛","禹","狄","米","贝","明","臧","计","伏","成","戴","谈","宋","茅","庞","熊","纪","舒","屈","项","祝","董","梁","杜","阮","蓝","闽","席","季","麻","强","贾","路","娄","危","江","童","颜","郭","梅","盛","林","刁","锺","徐","丘","骆","高","夏","蔡","田","樊","胡","凌","霍","虞","万","支","柯","昝","管","卢","莫","经","房","裘","缪","干","解","应","宗","丁","宣","贲","邓","郁","单","杭","洪","包","诸","左","石","崔","吉","钮","龚","程","嵇","邢","滑","裴","陆","荣","翁","荀","羊","於","惠","甄","麹","家","封","芮","羿","储","靳","汲","邴","糜","松","井","段","富","巫","乌","焦","巴","弓","牧","隗","山","谷","车","侯","宓","蓬","全","郗","班","仰","秋","仲","伊","宫","宁","仇","栾","暴","甘","斜","厉","戎","祖","武","符","刘","景","詹","束","龙","叶","幸","司","韶","郜","黎","蓟","薄","印","宿","白","怀","蒲","邰","从","鄂","索","咸","籍","赖","卓","蔺","屠","蒙","池","乔","阴","郁","胥","能","苍","双","闻","莘","党","翟","谭","贡","劳","逄","姬","申","扶","堵","冉","宰","郦","雍","郤","璩","桑","桂","濮","牛","寿","通","边","扈","燕","冀","郏","浦","尚","农","温","别","庄","晏","柴","瞿","阎","充","慕","连","茹","习","宦","艾","鱼","容","向","古","易","慎","戈","廖","庾","终","暨","居","衡","步","都","耿","满","弘","匡","国","文","寇","广","禄","阙","东","欧","殳","沃","利","蔚","越","夔","隆","师","巩","厍","聂","晁","勾","敖","融","冷","訾","辛","阚","那","简","饶","空","曾","毋","沙","乜","养","鞠","须","丰","巢","关","蒯","相","查","后","荆","红","游","竺","权","逑","盖","益","桓","公","万俟","司马","上官","欧阳","夏侯","诸葛","闻人","东方","赫连","皇甫","尉迟","公羊","澹台","公冶","宗政","濮阳","淳于","单于","太叔","申屠","公孙","仲孙","轩辕","令狐","锺离","宇文","长孙","慕容","鲜于","闾丘","司徒","司空","丌官","司寇","仉","督","子车","颛孙","端木","巫马","公西","漆雕","乐正","壤驷","公良","拓拔","夹谷","宰父","谷梁","晋","楚","阎","法","汝","鄢","涂","钦","段干","百里","东郭","南门","呼延","归","海","羊舌","微生","岳","帅","缑","亢","况","后","有","琴","梁丘","左丘","东门","西门","商","牟","佘","佴","伯","赏","南宫","墨","哈","谯","笪","年","爱","阳","佟","第五","言","福"]');
  }, function (e, n, c) {
    "use strict";

    c.r(n);
    var d = c(1),
      o = c(0);
    function a(e, n) {
      var c;
      if ("undefined" == typeof Symbol || null == e[Symbol.iterator]) {
        if (Array.isArray(e) || (c = r(e)) || n && e && "number" == typeof e.length) {
          c && (e = c);
          var d = 0,
            o = function () {};
          return {
            s: o,
            n: function () {
              return d >= e.length ? {
                done: !0
              } : {
                done: !1,
                value: e[d++]
              };
            },
            e: function (e) {
              throw e;
            },
            f: o
          };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }
      var a,
        m = !0,
        i = !1;
      return {
        s: function () {
          c = e[Symbol.iterator]();
        },
        n: function () {
          var e = c.next();
          return m = e.done, e;
        },
        e: function (e) {
          i = !0, a = e;
        },
        f: function () {
          try {
            m || null == c.return || c.return();
          } finally {
            if (i) throw a;
          }
        }
      };
    }
    function m(e) {
      return function (e) {
        if (Array.isArray(e)) return i(e);
      }(e) || function (e) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
      }(e) || r(e) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }
    function r(e, n) {
      if (e) {
        if ("string" == typeof e) return i(e, n);
        var c = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === c && e.constructor && (c = e.constructor.name), "Map" === c || "Set" === c ? Array.from(e) : "Arguments" === c || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(c) ? i(e, n) : void 0;
      }
    }
    function i(e, n) {
      (null == n || n > e.length) && (n = e.length);
      for (var c = 0, d = new Array(n); c < n; c++) d[c] = e[c];
      return d;
    }
    function l(e) {
      return (l = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }
    function h(e, n) {
      var c = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var d = Object.getOwnPropertySymbols(e);
        n && (d = d.filter(function (n) {
          return Object.getOwnPropertyDescriptor(e, n).enumerable;
        })), c.push.apply(c, d);
      }
      return c;
    }
    function t(e) {
      for (var n = 1; n < arguments.length; n++) {
        var c = null != arguments[n] ? arguments[n] : {};
        n % 2 ? h(Object(c), !0).forEach(function (n) {
          u(e, n, c[n]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(c)) : h(Object(c)).forEach(function (n) {
          Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(c, n));
        });
      }
      return e;
    }
    function u(e, n, c) {
      return n in e ? Object.defineProperty(e, n, {
        value: c,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[n] = c, e;
    }
    function f(e, n) {
      if (null == e) return {};
      var c,
        d,
        o = function (e, n) {
          if (null == e) return {};
          var c,
            d,
            o = {},
            a = Object.keys(e);
          for (d = 0; d < a.length; d++) c = a[d], n.indexOf(c) >= 0 || (o[c] = e[c]);
          return o;
        }(e, n);
      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);
        for (d = 0; d < a.length; d++) c = a[d], n.indexOf(c) >= 0 || Object.prototype.propertyIsEnumerable.call(e, c) && (o[c] = e[c]);
      }
      return o;
    }
    var p = ["行政区划"];
    o.forEach(function (e) {
      e.children && e.children.forEach(function (n, c) {
        ~p.findIndex(function (e) {
          return ~n.name.indexOf(e);
        }) && (e.children = e.children.concat(n.children || []), e.children.splice(c, 1));
      });
    });
    var s = o.reduce(function (e, n) {
        n.children;
        var c = f(n, ["children"]);
        return e.concat(c);
      }, []),
      v = o.reduce(function (e, n) {
        return e.concat(n.children ? n.children.map(function (e) {
          e.children;
          return t(t({}, f(e, ["children"])), {}, {
            provinceCode: n.code
          });
        }) : []);
      }, []),
      g = o.reduce(function (e, n) {
        var c = n.code;
        return e.concat(n.children ? n.children.reduce(function (e, n) {
          var d = n.code;
          return e.concat(n.children ? n.children.map(function (e) {
            e.children;
            return t(t({}, f(e, ["children"])), {}, {
              cityCode: d,
              provinceCode: c
            });
          }) : []);
        }, []) : []);
      }, []),
      y = JSON.stringify(s),
      b = JSON.stringify(v),
      O = JSON.stringify(g);
    s.length, v.length, g.length;
    var x = function (e) {
        var n = e.province,
          c = e.city,
          d = e.area;
        n && (s.push.apply(s, m(n)), y = JSON.stringify(s)), n && (v.push.apply(v, m(c)), b = JSON.stringify(v)), n && (g.push.apply(g, m(d)), O = JSON.stringify(g));
      },
      S = function (e) {
        var n = [];
        return ["省", "市", "区", "县", "镇"].forEach(function (c) {
          var d,
            o = (d = c, e.findIndex(function (e) {
              return ~e.indexOf(d);
            }));
          ~o && n.push(e.splice(o, 1)[0]);
        }), [].concat(n, m(e));
      },
      j = function (e, n) {
        var c = n.province || [],
          d = n.city || [],
          o = n.area || [],
          a = [],
          m = "";
        if (0 === c.length) {
          for (var r = 1; r < e.length; r++) {
            var i = e.substring(0, r + 1),
              l = new RegExp('{"code":"[0-9]{1,6}","name":"'.concat(i, '[一-龥]*?"}'), "g"),
              h = y.match(l);
            if (!h) break;
            var t = JSON.parse(h[0]);
            1 === h.length && (m = i, (c = []).push(t));
          }
          c[0] && (e = e.replace(new RegExp(m, "g"), ""));
        }
        if (0 === d.length) {
          for (var u = 1; u < e.length; u++) {
            var f = e.substring(0, u + 1),
              p = new RegExp('{"code":"[0-9]{1,6}","name":"'.concat(f, '[一-龥]*?","provinceCode":"').concat(c[0] ? "".concat(c[0].code) : "[0-9]{1,6}", '"}'), "g"),
              s = b.match(p);
            if (!s) break;
            var v = JSON.parse(s[0]);
            1 === s.length && (m = f, (d = []).push(v));
          }
          if (d[0]) {
            var g = d[0].provinceCode;
            if (e = e.replace(new RegExp(m, "g"), ""), 0 === c.length) {
              var x = new RegExp('{"code":"'.concat(g, '","name":"[一-龥]+?"}'), "g"),
                S = y.match(x);
              c.push(JSON.parse(S[0]));
            }
          }
        }
        if (0 === o.length) {
          for (var j = 1; j < e.length; j++) {
            var w = e.substring(0, j + 1),
              E = new RegExp('{"code":"[0-9]{1,9}","name":"'.concat(w, '[一-龥]*?","cityCode":"').concat(d[0] ? d[0].code : "[0-9]{1,6}", '","provinceCode":"').concat(c[0] ? "".concat(c[0].code) : "[0-9]{1,6}", '"}'), "g"),
              k = O.match(E);
            if (!k) break;
            var P = JSON.parse(k[0]);
            1 === k.length && (m = w, (o = []).push(P));
          }
          if (o[0]) {
            var C = o[0],
              J = C.provinceCode,
              N = C.cityCode;
            if (e = e.replace(m, ""), 0 === c.length) {
              var A = new RegExp('{"code":"'.concat(J, '","name":"[一-龥]+?"}'), "g"),
                R = y.match(A);
              c.push(JSON.parse(R[0]));
            }
            if (0 === d.length) {
              var $ = new RegExp('{"code":"'.concat(N, '","name":"[一-龥]+?","provinceCode":"').concat(J, '"}'), "g"),
                I = b.match($);
              d.push(JSON.parse(I[0]));
            }
          }
        }
        return e.length > 0 && a.push(e), {
          province: c,
          city: d,
          area: o,
          detail: a
        };
      },
      w = function (e, n) {
        var c = [],
          d = [],
          o = [],
          m = [];
        if (n.province[0]) c = n.province;else {
          var r,
            i = a(s);
          try {
            for (i.s(); !(r = i.n()).done;) {
              for (var l = r.value, h = l.name, t = "", u = h.length; u > 1; u--) {
                var f = h.substring(0, u);
                if (0 === e.indexOf(f)) {
                  t = f;
                  break;
                }
              }
              if (t) {
                c.push(l), e = e.replace(new RegExp(t, "g"), "");
                break;
              }
            }
          } catch (e) {
            i.e(e);
          } finally {
            i.f();
          }
        }
        if (n.city[0]) d = n.city;else {
          var p,
            y = a(v);
          try {
            var b = function () {
              var n = p.value,
                o = n.name,
                a = n.provinceCode,
                m = c[0];
              if (m) {
                if (m.code === a) {
                  for (var r = "", i = o.length; i > 1; i--) {
                    var l = o.substring(0, i);
                    if (0 === e.indexOf(l)) {
                      r = l;
                      break;
                    }
                  }
                  if (r) return d.push(n), e = e.replace(new RegExp(r, "g"), ""), "break";
                }
              } else {
                for (var h = o.length; h > 1; h--) {
                  var t = o.substring(0, h);
                  if (0 === e.indexOf(t)) {
                    d.push(n), c.push(s.find(function (e) {
                      return e.code === a;
                    })), e = e.replace(t, "");
                    break;
                  }
                }
                if (d.length > 0) return "break";
              }
            };
            for (y.s(); !(p = y.n()).done;) {
              if ("break" === b()) break;
            }
          } catch (e) {
            y.e(e);
          } finally {
            y.f();
          }
        }
        var O,
          x = a(g);
        try {
          var S = function () {
            var n = O.value,
              a = n.name,
              m = n.provinceCode,
              r = n.cityCode,
              i = c[0],
              l = d[0];
            if (i || l) {
              if (i && i.code === m || (l && l.code) === r) {
                for (var h = "", t = a.length; t > 1; t--) {
                  var u = a.substring(0, t);
                  if (0 === e.indexOf(u)) {
                    h = u;
                    break;
                  }
                }
                if (h) return o.push(n), !l && d.push(v.find(function (e) {
                  return e.code === r;
                })), !i && c.push(s.find(function (e) {
                  return e.code === m;
                })), e = e.replace(h, ""), "break";
              }
            } else {
              for (var f = a.length; f > 1; f--) {
                var p = a.substring(0, f);
                if (0 === e.indexOf(p)) {
                  o.push(n), d.push(v.find(function (e) {
                    return e.code === r;
                  })), c.push(s.find(function (e) {
                    return e.code === m;
                  })), e = e.replace(p, "");
                  break;
                }
              }
              if (o.length > 0) return "break";
            }
          };
          for (x.s(); !(O = x.n()).done;) {
            if ("break" === S()) break;
          }
        } catch (e) {
          x.e(e);
        } finally {
          x.f();
        }
        return e.length > 0 && m.push(e), {
          province: c,
          city: d,
          area: o,
          detail: m
        };
      },
      E = function (e, n) {
        if (!e || !/[\u4E00-\u9FA5]/.test(e)) return "";
        if (["先生", "小姐", "同志", "哥哥", "姐姐", "妹妹", "弟弟", "妈妈", "爸爸", "爷爷", "奶奶", "姑姑", "舅舅"].find(function (n) {
          return ~e.indexOf(n);
        })) return e;
        if (~["街道", "乡镇", "镇", "乡"].findIndex(function (n) {
          return ~e.indexOf(n);
        })) return "";
        var c = e.substring(0, 1);
        return e.length <= n && e.length > 1 && ~d.indexOf(c) ? e : "";
      },
      k = function (e) {
        var n = "";
        e = (e = (e = (e = e.replace(/(\d{3})-(\d{4})-(\d{4})/g, "$1$2$3")).replace(/(\d{3}) (\d{4}) (\d{4})/g, "$1$2$3")).replace(/(\d{4}) \d{4} \d{4}/g, "$1$2$3")).replace(/(\d{4})/g, "$1");
        var c = /(0|\+?86-?|17951|)?1[3456789]\d{9}/g.exec(e);
        return c && (n = c[0], e = e.replace(c[0], " ")), {
          address: e,
          phone: n
        };
      },
      P = function (e) {
        var n = "",
          c = /[1-9]\d{5}(?!\d)/g.exec(e);
        return c && (n = c[0], e = e.replace(c[0], " ")), {
          address: e,
          postalCode: n
        };
      },
      C = function (e) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
        e = e.replace(/\r\n/g, " ").replace(/\n/g, " ").replace(/\t/g, " ");
        var c = ["详细地址", "收货地址", "收件地址", "地址", "所在地区", "姓名", "收货人", "收件人", "联系人", "收", "邮编", "联系电话", "电话", "联系人手机号码", "手机号码", "手机号", "自治区直辖县级行政区划", "省直辖县级行政区划"].concat(n);
        c.forEach(function (n) {
          e = e.replace(new RegExp(n, "g"), " ");
        });
        var d = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“’。，、？]", "g");
        return e = (e = e.replace(d, " ")).replace(/ {2,}/g, " ");
      };
    n.default = function (e, n) {
      var c = "object" === l(n) ? n : "number" == typeof n ? {
          type: n
        } : {},
        d = c.type,
        o = void 0 === d ? 0 : d,
        a = c.extraGovData,
        r = void 0 === a ? {} : a,
        i = c.textFilter,
        h = void 0 === i ? [] : i,
        t = c.nameMaxLength,
        u = void 0 === t ? 4 : t;
      if (!e) return {};
      x(r);
      var f = {
        phone: "",
        province: [],
        city: [],
        area: [],
        detail: [],
        name: ""
      };
      e = C(e, h);
      var p = k(e);
      e = p.address, f.phone = p.phone;
      var s = P(e);
      e = s.address, f.postalCode = s.postalCode;
      var v = e.split(" ").filter(function (e) {
        return e && !/^\d+$/.test(e);
      }).map(function (e) {
        return e.trim();
      });
      v = S(v);
      new Date().getTime();
      v.forEach(function (e, n) {
        if (f.province[0] && f.city[0] && f.area[0]) f.detail.push(e);else {
          var c = {};
          1 === o && (c = w(e, f)), 0 === o && (c = j(e, f));
          var d = c,
            a = d.province,
            m = d.city,
            r = d.area,
            i = d.detail;
          f.province = a || [], f.area = r || [], f.city = m || [], f.detail = f.detail.concat(i || []);
        }
      });
      new Date().getTime();
      var g = f.province[0],
        y = f.city[0],
        b = f.area[0],
        O = f.detail;
      if (O = O.map(function (e) {
        return e.replace(new RegExp("".concat(g && g.name, "|").concat(y && y.name, "|").concat(b && b.name), "g"), "");
      }), (O = Array.from(new Set(O))) && O.length > 0) {
        var J = m(O).filter(function (e) {
          return !!e;
        });
        J.sort(function (e, n) {
          return e.length - n.length;
        });
        var N = J.findIndex(function (e) {
            return E(e, u);
          }),
          A = "";
        ~N ? A = J[N] : J[0].length <= u && /[\u4E00-\u9FA5]/.test(J[0]) && (A = J[0]), A && (f.name = A, O.splice(O.findIndex(function (e) {
          return e === A;
        }), 1));
      }
      JSON.stringify(f);
      var R = g && g.name,
        $ = y && y.name;
      return ~["市辖区", "区", "县", "镇"].indexOf($) && ($ = R), Object.assign(f, {
        province: R || "",
        city: $ || "",
        area: b && b.name || "",
        detail: O && O.length > 0 && O.join("") || ""
      });
    };
  }]).default;
});

/***/ }),

/***/ "e+zK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: " flex-wrap",
    staticStyle: {
      "display": "flex"
    }
  }, [_vm._l((_vm.imgs), function(item, index) {
    return [(_vm.showImg(item)) ? _c('div', {
      key: index,
      staticClass: "upload-warp"
    }, [_c('img', {
      staticClass: "hover imgs",
      attrs: {
        "src": item.url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "del-mask"
    }, [_c('div', {
      staticClass: "icons"
    }, [_c('Icon', {
      attrs: {
        "type": "md-eye",
        "size": "18",
        "color": "#fff"
      },
      on: {
        "click": function($event) {
          return _vm.handlePreview(item.url)
        }
      }
    }), _vm._v(" "), _c('Icon', {
      attrs: {
        "type": "ios-trash",
        "size": "18",
        "color": "#fff"
      },
      on: {
        "click": function($event) {
          return _vm.handleDelImg(index)
        }
      }
    })], 1)]), _vm._v(" "), (item.jigou) ? _c('span', {
      staticClass: "og-name"
    }, [_vm._v(_vm._s(item.jigou.name))]) : _vm._e()]) : _vm._e()]
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "footerHide": "",
      "width": "850px",
      "title": "图片预览"
    },
    model: {
      value: (_vm.showPreview),
      callback: function($$v) {
        _vm.showPreview = $$v
      },
      expression: "showPreview"
    }
  }, [_c('img', {
    staticClass: "pre-img",
    attrs: {
      "src": _vm.previewImg
    }
  })])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eLH1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "20px 0"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "border-top": "1px solid #f1f1f1",
      "margin-top": "20px",
      "padding-bottom": "40px"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "icon": "ios-search",
      "placeholder": "输入名称或编号查询..."
    },
    on: {
      "on-enter": _vm.keywordsChanged
    },
    model: {
      value: (_vm.query.keywords),
      callback: function($$v) {
        _vm.$set(_vm.query, "keywords", $$v)
      },
      expression: "query.keywords"
    }
  }), _vm._v(" "), (_vm.usedKeywords) ? _c('Tag', {
    staticStyle: {
      "height": "32px",
      "line-height": "32px",
      "margin": "0"
    },
    attrs: {
      "closable": ""
    },
    on: {
      "on-close": _vm.clearKeywords
    }
  }, [_vm._v("\n                搜索：" + _vm._s(_vm.usedKeywords))]) : _vm._e()], 1), _vm._v(" "), (_vm.kucunmobans.length) ? _c('div', [_c('Table', {
    attrs: {
      "columns": _vm.columns1,
      "loading": _vm.loading,
      "data": _vm.kucunmobans
    },
    on: {
      "on-select": _vm.itemSelected,
      "on-select-cancel": _vm.itemSelectedCancel,
      "on-select-all": _vm.allSelected,
      "on-select-all-cancel": _vm.allSelectedCancel
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('Page', {
    staticStyle: {
      "padding": "16px"
    },
    attrs: {
      "size": "small",
      "placement": "top",
      "total": _vm.total,
      "current": _vm.page.current,
      "page-size": _vm.page.size,
      "show-total": ""
    },
    on: {
      "on-change": _vm.pageChanged
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.kucunmobans.length) ? _c('div', {
    staticClass: "center",
    staticStyle: {
      "color": "#aaa",
      "min-height": "200px"
    }
  }, [_vm._v("暂无数据")]) : _vm._e()])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "font-size": "20px",
      "padding": "0 20px"
    }
  }, [_c('div', [_vm._v("选择要使用的模板")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "f+Sb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    /**图片数组 */
    imgs: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      session: this.$store.session,
      showPreview: false,
      previewImg: ''
    };
  },

  methods: {
    /**查看图片权限-自己和下级机构 */
    showImg: function showImg(item) {
      if (!this.session.jigou || !item.jigou) return false;
      return this.session.jigou._id === item.jigou._id || this.session.zhanghao.guanxiajigous.find(function (jg) {
        return jg._id === item.jigou._id;
      });
    },

    /**预览图片 */
    handlePreview: function handlePreview(img) {
      this.showPreview = true;
      this.previewImg = img;
    },

    /**删除图片 */
    handleDelImg: function handleDelImg(index) {
      this.$emit('del', index);
    }
  }
});

/***/ }),

/***/ "f3aI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ftv1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    // 宽度
    width: {
      type: Number,
      default: 800
    },
    // 方向
    placement: {
      type: String,
      default: 'left'
    },
    // tooltip内容
    content: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: '说明'
    },
    // 颜色
    color: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: 'ios-help-circle'
    },
    size: {
      type: [String, Number],
      default: 16
    }
  }
});

/***/ }),

/***/ "fyPN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    computed: {
        keyongguanxiajigous: function keyongguanxiajigous() {
            return this.session.zhanghao.guanxiajigous.filter(function (item) {
                return item.actived === undefined || item.actived;
            });
        }
    },
    data: function data() {
        return {
            zhengshuguanli: false,
            qrcodetype: null,
            session: this.$store.session,
            loading: false,
            nameInput: false,
            phoneInput: false,
            phoneInputStep: 1,
            form: {},
            cd: -1,
            codeSend: false,
            qrcode: null,
            qrcodeModal: false,
            binderror: null,
            bind: false,
            firstlevel: []
        };
    },
    mounted: function mounted() {
        this.loadData();
    },

    methods: {
        hideChildren: function hideChildren() {
            var _this = this;

            var firstlevel = [];

            var _loop = function _loop(item) {
                if (!item.parent) {
                    firstlevel.push(item);
                    return 'continue';
                }
                var p = item.parent ? _this.keyongguanxiajigous.find(function (o) {
                    return o._id == item.parent._id;
                }) : null;
                if (p) {
                    p.childCount = (p.childCount || 0) + 1;
                    return 'continue';
                }
                if (item.actived !== false) firstlevel.push(item);
            };

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.keyongguanxiajigous), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    var _ret = _loop(item);

                    if (_ret === 'continue') continue;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            this.firstlevel = firstlevel;
        },
        countChild: function countChild(jigou, parent) {
            if (parent.parent) {
                var parent2 = this.keyongguanxiajigous.findOne({ _id: parent.parent._id });
                if (parent2) {
                    return this.countChild(parent, parent2);
                }
            }
            parent.childCount++;
        },
        toBindWechat: function toBindWechat() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var res;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this2.bind = false;
                                _this2.binderror = null;
                                _this2.qrcodeModal = true;
                                _this2.qrcodetype = _this2.session.user.pubopenid ? 'unbind' : 'bind';
                                _this2.loading = true;
                                _context.next = 7;
                                return _this2.$api.post('/web/main/qrcode/load', {
                                    type: _this2.qrcodetype,
                                    phone: _this2.session.user.phone
                                });

                            case 7:
                                res = _context.sent;

                                _this2.loading = false;
                                _this2.qrcode = res.data.qrcode;

                            case 10:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        qrcodeScaned: function qrcodeScaned(res) {
            if (res.data.error) {
                this.binderror = res.data.error;
                this.$Message.error(res.data.error);
            } else {
                this.bind = true;
                this.qrcode = null;
                if (res.data.type == 'bind') {
                    this.session.user.pubopenid = res.data.pubopenid;
                } else if (res.data.type == 'unbind') {
                    this.session.user.pubopenid = null;
                }
            }
        },
        savePhone: function savePhone() {
            var _this3 = this;

            this.loading = true;
            this.$api.post('/web/session/profile/phone/update', {
                phone: this.form.phone,
                code: this.form.smscode
            }).then(function (res) {
                if (res.data.success) {
                    _this3.codeSend = false;
                    _this3.cd = -1;
                    _this3.phoneInputStep = 1;
                    _this3.phoneInput = false;
                    _this3.$Message.success('更新成功');
                    _this3.session.user.phone = _this3.form.phone;
                    _this3.session.zhanghao.user.phone = _this3.form.phone;
                }
                _this3.loading = false;
            }, function () {
                _this3.loading = false;
            });
        },
        checkCode: function checkCode(phone) {
            var _this4 = this;

            this.loading = true;
            this.$api.post('/web/session/profile/smscode/check', {
                phone: phone,
                code: this.form.smscode
            }).then(function (res) {
                if (res.data.success) {
                    _this4.codeSend = false;
                    _this4.cd = -1;
                    _this4.phoneInputStep = 2;
                    _this4.form.smscode = null;
                }
                _this4.loading = false;
            }, function () {
                _this4.loading = false;
            });
        },
        sendCode: function sendCode(phone) {
            var _this5 = this;

            if (!phone || !/^1\d{10}$/.test(phone)) {
                this.$Message.warning('请输入正确手机号');
                return;
            }
            this.loading = true;
            this.$api.post('/web/session/profile/smscode/send', {
                phone: phone
            }).then(function (res) {
                if (res.data.success) {
                    _this5.codeSend = true;
                    _this5.cd = 60;
                    _this5.runCD();
                }
                _this5.loading = false;
            }, function () {
                _this5.loading = false;
            });
        },
        runCD: function runCD() {
            var _this6 = this;

            this.cd--;
            if (this.cd > 0) {
                setTimeout(function () {
                    _this6.runCD();
                }, 1000);
            }
        },
        nameChanged: function nameChanged() {
            var that = this;
            that.loading = true;
            that.$api.post('/web/session/profile/update', {
                form: { 'zhenshixingming': that.form.zhenshixingming }
            }).then(function (res) {
                if (res.data.success) {
                    that.$Message.success('更新成功');
                    that.session.zhanghao.name = that.form.zhenshixingming;
                    that.session.z.name = that.form.zhenshixingming;
                }
                that.loading = false;
            }, function () {
                that.loading = false;
            });
            that.nameInput = false;
        },
        loadData: function loadData() {
            var _this7 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var that, res;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                that = _this7;

                                that.loading = true;
                                _context2.next = 4;
                                return that.$api.post('/web/session/profile/load', {});

                            case 4:
                                res = _context2.sent;

                                _this7.session = res.data.session;
                                _this7.zhengshuguanli = res.data.zhengshuguanli;
                                _this7.yunxuweixin = res.data.yunxuweixin;
                                if (_this7.session.zhanghao.jueses && _this7.session.zhanghao.jueses.findOne({ name: '集团管理员' })) {
                                    _this7.session.zhanghao.jituanadmin = true;
                                }
                                _this7.hideChildren();

                            case 10:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this7);
            }))();
        }
    }
});

/***/ }),

/***/ "gCtd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gS2X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Caozuojilu_vue__ = __webpack_require__("+blG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67e18955_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Caozuojilu_vue__ = __webpack_require__("dkQH");
function injectStyle (ssrContext) {
  __webpack_require__("Zdz5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-67e18955"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Caozuojilu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67e18955_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Caozuojilu_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gYAa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_baseLayout_vue__ = __webpack_require__("Sqqx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5f517b4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_baseLayout_vue__ = __webpack_require__("EPV4");
function injectStyle (ssrContext) {
  __webpack_require__("bash")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d5f517b4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_baseLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5f517b4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_baseLayout_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ghPf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_price__ = __webpack_require__("rlYW");





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        options: {
            type: Object,
            default: {}
        },
        nopage: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            session: this.$store.session,
            loading: false,
            query: {
                keywords: '',
                init: true
            },
            usedKeywords: '',
            page: {
                current: 1,
                size: 10
            },
            total: 0,
            columns: [{ type: 'selection', align: 'center', width: 60 }].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(this.options.columns)),
            results: [],
            selections: [],
            uploadConfig: null,
            importErrorModal: false,
            importErrors: [],
            importedItems: []
        };
    },
    mounted: function mounted() {
        if (this.options.all) {
            this.page.size = 99999999;
        } else {
            this.page.size = Number(sessionStorage['query:' + this.options.datatype + '.pagesize']) || 5;
        }
        if (this.options.current) {
            if (this.options.multi) {
                this.selections = this.options.current.map(function (item) {
                    return item;
                }); //使用map中断引用传递
            } else {
                this.selections = [this.options.current];
            }
            if (this.options.disablecurrent) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.selections), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var item = _step.value;

                        item._disabled = true;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
        this.loadData();
    },

    methods: {
        exportSelections: function exportSelections() {
            this.$refs.sheet.exportCsv({
                filename: '数据导出_' + this.selections.length + '条_' + new Date().getTime(),
                columns: this.options.importColumns,
                data: this.selections
            });
        },
        toImport: function toImport(_ref) {
            var _this = this;

            var url = _ref.url;
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
                var loadurl, res, _res$data, items, errors;

                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                console.log('url', url);
                                _this.loading = true;
                                loadurl = _this.options.loadurl || '/web/main/selector/load';
                                _context.next = 5;
                                return _this.$api.post(loadurl, {
                                    datatype: _this.options.datatype,
                                    query: _this.query,
                                    fields: _this.options.fields,
                                    loadSelectionFromFile: url,
                                    importColumns: _this.options.importColumns
                                });

                            case 5:
                                res = _context.sent;

                                _this.loading = false;
                                _res$data = res.data, items = _res$data.items, errors = _res$data.errors;

                                _this.importedItems = items;

                                if (!(errors && errors.length)) {
                                    _context.next = 13;
                                    break;
                                }

                                _this.importErrors = errors;
                                _this.importErrorModal = true;
                                return _context.abrupt('return');

                            case 13:

                                _this.importErrors = [];
                                _this.doImport();

                            case 15:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        doImport: function doImport() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, item, formItem;

                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this2.importErrorModal = false;
                                _iteratorNormalCompletion2 = true;
                                _didIteratorError2 = false;
                                _iteratorError2 = undefined;
                                _context2.prev = 4;
                                for (_iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(_this2.importedItems); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                    item = _step2.value;
                                    formItem = _this2.selections.findOne({ _id: item._id });

                                    if (!formItem) {
                                        _this2.selections.push(item);
                                    }
                                }
                                _context2.next = 12;
                                break;

                            case 8:
                                _context2.prev = 8;
                                _context2.t0 = _context2['catch'](4);
                                _didIteratorError2 = true;
                                _iteratorError2 = _context2.t0;

                            case 12:
                                _context2.prev = 12;
                                _context2.prev = 13;

                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                    _iterator2.return();
                                }

                            case 15:
                                _context2.prev = 15;

                                if (!_didIteratorError2) {
                                    _context2.next = 18;
                                    break;
                                }

                                throw _iteratorError2;

                            case 18:
                                return _context2.finish(15);

                            case 19:
                                return _context2.finish(12);

                            case 20:
                                _this2.resultUpdate();

                            case 21:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2, [[4, 8, 12, 20], [13,, 15, 19]]);
            }))();
        },
        fileUploadSuccess: function fileUploadSuccess(res, file) {
            console.log('fileUploadSuccess', res, file);
            file.url = '//igyl.weizhilian.com/' + res.key;
            this.loading = false;
            this.toImport({ url: file.url });
        },
        fileProgress: function fileProgress(res, file) {
            if (!file) {
                return;
            }
            this.detailModal = true;
            this.loading = true;
        },
        refreshUploadToken: function refreshUploadToken() {
            var that = this;
            that.loadUploadToken(function (token) {
                that.uploadConfig = {
                    token: token
                };
            });
        },
        clearKeywords: function clearKeywords() {
            this.query.keywords = '';
            this.usedKeywords = '';
            this.loadData();
        },
        keywordsChanged: function keywordsChanged() {
            this.usedKeywords = this.query.keywords;
            this.page.current = 1;
            this.loadData();
        },
        pageChanged: function pageChanged(value) {
            this.page.current = value;
            this.loadData();
        },
        pageSizeChanged: function pageSizeChanged(value) {
            this.page.size = value;
            sessionStorage['query:' + this.options.datatype + '.pagesize'] = value;
            if (this.page.current == 1) this.loadData();
        },
        loadData: function loadData() {
            var _this3 = this;

            this.loading = true;
            if (this.options.query) {
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.options.query)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var key = _step3.value;

                        this.query[key] = this.options.query[key];
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
            }
            var loadurl = this.options.loadurl || '/web/main/selector/load';
            this.$api.post(loadurl, {
                datatype: this.options.datatype,
                query: this.query,
                page: this.page,
                fields: this.options.fields
            }).then(function (res) {
                _this3.loading = false;
                if (_this3.query.init) {
                    _this3.query.init = false;
                }
                _this3.total = res.data.total;
                _this3.usedKeywords = _this3.query.keywords;
                var results = res.data.results;
                var _iteratorNormalCompletion4 = true;
                var _didIteratorError4 = false;
                var _iteratorError4 = undefined;

                try {
                    for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(results), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                        var result = _step4.value;

                        var item = _this3.selections.findOne({ _id: result._id });
                        if (item) {
                            result._checked = true;
                            if (item._disabled) {
                                result._disabled = true;
                            }
                        }
                        var _iteratorNormalCompletion5 = true;
                        var _didIteratorError5 = false;
                        var _iteratorError5 = undefined;

                        try {
                            for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(_this3.columns), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                                var c = _step5.value;

                                if (c.fix) {
                                    result[c.key] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_price__["a" /* AmountDecimal */])(result[c.key], c.fix);
                                }
                            }
                        } catch (err) {
                            _didIteratorError5 = true;
                            _iteratorError5 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                                    _iterator5.return();
                                }
                            } finally {
                                if (_didIteratorError5) {
                                    throw _iteratorError5;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError4 = true;
                    _iteratorError4 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
                            _iterator4.return();
                        }
                    } finally {
                        if (_didIteratorError4) {
                            throw _iteratorError4;
                        }
                    }
                }

                _this3.results = results;
                if (_this3.options.disableItem) {
                    _this3.options.disableItem(_this3, _this3.results, _this3.selections);
                }
            }, function () {
                _this3.loading = false;
            });
        },
        search: function search() {
            this.loadData();
        },
        cancel: function cancel() {
            this.$emit('cancel');
        },
        confirm: function confirm() {
            var _iteratorNormalCompletion6 = true;
            var _didIteratorError6 = false;
            var _iteratorError6 = undefined;

            try {
                for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.selections), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                    var s = _step6.value;

                    delete s._checked;
                    delete s._disabled;
                }
            } catch (err) {
                _didIteratorError6 = true;
                _iteratorError6 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion6 && _iterator6.return) {
                        _iterator6.return();
                    }
                } finally {
                    if (_didIteratorError6) {
                        throw _iteratorError6;
                    }
                }
            }

            var value = void 0;
            if (this.options.multi) {
                value = this.selections;
            } else {
                value = this.selections[0];
            }
            if (this.options.fields) {
                value = this.simple(value, this.options.fields);
            }
            this.$emit('confirm', value);
        },
        showSelections: function showSelections() {
            this.query.selections = this.selections.map(function (item) {
                return { _id: item._id };
            });
            this.page.current = 1;
            this.loadData();
        },
        clearSelections: function clearSelections() {
            this.selections = this.selections.filter(function (o) {
                return o._disabled;
            });
            var results = [];
            var _iteratorNormalCompletion7 = true;
            var _didIteratorError7 = false;
            var _iteratorError7 = undefined;

            try {
                for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.results), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                    var item = _step7.value;

                    if (!item._disabled) {
                        item._checked = false;
                    }
                    results.push(item);
                }
            } catch (err) {
                _didIteratorError7 = true;
                _iteratorError7 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion7 && _iterator7.return) {
                        _iterator7.return();
                    }
                } finally {
                    if (_didIteratorError7) {
                        throw _iteratorError7;
                    }
                }
            }

            this.results = results;
            if (this.options.disableItem) {
                this.options.disableItem(this, this.results, this.selections);
            }
        },
        allSelected: function allSelected(items) {
            if (this.options.disableItem) {
                //如果存在选择冲突项目，需要一个一个选择以排除冲突
                var _iteratorNormalCompletion8 = true;
                var _didIteratorError8 = false;
                var _iteratorError8 = undefined;

                try {
                    for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.results), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                        var item = _step8.value;

                        var current = this.selections.findOne({ _id: item._id });
                        if (!current && !item._disabled) {
                            this.itemSelected({}, item);
                        }
                    }
                } catch (err) {
                    _didIteratorError8 = true;
                    _iteratorError8 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion8 && _iterator8.return) {
                            _iterator8.return();
                        }
                    } finally {
                        if (_didIteratorError8) {
                            throw _iteratorError8;
                        }
                    }
                }
            } else {
                var _iteratorNormalCompletion9 = true;
                var _didIteratorError9 = false;
                var _iteratorError9 = undefined;

                try {
                    for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(items), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                        var _item = _step9.value;

                        if (!this.selections.findOne({ _id: _item._id })) {
                            if (!_item._disabled) {
                                this.selections.push(_item);
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError9 = true;
                    _iteratorError9 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion9 && _iterator9.return) {
                            _iterator9.return();
                        }
                    } finally {
                        if (_didIteratorError9) {
                            throw _iteratorError9;
                        }
                    }
                }
            }
        },
        allSelectedCancel: function allSelectedCancel() {
            if (this.options.disableItem) {
                var _iteratorNormalCompletion10 = true;
                var _didIteratorError10 = false;
                var _iteratorError10 = undefined;

                try {
                    for (var _iterator10 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.results), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                        var item = _step10.value;

                        this.itemSelectedCancel({}, item);
                    }
                } catch (err) {
                    _didIteratorError10 = true;
                    _iteratorError10 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion10 && _iterator10.return) {
                            _iterator10.return();
                        }
                    } finally {
                        if (_didIteratorError10) {
                            throw _iteratorError10;
                        }
                    }
                }
            } else {
                var _iteratorNormalCompletion11 = true;
                var _didIteratorError11 = false;
                var _iteratorError11 = undefined;

                try {
                    for (var _iterator11 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.results), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
                        var _item2 = _step11.value;

                        if (!_item2._disabled) {
                            this.selections.remove({ _id: _item2._id });
                        }
                    }
                } catch (err) {
                    _didIteratorError11 = true;
                    _iteratorError11 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion11 && _iterator11.return) {
                            _iterator11.return();
                        }
                    } finally {
                        if (_didIteratorError11) {
                            throw _iteratorError11;
                        }
                    }
                }
            }
        },
        rowSelected: function rowSelected(item) {
            if (item._disabled) return;
            var current = this.selections.findOne({ _id: item._id });
            if (current) {
                this.itemSelectedCancel({}, item);
            } else {
                this.itemSelected({}, item);
            }
        },
        itemSelected: function itemSelected(_, item) {
            if (this.options.multi) {
                this.selections.push(item);
            } else {
                this.selections = [item];
            }
            this.resultUpdate();
        },
        itemSelectedCancel: function itemSelectedCancel(_, item) {
            this.selections.remove({ _id: item._id });
            this.resultUpdate();
        },
        resultUpdate: function resultUpdate() {
            var results = [];
            var _iteratorNormalCompletion12 = true;
            var _didIteratorError12 = false;
            var _iteratorError12 = undefined;

            try {
                for (var _iterator12 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.results), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
                    var result = _step12.value;

                    if (!result._disabled) {
                        var current = this.selections.findOne({ _id: result._id });
                        if (current) {
                            result._checked = true;
                        } else {
                            result._checked = false;
                        }
                    }
                    results.push(result);
                }
            } catch (err) {
                _didIteratorError12 = true;
                _iteratorError12 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion12 && _iterator12.return) {
                        _iterator12.return();
                    }
                } finally {
                    if (_didIteratorError12) {
                        throw _iteratorError12;
                    }
                }
            }

            this.results = results;
            if (this.options.disableItem) {
                this.options.disableItem(this, this.results, this.selections);
            }
        },
        getRowClass: function getRowClass() {
            return 'hover';
        }
    }
});

/***/ }),

/***/ "gomf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gpth":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "20px 0"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "border-top": "1px solid #f1f1f1",
      "border-bottom": "1px solid #f1f1f1",
      "margin-top": "20px",
      "padding": "20px"
    }
  }, [(!_vm.nameInput) ? _c('div', [_c('div', {
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.session.zhanghao.name) + "\n                "), _c('Icon', {
    staticClass: "hover",
    attrs: {
      "type": "ios-create-outline"
    },
    on: {
      "click": function($event) {
        _vm.nameInput = true;
        _vm.form.zhenshixingming = _vm.session.zhanghao.name
      }
    }
  })], 1), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.session.jigou.jituan.name)), (_vm.session.jigou.name != _vm.session.jigou.jituan.name) ? _c('span', [_vm._v(" - " + _vm._s(_vm.session.jigou.name))]) : _vm._e(), _vm._v("（ " + _vm._s(_vm.session.jigou.code) + " ）")])]) : _vm._e(), _vm._v(" "), (_vm.nameInput) ? _c('div', {
    staticStyle: {
      "font-size": "24px",
      "padding": "20px",
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("修改真实姓名:")]), _vm._v(" "), _c('Input', {
    staticStyle: {
      "width": "180px",
      "margin-left": "20px"
    },
    model: {
      value: (_vm.form.zhenshixingming),
      callback: function($$v) {
        _vm.$set(_vm.form, "zhenshixingming", $$v)
      },
      expression: "form.zhenshixingming"
    }
  }), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "default"
    },
    on: {
      "click": function($event) {
        _vm.nameInput = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.nameChanged
    }
  }, [_vm._v("确定")])], 1) : _vm._e()]), _vm._v(" "), (!_vm.phoneInput) ? _c('div', {
    staticClass: "jcsb",
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('div', [_c('div', {
    staticStyle: {
      "font-size": "18px",
      "font-weight": "bold"
    }
  }, [_vm._v("手机号")]), _vm._v(" "), _c('div', [_vm._v("已绑定手机号：" + _vm._s(_vm.session.user.phone))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', [(!_vm.session.user.pubopenid) ? _c('Button', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.toBindWechat
    }
  }, [_vm._v("绑定微信")]) : _c('Button', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.toBindWechat
    }
  }, [_vm._v("解绑微信")])], 1), _vm._v(" "), _c('Button', {
    on: {
      "click": function($event) {
        _vm.phoneInput = true
      }
    }
  }, [_vm._v("更换手机号")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.phoneInput) ? _c('div', [(_vm.phoneInputStep == 1) ? _c('div', [(_vm.codeSend == false) ? _c('div', {
    staticStyle: {
      "padding": "20px",
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', [_vm._v("验证原手机号:" + _vm._s(_vm.session.user.phone))]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.sendCode(_vm.session.user.phone)
      }
    }
  }, [_vm._v("发送验证码")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "default"
    },
    on: {
      "click": function($event) {
        _vm.phoneInput = false
      }
    }
  }, [_vm._v("取消")])], 1) : _vm._e(), _vm._v(" "), (_vm.codeSend) ? _c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('div', [_vm._v("请输入原手机号:" + _vm._s(_vm.session.user.phone) + "收到的验证码")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "margin-top": "10px"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "placeholder": "请输入验证码"
    },
    model: {
      value: (_vm.form.smscode),
      callback: function($$v) {
        _vm.$set(_vm.form, "smscode", $$v)
      },
      expression: "form.smscode"
    }
  }), _vm._v(" "), (_vm.cd > 0) ? _c('Button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "default",
      "disabled": ""
    }
  }, [_vm._v("重新获取（" + _vm._s(_vm.cd) + ")")]) : _vm._e(), _vm._v(" "), (_vm.cd <= 0) ? _c('Button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.sendCode(_vm.session.user.phone)
      }
    }
  }, [_vm._v("重新获取")]) : _vm._e(), _vm._v(" "), (!_vm.form.smscode) ? _c('Button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "default"
    },
    on: {
      "click": function($event) {
        _vm.phoneInput = false
      }
    }
  }, [_vm._v("取消")]) : _vm._e(), _vm._v(" "), (_vm.form.smscode) ? _c('Button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.checkCode()
      }
    }
  }, [_vm._v("继续")]) : _vm._e()], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.phoneInputStep == 2) ? _c('div', [(!_vm.codeSend) ? _c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('span', [_vm._v("请输入新手机号：")]), _vm._v(" "), _c('Input', {
    staticStyle: {
      "width": "200px"
    },
    model: {
      value: (_vm.form.phone),
      callback: function($$v) {
        _vm.$set(_vm.form, "phone", $$v)
      },
      expression: "form.phone"
    }
  }), _vm._v(" "), (_vm.cd > 0) ? _c('Button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "default",
      "disabled": ""
    }
  }, [_vm._v("获取验证码（" + _vm._s(_vm.cd) + ")")]) : _vm._e(), _vm._v(" "), (_vm.cd <= 0) ? _c('Button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.sendCode(_vm.form.phone)
      }
    }
  }, [_vm._v("获取验证码")]) : _vm._e(), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "default"
    },
    on: {
      "click": function($event) {
        _vm.phoneInputStep = 1
      }
    }
  }, [_vm._v("返回")])], 1) : _vm._e(), _vm._v(" "), (_vm.codeSend) ? _c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('div', [_vm._v("请输入新手机号:" + _vm._s(_vm.form.phone) + "收到的验证码")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "margin-top": "10px"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "placeholder": "请输入验证码"
    },
    model: {
      value: (_vm.form.smscode),
      callback: function($$v) {
        _vm.$set(_vm.form, "smscode", $$v)
      },
      expression: "form.smscode"
    }
  }), _vm._v(" "), (_vm.cd > 0) ? _c('Button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "default",
      "disabled": ""
    }
  }, [_vm._v("重新获取（" + _vm._s(_vm.cd) + ")")]) : _vm._e(), _vm._v(" "), (_vm.cd <= 0) ? _c('Button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.sendCode(_vm.form.phone)
      }
    }
  }, [_vm._v("重新获取")]) : _vm._e(), _vm._v(" "), (!_vm.form.smscode) ? _c('Button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "default"
    },
    on: {
      "click": function($event) {
        _vm.codeSend = false;
      }
    }
  }, [_vm._v("返回")]) : _vm._e(), _vm._v(" "), (_vm.form.smscode) ? _c('Button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.savePhone
    }
  }, [_vm._v("完成")]) : _vm._e()], 1)]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.zhengshuguanli && _vm.session && _vm.session.zhanghao && (!_vm.session.zhanghao.jituanadmin) && _vm.session.zhanghao.zhengshu) ? _c('div', {
    staticStyle: {
      "padding": "20px",
      "border-top": "1rpx solid #f1f1f1"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "font-weight": "bold"
    }
  }, [_vm._v("证书")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100px",
      "height": "150px"
    },
    attrs: {
      "src": _vm.session.zhanghao.zhengshu.url + '?imageView2/1/w/200/h/300'
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "20px",
      "border-top": "1rpx solid #f1f1f1"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "font-weight": "bold"
    }
  }, [_vm._v("角色")]), _vm._v(" "), _vm._l((_vm.session.zhanghao.jueses), function(item, index) {
    return _c('div', {
      key: index
    }, [_vm._v(_vm._s(item.name))])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), (_vm.session.zhanghao.jigou.type != 'MD') ? _c('div', [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "font-weight": "bold",
      "padding": "20px 0"
    }
  }, [_vm._v("管辖范围")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px",
      "background-color": "#fafafa",
      "min-width": "200px",
      "border-radius": "4px"
    }
  }, [_c('div', [_vm._v("管辖机构")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', [_c('span', {
    staticStyle: {
      "color": "#20bf64",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.keyongguanxiajigous.length))]), _vm._v(" 个机构")])]), _vm._v(" "), (_vm.firstlevel.length) ? _c('div', {
    staticStyle: {
      "max-height": "500px",
      "overflow-y": "scroll"
    }
  }, _vm._l((_vm.firstlevel), function(item, index) {
    return _c('div', {
      staticStyle: {
        "padding": "0 4px",
        "box-sizing": "border-box",
        "position": "relative",
        "margin-top": "8px"
      }
    }, [_c('div', {
      key: index,
      staticClass: "jcsb"
    }, [_c('div', {
      staticClass: "nowrap",
      staticStyle: {
        "width": "160px"
      }
    }, [_vm._v("- " + _vm._s(item.name) + "\n                                ")]), _vm._v(" "), _c('Tag', [_vm._v(_vm._s(item.type))])], 1)])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "20px"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px",
      "background-color": "#fafafa",
      "min-width": "200px",
      "border-radius": "4px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("管辖仓库")]), _vm._v(" "), (_vm.session.zhanghao['guanxiacangkumode'] == 'part') ? _c('div', [_c('span', {
    staticStyle: {
      "color": "#20bf64",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.session.zhanghao.guanxiacangkus.length))]), _vm._v("个仓库")]) : _c('div', [_vm._v("全部仓库")]), _vm._v(" "), (_vm.session.zhanghao.guanxiacangkus) ? _c('CustomData', {
    attrs: {
      "current": _vm.session.zhanghao.guanxiacangkus || [],
      "unimode": "",
      "moveable": false,
      "query": {},
      "fields": {
        _id: 1,
        name: 1,
        code: 1,
        'jigou._id': 1,
        'jigou.name': 1,
        'jigou.type': 1,
        'jiagongjian._id': 1,
        'jiagongjian.name': 1,
      },
      "multi": true,
      "editable": false,
      "datatype": "cangku"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "20px"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px",
      "background-color": "#fafafa",
      "min-width": "200px",
      "border-radius": "4px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("管辖供应商")]), _vm._v(" "), (_vm.session.zhanghao['guanxiagonghuojigoumode'] == 'part') ? _c('div', [_c('span', {
    staticStyle: {
      "color": "#20bf64",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.session.zhanghao.guanxiagonghuojigous.length))]), _vm._v("个供应商")]) : _c('div', [_vm._v("全部供应商")]), _vm._v(" "), (_vm.session.zhanghao.guanxiagonghuojigous) ? _c('CustomData', {
    attrs: {
      "current": _vm.session.zhanghao.guanxiagonghuojigous || [],
      "unimode": "",
      "moveable": false,
      "fields": {
        _id: 1,
        name: 1,
        code: 1
      },
      "multi": true,
      "query": {
        type: 'KS',
        mendian: null
      },
      "editable": false,
      "datatype": "jigou"
    }
  }) : _vm._e()], 1)])]) : _vm._e()], 2), _vm._v(" "), _c('Modal', {
    staticClass: "nopadding",
    attrs: {
      "footer-hide": "",
      "closable": true,
      "width": 280
    },
    model: {
      value: (_vm.qrcodeModal),
      callback: function($$v) {
        _vm.qrcodeModal = $$v
      },
      expression: "qrcodeModal"
    }
  }, [_c('div', {
    staticClass: "center",
    staticStyle: {
      "padding": "20px 40px"
    }
  }, [(!_vm.bind && !_vm.binderror) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.qrcode) ? _c('img', {
    staticStyle: {
      "width": "240px",
      "height": "240px",
      "border-radius": "16rpx"
    },
    attrs: {
      "src": _vm.qrcode.url
    }
  }) : _c('div', {
    staticStyle: {
      "color": "#aaa",
      "height": "240px",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    }
  }, [_vm._v("二维码加载中")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v(_vm._s(_vm.session.user.phone))]), _vm._v(" "), (_vm.qrcodetype == 'bind') ? _c('div', [_vm._v("微信扫码绑定该账号")]) : _vm._e(), _vm._v(" "), (_vm.qrcodetype == 'unbind') ? _c('div', [_vm._v("请使用绑定该账号的微信扫码解绑")]) : _vm._e()])]) : (_vm.binderror) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('Icon', {
    staticStyle: {
      "color": "red",
      "font-size": "80px"
    },
    attrs: {
      "type": "ios-close-circle"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v("绑定失败")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.binderror))])], 1) : (_vm.bind) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('Icon', {
    staticStyle: {
      "color": "#20bf64",
      "font-size": "80px"
    },
    attrs: {
      "type": "ios-checkmark-circle"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), (_vm.qrcodetype == 'bind') ? _c('div', {
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v("绑定成功")]) : _vm._e(), _vm._v(" "), (_vm.qrcodetype == 'unbind') ? _c('div', {
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v("解除绑定成功")]) : _vm._e(), _vm._v(" "), (_vm.qrcodetype == 'bind') ? _c('div', [_vm._v("已可使用微信扫码登陆系统")]) : _vm._e(), _vm._v(" "), (_vm.qrcodetype == 'unbind') ? _c('div', [_vm._v("已可使用新的微信绑定该账号")]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "20px"
    }
  })])], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "font-size": "20px",
      "padding": "0 20px"
    }
  }, [_c('div', [_vm._v("个人中心")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gsbP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "h2E7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "0 0"
    }
  }, [(!_vm.loading) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "flex-wrap": "wrap"
    }
  }, _vm._l((_vm.options.items), function(item, index) {
    return (!item.vif || item.vif(_vm.query)) ? _c('div', {
      key: index,
      staticStyle: {
        "margin-right": "10px",
        "margin-bottom": "10px"
      }
    }, [(item.type == 'selection') ? _c('Select', {
      style: (("width:" + (item.width || 240) + "px")),
      attrs: {
        "value": item.multi ? ((_vm.query[item.key] && _vm.query[item.key].length) ? _vm.query[item.key].map(function (i) {
          return item.render(i)
        }) : []) : item.render(_vm.query[item.key]),
        "multiple": item.multi || false,
        "filterable": item.filterable || false,
        "clearable": item.clearable || false,
        "max-tag-count": item['max-tag-count'],
        "max-tag-placeholder": item['max-tag-placeholder'],
        "placeholder": item.placeholder || '请选择'
      },
      on: {
        "on-change": function($event) {
          return _vm.selectorChanged(item, $event)
        }
      }
    }, [_vm._l((Object.keys(item.loader ? item.loader() : item.selections)), function(group) {
      return (item.group) ? _c('OptionGroup', {
        key: group,
        attrs: {
          "label": group
        }
      }, _vm._l((item.loader ? item.loader() : item.selections[group]), function(selection, selectionindex) {
        return _c('Option', {
          key: selectionindex,
          attrs: {
            "value": item.render(selection)
          }
        }, [_vm._v(_vm._s(item.render(selection)))])
      }), 1) : _vm._e()
    }), _vm._v(" "), _vm._l((item.loader ? item.loader() : item.selections), function(selection, selectionindex) {
      return (!item.group) ? _c('Option', {
        key: selectionindex,
        attrs: {
          "value": item.render(selection)
        }
      }, [_vm._v(_vm._s(item.render(selection)))]) : _vm._e()
    })], 2) : _vm._e(), _vm._v(" "), (item.type == 'daterange') ? _c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [(item.riqitypes) ? _c('Select', {
      staticStyle: {
        "width": "100px",
        "margin-right": "10px"
      },
      on: {
        "on-change": function($event) {
          return _vm.riqitypeChanged(item, $event);
        }
      },
      model: {
        value: (_vm.query.riqitype),
        callback: function($$v) {
          _vm.$set(_vm.query, "riqitype", $$v)
        },
        expression: "query.riqitype"
      }
    }, _vm._l((item.riqitypes), function(riqitype) {
      return _c('Option', {
        key: riqitype,
        attrs: {
          "value": riqitype
        }
      }, [_vm._v(_vm._s(riqitype))])
    }), 1) : _vm._e(), _vm._v(" "), _c('DatePicker', {
      style: (("width:" + (item.width || 432) + "px")),
      attrs: {
        "value": _vm.query.riqi,
        "format": "yyyy-MM-dd",
        "type": "daterange",
        "placement": "bottom-end",
        "placeholder": item.label || '选择日期范围',
        "clearable": item.clearable || false
      },
      on: {
        "on-change": function($event) {
          return _vm.daterangeChanged(item, $event)
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.type == 'text') ? _c('div', [(!_vm.query[item.key]) ? _c('Input', {
      ref: 'input:' + item.key,
      refInFor: true,
      style: (("width:" + (item.width || 240) + "px")),
      attrs: {
        "icon": "ios-search",
        "placeholder": item.placeholder || ''
      },
      on: {
        "on-enter": function($event) {
          return _vm.textChanged(item)
        }
      },
      model: {
        value: (_vm.inputing[item.key]),
        callback: function($$v) {
          _vm.$set(_vm.inputing, item.key, $$v)
        },
        expression: "inputing[item.key]"
      }
    }) : _vm._e(), _vm._v(" "), ((!!_vm.query[item.key])) ? _c('div', {
      staticClass: "jcsb nowrap",
      style: (("height: 32px;line-height: 32px;margin: 0;width: " + (item.width || 240) + "px;background-color: #f5f5f5;color: #aaa;padding: 0 8px;border-radius: 4px;")),
      on: {
        "click": function($event) {
          return _vm.textEdit(item)
        }
      }
    }, [_c('div', [_vm._v(_vm._s(_vm.query[item.key]))]), _vm._v(" "), _c('Icon', {
      attrs: {
        "type": "ios-close-circle"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.textClear(item)
        }
      }
    })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (item.type == 'numberrange') ? _c('div', [((!!_vm.query[item.key] && (_vm.query[item.key][0] || _vm.query[item.key][1]))) ? _c('div', {
      on: {
        "click": function($event) {
          return _vm.numberrangeEdit(item)
        }
      }
    }, [(item.label) ? _c('div', {
      style: (("height: 32px;line-height: 32px;margin: 0;width: " + (item.width || 320) + "px;background-color:#f5f5f5;color:#aaa;padding: 0 8px;border-radius: 4px;"))
    }, [_c('div', {
      staticClass: "jcsb"
    }, [_c('div', {
      staticClass: "df"
    }, [_c('div', {
      style: (("width:" + ((item.label.length+1) * 16) + "px;color:#aaa"))
    }, [_vm._v(_vm._s(item.label) + "：")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "80px",
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(_vm.query[item.key][0] ? _vm.query[item.key][0] : '0'))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin": "0 10px"
      }
    }, [_vm._v("~")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "80px",
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(_vm.query[item.key][1] ? _vm.query[item.key][1] : '∞'))])]), _vm._v(" "), _c('Icon', {
      staticStyle: {
        "color": "#999"
      },
      attrs: {
        "type": "ios-close-circle"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.numberrangeClear(item)
        }
      }
    })], 1)]) : _c('div', [_vm._v("label required")])]) : _c('div', [(item.label) ? _c('div', {
      style: (("height: 32px;line-height: 32px;margin: 0;width: " + (item.width || 320) + "px;border:1px solid #ddd;padding: 0 8px;border-radius: 4px;"))
    }, [_c('div', {
      staticClass: "jcsb"
    }, [_c('div', {
      staticClass: "df"
    }, [_c('div', {
      style: (("width:" + ((item.label.length+1) * 16) + "px;color:#aaa"))
    }, [_vm._v(_vm._s(item.label) + "：")]), _vm._v(" "), _c('Input', {
      ref: 'input:' + item.key + '_min',
      refInFor: true,
      staticStyle: {
        "width": "80px",
        "text-align": "center",
        "background-color": "#f1f1f1"
      },
      attrs: {
        "size": "small",
        "placeholder": "最小值",
        "border": false
      },
      on: {
        "on-enter": function($event) {
          return _vm.numberrangeChanged(item)
        }
      },
      model: {
        value: (_vm.inputing[((item.key) + "_min")]),
        callback: function($$v) {
          _vm.$set(_vm.inputing, ((item.key) + "_min"), _vm._n($$v))
        },
        expression: "inputing[`${item.key}_min`]"
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin": "0 10px"
      }
    }, [_vm._v("~")]), _vm._v(" "), _c('Input', {
      ref: 'input:' + item.key + '_max',
      refInFor: true,
      staticStyle: {
        "width": "80px",
        "text-align": "center",
        "background-color": "#f1f1f1"
      },
      attrs: {
        "size": "small",
        "placeholder": "最大值",
        "border": false
      },
      on: {
        "on-enter": function($event) {
          return _vm.numberrangeChanged(item)
        }
      },
      model: {
        value: (_vm.inputing[((item.key) + "_max")]),
        callback: function($$v) {
          _vm.$set(_vm.inputing, ((item.key) + "_max"), _vm._n($$v))
        },
        expression: "inputing[`${item.key}_max`]"
      }
    })], 1), _vm._v(" "), _c('Icon', {
      staticStyle: {
        "color": "#999"
      },
      attrs: {
        "type": "ios-search"
      }
    })], 1)]) : _c('div', [_vm._v("label required")])])]) : _vm._e(), _vm._v(" "), (item.type == 'jigou' || item.type == 'gonghuojigou') ? _c('BaseSelect', {
      attrs: {
        "value": _vm.query[item.key],
        "multiple": item.multi,
        "type": item.type,
        "parameter": item.query,
        "placeholder": item.placeholder
      },
      on: {
        "change": function($event) {
          return _vm.jigouChanged(item, $event)
        }
      }
    }) : _vm._e()], 1) : _vm._e()
  }), 0) : _vm._e(), _vm._v(" "), (_vm.options.confirm) ? _c('div', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.doQuery
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('Button', {
    on: {
      "click": _vm.init
    }
  }, [_vm._v("重置条件")])], 1) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hW7o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_nav__ = __webpack_require__("tfKK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_before_close__ = __webpack_require__("rRlr");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TagsNav',
  props: {
    value: Object,
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      tagBodyLeft: 0,
      rightOffset: 40,
      outerPadding: 4,
      contextMenuLeft: 0,
      contextMenuTop: 0,
      visible: false,
      menuList: {
        others: '关闭其他',
        all: '关闭所有'
      }
    };
  },

  computed: {
    currentRouteObj: function currentRouteObj() {
      var _value = this.value,
          name = _value.name,
          params = _value.params,
          query = _value.query;

      return { name: name, params: params, query: query };
    }
  },
  methods: {
    handlescroll: function handlescroll(e) {
      var type = e.type;
      var delta = 0;
      if (type === 'DOMMouseScroll' || type === 'mousewheel') {
        delta = e.wheelDelta ? e.wheelDelta : -(e.detail || 0) * 40;
      }
      this.handleScroll(delta);
    },
    handleScroll: function handleScroll(offset) {
      var outerWidth = this.$refs.scrollOuter.offsetWidth;
      var bodyWidth = this.$refs.scrollBody.offsetWidth;
      if (offset > 0) {
        this.tagBodyLeft = Math.min(0, this.tagBodyLeft + offset);
      } else {
        if (outerWidth < bodyWidth) {
          if (this.tagBodyLeft < -(bodyWidth - outerWidth)) {
            this.tagBodyLeft = this.tagBodyLeft;
          } else {
            this.tagBodyLeft = Math.max(this.tagBodyLeft + offset, outerWidth - bodyWidth);
          }
        } else {
          this.tagBodyLeft = 0;
        }
      }
    },
    handleTagsOption: function handleTagsOption(type) {
      var _this = this;

      if (type.includes('all')) {
        // 关闭所有，除了home
        var res = this.list.filter(function (item) {
          return item.name === '首页';
        });
        this.$emit('on-close', res, 'all');
      } else if (type.includes('others')) {
        // 关闭除当前页和home页的其他页
        var _res = this.list.filter(function (item) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_nav__["a" /* routeEqual */])(_this.currentRouteObj, item) || item.name === '首页';
        });
        this.$emit('on-close', _res, 'others', this.currentRouteObj);
        setTimeout(function () {
          _this.getTagElementByRoute(_this.currentRouteObj);
        }, 100);
      }
    },
    handleClose: function handleClose(current) {
      var _this2 = this;

      if (current.meta && current.meta.beforeCloseName && current.meta.beforeCloseName in __WEBPACK_IMPORTED_MODULE_2__router_before_close__["a" /* default */]) {
        new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(__WEBPACK_IMPORTED_MODULE_2__router_before_close__["a" /* default */][current.meta.beforeCloseName]).then(function (close) {
          if (close) {
            _this2.close(current);
          }
        });
      } else {
        this.close(current);
      }
    },
    close: function close(route) {
      var res = this.list.filter(function (item) {
        return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_nav__["a" /* routeEqual */])(route, item);
      });
      this.$emit('on-close', res, undefined, route);
    },
    handleClick: function handleClick(item) {
      if (this.isCurrentTag(item)) {
        return;
      }
      this.$emit('input', item);
    },
    showTitleInside: function showTitleInside(item) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_nav__["c" /* showTitle */])(item, this);
    },
    isCurrentTag: function isCurrentTag(item) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_nav__["a" /* routeEqual */])(this.currentRouteObj, item);
    },
    moveToView: function moveToView(tag) {
      var outerWidth = this.$refs.scrollOuter.offsetWidth;
      var bodyWidth = this.$refs.scrollBody.offsetWidth;
      if (bodyWidth < outerWidth) {
        this.tagBodyLeft = 0;
      } else if (tag.offsetLeft < -this.tagBodyLeft) {
        // 标签在可视区域左侧
        this.tagBodyLeft = -tag.offsetLeft + this.outerPadding;
      } else if (tag.offsetLeft > -this.tagBodyLeft && tag.offsetLeft + tag.offsetWidth < -this.tagBodyLeft + outerWidth) {
        // 标签在可视区域
        this.tagBodyLeft = Math.min(0, outerWidth - tag.offsetWidth - tag.offsetLeft - this.outerPadding);
      } else {
        // 标签在可视区域右侧
        this.tagBodyLeft = -(tag.offsetLeft - (outerWidth - this.outerPadding - tag.offsetWidth));
      }
    },
    getTagElementByRoute: function getTagElementByRoute(route) {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.refsTag = _this3.$refs.tagsPageOpened;
        if (!_this3.refsTag) {
          return;
        }
        _this3.refsTag.forEach(function (item, index) {
          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_nav__["a" /* routeEqual */])(route, item.$attrs['data-route-item'])) {
            var tag = _this3.refsTag[index].$el;
            _this3.moveToView(tag);
          }
        });
      });
    },
    contextMenu: function contextMenu(item, e) {
      if (item.name === '首页') {
        return;
      }
      this.visible = true;
      var offsetLeft = this.$el.getBoundingClientRect().left;
      this.contextMenuLeft = e.clientX - offsetLeft + 10;
      this.contextMenuTop = e.clientY - 64;
    },
    closeMenu: function closeMenu() {
      this.visible = false;
    }
  },
  watch: {
    '$route': function $route(to) {
      this.getTagElementByRoute(to);
    },
    visible: function visible(value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu);
      } else {
        document.body.removeEventListener('click', this.closeMenu);
      }
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    setTimeout(function () {
      _this4.getTagElementByRoute(_this4.$route);
    }, 200);
  }
});

/***/ }),

/***/ "htLF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        form: Object,
        data: {
            type: Object,
            default: function _default() {
                return {};
            }
        },
        editable: {
            type: Boolean,
            default: true
        },
        options: {
            type: Object,
            default: function _default() {
                return {};
            }
        }
    },
    data: function data() {
        var _this = this;

        var diqudata = this.$chinapcdata.map(function (p) {
            return { code: p.code, value: p.name, label: p.name, children: p.children ? p.children.map(function (c) {
                    return { code: c.code, label: c.name, value: c.name, children: c.children ? c.children.map(function (d) {
                            return { code: d.code, value: d.name, label: d.name };
                        }) : [] };
                }) : [] };
        });
        return {
            diqudata: diqudata,
            addressParseModal: {
                content: '',
                result: {},
                calculate: function calculate() {
                    var address = _this.addressParseModal.content;
                    var r = _this.$parseAddress(address);
                    var province = r.province,
                        city = r.city,
                        area = r.area,
                        detail = r.detail,
                        name = r.name,
                        phone = r.phone;


                    var provinceData = null;
                    var cityData = null;
                    if (province) {
                        provinceData = diqudata.find(function (item) {
                            return item.value == province;
                        });
                        if (!provinceData) province = null;
                    }

                    if (province == '新疆维吾尔自治区' && city && !area) {
                        // 新疆维吾尔自治区/自治区直辖县级行政区划/可克达拉市  这种被识别为 province:新疆维吾尔自治区 city:可克达拉市 area:'', 实际应是 province: 新疆维吾尔自治区 city:自治区直辖县级行政区划 area:可克达拉市
                        area = city;
                    }

                    if (province && city) {
                        cityData = provinceData.children.find(function (item) {
                            return item.value == city;
                        });
                        if (!cityData && provinceData.children[0].children.find(function (item) {
                            return item.value == area;
                        })) {
                            cityData = provinceData.children[0];
                            city = cityData.value;
                        }
                        if (!cityData) city = null;
                    }

                    if (province && !city && area) {
                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                            for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(provinceData.children), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                var child = _step.value;

                                if (child.children.find(function (item) {
                                    return item.value == area;
                                })) {
                                    cityData = child;
                                    city = child.value;
                                    break;
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }
                            } finally {
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }

                    if (province && city && area) {
                        var areaData = cityData.children.find(function (item) {
                            return item.value == area;
                        });
                        if (!areaData) area = null;
                    }

                    console.log('parse address', r, province, city, area, detail, name, phone);

                    _this.addressParseModal.result = {
                        shouhuodiqu: province && city && area ? [province, city, area] : [],
                        shouhuodizhi: detail,
                        shouhuorenxingming: name,
                        shouhuodianhua: phone
                    };
                },
                confirm: function confirm() {
                    // 省市区：有识别结果则更新，无则清空
                    if (_this.addressParseModal.result.shouhuodiqu && _this.addressParseModal.result.shouhuodiqu[0]) {
                        _this.form.shouhuodiqu = _this.addressParseModal.result.shouhuodiqu;
                    } else {
                        _this.form.shouhuodiqu = [];
                    }
                    // 详细地址：有识别结果则更新，无则清空
                    if (_this.addressParseModal.result.shouhuodizhi) {
                        _this.form.shouhuodizhi = _this.addressParseModal.result.shouhuodizhi;
                    } else {
                        _this.form.shouhuodizhi = '';
                    }
                    // 收货人姓名：有识别结果则更新，无则清空
                    if (_this.addressParseModal.result.shouhuorenxingming) {
                        _this.form.shouhuorenxingming = _this.addressParseModal.result.shouhuorenxingming;
                    } else {
                        _this.form.shouhuorenxingming = '';
                    }
                    // 收货电话：有识别结果则更新，无则清空
                    if (_this.addressParseModal.result.shouhuodianhua) {
                        _this.form.shouhuodianhua = _this.addressParseModal.result.shouhuodianhua;
                    } else {
                        _this.form.shouhuodianhua = '';
                    }
                    _this.diquChanged(_this.form.shouhuodiqu);
                }
            }
        };
    },
    mounted: function mounted() {},

    methods: {
        diquChanged: function diquChanged(value) {
            this.$emit('diquChanged', value);
        }
    },
    created: function created() {}
});

/***/ }),

/***/ "irjp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        current: {
            type: [Object, Array],
            default: null
        },
        multi: {
            type: Boolean,
            default: false
        },
        max: {
            type: Number,
            default: null
        },
        editable: {
            type: Boolean,
            default: true
        },
        maxsize: {
            type: Number,
            default: 2048
        },
        accept: {
            type: String,
            default: 'image/*'
        },
        type: {
            type: String,
            default: 'image'
        }
    },
    data: function data() {
        return {
            loading: false,
            uploadConfig: {
                token: null,
                index: null
            },
            result: this.current ? this.copy(this.current) : this.multi ? [] : null
        };
    },

    watch: {
        current: function current(value) {
            if (value) {
                this.result = this.copy(value);
            } else {
                if (this.multi) {
                    this.result = [];
                } else {
                    this.result = null;
                }
            }
        }
    },
    mounted: function mounted() {
        // setTimeout(() => { this.init() }, 100)
        this.init();
    },

    methods: {
        init: function init() {},
        toUpload: function toUpload(index) {
            this.refreshUploadToken();
            if (index !== undefined) {
                this.uploadConfig.index = index;
                this.uploadConfig._replace = true;
            } else {
                this.uploadConfig.index = null;
            }
        },
        beforeUpload: function beforeUpload(file) {
            // let index = file.name.lastIndexOf(".")
            // let ext = file.name.substr(index + 1)
            // let suffix = ['png', 'jpg', 'PNG', 'JPG', 'GIF', 'gif']
            // if (suffix.indexOf(ext.toLowerCase()) == -1 ) {
            //     this.$Message.error({
            //         content: '上传图片必须是 JPG/PNG/GIF 格式，且不超过5MB',
            //         duration: 4,
            //         closable: true
            //     })
            //     return false
            // }
            if (file.size > this.maxsize * 1024) {
                var maxsizeStr = void 0,
                    filesizeStr = void 0;
                if (this.maxsize > 1024) {
                    maxsizeStr = Number(this.maxsize / 1024).toFixed(2) + 'M';
                    filesizeStr = Number(file.size / 1024 / 1024).toFixed(2) + 'M';
                } else {
                    maxsizeStr = this.maxsize + 'K';
                    filesizeStr = Math.floor(file.size / 1024) + 'K';
                }

                this.$Message.error({
                    content: file.name + '\u6587\u4EF6\u5927\u5C0F\u4E3A' + filesizeStr + '\uFF0C\u8D85\u8FC7\u4E86\u5141\u8BB8\u7684\u6700\u5927\u503C' + maxsizeStr,
                    duration: 0,
                    closable: true
                });
            }
        },
        imageUploadSuccess: function imageUploadSuccess(res, file) {
            file.url = 'http://igyl.weizhilian.com/' + res.key;
            var image = { url: file.url, width: res.width, height: res.height, color: res.color };
            if (this.multi) {
                if (this.uploadConfig._replace) {
                    this.uploadConfig._replace = false;
                    this.result.splice(this.uploadConfig.index, 1);
                }
                if (this.max && this.result.length >= this.max) {
                    this.$Message.error({
                        content: '\u6700\u591A\u53EA\u80FD\u4E0A\u4F20' + this.max + '\u5F20\u56FE\u7247',
                        duration: 4,
                        closable: true
                    });
                    return;
                }
                if (this.uploadConfig.index !== null) {
                    this.result.splice(this.uploadConfig.index, 0, image);
                } else {
                    this.result.push(image);
                }
            } else {
                this.result = image;
            }
            this.loading = false;
            this.$emit('confirm', this.result);
        },
        imageProgress: function imageProgress(res, file) {
            if (!file) {
                return;
            }
            this.loading = true;
        },
        refreshUploadToken: function refreshUploadToken() {
            var _this = this;

            this.loadUploadToken(function (token) {
                _this.uploadConfig.token = token;
            });
        },
        toView: function toView(index) {
            this.openImage(this.result[index].url);
        },
        openImage: function openImage(url) {
            window.open(url);
        },
        moveUp: function moveUp(index) {
            if (index == 0) {
                return;
            }
            var temp = this.result[index - 1];
            this.result[index - 1] = this.result[index];
            this.result[index] = temp;
            this.$emit('confirm', this.result);
        },
        moveDown: function moveDown(index) {
            if (index == this.result.length - 1) {
                return;
            }
            var temp = this.result[index + 1];
            this.result[index + 1] = this.result[index];
            this.result[index] = temp;
            this.$emit('confirm', this.result);
        },
        removeItem: function removeItem(index) {
            if (this.multi) {
                this.result.splice(index, 1);
            } else {
                this.result = null;
            }
            this.$emit('confirm', this.result);
        }
    }
});

/***/ }),

/***/ "jGmC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        current: String
    },
    data: function data() {
        return {
            session: this.$store.session,
            keywords: '',
            query: {
                keywords: '',
                from: {
                    version: null,
                    _id: null
                },
                size: 20,
                client: 'web'
            },
            loading: false,
            loadingmore: false,
            nomore: false,
            gengxinrizhis: [],
            listHeight: 400
        };
    },
    mounted: function mounted() {
        var _this = this;

        this.loadData();
        setTimeout(function () {
            _this.calcListHeight();
        }, 330);
    },

    methods: {
        newversiontip: function newversiontip(gengxinrizhi) {
            return compareVersions(gengxinrizhi ? gengxinrizhi.version : '0.0.0', this.current);
        },
        calcListHeight: function calcListHeight() {
            this.listHeight = window.innerHeight - this.$refs['list'].$el.offsetTop - 20;
        },
        keywordsChanged: function keywordsChanged() {
            this.query.keywords = this.keywords;
            this.refresh();
        },
        keywordsEdit: function keywordsEdit() {
            var _this2 = this;

            this.query.keywords = '';
            setTimeout(function () {
                var input = _this2.$refs['input:keywords'][0];
                if (input) input.focus();
            }, 200);
        },
        keywordsClear: function keywordsClear() {
            var _this3 = this;

            this.query['keywords'] = '';
            this.keywords = '';
            setTimeout(function () {
                var input = _this3.$refs['input:keywords'][0];
                if (input) input.focus();
            }, 200);
            this.refresh();
        },
        loadData: function loadData() {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var res, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, gengxinrizhi;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!(_this4.loading || _this4.nomore)) {
                                    _context.next = 2;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 2:
                                _this4.loading = true;
                                _context.next = 5;
                                return _this4.$api.post('/web/main/gengxinrizhi/list', {
                                    query: _this4.query
                                });

                            case 5:
                                res = _context.sent;

                                _this4.loading = false;
                                if (res.data.gengxinrizhis.length < _this4.query.size) {
                                    _this4.nomore = true;
                                }
                                if (_this4.query.from._id) {
                                    _this4.gengxinrizhis = _this4.gengxinrizhis.concat(res.data.gengxinrizhis);
                                } else {
                                    _this4.gengxinrizhis = res.data.gengxinrizhis;
                                }
                                _iteratorNormalCompletion = true;
                                _didIteratorError = false;
                                _iteratorError = undefined;
                                _context.prev = 12;
                                for (_iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this4.gengxinrizhis); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                    gengxinrizhi = _step.value;

                                    gengxinrizhi.lastUpdateTimeStr = _this4.moment(gengxinrizhi.lastUpdateTime || gengxinrizhi.createTime).format('YYYY-MM-DD HH:mm:ss');
                                    if (gengxinrizhi.content) gengxinrizhi.content = gengxinrizhi.content.replace(/<img/g, '<img style="max-width: 100%;"');
                                    if (_this4.query.keywords) {
                                        if (gengxinrizhi.content) gengxinrizhi.content = gengxinrizhi.content.replace(new RegExp(_this4.query.keywords, 'g'), '<span style="color: #333;background-color:yellow;font-weight:bold">' + _this4.query.keywords + '</span>');
                                    }
                                }
                                _context.next = 20;
                                break;

                            case 16:
                                _context.prev = 16;
                                _context.t0 = _context['catch'](12);
                                _didIteratorError = true;
                                _iteratorError = _context.t0;

                            case 20:
                                _context.prev = 20;
                                _context.prev = 21;

                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }

                            case 23:
                                _context.prev = 23;

                                if (!_didIteratorError) {
                                    _context.next = 26;
                                    break;
                                }

                                throw _iteratorError;

                            case 26:
                                return _context.finish(23);

                            case 27:
                                return _context.finish(20);

                            case 28:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this4, [[12, 16, 20, 28], [21,, 23, 27]]);
            }))();
        },
        loadMore: function loadMore() {
            var _this5 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!(_this5.loading || _this5.nomore || _this5.loadingmore)) {
                                    _context2.next = 2;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 2:
                                _this5.query.from = {
                                    version: _this5.gengxinrizhis[_this5.gengxinrizhis.length - 1].version,
                                    _id: _this5.gengxinrizhis[_this5.gengxinrizhis.length - 1]._id
                                };
                                _this5.loadingmore = true;
                                _context2.next = 6;
                                return _this5.loadData();

                            case 6:
                                _this5.loadingmore = false;

                            case 7:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this5);
            }))();
        },
        refresh: function refresh() {
            var _this6 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _this6.nomore = false;
                                _this6.query.from = {
                                    version: null,
                                    _id: null
                                };
                                _context3.next = 4;
                                return _this6.loadData();

                            case 4:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this6);
            }))();
        }
    }
});

function compareVersions(version1, version2) {
    var parts1 = version1.split('.').map(Number);
    var parts2 = version2.split('.').map(Number);

    for (var i = 0; i < parts1.length; i++) {
        if (parts1[i] > parts2[i]) {
            return true;
        } else if (parts1[i] < parts2[i]) {
            return false;
        }
    }

    return false;
}

/***/ }),

/***/ "kCMK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kQSw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "20px 0"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "0px 0"
    }
  }, [_c('div', [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "20px",
      "font-size": "24px",
      "font-weight": "bold"
    }
  }, [_vm._v("请选择" + _vm._s(_vm.options.name))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "icon": "ios-search",
      "placeholder": _vm.options.placeholder || '输入名称/编码查询...'
    },
    on: {
      "on-enter": _vm.keywordsChanged
    },
    model: {
      value: (_vm.query.keywords),
      callback: function($$v) {
        _vm.$set(_vm.query, "keywords", $$v)
      },
      expression: "query.keywords"
    }
  }), _vm._v(" "), (_vm.usedKeywords) ? _c('Tag', {
    staticStyle: {
      "height": "32px",
      "line-height": "32px",
      "margin": "0"
    },
    attrs: {
      "closable": ""
    },
    on: {
      "on-close": _vm.clearKeywords
    }
  }, [_vm._v(" 搜索：" + _vm._s(_vm.usedKeywords))]) : _vm._e(), _vm._v(" "), (_vm.query.selections) ? _c('Tag', {
    staticStyle: {
      "height": "32px",
      "line-height": "32px",
      "margin": "0"
    },
    attrs: {
      "closable": ""
    },
    on: {
      "on-close": function($event) {
        _vm.query.selections = null
        _vm.loadData()
      }
    }
  }, [_vm._v("\n                        仅查看包含在 "), _c('span', {
    staticStyle: {
      "color": "#20bf64"
    }
  }, [_vm._v(_vm._s(_vm.query.selections.length))]), _vm._v(" 个已选项中的内容")]) : _vm._e()], 1)]), _vm._v(" "), (_vm.results.length) ? _c('div', [_c('Table', {
    ref: "sheet",
    attrs: {
      "columns": _vm.columns,
      "loading": _vm.loading,
      "row-class-name": _vm.getRowClass,
      "data": _vm.results
    },
    on: {
      "on-select": _vm.itemSelected,
      "on-row-click": _vm.rowSelected,
      "on-select-cancel": _vm.itemSelectedCancel,
      "on-select-all": _vm.allSelected,
      "on-select-all-cancel": _vm.allSelectedCancel
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "jcsb"
  }, [_c('div', [(_vm.selections.length || _vm.results.length) ? _c('div', {
    staticStyle: {
      "padding": "10px 20px",
      "display": "flex",
      "align-items": "center"
    }
  }, [_vm._v("\n                            已选"), _c('span', {
    staticStyle: {
      "color": "#20bf64",
      "margin": "0 4px"
    }
  }, [_vm._v(_vm._s(_vm.selections.length))]), _vm._v("项\n                            "), (_vm.selections.length) ? _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "hover",
    staticStyle: {
      "color": "#20bf64",
      "margin-left": "10px"
    },
    on: {
      "click": _vm.showSelections
    }
  }, [_vm._v("查看")]), _vm._v(" "), _c('div', {
    staticClass: "hover",
    staticStyle: {
      "color": "#20bf64",
      "margin-left": "10px"
    },
    on: {
      "click": _vm.clearSelections
    }
  }, [_vm._v("取消选择")])]) : _vm._e(), _vm._v(" "), (_vm.options.importable) ? [_c('a', {
    staticClass: "hover",
    staticStyle: {
      "color": "#20bf64",
      "margin-left": "20px"
    },
    on: {
      "click": _vm.exportSelections
    }
  }, [_vm._v("导出选项")]), _vm._v(" "), _c('Upload', {
    ref: "uploader",
    attrs: {
      "data": _vm.uploadConfig,
      "show-upload-list": false,
      "on-success": _vm.fileUploadSuccess,
      "on-progress": _vm.fileProgress,
      "multiple": "",
      "action": "//upload.qiniup.com/"
    }
  }, [_c('div', {
    on: {
      "click": _vm.refreshUploadToken
    }
  }, [_c('a', {
    staticClass: "hover",
    staticStyle: {
      "color": "#20bf64",
      "margin-left": "20px"
    }
  }, [_vm._v("导入选项")])])])] : _vm._e()], 2) : _vm._e()]), _vm._v(" "), (!_vm.nopage) ? _c('Page', {
    staticStyle: {
      "padding": "16px"
    },
    attrs: {
      "size": "small",
      "placement": "top",
      "total": _vm.total,
      "current": _vm.page.current,
      "page-size": _vm.page.size,
      "show-total": "",
      "show-sizer": "",
      "page-size-opts": [10, 20, 50, 100, 200]
    },
    on: {
      "on-change": _vm.pageChanged,
      "on-page-size-change": _vm.pageSizeChanged
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.results.length) ? _c('div', {
    staticClass: "center",
    staticStyle: {
      "color": "#aaa",
      "min-height": "200px"
    }
  }, [_vm._v("暂无数据")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "foot jcsb",
    staticStyle: {
      "padding": "0 20px"
    }
  }, [_c('div', [(!_vm.options.multi && _vm.selections.length > 1) ? _c('div', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("只能选择1项")]) : (_vm.options.max && _vm.selections.length > _vm.options.max) ? _c('div', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("只能选择" + _vm._s(_vm.options.max) + "项")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('Button', {
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), ((!_vm.options.multi && _vm.selections.length != 1) || (_vm.options.max && _vm.selections.length > _vm.options.max)) ? _c('Button', {
    attrs: {
      "disabled": "",
      "type": "primary"
    }
  }, [_vm._v("确定")]) : _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("确定")])], 1)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lV2/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageTooltip_vue__ = __webpack_require__("ftv1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_defe148c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PageTooltip_vue__ = __webpack_require__("mrHh");
function injectStyle (ssrContext) {
  __webpack_require__("gCtd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageTooltip_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_defe148c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PageTooltip_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "luFF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__logics_services_common__ = __webpack_require__("SRib");








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var commonService = new __WEBPACK_IMPORTED_MODULE_8__logics_services_common__["a" /* default */]();
/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        current: Array,
        xieyi: Object,
        xieyitype: String,
        gonghuojigou: Object,
        jigou: Object,
        cangku: Object,
        disables: Array,
        scene: String,
        zengpin: Boolean,
        jiaoyankucun: Boolean,
        caigoudanwei: { // 0 不显示 1显示caigoudanweiStr，2显示多选框
            type: Number,
            default: 0
        },
        /**是否单选 */
        radio: {
            type: Boolean,
            default: false
        },
        /**是否选择商品信息 */
        isMallGoods: {
            type: Boolean,
            default: false
        },
        type: String,
        //是否是协议选择物品（配送、采购），如果是，则会在回显时判断单位是否仍被选中等
        xieyiload: {
            type: Boolean,
            default: false
        },
        fanganload: {
            type: Boolean,
            default: false
        },
        isShangpin: {
            type: Boolean,
            default: false
        },
        skipShangpin: {
            type: Boolean,
            default: false
        },
        initmode: { //多单位初始化模式，moren = 选择默认值,all = 全选，none = 全不选
            type: String,
            default: 'moren'
        },
        wupinquery: Object
    },
    computed: {
        selectionLength: function selectionLength() {
            // 不同huozhu的物品，只计算1次
            var codes = [];
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default()(this.selections), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    if (!codes.includes(item.code)) {
                        codes.push(item.code);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return codes.length;
        },
        querySelectionLength: function querySelectionLength() {
            var codes = [];
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default()(this.query.selections), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var item = _step2.value;

                    if (!codes.includes(item.code)) {
                        codes.push(item.code);
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            return codes.length;
        },
        showOnlyIssuedOption: function showOnlyIssuedOption() {
            // 配送申请/审核场景允许按下发状态筛选
            return ['psgh', 'psyh'].includes(this.scene);
        }
    },
    data: function data() {
        return {
            singleGoodsId: null,
            /**单选物品id */
            loading: false,
            cloneSection: [], // 备份一份
            query: {
                keywords: '',
                init: true,
                selections: null,
                disables: this.disables ? this.disables.map(function (o) {
                    return o.code;
                }) : null
                // onlyIssued: true
            },
            usedKeywords: '',
            page: {
                current: 1,
                size: 10
            },
            total: 0,
            wupins: [],
            columns1: [{ type: 'selection', align: 'center', width: 60 }, {
                title: '物品名称',
                key: 'name',
                minWidth: 180,
                render: function render(h, params) {
                    if (params.row._disabled) {
                        var disableReason = '';
                        if (params.row.kucunbuzu) {
                            disableReason = '库存不足';
                        }
                        if (params.row.weixiafa) {
                            disableReason = '未下发';
                        }
                        if (!params.row.actived) {
                            if (disableReason) disableReason += ',';
                            disableReason += '未启用';
                        }
                        return h('div', [h('div', params.row.name), h('div', { style: { color: 'red' } }, disableReason)]);
                    } else {
                        return h('div', params.row.name);
                    }
                }
            }, { title: '编码', key: 'code', minWidth: 120 }, { title: '规格型号', key: 'guigexinghao', minWidth: 120 }, { title: '类别', key: 'leibieStr', minWidth: 100 }, {
                title: '库存单位',
                key: 'kucundanweiStr',
                minWidth: 100
            }, { title: '存储方式', key: 'cunchufangshi', minWidth: 100 }],
            selections: [],
            treeData: [],
            leibies: [],
            zengpins: [],
            feizengpins: []
        };
    },
    mounted: function mounted() {
        var _this = this;

        if (this.xieyiload || this.fanganload) {
            this.selections = this.getSelect(this.current.map(function (item) {
                return item;
            }));
        } else {
            this.selections = this.current.map(function (item) {
                return item;
            });
        }
        // this.selections = this.current.map(item => { return item })
        this.cloneSection = this.current.map(function (item) {
            return item;
        }); //使用map中断引用传递
        // this.$set(this.page, 'size', Number(sessionStorage.pagesize || 10))
        this.loadData();
        this.getTableColumn(); // 处理显示表格column
        this._loadData(this.id, function (array) {
            _this.treeData = array;
        });
    },

    methods: {
        getSelect: function getSelect(arr) {
            var newArr = this.copy(arr);
            for (var i = 0; i < newArr.length - 1; i++) {
                for (var j = i + 1; j < newArr.length; j++) {
                    if (newArr[i].code === newArr[j].code) {
                        newArr.splice(j, 1);
                        j--;
                    }
                }
            }
            newArr.forEach(function (row) {
                row.selectedCaigoudanweis = [];
                arr.forEach(function (item) {
                    if (row.code == item.code) {
                        row.selectedCaigoudanweis.push(item.caigoudanweiStr);
                    }
                });
                if (row.selectedCaigoudanweis.length == 1) {
                    delete row.selectedCaigoudanweis;
                }
            });
            return newArr;
        },
        setTree: function setTree(list) {
            list.forEach(function (row) {
                row.title = row.name;
                //是否有下级
                if (row.childCount > 0) {
                    row.loading = false;
                    row.children = [];
                }
            });
        },
        loadDataTree: function loadDataTree(item, callback) {
            //异步加载的方法
            this._loadData(item._id, callback);
        },
        _loadData: function _loadData(_id, callback) {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee() {
                var p, res;
                return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                //发送请求并且对后台的数据进行处理
                                p = { level: 0, withChildCount: true, size: 99999 };

                                if (_id) {
                                    p = { parentId: _id, withChildCount: true, size: 99999 };
                                }
                                _context.next = 4;
                                return commonService.getCategory(p);

                            case 4:
                                res = _context.sent;

                                _this2.setTree(res.leibies);
                                callback(res.leibies); //返回新数组

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },

        /**单选 */
        handleSelSingle: function handleSelSingle(v, row) {
            var wupins = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(this.wupins));
            var selections = [];
            wupins.map(function (item) {
                if (item._id !== row._id) {
                    item._checked = false;
                } else if (!item._disabled) {
                    item._checked = true;
                    selections.push(item);
                }
            });
            this.selections = selections;
        },

        // 处理表格行数据
        getTableColumn: function getTableColumn() {
            var _this3 = this;

            if (this.caigoudanwei) {
                var unitColumn = {
                    title: '采购单位',
                    key: 'caigoudanweiStr',
                    minWidth: 100,
                    render: function render(h, params) {
                        var wupin = params.row;
                        if (_this3.caigoudanwei == 1) {
                            return h('div', wupin.caigoudanweiStr);
                        } else if (wupin.caigoufangshis.length == 1) {
                            return h('div', wupin.caigoufangshis[0].danweiStr);
                        } else {
                            var checkboxs = [];
                            var _iteratorNormalCompletion3 = true;
                            var _didIteratorError3 = false;
                            var _iteratorError3 = undefined;

                            try {
                                for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default()(wupin.caigoufangshis), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                    var caigoufangshi = _step3.value;

                                    checkboxs.push(h('Checkbox', {
                                        props: {
                                            label: caigoufangshi.danweiStr
                                        }
                                    }, caigoufangshi.danweiStr));
                                }
                            } catch (err) {
                                _didIteratorError3 = true;
                                _iteratorError3 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                        _iterator3.return();
                                    }
                                } finally {
                                    if (_didIteratorError3) {
                                        throw _iteratorError3;
                                    }
                                }
                            }

                            var group = h('CheckboxGroup', {
                                style: {
                                    'padding': '10px 0'
                                },
                                props: {
                                    value: wupin.selectedCaigoudanweis
                                },
                                on: {
                                    'on-change': function onChange(value) {
                                        wupin.selectedCaigoudanweis = value;
                                        _this3.caigoudanweisChanged(value, wupin.code);
                                    }
                                }
                            }, checkboxs);
                            return group;
                        }
                    }
                };
                if (!this.caigoudanwei || this.wupins.some(function (item) {
                    return !item.caigoudanweiStr;
                })) {
                    return;
                }
                var columns = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(this.columns1));
                columns.splice(columns.length - 1, 0, unitColumn);
                this.columns1 = columns;
            }
            /**单选 */
            if (this.radio) {
                var _columns = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(this.columns1));
                var radioColumn = {
                    slot: 'radio',
                    width: 30,
                    title: " "
                };
                _columns.splice(0, 1, radioColumn);
                this.columns1 = _columns;
            }
        },

        // 切换物品采购单位-处理默认值
        caigoudanweisChanged: function caigoudanweisChanged(value, code) {
            var item = this.selections.findOne({ code: code });
            var wupin = this.wupins.findOne({ code: code });
            if (!item) {
                item = wupin;
            } else {
                item.caigoufangshis = wupin.caigoufangshis;
            }
            item.selectedCaigoudanweis = value;
        },
        tableRowClass: function tableRowClass(row) {
            if (row._disabled) {
                return 'disabled';
            } else {
                return '';
            }
        },
        clearTreeChecks: function clearTreeChecks() {
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
                for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default()(this.treeData), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var node = _step4.value;

                    node.checked = false;
                    this.clearNode(node);
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                    }
                } finally {
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }
        },
        clearNode: function clearNode(node) {
            if (node.children) {
                var _iteratorNormalCompletion5 = true;
                var _didIteratorError5 = false;
                var _iteratorError5 = undefined;

                try {
                    for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default()(node.children), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                        var child = _step5.value;

                        child.checked = false;
                        this.clearNode(child);
                    }
                } catch (err) {
                    _didIteratorError5 = true;
                    _iteratorError5 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion5 && _iterator5.return) {
                            _iterator5.return();
                        }
                    } finally {
                        if (_didIteratorError5) {
                            throw _iteratorError5;
                        }
                    }
                }
            }
        },
        resetTree: function resetTree() {
            this.query.relations = null;
            this.clearTreeChecks();
            this.loadData();
        },

        // treeClicked(nodes) {
        //     let that = this
        //     if (nodes.length) {
        //         that.query.relation = { _id: nodes[0]._id, name: nodes[0].name }
        //     } else {
        //         that.query.relation = null
        //     }
        //     that.loadData()
        // },
        treeSelected: function treeSelected(nodes) {
            this.query.relations = nodes.map(function (item) {
                return { _id: item._id, name: item.name };
            });
            // this.parseNode(current)
            var _iteratorNormalCompletion6 = true;
            var _didIteratorError6 = false;
            var _iteratorError6 = undefined;

            try {
                for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default()(nodes), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                    var node = _step6.value;

                    this.parseNode(node);
                }
            } catch (err) {
                _didIteratorError6 = true;
                _iteratorError6 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion6 && _iterator6.return) {
                        _iterator6.return();
                    }
                } finally {
                    if (_didIteratorError6) {
                        throw _iteratorError6;
                    }
                }
            }

            this.loadData();
        },
        parseNode: function parseNode() {
            // if (node.checked && node.children) {
            //     for (let child of node.children) {
            //         if (!child.checked) {
            //             child.checked = true
            //             this.query.relations.push({ _id: child._id, name: child.name })
            //             this.parseNode(child)
            //         }
            //     }
            // }
        },
        clearKeywords: function clearKeywords() {
            this.query.keywords = '';
            this.usedKeywords = '';
            this.loadData();
        },
        keywordsChanged: function keywordsChanged() {
            this.usedKeywords = this.query.keywords;
            this.page.current = 1;
            this.loadData();
        },
        onlyIssuedChanged: function onlyIssuedChanged() {
            this.page.current = 1;
            this.loadData();
        },
        pageChanged: function pageChanged(value) {
            this.page.current = value;
            this.loadData();
        },
        pageSizeChanged: function pageSizeChanged(value) {
            var _this4 = this;

            this.page.size = value;
            // sessionStorage.pagesize = value
            if (this.page.current == 1) {
                setTimeout(function () {
                    _this4.loadData();
                }, 30);
            }
        },
        loadData: function loadData() {
            var _this5 = this;

            var that = this;
            that.loading = true;
            that.wupins = [];
            that.$api.post('/web/main/wupinselector/load?V=2', {
                type: this.type,
                query: this.query,
                page: this.page,
                xieyiId: this.xieyi ? this.xieyi._id : null,
                xieyitype: this.xieyitype,
                jigouId: this.jigou ? this.jigou._id : null,
                jigouType: this.jigou ? this.jigou.type : null,
                gonghuojigouId: this.gonghuojigou ? this.gonghuojigou._id : null,
                gonghuojigouCode: this.gonghuojigou ? this.gonghuojigou.code : null,
                cangkuId: this.cangku ? this.cangku._id : null,
                shangpincheck: this.isMallGoods,
                isShangpin: this.isShangpin,
                wupinquery: this.wupinquery,
                jiaoyankucun: this.jiaoyankucun
            }).then(function (res) {
                that.loading = false;
                that.total = res.data.total;
                that.usedKeywords = that.query.keywords;
                var wupins = res.data.wupins;

                _this5.selections.forEach(function (item, index) {
                    item._index = index;
                });
                if (that.query.init) {
                    that.query.init = false;
                    if (_this5.zengpin) {
                        _this5.feizengpins = _this5.selections.filter(function (o) {
                            return !o.zengpin;
                        });
                        _this5.selections = _this5.selections.filter(function (o) {
                            return o.zengpin;
                        });
                    } else {
                        _this5.zengpins = _this5.selections.filter(function (o) {
                            return o.zengpin;
                        });
                        _this5.selections = _this5.selections.filter(function (o) {
                            return !o.zengpin;
                        });
                    }
                }
                if (_this5.caigoudanwei == 2) {
                    // this.selections = this.selections.unique('code')
                    // console.log('this.selections', this.selections.map(o => `${o.name}(${o.caigoudanweiStr})`))
                    var selections = [];

                    var _loop = function _loop(selection) {
                        var item = selections.find(function (o) {
                            return o.code == selection.code;
                        });
                        if (!item) {
                            item = selection;
                            item._selectedCaigoudanweis = item._selectedCaigoudanweis || [];
                            item._caigoufangshis = item._caigoufangshis || [];
                            selections.push(item);
                        }

                        if (selection.caigoudanweiStr && !item._selectedCaigoudanweis.includes(selection.caigoudanweiStr)) {
                            // console.log(`${selection.name} ${selection.caigoudanweiStr}`)
                            item._selectedCaigoudanweis.push(selection.caigoudanweiStr);
                            item._caigoufangshis.push(selection.caigoufangshi);
                        }
                    };

                    var _iteratorNormalCompletion7 = true;
                    var _didIteratorError7 = false;
                    var _iteratorError7 = undefined;

                    try {
                        for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default()(_this5.selections), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                            var selection = _step7.value;

                            _loop(selection);
                        }
                    } catch (err) {
                        _didIteratorError7 = true;
                        _iteratorError7 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion7 && _iterator7.return) {
                                _iterator7.return();
                            }
                        } finally {
                            if (_didIteratorError7) {
                                throw _iteratorError7;
                            }
                        }
                    }

                    _this5.selections = selections;
                    // console.log('this.selections', selections.map(o => `${o.name}(${o._selectedCaigoudanweis})`))
                    var _iteratorNormalCompletion8 = true;
                    var _didIteratorError8 = false;
                    var _iteratorError8 = undefined;

                    try {
                        for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default()(_this5.selections), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                            var s = _step8.value;

                            if (!s.caigoufangshis) {
                                var wupin = wupins.findOne({ code: s.code });
                                if (wupin && wupin.caigoufangshis) {
                                    s.caigoufangshis = wupin.caigoufangshis;
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError8 = true;
                        _iteratorError8 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion8 && _iterator8.return) {
                                _iterator8.return();
                            }
                        } finally {
                            if (_didIteratorError8) {
                                throw _iteratorError8;
                            }
                        }
                    }
                }
                var _iteratorNormalCompletion9 = true;
                var _didIteratorError9 = false;
                var _iteratorError9 = undefined;

                try {
                    for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default()(wupins), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                        var _wupin = _step9.value;

                        var found = null;
                        if (_wupin.caigoudanweiStr) {
                            found = that.selections.findOne({ 'code': _wupin.code, 'caigoudanweiStr': _wupin.caigoudanweiStr });
                        } else {
                            found = that.selections.findOne({ 'code': _wupin.code });
                        }
                        if (_this5.caigoudanwei) {
                            _wupin.selectedCaigoudanweis = _this5.getWupinCaigoudanweis(_wupin); // 处理采购方式数组
                            var _s = _this5.selections.findOne({ code: _wupin.code });
                            if (_s && _s.selectedCaigoudanweis) _wupin.selectedCaigoudanweis = _s.selectedCaigoudanweis;
                            if (_s && !_s.selectedCaigoudanweis) _s.selectedCaigoudanweis = _wupin.selectedCaigoudanweis;
                        }
                        if (found) {
                            _wupin._checked = true;
                        }
                        if (_this5.jiaoyankucun && Number(_wupin.keyongshuliang).toFixed(0) <= 0 && _wupin.kucunbuxian == false) {
                            _wupin.kucunbuzu = true;
                        }
                        if (_wupin.actived == false || _wupin.weixiafa || _wupin.kucunbuzu) {
                            _wupin._disabled = true;
                        }
                        if (_this5.skipShangpin && _wupin.shangpin && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(_wupin.shangpin).length) {
                            _wupin._disabled = true;
                        }
                        /**单选 */
                        if (_this5.radio) {
                            if (_this5.selections.length && _wupin._id === _this5.selections[0]._id) {
                                _wupin._checked = true;
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError9 = true;
                    _iteratorError9 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion9 && _iterator9.return) {
                            _iterator9.return();
                        }
                    } finally {
                        if (_didIteratorError9) {
                            throw _iteratorError9;
                        }
                    }
                }

                that.wupins = wupins;
            }, function () {
                that.loading = false;
            });
        },


        // 处理采购方式数组
        getWupinCaigoudanweis: function getWupinCaigoudanweis(wupin) {
            var selectedCaigoudanweis = [];
            var currentWupins = this.cloneSection.findAll({ code: wupin.code });
            var _iteratorNormalCompletion10 = true;
            var _didIteratorError10 = false;
            var _iteratorError10 = undefined;

            try {
                for (var _iterator10 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default()(wupin.caigoufangshis), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                    var i = _step10.value;

                    if (currentWupins.length) {
                        var danweiMatched = false;
                        var _iteratorNormalCompletion11 = true;
                        var _didIteratorError11 = false;
                        var _iteratorError11 = undefined;

                        try {
                            for (var _iterator11 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default()(currentWupins), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
                                var j = _step11.value;

                                if (!j.caigoudanweiStr || i.danweiStr == j.caigoudanweiStr) {
                                    danweiMatched = true;
                                }
                            }
                        } catch (err) {
                            _didIteratorError11 = true;
                            _iteratorError11 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion11 && _iterator11.return) {
                                    _iterator11.return();
                                }
                            } finally {
                                if (_didIteratorError11) {
                                    throw _iteratorError11;
                                }
                            }
                        }

                        if (danweiMatched) selectedCaigoudanweis.push(i.danweiStr);
                    } else {
                        if (this.initmode == 'moren') {
                            if (i.moren) {
                                selectedCaigoudanweis.push(i.danweiStr);
                            }
                        } else if (this.initmode == 'all') {
                            selectedCaigoudanweis.push(i.danweiStr);
                        } else if (this.initmode == 'none') {
                            //
                        }
                    }
                }
            } catch (err) {
                _didIteratorError10 = true;
                _iteratorError10 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion10 && _iterator10.return) {
                        _iterator10.return();
                    }
                } finally {
                    if (_didIteratorError10) {
                        throw _iteratorError10;
                    }
                }
            }

            selectedCaigoudanweis = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(selectedCaigoudanweis));
            return selectedCaigoudanweis;
        },
        parseTree: function parseTree(leibies) {
            var treeData = [];
            var maxlevel = 0;
            var items = [];
            var _iteratorNormalCompletion12 = true;
            var _didIteratorError12 = false;
            var _iteratorError12 = undefined;

            try {
                for (var _iterator12 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default()(leibies), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
                    var leibie = _step12.value;

                    if (leibie.level > maxlevel) {
                        maxlevel = leibie.level;
                    }
                    items.push({ _id: leibie._id, name: leibie.name, level: leibie.level, parent: leibie.parent, title: leibie.name, checked: false, expand: true, children: [] });
                }
            } catch (err) {
                _didIteratorError12 = true;
                _iteratorError12 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion12 && _iterator12.return) {
                        _iterator12.return();
                    }
                } finally {
                    if (_didIteratorError12) {
                        throw _iteratorError12;
                    }
                }
            }

            var level = maxlevel;
            while (level >= 0) {
                var _iteratorNormalCompletion13 = true;
                var _didIteratorError13 = false;
                var _iteratorError13 = undefined;

                try {
                    for (var _iterator13 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default()(items), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
                        var _item = _step13.value;

                        if (_item.level == level) {
                            if (!_item.parent) {
                                treeData.push(_item);
                            } else {
                                var _iteratorNormalCompletion14 = true;
                                var _didIteratorError14 = false;
                                var _iteratorError14 = undefined;

                                try {
                                    for (var _iterator14 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default()(items), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
                                        var parent = _step14.value;

                                        if (parent._id == _item.parent._id) {
                                            parent.children.push(_item);
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError14 = true;
                                    _iteratorError14 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion14 && _iterator14.return) {
                                            _iterator14.return();
                                        }
                                    } finally {
                                        if (_didIteratorError14) {
                                            throw _iteratorError14;
                                        }
                                    }
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError13 = true;
                    _iteratorError13 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion13 && _iterator13.return) {
                            _iterator13.return();
                        }
                    } finally {
                        if (_didIteratorError13) {
                            throw _iteratorError13;
                        }
                    }
                }

                level--;
            }
            // for (let item of items) {
            //     let allchildren = this.getAllChildren(item)
            //     if (allchildren.some(o => o.checked) && allchildren.some(o => !o.checked)) {
            //         item.expand = true
            //     } else {
            //         item.expand = false
            //     }
            // }
            this.treeData = treeData;
        },
        search: function search() {
            this.loadData();
        },
        cancel: function cancel() {
            this.$emit('cancel');
        },
        wupinSelected: function wupinSelected() {
            var selections = this.getSelectionsWupins();
            if (this.zengpin) {
                selections.forEach(function (item) {
                    item.zengpin = true;
                });
                selections = selections.concat(this.feizengpins);
            } else {
                selections = selections.concat(this.zengpins);
            }
            //sort
            selections.sort(function (a, b) {
                return a._index - b._index;
            });
            var _iteratorNormalCompletion15 = true;
            var _didIteratorError15 = false;
            var _iteratorError15 = undefined;

            try {
                for (var _iterator15 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default()(selections), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
                    var selection = _step15.value;

                    delete selection.selectedCaigoudanweis;
                    delete selection._selectedCaigoudanweis;
                }
            } catch (err) {
                _didIteratorError15 = true;
                _iteratorError15 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion15 && _iterator15.return) {
                        _iterator15.return();
                    }
                } finally {
                    if (_didIteratorError15) {
                        throw _iteratorError15;
                    }
                }
            }

            this.$emit('wupinSelected', selections);
        },


        // 获取选中物品
        getSelectionsWupins: function getSelectionsWupins() {
            var _this6 = this;

            var newSelections = [];
            if (this.caigoudanwei == 0 || this.caigoudanwei == 1) {
                return this.selections;
            }

            var _loop2 = function _loop2(i) {
                if (i.selectedCaigoudanweis && i.selectedCaigoudanweis.length) {
                    i.selectedCaigoudanweis.map(function (item) {
                        var caigoufangshi = i.caigoufangshis.findOne({ danweiStr: item });
                        if (caigoufangshi) {
                            var cloneItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, i);
                            delete cloneItem._selectedCaigoudanweis;
                            delete cloneItem._caigoufangshis;
                            cloneItem.caigoudanweiStr = item;
                            cloneItem.caigoufangshi = caigoufangshi;
                            newSelections.push(cloneItem);
                        }
                    });
                } else if (i._selectedCaigoudanweis && i._selectedCaigoudanweis.length) {
                    i._selectedCaigoudanweis.map(function (item) {
                        var caigoufangshi = i._caigoufangshis.findOne({ danweiStr: item });
                        if (caigoufangshi) {
                            var cloneItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, i);
                            delete cloneItem._selectedCaigoudanweis;
                            delete cloneItem._caigoufangshis;
                            cloneItem.caigoudanweiStr = item;
                            cloneItem.caigoufangshi = caigoufangshi;
                            newSelections.push(cloneItem);
                        }
                    });
                } else {
                    if (_this6.caigoudanwei > 0) {
                        if (!i.caigoufangshi && Array.isArray(i.caigoufangshis) && i.caigoufangshis.length === 1) {
                            i.caigoufangshi = i.caigoufangshis[0];
                        }
                        if (!i.caigoudanweiStr && i.caigoufangshi) {
                            i.caigoudanweiStr = i.caigoufangshi.danweiStr;
                        }
                    }
                    newSelections.push(i);
                }
            };

            var _iteratorNormalCompletion16 = true;
            var _didIteratorError16 = false;
            var _iteratorError16 = undefined;

            try {
                for (var _iterator16 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default()(this.selections), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
                    var i = _step16.value;

                    _loop2(i);
                }
            } catch (err) {
                _didIteratorError16 = true;
                _iteratorError16 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion16 && _iterator16.return) {
                        _iterator16.return();
                    }
                } finally {
                    if (_didIteratorError16) {
                        throw _iteratorError16;
                    }
                }
            }

            return newSelections;
        },
        showSelections: function showSelections() {
            this.query = { selections: this.selections.map(function (item) {
                    return { _id: item._id, code: item.code };
                }) };
            this.page.current = 1;
            this.clearTreeChecks();
            this.loadData();
        },
        clearSelections: function clearSelections() {
            this.selections = [];
            var wupins = [];
            var _iteratorNormalCompletion17 = true;
            var _didIteratorError17 = false;
            var _iteratorError17 = undefined;

            try {
                for (var _iterator17 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default()(this.wupins), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
                    var _item2 = _step17.value;

                    _item2._checked = false;
                    wupins.push(_item2);
                }
            } catch (err) {
                _didIteratorError17 = true;
                _iteratorError17 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion17 && _iterator17.return) {
                        _iterator17.return();
                    }
                } finally {
                    if (_didIteratorError17) {
                        throw _iteratorError17;
                    }
                }
            }

            this.wupins = wupins;
        },
        allSelected: function allSelected(items) {
            var _iteratorNormalCompletion18 = true;
            var _didIteratorError18 = false;
            var _iteratorError18 = undefined;

            try {
                for (var _iterator18 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default()(items), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
                    var _item3 = _step18.value;

                    if (_item3.caigoudanweiStr) {
                        if (!this.selections.findOne({ code: _item3.code, caigoudanweiStr: _item3.caigoudanweiStr })) {
                            this.selections.push(_item3);
                        }
                    } else {
                        if (!this.selections.findOne({ code: _item3.code })) {
                            this.selections.push(_item3);
                        }
                    }
                }
            } catch (err) {
                _didIteratorError18 = true;
                _iteratorError18 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion18 && _iterator18.return) {
                        _iterator18.return();
                    }
                } finally {
                    if (_didIteratorError18) {
                        throw _iteratorError18;
                    }
                }
            }
        },
        allSelectedCancel: function allSelectedCancel() {
            var _iteratorNormalCompletion19 = true;
            var _didIteratorError19 = false;
            var _iteratorError19 = undefined;

            try {
                for (var _iterator19 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default()(this.wupins), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
                    var _item4 = _step19.value;

                    this.selections.remove({ code: _item4.code });
                }
            } catch (err) {
                _didIteratorError19 = true;
                _iteratorError19 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion19 && _iterator19.return) {
                        _iterator19.return();
                    }
                } finally {
                    if (_didIteratorError19) {
                        throw _iteratorError19;
                    }
                }
            }
        },
        itemSelected: function itemSelected(_, item) {
            this.selections.push(item);
        },
        itemSelectedCancel: function itemSelectedCancel(_, item) {
            if (item.caigoudanweiStr) {
                this.selections.remove({ code: item.code, caigoudanweiStr: item.caigoudanweiStr });
            } else {
                this.selections.remove({ code: item.code });
            }
        }
    }
});

/***/ }),

/***/ "meuW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [(_vm.item.tooltip) ? _c('Tooltip', {
    attrs: {
      "placement": "right",
      "transfer": ""
    }
  }, [_c('div', {
    staticStyle: {
      "white-space": "normal"
    },
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n            " + _vm._s(_vm.item.tooltip) + "\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [(_vm.item.required) ? _c('div', {
    staticStyle: {
      "margin-right": "4px",
      "color": "red"
    }
  }, [_vm._v("*")]) : _vm._e(), _vm._v("\n            " + _vm._s(_vm.item.name) + "\n            "), _c('Icon', {
    staticStyle: {
      "margin-left": "4px",
      "opacity": "0.4"
    },
    attrs: {
      "type": "ios-help-circle"
    }
  })], 1)]) : _c('div', [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [(_vm.item.required) ? _c('div', {
    staticStyle: {
      "margin-right": "4px",
      "color": "red"
    }
  }, [_vm._v("*")]) : _vm._e(), _vm._v("\n            " + _vm._s(_vm.item.name) + "\n        ")])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mrHh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Tooltip', {
    attrs: {
      "max-width": _vm.width,
      "placement": _vm.placement,
      "content": _vm.content,
      "transfer": true
    }
  }, [_c('div', {
    style: (("line-height: 32px;display: flex;align-items: center;color:" + _vm.color))
  }, [_vm._v("\n      " + _vm._s(_vm.name) + "\n    "), _c('Icon', {
    staticStyle: {
      "margin-left": "4px"
    },
    attrs: {
      "type": _vm.icon,
      "size": _vm.size
    }
  })], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nLDP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MALL_ROUTE; });
/**路由常量 */
var ROUTE = {
  MALL_SETTINGS: '/web/dhsc/scpz', /**商城配置 */
  MALL_CATEGORY_MANAGE: "/web/dhsc/spflgl", /**商城分类管理 */
  MALL_GOODS_MANAGE: "/web/dhsc/spgl", /**商品管理 */
  MALL_DRESS: "/web/mall/settings/mallDress", /**商城装扮 */
  SETTING_SET: "/web/mall/settings/set", /**创建配置 */
  SAVE_GOOD: "/web/mall/goodsManage/saveGood" /**创建配置 */


  /**订货商城路由 */
};var MALL_ROUTE = {
  INIT: "/pages/init/index", // 初始化页面
  GOODS_DETAIL: "/pages/goodsDetail/index", // 商品详情
  CATEGORY: "/pages/category/index", // 分类
  ORDER_LIST: "/pages/mine/orderList/index", // 订单列表
  ORDER_DETAIL: "/pages/mine/orderDetail/index" // 订单详情
};

/***/ }),

/***/ "nqNX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o0Pe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileForm_vue__ = __webpack_require__("fyPN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3684b8d3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileForm_vue__ = __webpack_require__("gpth");
function injectStyle (ssrContext) {
  __webpack_require__("+GCs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3684b8d3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3684b8d3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileForm_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "p0qc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pSkN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pi+Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        current: Array,
        // 禁用id
        disabledId: {
            type: null,
            default: null
        },
        options: null,
        biaoqianleixing: String
    },
    data: function data() {
        return {
            biaoqians: null,
            querytype: 'anzuzhi',
            loading: false,
            query: {
                keywords: '',
                init: true,
                biaoqianIds: []
            },
            usedKeywords: '',
            page: {
                current: 1,
                size: 5
            },
            total: 0,
            mendians: [],
            columns1: [{ type: 'selection', align: 'center', width: 60 }, { title: '机构名称', key: 'name' }, { title: '编码', key: 'code' }, { title: '地址', key: 'address' }],
            selections: [],
            treeData: [],
            jigous: [],
            biaoqiantree: [],
            isAdmin: this.$store.session.zhanghao.guanxiajigous.some(function (o) {
                return o.type == 'ZB';
            })
        };
    },
    mounted: function mounted() {
        if (this.current) this.selections = this.current.map(function (item) {
            return item;
        }); //使用map中断引用传递
        // this.$set(this.page, 'size', Number(sessionStorage.pagesize || 10))
        if (this.options) {
            if (this.options.query) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.options.query)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var key = _step.value;

                        this.query[key] = this.options.query[key];
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
        this.loadData();
    },

    methods: {
        selectall: function selectall() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var res, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, item;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!_this.loading) {
                                    _context.next = 2;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 2:
                                _this.loading = true;
                                _context.next = 5;
                                return _this.$api.post('/web/main/mendianselector/selectall', {
                                    query: _this.query,
                                    fields: {
                                        _id: 1,
                                        name: 1,
                                        code: 1,
                                        type: 1,
                                        level: 1,
                                        parent: 1,
                                        relations: 1,
                                        address: 1,
                                        jingyingfangshi: 1
                                    }
                                });

                            case 5:
                                res = _context.sent;

                                if (!res.data.items) {
                                    _context.next = 27;
                                    break;
                                }

                                _iteratorNormalCompletion2 = true;
                                _didIteratorError2 = false;
                                _iteratorError2 = undefined;
                                _context.prev = 10;

                                for (_iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(res.data.items); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                    item = _step2.value;

                                    if (!_this.selections.findOne({ _id: item._id })) {
                                        _this.selections.push(item);
                                    }
                                }

                                _context.next = 18;
                                break;

                            case 14:
                                _context.prev = 14;
                                _context.t0 = _context['catch'](10);
                                _didIteratorError2 = true;
                                _iteratorError2 = _context.t0;

                            case 18:
                                _context.prev = 18;
                                _context.prev = 19;

                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                    _iterator2.return();
                                }

                            case 21:
                                _context.prev = 21;

                                if (!_didIteratorError2) {
                                    _context.next = 24;
                                    break;
                                }

                                throw _iteratorError2;

                            case 24:
                                return _context.finish(21);

                            case 25:
                                return _context.finish(18);

                            case 26:
                                _this.loadData();

                            case 27:
                                _this.loading = false;

                            case 28:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[10, 14, 18, 26], [19,, 21, 25]]);
            }))();
        },
        biaoqiantreeSelected: function biaoqiantreeSelected(data) {
            this.query.biaoqianIds = data.filter(function (o) {
                return o.checked && o._id;
            }).map(function (o) {
                return o._id;
            });
            this.page.current = 1;
            this.loadData();
        },
        biaoqianSelected: function biaoqianSelected() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this2.page.current = 1;
                                _this2.loadData();

                            case 2:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        querytypeChanged: function querytypeChanged(value) {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var res;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _this3.query.biaoqianIds = [];

                                if (!(value == 'anbiaoqian')) {
                                    _context3.next = 7;
                                    break;
                                }

                                _context3.next = 4;
                                return _this3.$api.post('/web/main/mendianselector/loadbiaoqians', {
                                    biaoqianleixing: _this3.biaoqianleixing
                                });

                            case 4:
                                res = _context3.sent;

                                _this3.biaoqians = res.data.biaoqians;
                                _this3.loadBiaoqiantree();

                            case 7:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        },
        loadBiaoqiantree: function loadBiaoqiantree() {
            if (!this.biaoqians) return;
            this.biaoqiantree = [];
            this.biaoqiantree.push({ name: '全部', title: '全部', expand: true, checked: false, children: [] });
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.biaoqians), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var biaoqian = _step3.value;

                    this.biaoqiantree[0].children.push({ _id: biaoqian._id, name: biaoqian.name, title: biaoqian.name, checked: false });
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }
        },

        // 禁用选项
        disabledItem: function disabledItem() {
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
                for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.mendians), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var i = _step4.value;

                    if (i._id === this.disabledId) {
                        i._disabled = true;
                    }
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                    }
                } finally {
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }
        },
        clearTreeChecks: function clearTreeChecks() {
            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
                for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.treeData), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                    var node = _step5.value;

                    node.checked = false;
                    this.clearNode(node);
                }
            } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                        _iterator5.return();
                    }
                } finally {
                    if (_didIteratorError5) {
                        throw _iteratorError5;
                    }
                }
            }

            this.loadBiaoqiantree();
        },
        clearNode: function clearNode(node) {
            if (node.children) {
                var _iteratorNormalCompletion6 = true;
                var _didIteratorError6 = false;
                var _iteratorError6 = undefined;

                try {
                    for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(node.children), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                        var child = _step6.value;

                        child.checked = false;
                        this.clearNode(child);
                    }
                } catch (err) {
                    _didIteratorError6 = true;
                    _iteratorError6 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion6 && _iterator6.return) {
                            _iterator6.return();
                        }
                    } finally {
                        if (_didIteratorError6) {
                            throw _iteratorError6;
                        }
                    }
                }
            }
        },
        resetTree: function resetTree() {
            this.query.relations = null;
            this.clearTreeChecks();
            this.page.current = 1;
            this.loadData();
        },
        treeSelected: function treeSelected(nodes) {
            this.query.relations = nodes.map(function (item) {
                return { _id: item._id, name: item.name };
            });
            var _iteratorNormalCompletion7 = true;
            var _didIteratorError7 = false;
            var _iteratorError7 = undefined;

            try {
                for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(nodes), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                    var node = _step7.value;

                    this.parseNode(node);
                }
            } catch (err) {
                _didIteratorError7 = true;
                _iteratorError7 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion7 && _iterator7.return) {
                        _iterator7.return();
                    }
                } finally {
                    if (_didIteratorError7) {
                        throw _iteratorError7;
                    }
                }
            }

            this.page.current = 1;
            this.loadData();
        },
        parseNode: function parseNode() {
            // if (node.checked && node.children) {
            //     for (let child of node.children) {
            //         if (!child.checked) {
            //             child.checked = true
            //             this.query.relations.push({ _id: child._id, name: child.name })
            //             this.parseNode(child)
            //         }
            //     }
            // }
        },
        clearKeywords: function clearKeywords() {
            this.query.keywords = '';
            this.usedKeywords = '';
            this.page.current = 1;
            this.loadData();
        },
        keywordsChanged: function keywordsChanged() {
            this.usedKeywords = this.query.keywords;
            this.page.current = 1;
            this.loadData();
        },
        pageChanged: function pageChanged(value) {
            this.page.current = value;
            this.loadData();
        },
        pageSizeChanged: function pageSizeChanged(value) {
            this.page.size = value;
            // sessionStorage.pagesize = value
            if (this.page.current == 1) this.loadData();
        },
        loadData: function loadData() {
            var that = this;
            that.loading = true;
            that.$api.post('/web/main/mendianselector/load', {
                query: this.query,
                page: this.page
            }).then(function (res) {
                that.loading = false;
                if (that.query.init) {
                    that.query.init = false;
                    that.jigous = res.data.jigous;
                    that.parseTree(that.jigous);
                }
                that.total = res.data.total;
                that.usedKeywords = that.query.keywords;
                var mendians = res.data.mendians;
                var _iteratorNormalCompletion8 = true;
                var _didIteratorError8 = false;
                var _iteratorError8 = undefined;

                try {
                    for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(mendians), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                        var mendian = _step8.value;

                        var found = that.selections.findOne({ _id: mendian._id });
                        if (found) {
                            mendian._checked = true;
                        }
                    }
                } catch (err) {
                    _didIteratorError8 = true;
                    _iteratorError8 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion8 && _iterator8.return) {
                            _iterator8.return();
                        }
                    } finally {
                        if (_didIteratorError8) {
                            throw _iteratorError8;
                        }
                    }
                }

                that.mendians = mendians;
                if (that.disabledId) {
                    that.disabledItem();
                }
            }, function () {
                that.loading = false;
            });
        },
        parseTree: function parseTree(jigous) {
            var treeData = [];
            var maxlevel = 0;
            var items = [];
            var _iteratorNormalCompletion9 = true;
            var _didIteratorError9 = false;
            var _iteratorError9 = undefined;

            try {
                for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(jigous), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                    var jigou = _step9.value;

                    if (jigou.level > maxlevel) {
                        maxlevel = jigou.level;
                    }
                    items.push({ _id: jigou._id, name: jigou.name, level: jigou.level, parent: jigou.parent, title: jigou.name, checked: false, expand: jigou.level < 1 ? true : false, children: [] });
                }
            } catch (err) {
                _didIteratorError9 = true;
                _iteratorError9 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion9 && _iterator9.return) {
                        _iterator9.return();
                    }
                } finally {
                    if (_didIteratorError9) {
                        throw _iteratorError9;
                    }
                }
            }

            var level = maxlevel;
            while (level >= 0) {
                var _iteratorNormalCompletion10 = true;
                var _didIteratorError10 = false;
                var _iteratorError10 = undefined;

                try {
                    for (var _iterator10 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(items), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                        var item = _step10.value;

                        if (item.level == level) {
                            if (!item.parent) {
                                treeData.push(item);
                            } else {
                                var _iteratorNormalCompletion11 = true;
                                var _didIteratorError11 = false;
                                var _iteratorError11 = undefined;

                                try {
                                    for (var _iterator11 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(items), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
                                        var parent = _step11.value;

                                        if (parent._id == item.parent._id) {
                                            parent.children.push(item);
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError11 = true;
                                    _iteratorError11 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion11 && _iterator11.return) {
                                            _iterator11.return();
                                        }
                                    } finally {
                                        if (_didIteratorError11) {
                                            throw _iteratorError11;
                                        }
                                    }
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError10 = true;
                    _iteratorError10 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion10 && _iterator10.return) {
                            _iterator10.return();
                        }
                    } finally {
                        if (_didIteratorError10) {
                            throw _iteratorError10;
                        }
                    }
                }

                level--;
            }
            // for (let item of items) {
            //     let allchildren = this.getAllChildren(item)
            //     if (allchildren.some(o => o.checked) && allchildren.some(o => !o.checked)) {
            //         item.expand = true
            //     } else {
            //         item.expand = false
            //     }
            // }
            this.treeData = treeData;
        },
        search: function search() {
            this.loadData();
        },
        cancel: function cancel() {
            this.$emit('cancel');
        },
        mendianSelected: function mendianSelected() {
            this.$emit('mendianSelected', this.selections);
        },
        showSelections: function showSelections() {
            var selections = this.selections.map(function (item) {
                return { _id: item._id, actived: item.actived, type: item.type };
            });
            this.query = { selections: selections };
            if (this.options) {
                if (this.options.query) {
                    var _iteratorNormalCompletion12 = true;
                    var _didIteratorError12 = false;
                    var _iteratorError12 = undefined;

                    try {
                        for (var _iterator12 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.options.query)), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
                            var key = _step12.value;

                            this.query[key] = this.options.query[key];
                        }
                    } catch (err) {
                        _didIteratorError12 = true;
                        _iteratorError12 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion12 && _iterator12.return) {
                                _iterator12.return();
                            }
                        } finally {
                            if (_didIteratorError12) {
                                throw _iteratorError12;
                            }
                        }
                    }
                }
            }
            this.page.current = 1;
            this.clearTreeChecks();
            this.loadData();
        },
        clearSelections: function clearSelections(_ref) {
            var _this4 = this;

            var confirm = _ref.confirm;

            if (!this.isAdmin && this.$store.session.zhanghao.guanxiajigous && this.$store.session.zhanghao.guanxiajigous.length * this.selections.length > 1000000 && !confirm) {
                this.$Modal.confirm({
                    title: '提示',
                    content: '机构数量较多，清空需要一定时间，点击确定继续',
                    onOk: function onOk() {
                        _this4.clearSelections({ confirm: true });
                    }
                });
                return;
            }
            if (this.$store.session.zhanghao.guanxiajigous && !this.isAdmin) {
                this.selections = this.selections.filter(function (o) {
                    return !_this4.$store.session.zhanghao.guanxiajigous.some(function (j) {
                        return j._id == o._id;
                    });
                });
            } else {
                this.selections = [];
            }
            var mendians = [];
            var _iteratorNormalCompletion13 = true;
            var _didIteratorError13 = false;
            var _iteratorError13 = undefined;

            try {
                for (var _iterator13 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.mendians), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
                    var item = _step13.value;

                    item._checked = false;
                    mendians.push(item);
                }
            } catch (err) {
                _didIteratorError13 = true;
                _iteratorError13 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion13 && _iterator13.return) {
                        _iterator13.return();
                    }
                } finally {
                    if (_didIteratorError13) {
                        throw _iteratorError13;
                    }
                }
            }

            this.mendians = mendians;
        },
        allSelected: function allSelected(items) {
            var _iteratorNormalCompletion14 = true;
            var _didIteratorError14 = false;
            var _iteratorError14 = undefined;

            try {
                for (var _iterator14 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(items), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
                    var item = _step14.value;

                    if (!this.selections.findOne({ _id: item._id })) {
                        this.selections.push(item);
                    }
                }
            } catch (err) {
                _didIteratorError14 = true;
                _iteratorError14 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion14 && _iterator14.return) {
                        _iterator14.return();
                    }
                } finally {
                    if (_didIteratorError14) {
                        throw _iteratorError14;
                    }
                }
            }
        },
        allSelectedCancel: function allSelectedCancel() {
            var _iteratorNormalCompletion15 = true;
            var _didIteratorError15 = false;
            var _iteratorError15 = undefined;

            try {
                for (var _iterator15 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.mendians), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
                    var item = _step15.value;

                    this.selections.remove({ _id: item._id });
                }
            } catch (err) {
                _didIteratorError15 = true;
                _iteratorError15 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion15 && _iterator15.return) {
                        _iterator15.return();
                    }
                } finally {
                    if (_didIteratorError15) {
                        throw _iteratorError15;
                    }
                }
            }
        },
        itemSelected: function itemSelected(_, item) {
            this.selections.push(item);
        },
        itemSelectedCancel: function itemSelectedCancel(_, item) {
            this.selections.remove({ _id: item._id });
        }
    }
});

/***/ }),

/***/ "q6sT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomTable_vue__ = __webpack_require__("IdYH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_453801a3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_CustomTable_vue__ = __webpack_require__("cSsU");
function injectStyle (ssrContext) {
  __webpack_require__("4Jp4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-453801a3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_453801a3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_CustomTable_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "r5br":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blockLayout_vue__ = __webpack_require__("8cYE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36518c48_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_blockLayout_vue__ = __webpack_require__("xJvj");
function injectStyle (ssrContext) {
  __webpack_require__("UyV6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-36518c48"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blockLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36518c48_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_blockLayout_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rA0i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomData_vue__ = __webpack_require__("0G7C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79955136_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_CustomData_vue__ = __webpack_require__("PvwE");
function injectStyle (ssrContext) {
  __webpack_require__("Wq/E")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-79955136"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomData_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79955136_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_CustomData_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rJpw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap"
  }, [_c('Breadcrumb', _vm._l((_vm.levelList), function(item, index) {
    return _c('BreadcrumbItem', {
      key: index
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: item.path + '?' + item.query
        }
      }
    }, [_vm._v(_vm._s(item.meta.title))])], 1)
  }), 1), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("\n      " + _vm._s(_vm.contentTitle) + "\n    ")])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rRlr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_view_design__ = __webpack_require__("b3L9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_view_design___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_view_design__);

var beforeClose = {
  before_close_normal: function before_close_normal(resolve) {
    __WEBPACK_IMPORTED_MODULE_0_view_design__["Modal"].confirm({
      title: '确定要关闭这一页吗',
      onOk: function onOk() {
        resolve(true);
      },
      onCancel: function onCancel() {
        resolve(false);
      }
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (beforeClose);

/***/ }),

/***/ "rlYW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = Amount;
/* harmony export (immutable) */ __webpack_exports__["a"] = AmountDecimal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__validator__ = __webpack_require__("w3CS");

// 保留小数-精度
function Amount(value) {
    var fix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    var int = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    return Number(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__validator__["a" /* inputValidFloat */])('' + value, fix, int));
}

// 保留小数-计算
function AmountDecimal(value) {
    var fix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

    if (!value) {
        return 0;
    }
    if (value === '-' || value === '--') {
        return value;
    }
    var num = Number(value);
    var roundNum = Math.pow(100, fix / 2);
    num = Math.round(num * roundNum);
    // num = parseFloat(num / roundNum).toFixed(fix)
    num = String(num / roundNum).replace(/(\.\d{fix})\d+$/, '$1');
    return Number(num);
}

/***/ }),

/***/ "ruvo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormItemEditor_vue__ = __webpack_require__("y2EM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bacf56e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_FormItemEditor_vue__ = __webpack_require__("Lnip");
function injectStyle (ssrContext) {
  __webpack_require__("IYde")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5bacf56e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormItemEditor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bacf56e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_FormItemEditor_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rzXh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sB98":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CaigoumobanSelector_vue__ = __webpack_require__("Y3pB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09df6ad0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_CaigoumobanSelector_vue__ = __webpack_require__("VMgG");
function injectStyle (ssrContext) {
  __webpack_require__("5aUe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-09df6ad0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CaigoumobanSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09df6ad0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_CaigoumobanSelector_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sexz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KucunmobanSelector_vue__ = __webpack_require__("J6E2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63ba7604_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_KucunmobanSelector_vue__ = __webpack_require__("eLH1");
function injectStyle (ssrContext) {
  __webpack_require__("AOEg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-63ba7604"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KucunmobanSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63ba7604_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_KucunmobanSelector_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "siF6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  GET_ORGANIZATION: '/web/main/selector/jigou', /** 获取机构（供货、要货、管辖机构等） */
  GET_SUBLEVEL: '/web/main/selector/gonghuojigou', /**供货机构（供应商）下拉框 - 加载数据 */
  GET_WAREHOUSE: '/web/main/selector/cangku', /**仓库下拉框 - 加载数据 */
  GET_CATEGORY: '/web/main/selector/leibie', /**类别下拉框或树节点分段加载 - 加载数据 */
  GET_BUMEN: '/web/main/selector/bumen', /**类别下拉框或树节点分段加载 - 加载数据 */
  GET_BIAOQIAN: '/web/main/selector/biaoqian', /**类别下拉框或树节点分段加载 - 加载数据 */
  GET_YUANYIN: '/web/main/selector/yuanyin', /**类别下拉框或树节点分段加载 - 加载数据 */
  GET_WUPIN: '/web/main/selector/wupin', /**类别下拉框或树节点分段加载 - 加载数据 */
  GET_CAIPIN: '/web/main/selector/caipin', /**类别下拉框或树节点分段加载 - 加载数据 */
  GET_WAIXIAOKEHU: '/web/main/selector/waixiaokehu', /**类别下拉框或树节点分段加载 - 加载数据 */
  GET_ITEM: '/web/main/selector/item' /**类别下拉框或树节点分段加载 - 加载数据 */
});

/***/ }),

/***/ "tLal":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "20px 0"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "border-top": "1px solid #f1f1f1",
      "border-bottom": "1px solid #f1f1f1",
      "margin-top": "20px"
    }
  }, [_c('el-amap-search-box', {
    staticClass: "amap-search-box",
    attrs: {
      "search-option": _vm.amap.searchOption,
      "on-search-result": _vm.onSearchResult
    }
  }), _vm._v(" "), _c('el-amap', {
    staticClass: "amap-style",
    attrs: {
      "center": _vm.amap.center,
      "zoom": _vm.amap.zoom,
      "events": _vm.amap.events
    }
  }, [_c('el-amap-marker', {
    attrs: {
      "position": _vm.amap.marker.position,
      "events": _vm.amap.marker.events,
      "draggable": true
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "foot jcsb",
    staticStyle: {
      "padding": "0 20px"
    }
  }, [_c('div'), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('Button', {
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.locationConfirm
    }
  }, [_vm._v("确定")])], 1)])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "font-size": "20px",
      "padding": "0 20px"
    }
  }, [_c('div', [_vm._v("选择门店")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tNNF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tfKK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hasOneOf */
/* unused harmony export hasChild */
/* unused harmony export forEach */
/* unused harmony export objEqual */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return showTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return routeEqual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getBreadCrumbList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return setTagNavListInLocalstorage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getMenuByRouter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getTagNavListFromLocalstorage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getHomeRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getNextRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return routeHasExist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getRouteTitleHandled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return localSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return localRead; });
/* unused harmony export doCustomTimes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getNewTagList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);




/**
 * @param {Array} target 目标数组
 * @param {Array} arr 需要查询的数组
 * @description 判断要查询的数组是否至少有一个元素包含在目标数组中
 */
var hasOneOf = function hasOneOf(targetarr, arr) {
  return targetarr.some(function (_) {
    return arr.indexOf(_) > -1;
  });
};
var hasChild = function hasChild(item) {
  return item.children && item.children.length !== 0;
};
var forEach = function forEach(arr, fn) {
  if (!arr.length || !fn) return;
  var i = -1;
  var len = arr.length;
  while (++i < len) {
    var item = arr[i];
    fn(item, i, arr);
  }
};
var showThisMenuEle = function showThisMenuEle(item, access) {
  if (item.meta && item.meta.access && item.meta.access.length) {
    if (hasOneOf(item.meta.access, access)) return true;else return false;
  } else return true;
};
/**
 * @param {*} obj1 对象
 * @param {*} obj2 对象
 * @description 判断两个对象是否相等，这两个对象的值只能是数字或字符串
 */
var objEqual = function objEqual(obj1, obj2) {
  var keysArr1 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(obj1);
  var keysArr2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(obj2);
  if (keysArr1.length !== keysArr2.length) return false;else if (keysArr1.length === 0 && keysArr2.length === 0) return true;
  /* eslint-disable-next-line */
  else return !keysArr1.some(function (key) {
      return obj1[key] != obj2[key];
    });
};

var showTitle = function showTitle(item, vm) {
  var _item$meta = item.meta,
      title = _item$meta.title,
      __titleIsFunction__ = _item$meta.__titleIsFunction__;

  var useI18n = false;
  if (!title) return;
  if (useI18n) {
    if (title.includes('{{') && title.includes('}}') && useI18n) title = title.replace(/({{[\s\S]+?}})/, function (m, str) {
      return str.replace(/{{([\s\S]*)}}/, function (mm, _) {
        return vm.$t(_.trim());
      });
    });else if (__titleIsFunction__) title = item.meta.title;else title = vm.$t(item.name);
  } else title = item.meta && item.meta.title || item.name;
  return title;
};

/**
 * @description 根据name/params/query判断两个路由对象是否相等
 * @param {*} route1 路由对象
 * @param {*} route2 路由对象
 */
var routeEqual = function routeEqual(route1, route2) {
  var params1 = route1.params || {};
  var params2 = route2.params || {};
  var query1 = route1.query || {};
  var query2 = route2.query || {};
  var title1 = route1.meta && route1.meta.title || '';
  var title2 = route2.meta && route2.meta.title || '';
  return (route1.name === route2.name || title1 === title2) && objEqual(params1, params2) && objEqual(query1, query2);
};

/**
 * @param {Array} routeMetched 当前路由metched
 * @returns {Array}
 */
var getBreadCrumbList = function getBreadCrumbList(route, homeRoute) {
  var homeItem = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, homeRoute, { icon: homeRoute.meta.icon });
  var routeMetched = route.matched;
  if (routeMetched.some(function (item) {
    return item.name === homeRoute.name;
  })) return [homeItem];
  var res = routeMetched.filter(function (item) {
    return item.meta === undefined || !item.meta.hideInBread;
  }).map(function (item) {
    var meta = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, item.meta);
    if (meta.title && typeof meta.title === 'function') {
      meta.__titleIsFunction__ = true;
      meta.title = meta.title(route);
    }
    var obj = {
      icon: item.meta && item.meta.icon || '',
      name: item.name,
      meta: meta
    };
    return obj;
  });
  res = res.filter(function (item) {
    return !item.meta.hideInMenu;
  });
  return [__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, homeItem, { to: homeRoute.path })].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(res));
};

/**
 * @description 本地存储和获取标签导航列表
 */
var setTagNavListInLocalstorage = function setTagNavListInLocalstorage(list) {
  localStorage.tagNaveList = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(list);
};
/**
 * @param {Array} list 通过路由列表得到菜单列表
 * @returns {Array}
 */
var getMenuByRouter = function getMenuByRouter(list, access) {
  var res = [];
  forEach(list, function (item) {
    if (!item.meta || item.meta && !item.meta.hideInMenu) {
      var obj = {
        icon: item.meta && item.meta.icon || '',
        name: item.name,
        meta: item.meta
      };
      if ((hasChild(item) || item.meta && item.meta.showAlways) && showThisMenuEle(item, access)) {
        obj.children = getMenuByRouter(item.children, access);
      }
      if (item.meta && item.meta.href) obj.href = item.meta.href;
      if (showThisMenuEle(item, access)) res.push(obj);
    }
  });
  return res;
};
/**
 * @returns {Array} 其中的每个元素只包含路由原信息中的name, path, meta三项
 */
var getTagNavListFromLocalstorage = function getTagNavListFromLocalstorage() {
  var list = localStorage.tagNaveList;
  return list ? JSON.parse(list) : [];
};
/**
 * @param {Array} routers 路由列表数组
 * @description 用于找到路由列表中name为home的对象
 */
var getHomeRoute = function getHomeRoute(routers) {
  var homeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'home';

  var i = -1;
  var len = routers.length;
  var homeRoute = {};
  while (++i < len) {
    var item = routers[i];
    if (item.children && item.children.length) {
      var res = getHomeRoute(item.children, homeName);
      if (res.name) return res;
    } else {
      if (item.name === homeName) homeRoute = item;
    }
  }
  return homeRoute;
};
/**
 * @param {Array} list 标签列表
 * @param {String} name 当前关闭的标签的name
 */
var getNextRoute = function getNextRoute(list, route) {
  var res = {};
  if (list.length === 1) {
    res = getHomeRoute(list);
  } else {
    var index = list.findIndex(function (item) {
      return routeEqual(item, route);
    });
    if (index === list.length - 1) res = list[list.length - 2];else res = list[index + 1];
  }
  return res;
};
/**
 * 判断打开的标签列表里是否已存在这个新添加的路由对象
 */
var routeHasExist = function routeHasExist(tagNavList, routeItem) {
  var len = tagNavList.length;
  var res = false;
  doCustomTimes(len, function (index) {
    if (routeEqual(tagNavList[index], routeItem)) res = true;
  });
  return res;
};
var getRouteTitleHandled = function getRouteTitleHandled(route) {
  var router = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, route);
  var meta = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, route.meta);
  var title = '';
  if (meta.title) {
    if (typeof meta.title === 'function') {
      meta.__titleIsFunction__ = true;
      title = meta.title(router);
    } else title = meta.title;
  }
  meta.title = title;
  router.meta = meta;
  return router;
};
var localSave = function localSave(key, value) {
  localStorage.setItem(key, value);
};

var localRead = function localRead(key) {
  return localStorage.getItem(key) || '';
};
/**
 * @param {Number} times 回调函数需要执行的次数
 * @param {Function} callback 回调函数
 */
var doCustomTimes = function doCustomTimes(times, callback) {
  var i = -1;
  while (++i < times) {
    callback(i);
  }
};
/**
 * @param {*} list 现有标签导航列表
 * @param {*} newRoute 新添加的路由原信息对象
 * @description 如果该newRoute已经存在则不再添加
 */
var getNewTagList = function getNewTagList(list, newRoute) {
  var name = newRoute.name,
      path = newRoute.path,
      meta = newRoute.meta,
      params = newRoute.params,
      query = newRoute.query;

  var newList = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(list));
  // 检查是否已存在相同的路由（通过 routeEqual 比较）
  if (newList.findIndex(function (item) {
    var route1 = { name: item.name, params: item.params || {}, query: item.query || {}, meta: item.meta };
    var route2 = { name: name, params: params || {}, query: query || {}, meta: meta };
    return routeEqual(route1, route2);
  }) >= 0) return newList;else newList.push({ name: name, path: path, meta: meta, params: params, query: query });
  return newList;
};

/***/ }),

/***/ "u+K/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    theme: {
      type: String,
      default: 'dark'
    },
    isResponse: {
      type: Boolean,
      default: false
    },
    content: {
      type: String,
      default: ''
    },
    placement: {
      default: 'right',
      type: String
    },
    width: {
      type: [String, Number],
      default: 400
    },
    /**展现形式-图标 */
    showIcon: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    response: function response() {
      this.$emit('clickIcon', true);
    }
  }
});

/***/ }),

/***/ "vJRf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FormItemLabel__ = __webpack_require__("zJQN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_LocationSelector_vue__ = __webpack_require__("T9ui");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        FormItemLabel: __WEBPACK_IMPORTED_MODULE_4__FormItemLabel__["a" /* default */],
        LocationSelector: __WEBPACK_IMPORTED_MODULE_5__components_common_LocationSelector_vue__["a" /* default */]
    },
    props: {
        options: Object
    },
    data: function data() {
        var _this = this;

        return {
            config: {},
            current: null,
            loading: true,
            form: null,
            rules: {
                // name: [{ required: true, message: ' ', trigger: 'blur' }],
            },
            caozuojilus: [],
            uploadConfig: {
                token: null,
                field: 'image'
            },
            locationSelector: {
                display: false,
                field: null,
                current: null,
                show: function show(field) {
                    _this.locationSelector.display = true;
                    _this.locationSelector.current = _this.form[field] ? _this.form[field].value : null;
                    _this.locationSelector.field = field;
                },
                confirm: function () {
                    var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(value) {
                        var res;
                        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                            while (1) {
                                switch (_context.prev = _context.next) {
                                    case 0:
                                        _this.loading = true;
                                        _context.next = 3;
                                        return _this.$api.post('/web/main/location/parse', {
                                            location: value
                                        });

                                    case 3:
                                        res = _context.sent;

                                        _this.loading = false;
                                        _this.form[_this.locationSelector.field] = {
                                            value: value,
                                            name: res.data.locationStr,
                                            city: res.data.city,
                                            cityStr: res.data.cityStr,
                                            detail: res.data.locationDetail
                                        };
                                        _this.locationSelector.display = false;

                                    case 7:
                                    case 'end':
                                        return _context.stop();
                                }
                            }
                        }, _callee, _this);
                    }));

                    return function confirm(_x) {
                        return _ref.apply(this, arguments);
                    };
                }()
            }
        };
    },

    computed: {
        deleteable: function deleteable() {
            var value = false;
            if (this.config.deleteable === undefined) {
                value = true;
            } else {
                value = !!this.config.deleteable;
            }
            if (this.config.deleteableif) {
                value = this.config.deleteableif(this.current);
            }
            return value;
        }
    },
    mounted: function mounted() {
        this.config = this.copy(this.options);
        this.init();
    },

    methods: {
        init: function init() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var form, rules, items, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, col, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, item, rule, min, max, _rule, _min, _max;

                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                // if (this.config.deleteable === undefined) { this.config.deleteable = true }
                                // if (this.config.deleteableif) {
                                //     this.config.deleteableif(this.form)
                                // }
                                form = {};
                                rules = {};
                                items = [];
                                _iteratorNormalCompletion = true;
                                _didIteratorError = false;
                                _iteratorError = undefined;
                                _context2.prev = 6;

                                for (_iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this2.config.form.cols); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                    col = _step.value;

                                    if (!col.slot) {
                                        items = items.concat(col.items);
                                    }
                                }
                                _context2.next = 14;
                                break;

                            case 10:
                                _context2.prev = 10;
                                _context2.t0 = _context2['catch'](6);
                                _didIteratorError = true;
                                _iteratorError = _context2.t0;

                            case 14:
                                _context2.prev = 14;
                                _context2.prev = 15;

                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }

                            case 17:
                                _context2.prev = 17;

                                if (!_didIteratorError) {
                                    _context2.next = 20;
                                    break;
                                }

                                throw _iteratorError;

                            case 20:
                                return _context2.finish(17);

                            case 21:
                                return _context2.finish(14);

                            case 22:
                                _iteratorNormalCompletion2 = true;
                                _didIteratorError2 = false;
                                _iteratorError2 = undefined;
                                _context2.prev = 25;
                                _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(items);

                            case 27:
                                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                                    _context2.next = 40;
                                    break;
                                }

                                item = _step2.value;

                                if (item.key) {
                                    _context2.next = 31;
                                    break;
                                }

                                return _context2.abrupt('continue', 37);

                            case 31:
                                form[item.key] = item.default;
                                if (item.default === undefined) {
                                    if (item.multi || item.type == 'list') {
                                        form[item.key] = [];
                                    } else {
                                        form[item.key] = null;
                                    }
                                }
                                if (item.type == 'selector' && !item.render) {
                                    item.render = function (data) {
                                        if (data && data.name) {
                                            return data.name;
                                        } else {
                                            return data;
                                        }
                                    };
                                }
                                if (item.type == 'number' && item.unit) {
                                    if (item.unit.default && form[item.unit.key] === undefined) {
                                        form[item.unit.key] = item.unit.default;
                                    }
                                }

                                if (item.type == 'selector' && !item.selections) {
                                    item.selections = [];
                                }
                                if (item.required) {
                                    if (item.type == 'text' || item.type == 'textarea') {
                                        rules[item.key] = [{ required: true, message: ' ', trigger: 'blur' }];
                                    } else if (item.type == 'number') {
                                        rule = { required: true, type: 'number', message: item.message || ' ', trigger: 'blur' };
                                        min = typeof item.min === 'number' ? item.min : undefined;
                                        max = typeof item.max === 'number' ? item.max : undefined;

                                        if (min !== undefined) rule.min = min;
                                        if (max !== undefined) rule.max = max;
                                        rules[item.key] = [rule];
                                    } else if (item.type == 'image' || item.type == 'custom') {
                                        rules[item.key] = [{ required: true, type: 'object', message: ' ', trigger: 'blur' }];
                                    } else if (item.multi || item.type == 'list' || item.type == 'daterange') {
                                        rules[item.key] = [{ required: true, type: 'array', min: 1, message: '至少选择一项', trigger: 'blur' }];
                                    } else if (item.type == 'jigou' || item.type == 'gonghuojigou') {
                                        rules[item.key] = [{ required: true, type: 'object', message: ' ', trigger: 'blur' }];
                                    } else {
                                        if (item.required == 'object') {
                                            rules[item.key] = [{ required: true, type: 'object', message: '请填写', trigger: 'blur' }];
                                        } else if (item.required == 'list') {
                                            rules[item.key] = [{ required: true, type: 'array', min: 1, message: '至少选择一项', trigger: 'blur' }];
                                        } else {
                                            rules[item.key] = [{ required: true, type: 'string', message: '请填写', trigger: 'blur' }];
                                        }
                                    }
                                } else if (item.type == 'number' && (typeof item.min === 'number' || typeof item.max === 'number')) {
                                    // 非必填但有min/max
                                    _rule = { type: 'number', trigger: 'blur', message: item.message || ' ' };
                                    _min = typeof item.min === 'number' ? item.min : undefined;
                                    _max = typeof item.max === 'number' ? item.max : undefined;

                                    if (_min !== undefined) _rule.min = _min;
                                    if (_max !== undefined) _rule.max = _max;
                                    rules[item.key] = [_rule];
                                }

                            case 37:
                                _iteratorNormalCompletion2 = true;
                                _context2.next = 27;
                                break;

                            case 40:
                                _context2.next = 46;
                                break;

                            case 42:
                                _context2.prev = 42;
                                _context2.t1 = _context2['catch'](25);
                                _didIteratorError2 = true;
                                _iteratorError2 = _context2.t1;

                            case 46:
                                _context2.prev = 46;
                                _context2.prev = 47;

                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                    _iterator2.return();
                                }

                            case 49:
                                _context2.prev = 49;

                                if (!_didIteratorError2) {
                                    _context2.next = 52;
                                    break;
                                }

                                throw _iteratorError2;

                            case 52:
                                return _context2.finish(49);

                            case 53:
                                return _context2.finish(46);

                            case 54:
                                _this2.items = items;
                                _context2.next = 57;
                                return _this2.loadData(form);

                            case 57:
                                _this2.form = form;
                                _this2.options._form = form;
                                _this2.rules = rules;
                                if (_this2.options.onload) _this2.options.onload(form, _this2.current);

                            case 61:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2, [[6, 10, 14, 22], [15,, 17, 21], [25, 42, 46, 54], [47,, 49, 53]]);
            }))();
        },
        loadData: function loadData(_form) {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var form, res, data, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, key, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, item, _res;

                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                form = _form;

                                if (!form) {
                                    form = _this3.form;
                                }

                                if (!_this3.options.load) {
                                    _context3.next = 31;
                                    break;
                                }

                                _this3.loading = true;
                                _context3.next = 6;
                                return _this3.options.load({ dataId: _this3.config.current ? _this3.config.current._id : null });

                            case 6:
                                res = _context3.sent;

                                _this3.loading = false;
                                data = res.data[_this3.config.data.key];

                                if (!data) {
                                    _context3.next = 30;
                                    break;
                                }

                                _this3.current = data;
                                _iteratorNormalCompletion3 = true;
                                _didIteratorError3 = false;
                                _iteratorError3 = undefined;
                                _context3.prev = 14;
                                for (_iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(form)); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                    key = _step3.value;

                                    if (data[key] !== undefined) {
                                        form[key] = data[key];
                                    }
                                }
                                _context3.next = 22;
                                break;

                            case 18:
                                _context3.prev = 18;
                                _context3.t0 = _context3['catch'](14);
                                _didIteratorError3 = true;
                                _iteratorError3 = _context3.t0;

                            case 22:
                                _context3.prev = 22;
                                _context3.prev = 23;

                                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                    _iterator3.return();
                                }

                            case 25:
                                _context3.prev = 25;

                                if (!_didIteratorError3) {
                                    _context3.next = 28;
                                    break;
                                }

                                throw _iteratorError3;

                            case 28:
                                return _context3.finish(25);

                            case 29:
                                return _context3.finish(22);

                            case 30:
                                if (_this3.config.caozuojiluOn && res.data.caozuojilus) _this3.caozuojilus = res.data.caozuojilus;

                            case 31:
                                if (_this3.config.init) _this3.config.init({ current: _this3.current, form: form, options: _this3.config });
                                _iteratorNormalCompletion4 = true;
                                _didIteratorError4 = false;
                                _iteratorError4 = undefined;
                                _context3.prev = 35;
                                _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this3.items);

                            case 37:
                                if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
                                    _context3.next = 48;
                                    break;
                                }

                                item = _step4.value;

                                if (item.init) item.init({ item: item, form: form, current: _this3.current });

                                if (!item.load) {
                                    _context3.next = 45;
                                    break;
                                }

                                _context3.next = 43;
                                return item.load({ item: item, form: form, current: _this3.current });

                            case 43:
                                _res = _context3.sent;

                                if (item.type == 'selector' && _res.data && _res.data.items) {
                                    item.selections = _res.data.items || [];
                                }

                            case 45:
                                _iteratorNormalCompletion4 = true;
                                _context3.next = 37;
                                break;

                            case 48:
                                _context3.next = 54;
                                break;

                            case 50:
                                _context3.prev = 50;
                                _context3.t1 = _context3['catch'](35);
                                _didIteratorError4 = true;
                                _iteratorError4 = _context3.t1;

                            case 54:
                                _context3.prev = 54;
                                _context3.prev = 55;

                                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                    _iterator4.return();
                                }

                            case 57:
                                _context3.prev = 57;

                                if (!_didIteratorError4) {
                                    _context3.next = 60;
                                    break;
                                }

                                throw _iteratorError4;

                            case 60:
                                return _context3.finish(57);

                            case 61:
                                return _context3.finish(54);

                            case 62:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3, [[14, 18, 22, 30], [23,, 25, 29], [35, 50, 54, 62], [55,, 57, 61]]);
            }))();
        },
        cancel: function cancel() {
            this.$emit('cancel');
        },
        toSave: function toSave(_ref2) {
            var _this4 = this;

            var tijiao = _ref2.tijiao;
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _this4.$refs['form'].validate(function () {
                                    var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4(valid) {
                                        var r, res;
                                        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                                            while (1) {
                                                switch (_context4.prev = _context4.next) {
                                                    case 0:
                                                        if (valid) {
                                                            _context4.next = 2;
                                                            break;
                                                        }

                                                        return _context4.abrupt('return', _this4.$Message.error('请检查输入'));

                                                    case 2:
                                                        if (!_this4.config.beforeSave) {
                                                            _context4.next = 8;
                                                            break;
                                                        }

                                                        _context4.next = 5;
                                                        return _this4.config.beforeSave({ current: _this4.current, form: _this4.form });

                                                    case 5:
                                                        r = _context4.sent;

                                                        if (!r.error) {
                                                            _context4.next = 8;
                                                            break;
                                                        }

                                                        return _context4.abrupt('return', _this4.$Message.error(r.error));

                                                    case 8:
                                                        _this4.loading = true;
                                                        _context4.next = 11;
                                                        return _this4.options.save({ dataId: _this4.config.current ? _this4.config.current._id : null, form: _this4.form, tijiao: tijiao, timestamp: _this4.config.current ? _this4.config.current.lastUpdateTime : null });

                                                    case 11:
                                                        res = _context4.sent;

                                                        _this4.loading = false;

                                                        if (!(!res || !res.data)) {
                                                            _context4.next = 15;
                                                            break;
                                                        }

                                                        return _context4.abrupt('return');

                                                    case 15:
                                                        if (res.data.success) {
                                                            _this4.$Message.success({ content: '操作成功', duration: 4, closable: true });
                                                            _this4.$emit('dataChanged', { type: _this4.config.current ? 'edit' : 'add', data: res.data[_this4.config.data.key] });
                                                        } else if (res.data.errors && res.data.errors[0]) {
                                                            _this4.$Message.error('保存失败：' + res.data.errors[0].error);
                                                        }

                                                    case 16:
                                                    case 'end':
                                                        return _context4.stop();
                                                }
                                            }
                                        }, _callee4, _this4);
                                    }));

                                    return function (_x2) {
                                        return _ref3.apply(this, arguments);
                                    };
                                }());

                            case 1:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this4);
            }))();
        },
        toDelete: function toDelete() {
            var _this5 = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee7() {
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _this5.$Modal.confirm({
                                    title: '操作确认',
                                    render: function render(h) {
                                        return h('div', '删除操作不可恢复，确定要删除' + (_this5.config.current.name || '') + '？');
                                    },
                                    okText: '删除',
                                    onOk: function () {
                                        var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6() {
                                            var res;
                                            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                                                while (1) {
                                                    switch (_context6.prev = _context6.next) {
                                                        case 0:
                                                            _this5.loading = true;
                                                            _context6.next = 3;
                                                            return _this5.options.delete({ dataId: _this5.config.current._id });

                                                        case 3:
                                                            res = _context6.sent;

                                                            _this5.loading = false;
                                                            if (res.data.success) {
                                                                _this5.$Message.success({ content: '操作成功', duration: 4, closable: true });
                                                                _this5.$emit('dataChanged', { type: 'remove' });
                                                            } else if (res.data.errors && res.data.errors[0]) {
                                                                _this5.$Message.error('删除失败：' + res.data.errors[0].error);
                                                            }

                                                        case 6:
                                                        case 'end':
                                                            return _context6.stop();
                                                    }
                                                }
                                            }, _callee6, _this5);
                                        }));

                                        return function onOk() {
                                            return _ref4.apply(this, arguments);
                                        };
                                    }()
                                });

                            case 1:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, _this5);
            }))();
        },
        datePickerChanged: function datePickerChanged(form, item, value) {
            if (item.endOfDay && value.indexOf('00:00:00') != -1) {
                value = value.replace('00:00:00', '23:59:59');
            }
            if (value) {
                value = this.moment(value).format(item.format || 'YYYY-MM-DD HH:mm:ss');
                form[item.key] = value;
            } else {
                form[item.key] = null;
            }
        },
        daterangeChanged: function daterangeChanged(item, value) {
            // value[0] = value[0].replace(/\//g, '-')
            // value[1] = value[1].replace(/\//g, '-')
            this.form[item.key] = value;
        },
        selectorChanged: function selectorChanged(item, value) {
            var selections = item.loader ? item.loader(this.form) : item.selections;
            if (item.multi) {
                var result = [];
                var _iteratorNormalCompletion5 = true;
                var _didIteratorError5 = false;
                var _iteratorError5 = undefined;

                try {
                    for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(value), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                        var i = _step5.value;
                        var _iteratorNormalCompletion6 = true;
                        var _didIteratorError6 = false;
                        var _iteratorError6 = undefined;

                        try {
                            for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(selections), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                                var selection = _step6.value;

                                if (item.render(selection) == i) {
                                    result.push(this.simple(selection, item.fields));
                                    break;
                                }
                            }
                        } catch (err) {
                            _didIteratorError6 = true;
                            _iteratorError6 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                                    _iterator6.return();
                                }
                            } finally {
                                if (_didIteratorError6) {
                                    throw _iteratorError6;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError5 = true;
                    _iteratorError5 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion5 && _iterator5.return) {
                            _iterator5.return();
                        }
                    } finally {
                        if (_didIteratorError5) {
                            throw _iteratorError5;
                        }
                    }
                }

                this.form[item.key] = result;
            } else {
                if (value === undefined) {
                    this.form[item.key] = undefined;
                } else {
                    var _iteratorNormalCompletion7 = true;
                    var _didIteratorError7 = false;
                    var _iteratorError7 = undefined;

                    try {
                        for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(selections), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                            var _selection = _step7.value;

                            if (item.render(_selection) == value) {
                                this.form[item.key] = this.simple(_selection, item.fields);
                                break;
                            }
                        }
                    } catch (err) {
                        _didIteratorError7 = true;
                        _iteratorError7 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion7 && _iterator7.return) {
                                _iterator7.return();
                            }
                        } finally {
                            if (_didIteratorError7) {
                                throw _iteratorError7;
                            }
                        }
                    }
                }
            }
            if (item.change) {
                item.change({ value: this.form[item.key], form: this.form, item: item, current: this.current });
            }
        },
        jigouChanged: function jigouChanged(item, value) {
            this.form[item.key] = this.simple(value, item.fields);
            if (item.change) {
                item.change({ value: this.form[item.key], form: this.form, item: item, current: this.current });
            }
        }
    }
});

/***/ }),

/***/ "w3CS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return validatorNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return lt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ne; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return validatorDiff; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return validatorStep; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return validatorEmpty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return inputValidFloat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return inputValidInt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return inputValidNegInt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return validateMobile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return validServicePhone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return validEmptySimple; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return validGoods; });
var NumberFix = function NumberFix(value, fix) {
    if (!value) {
        return 0;
    }
    var num = Number(value);
    if (isNaN(num)) {
        return 0;
    }
    if (!fix) {
        return num;
    }
    var roundNum = Math.pow(100, fix / 2);
    num = Math.round(num * roundNum);
    num = parseFloat(num / roundNum).toFixed(fix);
    return Number(num);
};

// 表单校验
// 边界值校验
var validatorNumber = function validatorNumber(msg) {
    var minNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var item = arguments[2];
    var key = arguments[3];
    var tijiao = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

    return function (rule, value, callback) {
        value = item[key]; // 这里是为了防止-model时候，实际上value没有同步更新
        if (NumberFix(value, 6) <= minNumber && tijiao) {
            callback(new Error(msg));
        } else {
            callback();
        }
    };
};

var lt = function lt(msg) {
    var minNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var item = arguments[2];
    var key = arguments[3];
    var tijiao = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

    return function (rule, value, callback) {
        value = item[key]; // 这里是为了防止-model时候，实际上value没有同步更新
        if (NumberFix(value, 6) < minNumber && tijiao) {
            callback(new Error(msg));
        } else {
            callback();
        }
    };
};

var ne = function ne(msg) {
    var number = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var item = arguments[2];
    var key = arguments[3];
    var tijiao = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

    return function (rule, value, callback) {
        value = item[key]; // 这里是为了防止-model时候，实际上value没有同步更新
        var error = true;
        if (NumberFix(value, 6) < number || NumberFix(value, 6) > number) {
            error = false;
        }
        if (error && tijiao) {
            callback(new Error(msg));
        } else {
            callback();
        }
    };
};

// 大小值比较
var validatorDiff = function validatorDiff(msg, item, minNumberKey, maxNumberKey) {
    var tijiao = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

    return function (rule, value, callback) {
        // 不传-取value
        var maxNumber = maxNumberKey !== 0 ? item[maxNumberKey] : 0;
        var min = minNumberKey ? item[minNumberKey] : value;
        if (NumberFix(min, 6) > NumberFix(maxNumber, 6) && tijiao) {
            callback(new Error(msg));
        } else {
            callback();
        }
    };
};

// step比较
var validatorStep = function validatorStep(msg, item, stepKey, minKey) {
    var tijiao = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

    return function (rule, value, callback) {
        // 不传-取value
        var stepNumber = stepKey !== 0 ? item[stepKey] : 0;
        if ((value - (item[minKey] || 0)) % NumberFix(stepNumber, 6) > 0 && tijiao) {
            callback(new Error(msg));
        } else {
            callback();
        }
    };
};

// 数据为空
var validatorEmpty = function validatorEmpty(msg, item, key) {
    var tijiao = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

    return function (rule, value, callback) {
        value = item[key];
        if (!value && tijiao) {
            callback(new Error(msg));
        } else {
            callback();
        }
    };
};

// 浮点输入校验
var inputValidFloat = function inputValidFloat(value) {
    var fix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var int = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    if (typeof value.replace === 'undefined') {
        return value;
    }
    var inputing = false;
    if (value.indexOf('.') == value.length - 1) {
        inputing = true;
    } else if (value == '0.0' || value == '0.00' || value == '0.000' || value == '0.0000' || value == '0.00000' || value == '0.000000') {
        inputing = true;
    } else if (value.indexOf('-') == value.length - 1) {
        inputing = true;
    }
    if (!inputing && fix) {
        value = NumberFix(value, fix);
    }
    value = value.toString();
    switch (fix) {
        case 6:
            value = int ? value.replace(/[\D]|(\.*)(\d+)(\.?)(\d{0,6}).*$/g, '$2$3$4') : value.replace(/[^(\-)0-9]|(\.*)(\d+)(\.?)(\d{0,6}).*$/g, '$2$3$4');
            break;
        case 2:
            value = int ? value.replace(/[\D]|(\.*)(\d+)(\.?)(\d{0,2}).*$/g, '$2$3$4') : value.replace(/[^(\-)0-9]|(\.*)(\d+)(\.?)(\d{0,2}).*$/g, '$2$3$4');
            break;
        case 4:
            value = value.replace(/[\D]|(\.*)(\d+)(\.?)(\d{0,4}).*$/g, '$2$3$4');
            break;
        default:
            break;
    }
    return value;
};

// 整数校验
var inputValidInt = function inputValidInt(value) {
    if (typeof value.replace === 'undefined') {
        return value;
    }
    value = value.replace(/\D/g, '');
    return value;
};

// 允许负数整数
var inputValidNegInt = function inputValidNegInt(value) {
    if (typeof value.replace === 'undefined') {
        return value;
    }
    value = value.replace(/[^(\-)0-9]/g, '');
    return value;
};
// 手机号校验
var validateMobile = function validateMobile(msg) {
    return function (rule, value, callback) {
        var reg = /^1\d{10}$/;
        if (!reg.test(value)) {
            callback(new Error(msg));
        } else {
            callback();
        }
    };
};

/**客服号校验 */
var validServicePhone = function validServicePhone(rule, value, cb) {
    var tel = /^1\d{10}$/;
    var zoneTelTypeOne = /0\d{2}-\d{7,8}/; // 以"-"区分的区号+8座机号码
    var zoneTelTypeTwo = /\((0\d{2})\)\d{7,8}/; // 以"()"区分的区号+8座机号码
    var isTel = tel.test(value); //是否是手机号
    var isZoneTel = zoneTelTypeOne.test(value) && value.length === 12 || zoneTelTypeTwo.test(value) && value.length === 13; // 测试是否是区号+8位数座机号
    var isSerTel = value.length === 10 && value[0] == '4' && value[1] == '0' && value[2] == '0'; //是否是客服号
    // console.log(zoneTelTypeTwo.test(value), value, value.length)
    if (isTel || isSerTel || isZoneTel) {
        cb();
    } else {
        cb(new Error('请输入正确的客服号码'));
    }
    // validFormat('tel', '请输入正确的客服号码')
};

/**校验图片是否为空 */
var validEmptySimple = function validEmptySimple(msg) {
    return function (rule, value, callback) {
        if (!value.length) {
            callback(new Error(msg));
        } else {
            callback();
        }
    };
};

/**校验物品 */
var validGoods = function validGoods(msg) {
    return function (rule, value, callback) {
        if (!value) {
            callback(new Error(msg));
        } else {
            callback();
        }
    };
};

/***/ }),

/***/ "wC9Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_nav__ = __webpack_require__("tfKK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_routers__ = __webpack_require__("LkXW");





var homeName = '首页';

var closePage = function closePage(state, route) {
  var nextRoute = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_nav__["e" /* getNextRoute */])(state.tagNavList, route);
  state.tagNavList = state.tagNavList.filter(function (item) {
    return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_nav__["a" /* routeEqual */])(item, route);
  });
  __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(nextRoute);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    breadCrumbList: [],
    tagNavList: [],
    homeRoute: {},
    local: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_nav__["f" /* localRead */])('local'),
    errorList: [],
    hasReadErrorPage: false
  },
  getters: {
    menuList: function menuList(state, getters, rootState) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_nav__["g" /* getMenuByRouter */])(__WEBPACK_IMPORTED_MODULE_3__router_routers__["a" /* default */], rootState.user.access);
    },
    errorCount: function errorCount(state) {
      return state.errorList.length;
    }
  },
  mutations: {
    setBreadCrumb: function setBreadCrumb(state, route) {
      state.breadCrumbList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_nav__["h" /* getBreadCrumbList */])(route, state.homeRoute);
    },
    setHomeRoute: function setHomeRoute(state, routes) {
      state.homeRoute = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_nav__["i" /* getHomeRoute */])(routes, homeName);
    },
    setTagNavList: function setTagNavList(state, list) {
      var tagList = [];
      if (list) {
        tagList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(list.filter(function (o) {
          return o.name || o.meta && o.meta.title;
        })));
      } else tagList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_nav__["j" /* getTagNavListFromLocalstorage */])() || [];
      // 如果进行系统默认进入首页, 放开注释
      // if (tagList[0] && tagList[0].name !== homeName) tagList.shift()
      var homeTagIndex = tagList.findIndex(function (item) {
        return item.name === homeName;
      });
      if (homeTagIndex > 0) {
        var homeTag = tagList.splice(homeTagIndex, 1)[0];
        tagList.unshift(homeTag);
      }
      state.tagNavList = tagList;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_nav__["k" /* setTagNavListInLocalstorage */])([].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(tagList)));
    },
    closeTag: function closeTag(state, route) {
      var tag = state.tagNavList.filter(function (item) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_nav__["a" /* routeEqual */])(item, route);
      });
      route = tag[0] ? tag[0] : null;
      if (!route) return;
      closePage(state, route);
    },
    addTag: function addTag(state, _ref) {
      var route = _ref.route,
          _ref$type = _ref.type,
          type = _ref$type === undefined ? 'unshift' : _ref$type;

      var r = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_nav__["d" /* getRouteTitleHandled */])(route);
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_nav__["l" /* routeHasExist */])(state.tagNavList, r)) {
        if (type === 'push') state.tagNavList.push(r);else {
          if (r.name === homeName) state.tagNavList.unshift(r);else state.tagNavList.splice(1, 0, r);
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_nav__["k" /* setTagNavListInLocalstorage */])([].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(state.tagNavList)));
      }
    },
    clearTag: function clearTag(state) {
      var tagNavList = state.tagNavList.filter(function (o) {
        return o.name === homeName;
      });
      if (tagNavList.findIndex(function (o) {
        return o.name === homeName;
      }) < 0) {
        tagNavList.push({
          name: homeName,
          meta: { title: homeName },
          params: {},
          query: {}
        });
      }
      state.tagNavList = tagNavList;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_nav__["k" /* setTagNavListInLocalstorage */])(tagNavList);
    },
    setLocal: function setLocal(state, lang) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_nav__["m" /* localSave */])('local', lang);
      state.local = lang;
    },
    addError: function addError(state, error) {
      state.errorList.push(error);
    },
    setHasReadErrorLoggerStatus: function setHasReadErrorLoggerStatus(state) {
      var status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      state.hasReadErrorPage = status;
    }
  },
  actions: {}
});

/***/ }),

/***/ "x9kB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return HOST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TYPE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MD_CHUKU_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MD_RUKU_LIST; });
/**公用路径 */
var HOST = {
    FILE_HOST: '//igyl.weizhilian.com'

    /**数据报表出入库类型 */
};var TYPE_LIST = ['退货出库', '盘亏出库', '移库出库', '报损出库', '返货出库', '加工出库', '生产领料出库', '领料出库', '外销出库', '发货出库', '其它出库', '成本调整出库', '调拨出库', '菜品销售', '菜品报损', '调拨入库', '盘盈入库', '移库入库', '返货入库', '收货入库', '加工入库', '生产领料入库', '外销退货入库', '采购入库', '成本调整入库', '期初入库', '生产入库', '其它入库', '简单生产退料'];
/**门店出库 */
var MD_CHUKU_LIST = ["退货出库", "盘亏出库", "移库出库", "报损出库", "返货出库", "加工出库", "生产领料出库", "领料出库", "成本调整出库", "调拨出库", "其它出库", "菜品销售", "菜品报损"];
/**门店入库 */
var MD_RUKU_LIST = ["调拨入库", "盘盈入库", "移库入库", "收货入库", "加工入库", "生产领料入库", "采购入库", "成本调整入库", "期初入库", "生产入库", "其它入库", "简单生产退料"];

/***/ }),

/***/ "xEPM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DefaultForm_vue__ = __webpack_require__("vJRf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_acc0252a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_DefaultForm_vue__ = __webpack_require__("Xl+7");
function injectStyle (ssrContext) {
  __webpack_require__("Svrw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-acc0252a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DefaultForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_acc0252a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_DefaultForm_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_ProfileForm_vue__ = __webpack_require__("o0Pe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_Updatelog_vue__ = __webpack_require__("xkqu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_tagsNav_vue__ = __webpack_require__("134y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_nav__ = __webpack_require__("tfKK");






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        ProfileForm: __WEBPACK_IMPORTED_MODULE_6__components_common_ProfileForm_vue__["a" /* default */],
        TagsNav: __WEBPACK_IMPORTED_MODULE_8__components_common_tagsNav_vue__["a" /* default */],
        Updatelog: __WEBPACK_IMPORTED_MODULE_7__components_common_Updatelog_vue__["a" /* default */]
    },
    data: function data() {
        var _this = this;

        return {
            accounts: [],
            shopsName: '',
            scrollMaxRight: 0,
            session: null,
            form: {
                phone: null,
                code: null,
                type: 'phone'
            },
            username: null,
            password: null,
            active_menu: '0-1',
            active_menugroup: ['0'],
            profileMenusVisible: false,
            todoCount: 0,
            audio_order: new Audio("https://cdn.igyl.com/vendor-statics/club/audio/order.mp3"),
            permissions: {},
            logining: false,
            codeSend: false,
            codeCD: 0,
            loading: false,
            profileModal: false,
            loginCode: null,
            scanSuccess: false,
            showNav: true,
            sysadminphone: '',
            gengxinrizhiModal: {
                display: false,
                displayed: false,
                current: null,
                show: function show() {
                    _this.gengxinrizhiModal.current = _this.localcv_viewed;
                    sessionStorage.cv_viewed = _this.session.cv;
                    _this.localcv_viewed = _this.session.cv;
                    _this.newversiontip = false;
                    _this.gengxinrizhiModal.displayed = true;
                    setTimeout(function () {
                        _this.gengxinrizhiModal.display = true;
                    }, 30);
                    // if (this.gengxinrizhiModal.current < this.session.cv && this.$refs.updatelogref) {
                    if (version1gtversion2(_this.session.cv, _this.gengxinrizhiModal.current) && _this.$refs.updatelogref) {
                        _this.$refs.updatelogref.refresh();
                    }
                },
                displayChanged: function displayChanged(visiable) {
                    if (!visiable && _this.$store.auto_update) {
                        sessionStorage.updateTip = true;
                        window.location.reload();
                    }
                }
            },
            localcv: '',
            localcv_viewed: '',
            newversiontip: false
        };
    },

    watch: {
        $route: {
            handler: function handler(to, from) {
                var _this2 = this;

                if (to && to.path && to.path.indexOf('/docs') === 0) {
                    return;
                }
                if (from && from.path && from.path.indexOf('/docs') === 0 && !this.session) {
                    return this.loadSession({
                        cb: function cb() {
                            _this2.processRoute(to);
                        }
                    });
                }
                //this.$router.push跳转时没有高亮只针对出入库汇总跳转物品出入库明细
                if (to.path == '/web/sjbb/wpcrkmx' && from.path == '/web/sjbb/crkhz') {
                    this.active_menu = '7-6';
                }
                // 如果标签列表为空，先从 localStorage 恢复
                if (this.tagNavList.length === 0) {
                    this.setTagNavList(null);
                    // 等待标签列表恢复后再继续处理
                    this.$nextTick(function () {
                        _this2.processRoute(to);
                    });
                } else {
                    this.processRoute(to);
                }
            },

            deep: true,
            immediate: true
        }
    },
    computed: {
        isDocsRoute: function isDocsRoute() {
            var p = this.$route && this.$route.path || '';
            return p === '/docs' || p.indexOf('/docs/') === 0;
        },
        groupbadge: function groupbadge() {
            var r = {};
            if (this.session.badge) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(this.session.badge)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var key = _step.value;

                        r[key] = 0;
                        var _iteratorNormalCompletion2 = true;
                        var _didIteratorError2 = false;
                        var _iteratorError2 = undefined;

                        try {
                            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(this.session.badge[key])), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                var value = _step2.value;

                                r[key] += value;
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                    _iterator2.return();
                                }
                            } finally {
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }

                        if (r[key] < 0) r[key] = 0;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
            return r;
        },
        tagNavList: function tagNavList() {
            return this.$store.state.tagsNav.tagNavList || [];
        },

        // 不需要缓存的页面(组件)
        excludeCache: function excludeCache() {
            return ['HomePage', 'mallDress'];
        }
    },
    created: function created() {
        var that = this;
        // 在初始化时先从 localStorage 恢复标签列表
        if (this.$store.state.tagsNav.tagNavList.length === 0) {
            this.setTagNavList(null); // 传入 null 会从 localStorage 读取
        }
        if (!this.isDocsRoute) {
            that.loadSession({
                cb: function cb(session) {
                    that.localcv_viewed = sessionStorage.cv_viewed || '';
                    that.localcv = session.cv || '';
                    if (version1gtversion2(session.cv, that.localcv_viewed)) {
                        that.newversiontip = true;
                    }
                    if (sessionStorage.updateTip === 'true' || sessionStorage.updateTip === true) {
                        sessionStorage.updateTip = false;
                        that.$Notice.success({
                            title: '系统已更新',
                            duration: 5,
                            render: function render(h) {
                                return h('span', ['检测到新版本，系统已自动完成更新', h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                    style: {
                                        marginLeft: '-8px',
                                        color: '#20bf64',
                                        marginTop: '8px'
                                    },
                                    on: {
                                        click: function click() {
                                            that.gengxinrizhiModal.show();
                                        }
                                    }
                                }, '查看更新内容')]);
                            }
                        });
                    }
                }
            });
        }
        if (window.location.host == 'dev.gylzl.com') {
            if (window.document.title.indexOf('[dev]') == -1) window.document.title = window.document.title + ' [dev]';
        } else if (window.location.host == 'test.gylzl.com') {
            window.document.title = window.document.title + ' [test]';
        } else if (window.location.host == 'qa.gylzl.com') {
            window.document.title = window.document.title + ' [qa]';
        } else if (window.location.host == 'pre.gylzl.com') {
            window.document.title = window.document.title + ' [pre]';
        }
        window.document.body.onkeydown = function (e) {
            if (e.code == 'F5') {
                e.preventDefault();
                if (that.$refs.main && that.$refs.main.loadData) that.$refs.main.loadData();
                that.$Message.success('数据已更新');
            }
            if (that.$refs.main && that.$refs.main.onkeydown) that.$refs.main.onkeydown(e);
        };
        window.document.addEventListener('sessionUpdated', function () {
            that.loadSession({
                cb: function cb(session) {
                    that.session = session;
                }
            });
        });
        window.document.body.onhashchange = function (e) {
            that.updateMenu(e);
        };
    },
    mounted: function mounted() {
        window.addEventListener('scroll', this.handleTableScroll, true); // 坑-必须加上true，否则监听不上
    },

    sockets: {
        connect: function connect() {
            console.log('socket connected');
            if (this.session && this.session.token) {
                this.$socket.emit('join', this.session.token || 1);
            } else {
                this.socketReady = true;
            }
        },
        event: function event(res) {
            console.log(res);
            var _res$data = res.data,
                event = _res$data.event,
                changes = _res$data.changes,
                type = _res$data.type,
                details = _res$data.details;

            switch (event) {
                case 'CLIENT_VERSION_CHANGED':
                    this.session.cv = res.data.version;
                    this.$store.session.cv = res.data.version;
                    // if (this.session.cv > this.localcv) {
                    if (version1gtversion2(this.session.cv, this.localcv)) {
                        this.$store.auto_update = true; // 将在下次list请求时刷新页面
                    }
                    // if (this.session.cv > this.localcv_viewed) {
                    if (version1gtversion2(this.session.cv, this.localcv_viewed)) {
                        this.newversiontip = true;
                    }
                    break;
                case 'SESSION_CHANGE':
                    /**session改动 */
                    this.loadSession({ dataChanged: true, changes: changes });
                    break;
                case 'BADGE_CHANGE':
                    /**session改动 */
                    this.loadSession({ badgeChanged: true, changes: changes });
                    break;
                case 'BADGE_CHANGE_LOCAL':
                    /**session改动 */
                    if (details) {
                        var _iteratorNormalCompletion3 = true;
                        var _didIteratorError3 = false;
                        var _iteratorError3 = undefined;

                        try {
                            for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(details), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                var detail = _step3.value;

                                this.session.badge[detail.group][detail.menu] = this.session.badge[detail.group][detail.menu] || 0;
                                this.session.badge[detail.group][detail.menu] += detail.amount;
                                if (this.session.badge[detail.group][detail.menu] < 0) this.session.badge[detail.group][detail.menu] = 0;
                                // this.groupbadge[detail.group] += detail.amount
                                // if (this.groupbadge[detail.group] < 0) this.groupbadge[detail.group] = 0
                            }
                        } catch (err) {
                            _didIteratorError3 = true;
                            _iteratorError3 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                    _iterator3.return();
                                }
                            } finally {
                                if (_didIteratorError3) {
                                    throw _iteratorError3;
                                }
                            }
                        }
                    }
                    break;
                case 'OA_AUTH':
                    /**授权二维码 */
                    if (this.$refs['main'] && this.$refs['main'].getAuthResult) {
                        this.$refs['main'].getAuthResult(res);
                    }
                    break;
                default:
                    if (type == 'bind' || type == 'unbind') {
                        if (this.$refs['profileForm'] && this.$refs['profileForm'].qrcodeScaned) this.$refs['profileForm'].qrcodeScaned(res);
                        if (this.$refs['main'] && this.$refs['main'].qrcodeScaned) this.$refs['main'].qrcodeScaned(res);
                    } else if (type == 'login') {
                        this.loginbyQrcode(res);
                    }
                    break;
            }

            //用进度条提醒页面已收到ws消息
            this.$Loading.start();
            this.$Loading.finish();
        }
    },
    methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["mapMutations"])(['setTagNavList', 'addTag', 'setLocal', 'setHomeRoute', 'closeTag', 'clearTag']), {
        loadZhanghaos: function loadZhanghaos(visiable) {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var res;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (visiable) {
                                    _context.next = 2;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 2:
                                if (!_this3.zhanghaos) {
                                    _this3.loading = true;
                                }
                                _context.next = 5;
                                return _this3.$api.post('/web/main/zhanghaos/load', {
                                    sysadminphone: _this3.sysadminphone
                                });

                            case 5:
                                res = _context.sent;

                                _this3.loading = false;
                                if (res.data.success) {
                                    _this3.zhanghaos = res.data.zhanghaos;
                                    _this3.accounts = _this3.zhanghaos;
                                    _this3.shopsName = '';
                                }

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this3);
            }))();
        },
        shopInput: function shopInput(val) {
            this.accounts = this.zhanghaos.filter(function (row) {
                var name = row.jigou ? row.jigou.name || '' : '总后台';
                return name.indexOf(val) != -1;
            });
        },
        loginbyQrcode: function loginbyQrcode(res) {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (res.data.error) {
                                    _this4.$Message.error(res.data.error);
                                } else {
                                    _this4.form = { type: 'scan', qrcode: res.data.qrcode };
                                    _this4.scanSuccess = true;
                                    _this4.login();
                                }

                            case 1:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this4);
            }))();
        },
        resetQrcode: function resetQrcode() {
            this.scanSuccess = false;
            this.loginCode = null;
            this.loadLoginCode();
        },
        loadLoginCode: function loadLoginCode() {
            var _this5 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var res;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                if (_this5.loginCode) {
                                    _context3.next = 7;
                                    break;
                                }

                                _this5.loadingCode = true;
                                _context3.next = 4;
                                return _this5.$api.post('/web/main/qrcode/load', {
                                    type: 'login'
                                });

                            case 4:
                                res = _context3.sent;

                                _this5.loginCode = res.data.qrcode;
                                // this.loginCode = {url:'https://cdn.igyl.com/vendor-statics/qrcode_for_gh_88fe6cc99f1b_1280-2.jpg'}
                                _this5.loadingCode = false;

                            case 7:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this5);
            }))();
        },

        // 这里是控制table滚动阴影-结合index.css
        handleTableScroll: function handleTableScroll() {
            var tableEl = document.querySelector('.ivu-table-wrapper .ivu-table-overflowX');
            var leftFixedEl = document.querySelector('.ivu-table-wrapper .ivu-table-fixed');
            var rightFixedEl = document.querySelector('.ivu-table-wrapper .ivu-table-fixed-right');
            if (tableEl && tableEl.scrollLeft > 0) {
                if (leftFixedEl) {
                    leftFixedEl.className = 'ivu-table-fixed shadow-show';
                }
                if (rightFixedEl) {
                    rightFixedEl.className = 'ivu-table-fixed-right shadow-show';
                }
                // 判断是否滚动到底 - todo
            } else {
                if (leftFixedEl) {
                    leftFixedEl.className = 'ivu-table-fixed shadow-hide';
                }
                if (rightFixedEl) {
                    rightFixedEl.className = 'ivu-table-fixed-right shadow-hide';
                }
            }
        },
        reload: function reload() {
            var _this6 = this;

            this.isRouterAlive = false; //先关闭，
            this.$nextTick(function () {
                _this6.isRouterAlive = true; //再打开
            });
        },
        toProfile: function toProfile() {
            this.profileModal = true;
        },

        // 选中menu-item时，手动更新active_menu值-否则手动跳转时不会更新
        mendSelect: function mendSelect(name) {
            this.active_menu = name;
            // 选择menu-item时, 删除缓存, 使用页面正常刷新
            this.clearCache(name);
        },

        // 清除keep-alive缓存
        clearCache: function clearCache(name) {
            if (this.$refs.main && this.$refs.main.$options && this.$refs.main.$options.parent && this.$refs.main.$options.parent.keys && this.$refs.main.$options.parent.cache) {
                var cache = this.$refs.main.$options.parent.cache;
                var keys = this.$refs.main.$options.parent.keys;
                for (var k in cache) {
                    if (!name || cache[k] && cache[k].data && cache[k].data.attrs && cache[k].data.attrs.activeMenu == name) {
                        if (cache[k] && cache[k].componentInstance) {
                            cache[k].componentInstance.$destroy();
                        }
                        cache[k] = null;
                        delete cache[k];
                        var idx = keys.indexOf(k);
                        if (idx > -1) {
                            keys.splice(idx, 1);
                        }
                    }
                }
            }
        },
        reloadMenus: function reloadMenus() {
            var that = this;
            that.$api.post('/web/session/reloadMenus', {}).then(function (res) {
                if (res.data.success) {
                    // that.sessionChanged(res.data.session)
                    that.$Message.success({ content: '操作成功', duration: 4, closable: true });
                }
            });
        },
        sessionChanged: function sessionChanged(session) {
            if (!session.badge) session.badge = {};
            this.session = session;
            if (this.socketReady) {
                this.socketReady = false;
                this.$socket.emit('join', this.session.token || 1);
            }
            this.checkPagePermission();
            this.updateMenu();
            if (session.delayToLoadBadge) {
                this.loadBadge();
            }
        },
        toSwitch: function toSwitch(zhanghao) {
            var that = this;
            if (that.loading) {
                return;
            }
            that.loading = true;
            that.$api.post('/web/session/switch', {
                zhanghaoId: zhanghao._id
            }).then(function () {
                var hash = window.location.hash;
                that.resetNav();
                window.location.hash = '/';
                setTimeout(function () {
                    window.location.hash = hash;
                    that.loading = false;
                    var currentView = that.$refs['main'];
                    if (currentView && currentView.sessionChanged) {
                        currentView.sessionChanged();
                    }
                }, 200);
            }, function () {
                that.loading = false;
            });
        },
        getCode: function getCode() {
            var that = this;
            if (that.logining) {
                return;
            }
            that.logining = true;
            that.$api.post('/web/session/sms/code', {
                form: that.form
            }).then(function (res) {
                that.logining = false;
                if (res.data.success) {
                    that.codeSend = true;
                    that.codeCD = 60;
                    that.codeCount();
                }
            }, function () {
                that.logining = false;
            });
        },
        codeCount: function codeCount() {
            var that = this;
            if (that.codeCD > 0) {
                that.codeCD--;
                setTimeout(function () {
                    that.codeCount();
                }, 1000);
            }
        },
        login: function login() {
            var _this7 = this;

            if (this.logining) {
                return;
            }
            this.logining = true;
            this.resetNav();
            this.$api.post('/web/session/login', {
                form: this.form
            }).then(function (res) {
                _this7.logining = false;
                if (res.data.success) {
                    _this7.codeCD = 0;
                    // this.$socket.emit('join', this.session.token || 1);
                    // this.sessionChanged(res.data.session)
                    // this.checkPagePermission()
                }
            }, function () {
                _this7.logining = false;
            });
        },
        updateMenu: function updateMenu() {
            var that = this;
            if (that.session && !that.session.menuGroups) return;
            var hash = window.location.hash;
            if (hash && hash.indexOf('/logout') != -1) {
                that.logout();
            } else {
                var _iteratorNormalCompletion4 = true;
                var _didIteratorError4 = false;
                var _iteratorError4 = undefined;

                try {
                    for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(this.session.menuGroups), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                        var menuGroup = _step4.value;
                        var _iteratorNormalCompletion5 = true;
                        var _didIteratorError5 = false;
                        var _iteratorError5 = undefined;

                        try {
                            for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(menuGroup.menus), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                                var menu = _step5.value;

                                if (hash && hash.indexOf(menu.path) != -1) {
                                    that.active_menugroup = [menu.group];
                                    that.active_menu = menu.key;
                                    that.$nextTick(function () {
                                        that.$refs['menus'].updateOpened();
                                        that.$refs['menus'].updateActiveName();
                                    });
                                    return;
                                }
                            }
                        } catch (err) {
                            _didIteratorError5 = true;
                            _iteratorError5 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                                    _iterator5.return();
                                }
                            } finally {
                                if (_didIteratorError5) {
                                    throw _iteratorError5;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError4 = true;
                    _iteratorError4 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
                            _iterator4.return();
                        }
                    } finally {
                        if (_didIteratorError4) {
                            throw _iteratorError4;
                        }
                    }
                }

                that.active_menugroup = ['0'];
                that.active_menu = '0';
                that.$nextTick(function () {
                    that.$refs['menus'].updateOpened();
                    that.$refs['menus'].updateActiveName();
                });
            }
        },
        checkMenu: function checkMenu() {
            var that = this;
            var hash = window.location.hash;
            if (!that.session || !that.session.menuGroups || !hash) return;
            // 处理首页
            if (hash && hash.split('/').length === 2) {
                this.active_menu = '0';
                this.active_menugroup = ['0'];
                that.$nextTick(function () {
                    that.$refs['menus'].updateOpened();
                    that.$refs['menus'].updateActiveName();
                });
                return;
            }
            var _iteratorNormalCompletion6 = true;
            var _didIteratorError6 = false;
            var _iteratorError6 = undefined;

            try {
                for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(this.session.menuGroups), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                    var menuGroup = _step6.value;
                    var _iteratorNormalCompletion7 = true;
                    var _didIteratorError7 = false;
                    var _iteratorError7 = undefined;

                    try {
                        for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(menuGroup.menus), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                            var menu = _step7.value;

                            if (hash && hash.indexOf(menu.path) != -1) {
                                var active_menu = menu.key;
                                if (this.active_menu !== active_menu) {
                                    this.active_menu = active_menu;
                                    this.active_menugroup = [menu.group];
                                    that.$nextTick(function () {
                                        that.$refs['menus'].updateOpened();
                                        that.$refs['menus'].updateActiveName();
                                    });
                                    return;
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError7 = true;
                        _iteratorError7 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion7 && _iterator7.return) {
                                _iterator7.return();
                            }
                        } finally {
                            if (_didIteratorError7) {
                                throw _iteratorError7;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError6 = true;
                _iteratorError6 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion6 && _iterator6.return) {
                        _iterator6.return();
                    }
                } finally {
                    if (_didIteratorError6) {
                        throw _iteratorError6;
                    }
                }
            }
        },
        closeProfileMenus: function closeProfileMenus() {
            this.profileMenusVisible = false;
        },
        logout: function logout() {
            var _this8 = this;

            var that = this;
            that.$api.get('/web/session/logout').then(function (res) {
                if (res.data.success) {
                    that.sessionChanged(res.data.session);
                    // if (this.socketReady) {
                    //     this.$socket.emit('leave', this.session.token || 1);
                    // }
                    window.location.hash = '/';
                    if (_this8.form.type == 'scan') {
                        _this8.resetQrcode();
                    }
                } else {
                    that.$Message.error(res.data.error);
                }
            });
        },
        checkPagePermission: function checkPagePermission() {
            var hash = window.location.hash;
            if (hash.indexOf('/index') != -1 && hash.indexOf('/logout') != -1) {
                return window.location.hash = '/';
            }
            // Local docs page: not bound to menu permissions
            if (hash.indexOf('/docs') !== -1) {
                return;
            }
            var pagepermission = false;
            if (this.session.menuGroups && this.session.menuGroups.length) {
                var _iteratorNormalCompletion8 = true;
                var _didIteratorError8 = false;
                var _iteratorError8 = undefined;

                try {
                    for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(this.session.menuGroups), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                        var menuGroup = _step8.value;
                        var _iteratorNormalCompletion9 = true;
                        var _didIteratorError9 = false;
                        var _iteratorError9 = undefined;

                        try {
                            for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(menuGroup.menus), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                                var menu = _step9.value;

                                if (hash.indexOf(menu.path) != -1) {
                                    pagepermission = true;
                                }
                            }
                        } catch (err) {
                            _didIteratorError9 = true;
                            _iteratorError9 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion9 && _iterator9.return) {
                                    _iterator9.return();
                                }
                            } finally {
                                if (_didIteratorError9) {
                                    throw _iteratorError9;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError8 = true;
                    _iteratorError8 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion8 && _iterator8.return) {
                            _iterator8.return();
                        }
                    } finally {
                        if (_didIteratorError8) {
                            throw _iteratorError8;
                        }
                    }
                }
            }
            if (!pagepermission) {
                this.resetNav();
                window.location.hash = '/';
            }
        },
        turnToPage: function turnToPage(route) {
            var _ref = {},
                name = _ref.name,
                params = _ref.params,
                query = _ref.query;

            if (typeof route === 'string') name = route;else {
                name = route.name;
                params = route.params;
                query = route.query;
            }
            if (name.indexOf('isTurnByHref_') > -1) {
                window.open(name.split('_')[1]);
                return;
            }
            this.$router.push({
                name: name,
                params: params,
                query: query
            });
        },
        handleClick: function handleClick(item) {
            this.turnToPage(item);
        },
        handleCloseTag: function handleCloseTag(res, type, route) {
            if (type !== 'others') {
                if (type === 'all') {
                    this.turnToPage('首页');
                } else {
                    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_nav__["a" /* routeEqual */])(this.$route, route)) {
                        this.closeTag(route);
                    }
                }
            }
            this.setTagNavList(res);
        },
        resetNav: function resetNav() {
            this.clearTag();
            this.clearCache();
        },
        processRoute: function processRoute(to) {
            var name = to.name,
                query = to.query,
                params = to.params,
                meta = to.meta;

            this.addTag({
                route: { name: name, query: query, params: params, meta: meta },
                type: 'push'
            });
            this.setTagNavList(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_nav__["b" /* getNewTagList */])(this.tagNavList, to));
            this.checkMenu();
        }
    })
});

function versiontonumber(version) {
    if (!version) return 0;
    var parts = version.split('.').map(Number);
    return parts[0] * 1000000 + parts[1] * 1000 + parts[2];
}

function version1gtversion2(version1, version2) {
    var parts1 = versiontonumber(version1);
    var parts2 = versiontonumber(version2);
    return parts1 > parts2;
}

/***/ }),

/***/ "xJvj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-div"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._t("default")], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xVKL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("LfpU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5965d01a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("FjSk");
function injectStyle (ssrContext) {
  __webpack_require__("tNNF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5965d01a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5965d01a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xdmG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_dialog__ = __webpack_require__("Quz9");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_dialog__["a" /* default */]],
  props: {
    /**
     * 取消文字
     */
    cancelText: {
      type: String,
      default: '取消'
    },
    /**
     * 确定文字
     */
    confirmText: {
      type: String,
      default: '确定'
    },
    /**
     * 是否隐藏footer
     */
    footerHide: {
      type: Boolean,
      default: false
    },
    transfer: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    /**确定 */
    confirm: function confirm() {
      this.$emit('confirm');
    }
  }
});

/***/ }),

/***/ "xfZz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomInput_vue__ = __webpack_require__("9neA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_217cbf9f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_CustomInput_vue__ = __webpack_require__("8OJP");
function injectStyle (ssrContext) {
  __webpack_require__("T43E")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-217cbf9f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_217cbf9f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_CustomInput_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xkqu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Updatelog_vue__ = __webpack_require__("jGmC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aaf69dbe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Updatelog_vue__ = __webpack_require__("ITRb");
function injectStyle (ssrContext) {
  __webpack_require__("pSkN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-aaf69dbe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Updatelog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aaf69dbe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Updatelog_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xl10":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WupinSelector_vue__ = __webpack_require__("luFF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a7b34c88_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_WupinSelector_vue__ = __webpack_require__("ZVj6");
function injectStyle (ssrContext) {
  __webpack_require__("+CgP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a7b34c88"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WupinSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a7b34c88_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_WupinSelector_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xmNE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "y2EM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        current: {
            type: [Array],
            default: []
        },
        max: {
            type: Number,
            default: null
        },
        editable: {
            type: Boolean,
            default: true
        }
    },
    data: function data() {
        return {
            showAll: false,
            loading: false,
            types: [{ name: '文字', value: 'text' }, { name: '单选', value: 'radio' }, { name: '多选', value: 'checkbox' }, { name: '手机号', value: 'phone' }],
            rules: {},
            form: {}
        };
    },
    mounted: function mounted() {
        // setTimeout(() => { this.init() }, 100)
        this.init();
    },

    methods: {
        init: function init() {},
        confirm: function confirm() {
            this.$emit('confirm', this.current);
        },
        typeChanged: function typeChanged(item) {
            item.type = this.types.findOne({ name: item.typeStr });
            if ((item.type.value == 'radio' || item.type.value == 'checkbox') && (!item.selections || item.selections.length == 0)) {
                item.selections = item.selections || [];
                if (item.selections.length == 0) {
                    this.addSelection(item, 0);
                }
            }
        },
        addItem: function addItem() {
            this.rules['current[' + this.current.length + '].label'] = [{ required: true, message: ' ', trigger: 'blur' }];
            this.current.push({ type: { name: '文字', value: 'text' }, typeStr: '文字', selections: [] });
        },
        removeItem: function removeItem(index) {
            delete this.rules['current[' + this.current.length + '].label'];
            this.current.splice(index, 1);
        },
        insertItem: function insertItem(index) {
            this.rules['current[' + this.current.length + '].label'] = [{ required: true, message: ' ', trigger: 'blur' }];
            this.current.splice(index + 1, 0, { type: { name: '文字', value: 'text' }, typeStr: '文字', selections: [] });
        },
        addSelection: function addSelection(item, index) {
            this.rules['current[' + index + '].selections[' + item.selections.length + '].name'] = [{ required: true, message: ' ', trigger: 'blur' }];
            item.selections.push({ name: '' });
        },
        removeSelection: function removeSelection(item, index, j) {
            delete this.rules['current[' + index + '].selections[' + item.selections.length + ']'];
            item.selections.splice(j, 1);
        },
        insertSelection: function insertSelection(item, index, j) {
            this.rules['current[' + index + '].selections[' + item.selections.length + '].name'] = [{ required: true, message: ' ', trigger: 'blur' }];
            item.selections.splice(j + 1, 0, { name: '' });
        }
    }
});

/***/ }),

/***/ "y33K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrintForm_vue__ = __webpack_require__("2XLQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_260ce524_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PrintForm_vue__ = __webpack_require__("U0h6");
function injectStyle (ssrContext) {
  __webpack_require__("xmNE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-260ce524"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrintForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_260ce524_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PrintForm_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ypck":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "20px 0"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "40px",
      "padding": "0 20px"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_vm._v("已下发的门店如下：")]), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.mendians,
      "border": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "padding": "0",
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "200px",
      "margin-right": "20px"
    },
    attrs: {
      "search": "",
      "size": "small",
      "placeholder": "搜索"
    },
    on: {
      "on-enter": _vm.keywordsChanged
    },
    model: {
      value: (_vm.query.keywords),
      callback: function($$v) {
        _vm.$set(_vm.query, "keywords", $$v)
      },
      expression: "query.keywords"
    }
  }), _vm._v(" "), _c('Page', {
    attrs: {
      "placement": "top",
      "page-size-opts": [10, 20, 50, 100, 200],
      "total": _vm.total,
      "current": _vm.page.current,
      "page-size": _vm.page.size,
      "show-sizer": "",
      "show-total": "",
      "size": "small"
    },
    on: {
      "on-change": _vm.pageChanged,
      "on-page-size-change": _vm.pageSizeChanged
    }
  })], 1)], 1)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jcsb",
    staticStyle: {
      "font-size": "20px",
      "padding": "0 20px"
    }
  }, [_c('div', [_vm._v("查看下发门店")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zJQN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormItemLabel_vue__ = __webpack_require__("Bjk0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b04a52fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_FormItemLabel_vue__ = __webpack_require__("meuW");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormItemLabel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b04a52fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_FormItemLabel_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.34b738f6d2bc9b80b418.js